// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Toyota costumers theme*/
@font-face {
  font-family: "toyota-bold";
  src: url("/fonts/ToyotaType-Bold.ttf") format("truetype");
}
@font-face {
  font-family: "toyota-book";
  src: url("/fonts/ToyotaType-Book.ttf") format("truetype");
}
@font-face {
  font-family: "toyota-regular";
  src: url("/fonts/ToyotaType-Regular.ttf") format("truetype");
}
::ng-deep .link__tooltip {
  padding: 1em;
  width: auto;
  height: auto;
  border-radius: 0.2em;
  font-size: 1em;
  line-height: 1.5;
  text-align: center;
}

@media only print {
  * {
    margin: 0;
    padding: 0;
    font-size: 1em;
  }
  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/
  ::ng-deep .mat-select-value-text {
    display: none;
  }
  ::ng-deep .message__title,
  .message__description {
    display: none;
  }
  ::ng-deep .search-section {
    display: none;
  }
  ::ng-deep .print__confirmation {
    display: none;
  }
  ::ng-deep .button__confirmation {
    display: none;
  }
  .mat-mdc-card {
    box-shadow: none;
  }
}
.half-width {
  width: 50% !important;
}

.full-width {
  width: 100% !important;
}

.spacer {
  flex: 1 1 auto;
}

.bold {
  font-weight: "toyota-bold";
}

@font-face {
  font-family: "toyota-bold";
  src: url("/fonts/ToyotaType-Bold.ttf") format("truetype");
}
@font-face {
  font-family: "toyota-book";
  src: url("/fonts/ToyotaType-Book.ttf") format("truetype");
}
@font-face {
  font-family: "toyota-regular";
  src: url("/fonts/ToyotaType-Regular.ttf") format("truetype");
}
.admin-card {
  height: 100%;
}
.admin-card .card-title {
  color: rgb(255, 5, 0);
  border-bottom: 0.01em solid rgba(248, 248, 248, 0.8);
  padding: 1em 1.3em 0.5em;
  font-size: 1.2em;
  font-weight: bold;
  display: flex;
  font-family: "toyota-regular";
}
.admin-card .card-body {
  padding: 1em 1em;
}

.address-row mat-form-field {
  width: calc(33.3333333333% - 2em);
}

.card-footer {
  padding: 0 1em;
  font-size: 0.7em;
}
.card-footer .card-footer-title {
  font-weight: bold;
}

.customer-state * {
  color: black !important;
}

.save-button {
  padding: 0em 0em 0.3em;
  background-color: rgb(180, 57, 53) !important;
  color: rgb(255, 255, 255) !important;
}

.disabled-save-button {
  color: rgb(255, 255, 255) !important;
  opacity: 0.6;
}

html {
  --mat-badge-text-font: toyota-book;
  --mat-badge-line-height: 22px;
  --mat-badge-text-size: 12px;
  --mat-badge-text-weight: 600;
  --mat-badge-small-size-text-size: 9px;
  --mat-badge-small-size-line-height: 16px;
  --mat-badge-large-size-text-size: 24px;
  --mat-badge-large-size-line-height: 28px;
}

.mat-h1,
.mat-headline-5,
.mat-typography .mat-h1,
.mat-typography .mat-headline-5,
.mat-typography h1 {
  font: 400 24px / 32px toyota-book;
  letter-spacing: normal;
  margin: 0 0 16px;
}

.mat-h2,
.mat-headline-6,
.mat-typography .mat-h2,
.mat-typography .mat-headline-6,
.mat-typography h2 {
  font: 500 20px / 32px toyota-book;
  letter-spacing: 0.0125em;
  margin: 0 0 16px;
}

.mat-h3,
.mat-subtitle-1,
.mat-typography .mat-h3,
.mat-typography .mat-subtitle-1,
.mat-typography h3 {
  font: 400 16px / 28px toyota-book;
  letter-spacing: 0.009375em;
  margin: 0 0 16px;
}

.mat-h4,
.mat-body-1,
.mat-typography .mat-h4,
.mat-typography .mat-body-1,
.mat-typography h4 {
  font: 400 16px / 24px toyota-book;
  letter-spacing: 0.03125em;
  margin: 0 0 16px;
}

.mat-h5,
.mat-typography .mat-h5,
.mat-typography h5 {
  font: 400 calc(14px * 0.83) / 20px toyota-book;
  margin: 0 0 12px;
}

.mat-h6,
.mat-typography .mat-h6,
.mat-typography h6 {
  font: 400 calc(14px * 0.67) / 20px toyota-book;
  margin: 0 0 12px;
}

.mat-body-strong,
.mat-subtitle-2,
.mat-typography .mat-body-strong,
.mat-typography .mat-subtitle-2 {
  font: 500 14px / 22px toyota-book;
  letter-spacing: 0.0071428571em;
}

.mat-body,
.mat-body-2,
.mat-typography .mat-body,
.mat-typography .mat-body-2,
.mat-typography {
  font: 400 14px / 20px toyota-book;
  letter-spacing: 0.0178571429em;
}
.mat-body p,
.mat-body-2 p,
.mat-typography .mat-body p,
.mat-typography .mat-body-2 p,
.mat-typography p {
  margin: 0 0 12px;
}

.mat-small,
.mat-caption,
.mat-typography .mat-small,
.mat-typography .mat-caption {
  font: 400 12px / 20px toyota-book;
  letter-spacing: 0.0333333333em;
}

.mat-headline-1,
.mat-typography .mat-headline-1 {
  font: 300 96px / 96px toyota-book;
  letter-spacing: -0.015625em;
  margin: 0 0 56px;
}

.mat-headline-2,
.mat-typography .mat-headline-2 {
  font: 300 60px / 60px toyota-book;
  letter-spacing: -0.0083333333em;
  margin: 0 0 64px;
}

.mat-headline-3,
.mat-typography .mat-headline-3 {
  font: 400 48px / 50px toyota-book;
  letter-spacing: normal;
  margin: 0 0 64px;
}

.mat-headline-4,
.mat-typography .mat-headline-4 {
  font: 400 34px / 40px toyota-book;
  letter-spacing: 0.0073529412em;
  margin: 0 0 64px;
}

html {
  --mat-bottom-sheet-container-text-font: toyota-book;
  --mat-bottom-sheet-container-text-line-height: 20px;
  --mat-bottom-sheet-container-text-size: 14px;
  --mat-bottom-sheet-container-text-tracking: 0.0178571429em;
  --mat-bottom-sheet-container-text-weight: 400;
}

html {
  --mat-button-toggle-label-text-font: toyota-book;
  --mat-button-toggle-label-text-line-height: 24px;
  --mat-button-toggle-label-text-size: 16px;
  --mat-button-toggle-label-text-tracking: 0.03125em;
  --mat-button-toggle-label-text-weight: 400;
  --mat-button-toggle-legacy-label-text-font: toyota-book;
  --mat-button-toggle-legacy-label-text-line-height: 24px;
  --mat-button-toggle-legacy-label-text-size: 16px;
  --mat-button-toggle-legacy-label-text-tracking: 0.03125em;
  --mat-button-toggle-legacy-label-text-weight: 400;
}

html {
  --mat-datepicker-calendar-text-font: toyota-book;
  --mat-datepicker-calendar-text-size: 13px;
  --mat-datepicker-calendar-body-label-text-size: 14px;
  --mat-datepicker-calendar-body-label-text-weight: 500;
  --mat-datepicker-calendar-period-button-text-size: 14px;
  --mat-datepicker-calendar-period-button-text-weight: 500;
  --mat-datepicker-calendar-header-text-size: 11px;
  --mat-datepicker-calendar-header-text-weight: 400;
}

html {
  --mat-expansion-header-text-font: toyota-book;
  --mat-expansion-header-text-size: 14px;
  --mat-expansion-header-text-weight: 500;
  --mat-expansion-header-text-line-height: inherit;
  --mat-expansion-header-text-tracking: inherit;
  --mat-expansion-container-text-font: toyota-book;
  --mat-expansion-container-text-line-height: 20px;
  --mat-expansion-container-text-size: 14px;
  --mat-expansion-container-text-tracking: 0.0178571429em;
  --mat-expansion-container-text-weight: 400;
}

html {
  --mat-grid-list-tile-header-primary-text-size: 14px;
  --mat-grid-list-tile-header-secondary-text-size: 12px;
  --mat-grid-list-tile-footer-primary-text-size: 14px;
  --mat-grid-list-tile-footer-secondary-text-size: 12px;
}

html {
  --mat-stepper-container-text-font: toyota-book;
  --mat-stepper-header-label-text-font: toyota-book;
  --mat-stepper-header-label-text-size: 14px;
  --mat-stepper-header-label-text-weight: 400;
  --mat-stepper-header-error-state-label-text-size: 16px;
  --mat-stepper-header-selected-state-label-text-size: 16px;
  --mat-stepper-header-selected-state-label-text-weight: 400;
}

html {
  --mat-toolbar-title-text-font: toyota-book;
  --mat-toolbar-title-text-line-height: 32px;
  --mat-toolbar-title-text-size: 20px;
  --mat-toolbar-title-text-tracking: 0.0125em;
  --mat-toolbar-title-text-weight: 500;
}

html {
  --mat-tree-node-text-font: toyota-book;
  --mat-tree-node-text-size: 14px;
  --mat-tree-node-text-weight: 400;
}

html {
  --mat-option-label-text-font: toyota-book;
  --mat-option-label-text-line-height: 24px;
  --mat-option-label-text-size: 16px;
  --mat-option-label-text-tracking: 0.03125em;
  --mat-option-label-text-weight: 400;
}

html {
  --mat-optgroup-label-text-font: toyota-book;
  --mat-optgroup-label-text-line-height: 24px;
  --mat-optgroup-label-text-size: 16px;
  --mat-optgroup-label-text-tracking: 0.03125em;
  --mat-optgroup-label-text-weight: 400;
}

html {
  --mat-card-title-text-font: toyota-book;
  --mat-card-title-text-line-height: 32px;
  --mat-card-title-text-size: 20px;
  --mat-card-title-text-tracking: 0.0125em;
  --mat-card-title-text-weight: 500;
  --mat-card-subtitle-text-font: toyota-book;
  --mat-card-subtitle-text-line-height: 22px;
  --mat-card-subtitle-text-size: 14px;
  --mat-card-subtitle-text-tracking: 0.0071428571em;
  --mat-card-subtitle-text-weight: 500;
}

html {
  --mat-tooltip-supporting-text-font: toyota-book;
  --mat-tooltip-supporting-text-size: 12px;
  --mat-tooltip-supporting-text-weight: 400;
  --mat-tooltip-supporting-text-tracking: 0.0333333333em;
}

html {
  --mat-form-field-container-text-font: toyota-book;
  --mat-form-field-container-text-line-height: 24px;
  --mat-form-field-container-text-size: 16px;
  --mat-form-field-container-text-tracking: 0.03125em;
  --mat-form-field-container-text-weight: 400;
  --mat-form-field-outlined-label-text-populated-size: 16px;
  --mat-form-field-subscript-text-font: toyota-book;
  --mat-form-field-subscript-text-line-height: 20px;
  --mat-form-field-subscript-text-size: 12px;
  --mat-form-field-subscript-text-tracking: 0.0333333333em;
  --mat-form-field-subscript-text-weight: 400;
  --mat-form-field-filled-label-text-font: toyota-book;
  --mat-form-field-filled-label-text-size: 16px;
  --mat-form-field-filled-label-text-tracking: 0.03125em;
  --mat-form-field-filled-label-text-weight: 400;
  --mat-form-field-outlined-label-text-font: toyota-book;
  --mat-form-field-outlined-label-text-size: 16px;
  --mat-form-field-outlined-label-text-tracking: 0.03125em;
  --mat-form-field-outlined-label-text-weight: 400;
}

html {
  --mat-select-trigger-text-font: toyota-book;
  --mat-select-trigger-text-line-height: 24px;
  --mat-select-trigger-text-size: 16px;
  --mat-select-trigger-text-tracking: 0.03125em;
  --mat-select-trigger-text-weight: 400;
}

html {
  --mat-dialog-subhead-font: toyota-book;
  --mat-dialog-subhead-line-height: 32px;
  --mat-dialog-subhead-size: 20px;
  --mat-dialog-subhead-weight: 500;
  --mat-dialog-subhead-tracking: 0.0125em;
  --mat-dialog-supporting-text-font: toyota-book;
  --mat-dialog-supporting-text-line-height: 24px;
  --mat-dialog-supporting-text-size: 16px;
  --mat-dialog-supporting-text-weight: 400;
  --mat-dialog-supporting-text-tracking: 0.03125em;
}

.mat-mdc-standard-chip {
  --mat-chip-label-text-font: toyota-book;
  --mat-chip-label-text-line-height: 20px;
  --mat-chip-label-text-size: 14px;
  --mat-chip-label-text-tracking: 0.0178571429em;
  --mat-chip-label-text-weight: 400;
}

html {
  --mat-slide-toggle-label-text-font: toyota-book;
  --mat-slide-toggle-label-text-line-height: 20px;
  --mat-slide-toggle-label-text-size: 14px;
  --mat-slide-toggle-label-text-tracking: 0.0178571429em;
  --mat-slide-toggle-label-text-weight: 400;
}
html .mat-mdc-slide-toggle {
  --mat-slide-toggle-label-text-font: toyota-book;
  --mat-slide-toggle-label-text-line-height: 20px;
  --mat-slide-toggle-label-text-size: 14px;
  --mat-slide-toggle-label-text-tracking: 0.0178571429em;
  --mat-slide-toggle-label-text-weight: 400;
}

html {
  --mat-radio-label-text-font: toyota-book;
  --mat-radio-label-text-line-height: 20px;
  --mat-radio-label-text-size: 14px;
  --mat-radio-label-text-tracking: 0.0178571429em;
  --mat-radio-label-text-weight: 400;
}

html {
  --mat-slider-label-label-text-font: toyota-book;
  --mat-slider-label-label-text-size: 14px;
  --mat-slider-label-label-text-line-height: 22px;
  --mat-slider-label-label-text-tracking: 0.0071428571em;
  --mat-slider-label-label-text-weight: 500;
}

html {
  --mat-menu-item-label-text-font: toyota-book;
  --mat-menu-item-label-text-size: 16px;
  --mat-menu-item-label-text-tracking: 0.03125em;
  --mat-menu-item-label-text-line-height: 24px;
  --mat-menu-item-label-text-weight: 400;
}

html {
  --mat-list-list-item-label-text-font: toyota-book;
  --mat-list-list-item-label-text-line-height: 24px;
  --mat-list-list-item-label-text-size: 16px;
  --mat-list-list-item-label-text-tracking: 0.03125em;
  --mat-list-list-item-label-text-weight: 400;
  --mat-list-list-item-supporting-text-font: toyota-book;
  --mat-list-list-item-supporting-text-line-height: 20px;
  --mat-list-list-item-supporting-text-size: 14px;
  --mat-list-list-item-supporting-text-tracking: 0.0178571429em;
  --mat-list-list-item-supporting-text-weight: 400;
  --mat-list-list-item-trailing-supporting-text-font: toyota-book;
  --mat-list-list-item-trailing-supporting-text-line-height: 20px;
  --mat-list-list-item-trailing-supporting-text-size: 12px;
  --mat-list-list-item-trailing-supporting-text-tracking: 0.0333333333em;
  --mat-list-list-item-trailing-supporting-text-weight: 400;
}

.mdc-list-group__subheader {
  font: 400 16px / 28px toyota-book;
  letter-spacing: 0.009375em;
}

html {
  --mat-paginator-container-text-font: toyota-book;
  --mat-paginator-container-text-line-height: 20px;
  --mat-paginator-container-text-size: 12px;
  --mat-paginator-container-text-tracking: 0.0333333333em;
  --mat-paginator-container-text-weight: 400;
  --mat-paginator-select-trigger-text-size: 12px;
}

.mat-mdc-tab-header {
  --mat-tab-label-text-font: toyota-book;
  --mat-tab-label-text-size: 14px;
  --mat-tab-label-text-tracking: 0.0892857143em;
  --mat-tab-label-text-line-height: 36px;
  --mat-tab-label-text-weight: 500;
}

html {
  --mat-checkbox-label-text-font: toyota-book;
  --mat-checkbox-label-text-line-height: 20px;
  --mat-checkbox-label-text-size: 14px;
  --mat-checkbox-label-text-tracking: 0.0178571429em;
  --mat-checkbox-label-text-weight: 400;
}

html {
  --mat-button-filled-label-text-font: toyota-book;
  --mat-button-filled-label-text-size: 14px;
  --mat-button-filled-label-text-tracking: 0.0892857143em;
  --mat-button-filled-label-text-transform: none;
  --mat-button-filled-label-text-weight: 500;
  --mat-button-outlined-label-text-font: toyota-book;
  --mat-button-outlined-label-text-size: 14px;
  --mat-button-outlined-label-text-tracking: 0.0892857143em;
  --mat-button-outlined-label-text-transform: none;
  --mat-button-outlined-label-text-weight: 500;
  --mat-button-protected-label-text-font: toyota-book;
  --mat-button-protected-label-text-size: 14px;
  --mat-button-protected-label-text-tracking: 0.0892857143em;
  --mat-button-protected-label-text-transform: none;
  --mat-button-protected-label-text-weight: 500;
  --mat-button-text-label-text-font: toyota-book;
  --mat-button-text-label-text-size: 14px;
  --mat-button-text-label-text-tracking: 0.0892857143em;
  --mat-button-text-label-text-transform: none;
  --mat-button-text-label-text-weight: 500;
  --mat-button-tonal-label-text-font: toyota-book;
  --mat-button-tonal-label-text-size: 14px;
  --mat-button-tonal-label-text-tracking: 0.0892857143em;
  --mat-button-tonal-label-text-transform: none;
  --mat-button-tonal-label-text-weight: 500;
}

html {
  --mat-fab-extended-label-text-font: toyota-book;
  --mat-fab-extended-label-text-size: 14px;
  --mat-fab-extended-label-text-tracking: 0.0892857143em;
  --mat-fab-extended-label-text-weight: 500;
}

html {
  --mat-snack-bar-supporting-text-font: toyota-book;
  --mat-snack-bar-supporting-text-line-height: 20px;
  --mat-snack-bar-supporting-text-size: 14px;
  --mat-snack-bar-supporting-text-weight: 400;
}

html {
  --mat-table-header-headline-font: toyota-book;
  --mat-table-header-headline-line-height: 22px;
  --mat-table-header-headline-size: 14px;
  --mat-table-header-headline-weight: 500;
  --mat-table-header-headline-tracking: 0.0071428571em;
  --mat-table-row-item-label-text-font: toyota-book;
  --mat-table-row-item-label-text-line-height: 20px;
  --mat-table-row-item-label-text-size: 14px;
  --mat-table-row-item-label-text-weight: 400;
  --mat-table-row-item-label-text-tracking: 0.0178571429em;
  --mat-table-footer-supporting-text-font: toyota-book;
  --mat-table-footer-supporting-text-line-height: 20px;
  --mat-table-footer-supporting-text-size: 14px;
  --mat-table-footer-supporting-text-weight: 400;
  --mat-table-footer-supporting-text-tracking: 0.0178571429em;
}

.mat-elevation-z0, .mat-mdc-elevation-specific.mat-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0, 0px 0px 0px 0px --mat-sys-shadow, 0px 0px 0px 0px --mat-sys-shadow, 0px 0px 0px 0px --mat-sys-shadow);
}

.mat-elevation-z1, .mat-mdc-elevation-specific.mat-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1, 0px 2px 1px -1px --mat-sys-shadow, 0px 1px 1px 0px --mat-sys-shadow, 0px 1px 3px 0px --mat-sys-shadow);
}

.mat-elevation-z2, .mat-mdc-elevation-specific.mat-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2, 0px 3px 1px -2px --mat-sys-shadow, 0px 2px 2px 0px --mat-sys-shadow, 0px 1px 5px 0px --mat-sys-shadow);
}

.mat-elevation-z3, .mat-mdc-elevation-specific.mat-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3, 0px 3px 3px -2px --mat-sys-shadow, 0px 3px 4px 0px --mat-sys-shadow, 0px 1px 8px 0px --mat-sys-shadow);
}

.mat-elevation-z4, .mat-mdc-elevation-specific.mat-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4, 0px 2px 4px -1px --mat-sys-shadow, 0px 4px 5px 0px --mat-sys-shadow, 0px 1px 10px 0px --mat-sys-shadow);
}

.mat-elevation-z5, .mat-mdc-elevation-specific.mat-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5, 0px 3px 5px -1px --mat-sys-shadow, 0px 5px 8px 0px --mat-sys-shadow, 0px 1px 14px 0px --mat-sys-shadow);
}

.mat-elevation-z6, .mat-mdc-elevation-specific.mat-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6, 0px 3px 5px -1px --mat-sys-shadow, 0px 6px 10px 0px --mat-sys-shadow, 0px 1px 18px 0px --mat-sys-shadow);
}

.mat-elevation-z7, .mat-mdc-elevation-specific.mat-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7, 0px 4px 5px -2px --mat-sys-shadow, 0px 7px 10px 1px --mat-sys-shadow, 0px 2px 16px 1px --mat-sys-shadow);
}

.mat-elevation-z8, .mat-mdc-elevation-specific.mat-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8, 0px 5px 5px -3px --mat-sys-shadow, 0px 8px 10px 1px --mat-sys-shadow, 0px 3px 14px 2px --mat-sys-shadow);
}

.mat-elevation-z9, .mat-mdc-elevation-specific.mat-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9, 0px 5px 6px -3px --mat-sys-shadow, 0px 9px 12px 1px --mat-sys-shadow, 0px 3px 16px 2px --mat-sys-shadow);
}

.mat-elevation-z10, .mat-mdc-elevation-specific.mat-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10, 0px 6px 6px -3px --mat-sys-shadow, 0px 10px 14px 1px --mat-sys-shadow, 0px 4px 18px 3px --mat-sys-shadow);
}

.mat-elevation-z11, .mat-mdc-elevation-specific.mat-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11, 0px 6px 7px -4px --mat-sys-shadow, 0px 11px 15px 1px --mat-sys-shadow, 0px 4px 20px 3px --mat-sys-shadow);
}

.mat-elevation-z12, .mat-mdc-elevation-specific.mat-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12, 0px 7px 8px -4px --mat-sys-shadow, 0px 12px 17px 2px --mat-sys-shadow, 0px 5px 22px 4px --mat-sys-shadow);
}

.mat-elevation-z13, .mat-mdc-elevation-specific.mat-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13, 0px 7px 8px -4px --mat-sys-shadow, 0px 13px 19px 2px --mat-sys-shadow, 0px 5px 24px 4px --mat-sys-shadow);
}

.mat-elevation-z14, .mat-mdc-elevation-specific.mat-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14, 0px 7px 9px -4px --mat-sys-shadow, 0px 14px 21px 2px --mat-sys-shadow, 0px 5px 26px 4px --mat-sys-shadow);
}

.mat-elevation-z15, .mat-mdc-elevation-specific.mat-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15, 0px 8px 9px -5px --mat-sys-shadow, 0px 15px 22px 2px --mat-sys-shadow, 0px 6px 28px 5px --mat-sys-shadow);
}

.mat-elevation-z16, .mat-mdc-elevation-specific.mat-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16, 0px 8px 10px -5px --mat-sys-shadow, 0px 16px 24px 2px --mat-sys-shadow, 0px 6px 30px 5px --mat-sys-shadow);
}

.mat-elevation-z17, .mat-mdc-elevation-specific.mat-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17, 0px 8px 11px -5px --mat-sys-shadow, 0px 17px 26px 2px --mat-sys-shadow, 0px 6px 32px 5px --mat-sys-shadow);
}

.mat-elevation-z18, .mat-mdc-elevation-specific.mat-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18, 0px 9px 11px -5px --mat-sys-shadow, 0px 18px 28px 2px --mat-sys-shadow, 0px 7px 34px 6px --mat-sys-shadow);
}

.mat-elevation-z19, .mat-mdc-elevation-specific.mat-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19, 0px 9px 12px -6px --mat-sys-shadow, 0px 19px 29px 2px --mat-sys-shadow, 0px 7px 36px 6px --mat-sys-shadow);
}

.mat-elevation-z20, .mat-mdc-elevation-specific.mat-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20, 0px 10px 13px -6px --mat-sys-shadow, 0px 20px 31px 3px --mat-sys-shadow, 0px 8px 38px 7px --mat-sys-shadow);
}

.mat-elevation-z21, .mat-mdc-elevation-specific.mat-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21, 0px 10px 13px -6px --mat-sys-shadow, 0px 21px 33px 3px --mat-sys-shadow, 0px 8px 40px 7px --mat-sys-shadow);
}

.mat-elevation-z22, .mat-mdc-elevation-specific.mat-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22, 0px 10px 14px -6px --mat-sys-shadow, 0px 22px 35px 3px --mat-sys-shadow, 0px 8px 42px 7px --mat-sys-shadow);
}

.mat-elevation-z23, .mat-mdc-elevation-specific.mat-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23, 0px 11px 14px -7px --mat-sys-shadow, 0px 23px 36px 3px --mat-sys-shadow, 0px 9px 44px 8px --mat-sys-shadow);
}

.mat-elevation-z24, .mat-mdc-elevation-specific.mat-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24, 0px 11px 15px -7px --mat-sys-shadow, 0px 24px 38px 3px --mat-sys-shadow, 0px 9px 46px 8px --mat-sys-shadow);
}

html {
  --mat-sys-on-surface: initial;
}

.mat-app-background {
  background-color: var(--mat-app-background-color, var(--mat-sys-background, transparent));
  color: var(--mat-app-text-color, var(--mat-sys-on-background, inherit));
}

html {
  --mat-app-background-color: #fafafa;
  --mat-app-text-color: rgba(0, 0, 0, 0.87);
  --mat-app-elevation-shadow-level-0: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-1: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-2: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-3: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-4: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-5: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-6: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-7: 0px 4px 5px -2px rgba(0, 0, 0, 0.2), 0px 7px 10px 1px rgba(0, 0, 0, 0.14), 0px 2px 16px 1px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-8: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-9: 0px 5px 6px -3px rgba(0, 0, 0, 0.2), 0px 9px 12px 1px rgba(0, 0, 0, 0.14), 0px 3px 16px 2px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-10: 0px 6px 6px -3px rgba(0, 0, 0, 0.2), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-11: 0px 6px 7px -4px rgba(0, 0, 0, 0.2), 0px 11px 15px 1px rgba(0, 0, 0, 0.14), 0px 4px 20px 3px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-12: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-13: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 13px 19px 2px rgba(0, 0, 0, 0.14), 0px 5px 24px 4px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-14: 0px 7px 9px -4px rgba(0, 0, 0, 0.2), 0px 14px 21px 2px rgba(0, 0, 0, 0.14), 0px 5px 26px 4px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-15: 0px 8px 9px -5px rgba(0, 0, 0, 0.2), 0px 15px 22px 2px rgba(0, 0, 0, 0.14), 0px 6px 28px 5px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-16: 0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-17: 0px 8px 11px -5px rgba(0, 0, 0, 0.2), 0px 17px 26px 2px rgba(0, 0, 0, 0.14), 0px 6px 32px 5px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-18: 0px 9px 11px -5px rgba(0, 0, 0, 0.2), 0px 18px 28px 2px rgba(0, 0, 0, 0.14), 0px 7px 34px 6px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-19: 0px 9px 12px -6px rgba(0, 0, 0, 0.2), 0px 19px 29px 2px rgba(0, 0, 0, 0.14), 0px 7px 36px 6px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-20: 0px 10px 13px -6px rgba(0, 0, 0, 0.2), 0px 20px 31px 3px rgba(0, 0, 0, 0.14), 0px 8px 38px 7px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-21: 0px 10px 13px -6px rgba(0, 0, 0, 0.2), 0px 21px 33px 3px rgba(0, 0, 0, 0.14), 0px 8px 40px 7px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-22: 0px 10px 14px -6px rgba(0, 0, 0, 0.2), 0px 22px 35px 3px rgba(0, 0, 0, 0.14), 0px 8px 42px 7px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-23: 0px 11px 14px -7px rgba(0, 0, 0, 0.2), 0px 23px 36px 3px rgba(0, 0, 0, 0.14), 0px 9px 44px 8px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-24: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
}

html {
  --mat-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
}

html {
  --mat-option-selected-state-label-text-color: #03a9f4;
  --mat-option-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-option-hover-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 4%, transparent);
  --mat-option-focus-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-option-selected-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
}

.mat-accent {
  --mat-option-selected-state-label-text-color: #4caf50;
  --mat-option-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-option-hover-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 4%, transparent);
  --mat-option-focus-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-option-selected-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
}

.mat-warn {
  --mat-option-selected-state-label-text-color: #f44336;
  --mat-option-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-option-hover-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 4%, transparent);
  --mat-option-focus-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-option-selected-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
}

html {
  --mat-optgroup-label-text-color: rgba(0, 0, 0, 0.87);
}

html {
  --mat-pseudo-checkbox-full-selected-icon-color: #4caf50;
  --mat-pseudo-checkbox-full-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-pseudo-checkbox-full-disabled-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-full-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-minimal-selected-checkmark-color: #4caf50;
  --mat-pseudo-checkbox-minimal-disabled-selected-checkmark-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
}

.mat-primary {
  --mat-pseudo-checkbox-full-selected-icon-color: #03a9f4;
  --mat-pseudo-checkbox-full-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-pseudo-checkbox-full-disabled-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-full-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-minimal-selected-checkmark-color: #03a9f4;
  --mat-pseudo-checkbox-minimal-disabled-selected-checkmark-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
}

.mat-accent {
  --mat-pseudo-checkbox-full-selected-icon-color: #4caf50;
  --mat-pseudo-checkbox-full-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-pseudo-checkbox-full-disabled-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-full-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-minimal-selected-checkmark-color: #4caf50;
  --mat-pseudo-checkbox-minimal-disabled-selected-checkmark-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
}

.mat-warn {
  --mat-pseudo-checkbox-full-selected-icon-color: #f44336;
  --mat-pseudo-checkbox-full-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-pseudo-checkbox-full-disabled-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-full-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-minimal-selected-checkmark-color: #f44336;
  --mat-pseudo-checkbox-minimal-disabled-selected-checkmark-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
}

html {
  --mat-option-label-text-font: toyota-book;
  --mat-option-label-text-line-height: 24px;
  --mat-option-label-text-size: 16px;
  --mat-option-label-text-tracking: 0.03125em;
  --mat-option-label-text-weight: 400;
}

html {
  --mat-optgroup-label-text-font: toyota-book;
  --mat-optgroup-label-text-line-height: 24px;
  --mat-optgroup-label-text-size: 16px;
  --mat-optgroup-label-text-tracking: 0.03125em;
  --mat-optgroup-label-text-weight: 400;
}

html {
  --mat-card-elevated-container-shape: 4px;
  --mat-card-outlined-container-shape: 4px;
  --mat-card-filled-container-shape: 4px;
  --mat-card-outlined-outline-width: 1px;
}

html {
  --mat-card-elevated-container-color: white;
  --mat-card-elevated-container-elevation: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mat-card-outlined-container-color: white;
  --mat-card-outlined-container-elevation: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-card-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-card-subtitle-text-color: rgba(0, 0, 0, 0.54);
  --mat-card-filled-container-color: white;
  --mat-card-filled-container-elevation: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
}

html {
  --mat-card-title-text-font: toyota-book;
  --mat-card-title-text-line-height: 32px;
  --mat-card-title-text-size: 20px;
  --mat-card-title-text-tracking: 0.0125em;
  --mat-card-title-text-weight: 500;
  --mat-card-subtitle-text-font: toyota-book;
  --mat-card-subtitle-text-line-height: 22px;
  --mat-card-subtitle-text-size: 14px;
  --mat-card-subtitle-text-tracking: 0.0071428571em;
  --mat-card-subtitle-text-weight: 500;
}

html {
  --mat-progress-bar-active-indicator-height: 4px;
  --mat-progress-bar-track-height: 4px;
  --mat-progress-bar-track-shape: 0;
}

.mat-mdc-progress-bar {
  --mat-progress-bar-active-indicator-color: #03a9f4;
  --mat-progress-bar-track-color: rgba(3, 169, 244, 0.25);
}
.mat-mdc-progress-bar.mat-accent {
  --mat-progress-bar-active-indicator-color: #4caf50;
  --mat-progress-bar-track-color: rgba(76, 175, 80, 0.25);
}
.mat-mdc-progress-bar.mat-warn {
  --mat-progress-bar-active-indicator-color: #f44336;
  --mat-progress-bar-track-color: rgba(244, 67, 54, 0.25);
}

html {
  --mat-tooltip-container-shape: 4px;
  --mat-tooltip-supporting-text-line-height: 16px;
}

html {
  --mat-tooltip-container-color: #424242;
  --mat-tooltip-supporting-text-color: white;
}

html {
  --mat-tooltip-supporting-text-font: toyota-book;
  --mat-tooltip-supporting-text-size: 12px;
  --mat-tooltip-supporting-text-weight: 400;
  --mat-tooltip-supporting-text-tracking: 0.0333333333em;
}

html {
  --mat-form-field-filled-active-indicator-height: 1px;
  --mat-form-field-filled-focus-active-indicator-height: 2px;
  --mat-form-field-filled-container-shape: 4px;
  --mat-form-field-outlined-outline-width: 1px;
  --mat-form-field-outlined-focus-outline-width: 2px;
  --mat-form-field-outlined-container-shape: 4px;
}

html {
  --mat-form-field-focus-select-arrow-color: color-mix(in srgb, #03a9f4 87%, transparent);
  --mat-form-field-filled-caret-color: #03a9f4;
  --mat-form-field-filled-focus-active-indicator-color: #03a9f4;
  --mat-form-field-filled-focus-label-text-color: color-mix(in srgb, #03a9f4 87%, transparent);
  --mat-form-field-outlined-caret-color: #03a9f4;
  --mat-form-field-outlined-focus-outline-color: #03a9f4;
  --mat-form-field-outlined-focus-label-text-color: color-mix(in srgb, #03a9f4 87%, transparent);
  --mat-form-field-disabled-input-text-placeholder-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-form-field-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-form-field-error-text-color: #f44336;
  --mat-form-field-select-option-text-color: inherit;
  --mat-form-field-select-disabled-option-text-color: GrayText;
  --mat-form-field-leading-icon-color: unset;
  --mat-form-field-disabled-leading-icon-color: unset;
  --mat-form-field-trailing-icon-color: unset;
  --mat-form-field-disabled-trailing-icon-color: unset;
  --mat-form-field-error-focus-trailing-icon-color: unset;
  --mat-form-field-error-hover-trailing-icon-color: unset;
  --mat-form-field-error-trailing-icon-color: unset;
  --mat-form-field-enabled-select-arrow-color: rgba(0, 0, 0, 0.54);
  --mat-form-field-disabled-select-arrow-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-form-field-hover-state-layer-opacity: 0.04;
  --mat-form-field-focus-state-layer-opacity: 0.12;
  --mat-form-field-filled-container-color: #f6f6f6;
  --mat-form-field-filled-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 4%, transparent);
  --mat-form-field-filled-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-form-field-filled-hover-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-form-field-filled-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-form-field-filled-input-text-color: rgba(0, 0, 0, 0.87);
  --mat-form-field-filled-disabled-input-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-form-field-filled-input-text-placeholder-color: rgba(0, 0, 0, 0.54);
  --mat-form-field-filled-error-hover-label-text-color: #f44336;
  --mat-form-field-filled-error-focus-label-text-color: #f44336;
  --mat-form-field-filled-error-label-text-color: #f44336;
  --mat-form-field-filled-error-caret-color: #f44336;
  --mat-form-field-filled-active-indicator-color: rgba(0, 0, 0, 0.54);
  --mat-form-field-filled-disabled-active-indicator-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-form-field-filled-hover-active-indicator-color: rgba(0, 0, 0, 0.87);
  --mat-form-field-filled-error-active-indicator-color: #f44336;
  --mat-form-field-filled-error-focus-active-indicator-color: #f44336;
  --mat-form-field-filled-error-hover-active-indicator-color: #f44336;
  --mat-form-field-outlined-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-form-field-outlined-hover-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-form-field-outlined-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-form-field-outlined-input-text-color: rgba(0, 0, 0, 0.87);
  --mat-form-field-outlined-disabled-input-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-form-field-outlined-input-text-placeholder-color: rgba(0, 0, 0, 0.54);
  --mat-form-field-outlined-error-caret-color: #f44336;
  --mat-form-field-outlined-error-focus-label-text-color: #f44336;
  --mat-form-field-outlined-error-label-text-color: #f44336;
  --mat-form-field-outlined-error-hover-label-text-color: #f44336;
  --mat-form-field-outlined-outline-color: rgba(0, 0, 0, 0.38);
  --mat-form-field-outlined-disabled-outline-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-form-field-outlined-hover-outline-color: rgba(0, 0, 0, 0.87);
  --mat-form-field-outlined-error-focus-outline-color: #f44336;
  --mat-form-field-outlined-error-hover-outline-color: #f44336;
  --mat-form-field-outlined-error-outline-color: #f44336;
}

.mat-mdc-form-field.mat-accent {
  --mat-form-field-focus-select-arrow-color: color-mix(in srgb, #4caf50 87%, transparent);
  --mat-form-field-filled-caret-color: #4caf50;
  --mat-form-field-filled-focus-active-indicator-color: #4caf50;
  --mat-form-field-filled-focus-label-text-color: color-mix(in srgb, #4caf50 87%, transparent);
  --mat-form-field-outlined-caret-color: #4caf50;
  --mat-form-field-outlined-focus-outline-color: #4caf50;
  --mat-form-field-outlined-focus-label-text-color: color-mix(in srgb, #4caf50 87%, transparent);
}

.mat-mdc-form-field.mat-warn {
  --mat-form-field-focus-select-arrow-color: color-mix(in srgb, #f44336 87%, transparent);
  --mat-form-field-filled-caret-color: #f44336;
  --mat-form-field-filled-focus-active-indicator-color: #f44336;
  --mat-form-field-filled-focus-label-text-color: color-mix(in srgb, #f44336 87%, transparent);
  --mat-form-field-outlined-caret-color: #f44336;
  --mat-form-field-outlined-focus-outline-color: #f44336;
  --mat-form-field-outlined-focus-label-text-color: color-mix(in srgb, #f44336 87%, transparent);
}

html {
  --mat-form-field-container-height: 56px;
  --mat-form-field-filled-label-display: block;
  --mat-form-field-container-vertical-padding: 16px;
  --mat-form-field-filled-with-label-container-padding-top: 24px;
  --mat-form-field-filled-with-label-container-padding-bottom: 8px;
}

html {
  --mat-form-field-container-text-font: toyota-book;
  --mat-form-field-container-text-line-height: 24px;
  --mat-form-field-container-text-size: 16px;
  --mat-form-field-container-text-tracking: 0.03125em;
  --mat-form-field-container-text-weight: 400;
  --mat-form-field-outlined-label-text-populated-size: 16px;
  --mat-form-field-subscript-text-font: toyota-book;
  --mat-form-field-subscript-text-line-height: 20px;
  --mat-form-field-subscript-text-size: 12px;
  --mat-form-field-subscript-text-tracking: 0.0333333333em;
  --mat-form-field-subscript-text-weight: 400;
  --mat-form-field-filled-label-text-font: toyota-book;
  --mat-form-field-filled-label-text-size: 16px;
  --mat-form-field-filled-label-text-tracking: 0.03125em;
  --mat-form-field-filled-label-text-weight: 400;
  --mat-form-field-outlined-label-text-font: toyota-book;
  --mat-form-field-outlined-label-text-size: 16px;
  --mat-form-field-outlined-label-text-tracking: 0.03125em;
  --mat-form-field-outlined-label-text-weight: 400;
}

html {
  --mat-select-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

html {
  --mat-select-panel-background-color: white;
  --mat-select-enabled-trigger-text-color: rgba(0, 0, 0, 0.87);
  --mat-select-disabled-trigger-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-select-placeholder-text-color: rgba(0, 0, 0, 0.54);
  --mat-select-enabled-arrow-color: rgba(0, 0, 0, 0.54);
  --mat-select-disabled-arrow-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-select-focused-arrow-color: #03a9f4;
  --mat-select-invalid-arrow-color: #f44336;
}

.mat-mdc-form-field.mat-accent {
  --mat-select-panel-background-color: white;
  --mat-select-enabled-trigger-text-color: rgba(0, 0, 0, 0.87);
  --mat-select-disabled-trigger-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-select-placeholder-text-color: rgba(0, 0, 0, 0.54);
  --mat-select-enabled-arrow-color: rgba(0, 0, 0, 0.54);
  --mat-select-disabled-arrow-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-select-focused-arrow-color: #4caf50;
  --mat-select-invalid-arrow-color: #f44336;
}

.mat-mdc-form-field.mat-warn {
  --mat-select-panel-background-color: white;
  --mat-select-enabled-trigger-text-color: rgba(0, 0, 0, 0.87);
  --mat-select-disabled-trigger-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-select-placeholder-text-color: rgba(0, 0, 0, 0.54);
  --mat-select-enabled-arrow-color: rgba(0, 0, 0, 0.54);
  --mat-select-disabled-arrow-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-select-focused-arrow-color: #f44336;
  --mat-select-invalid-arrow-color: #f44336;
}

html {
  --mat-select-arrow-transform: translateY(-8px);
}

html {
  --mat-select-trigger-text-font: toyota-book;
  --mat-select-trigger-text-line-height: 24px;
  --mat-select-trigger-text-size: 16px;
  --mat-select-trigger-text-tracking: 0.03125em;
  --mat-select-trigger-text-weight: 400;
}

html {
  --mat-autocomplete-container-shape: 4px;
  --mat-autocomplete-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

html {
  --mat-autocomplete-background-color: white;
}

html {
  --mat-dialog-container-shape: 4px;
  --mat-dialog-container-elevation-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
  --mat-dialog-container-max-width: 80vw;
  --mat-dialog-container-small-max-width: 80vw;
  --mat-dialog-container-min-width: 0;
  --mat-dialog-actions-alignment: start;
  --mat-dialog-actions-padding: 8px;
  --mat-dialog-content-padding: 20px 24px;
  --mat-dialog-with-actions-content-padding: 20px 24px;
  --mat-dialog-headline-padding: 0 24px 9px;
}

html {
  --mat-dialog-container-color: white;
  --mat-dialog-subhead-color: rgba(0, 0, 0, 0.87);
  --mat-dialog-supporting-text-color: rgba(0, 0, 0, 0.54);
}

html {
  --mat-dialog-subhead-font: toyota-book;
  --mat-dialog-subhead-line-height: 32px;
  --mat-dialog-subhead-size: 20px;
  --mat-dialog-subhead-weight: 500;
  --mat-dialog-subhead-tracking: 0.0125em;
  --mat-dialog-supporting-text-font: toyota-book;
  --mat-dialog-supporting-text-line-height: 24px;
  --mat-dialog-supporting-text-size: 16px;
  --mat-dialog-supporting-text-weight: 400;
  --mat-dialog-supporting-text-tracking: 0.03125em;
}

.mat-mdc-standard-chip {
  --mat-chip-container-shape-radius: 16px;
  --mat-chip-disabled-container-opacity: 0.4;
  --mat-chip-disabled-outline-color: transparent;
  --mat-chip-flat-selected-outline-width: 0;
  --mat-chip-focus-outline-color: transparent;
  --mat-chip-hover-state-layer-opacity: 0.04;
  --mat-chip-outline-color: transparent;
  --mat-chip-outline-width: 0;
  --mat-chip-selected-hover-state-layer-opacity: 0.04;
  --mat-chip-selected-trailing-action-state-layer-color: transparent;
  --mat-chip-trailing-action-focus-opacity: 1;
  --mat-chip-trailing-action-focus-state-layer-opacity: 0;
  --mat-chip-trailing-action-hover-state-layer-opacity: 0;
  --mat-chip-trailing-action-opacity: 0.54;
  --mat-chip-trailing-action-state-layer-color: transparent;
  --mat-chip-with-avatar-avatar-shape-radius: 14px;
  --mat-chip-with-avatar-avatar-size: 28px;
  --mat-chip-with-avatar-disabled-avatar-opacity: 1;
  --mat-chip-with-icon-disabled-icon-opacity: 1;
  --mat-chip-with-icon-icon-size: 18px;
  --mat-chip-with-trailing-icon-disabled-trailing-icon-opacity: 1;
}

.mat-mdc-standard-chip {
  --mat-chip-disabled-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-chip-elevated-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-chip-elevated-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-chip-elevated-selected-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-chip-flat-disabled-selected-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-chip-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-focus-state-layer-opacity: 0.12;
  --mat-chip-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-chip-selected-disabled-trailing-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-selected-focus-state-layer-color: 0.12;
  --mat-chip-selected-focus-state-layer-opacity: 0.12;
  --mat-chip-selected-hover-state-layer-color: 0.04;
  --mat-chip-selected-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-chip-selected-trailing-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-icon-disabled-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-icon-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-icon-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-trailing-icon-disabled-trailing-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-trailing-icon-trailing-icon-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-standard-chip.mat-mdc-chip-selected.mat-primary, .mat-mdc-standard-chip.mat-mdc-chip-highlighted.mat-primary {
  --mat-chip-disabled-label-text-color: white;
  --mat-chip-elevated-container-color: #03a9f4;
  --mat-chip-elevated-disabled-container-color: #03a9f4;
  --mat-chip-elevated-selected-container-color: #03a9f4;
  --mat-chip-flat-disabled-selected-container-color: #03a9f4;
  --mat-chip-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-focus-state-layer-opacity: 0.12;
  --mat-chip-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-label-text-color: white;
  --mat-chip-selected-disabled-trailing-icon-color: white;
  --mat-chip-selected-focus-state-layer-color: 0.12;
  --mat-chip-selected-focus-state-layer-opacity: 0.12;
  --mat-chip-selected-hover-state-layer-color: 0.04;
  --mat-chip-selected-label-text-color: white;
  --mat-chip-selected-trailing-icon-color: white;
  --mat-chip-with-icon-disabled-icon-color: white;
  --mat-chip-with-icon-icon-color: white;
  --mat-chip-with-icon-selected-icon-color: white;
  --mat-chip-with-trailing-icon-disabled-trailing-icon-color: white;
  --mat-chip-with-trailing-icon-trailing-icon-color: white;
}
.mat-mdc-standard-chip.mat-mdc-chip-selected.mat-accent, .mat-mdc-standard-chip.mat-mdc-chip-highlighted.mat-accent {
  --mat-chip-disabled-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-chip-elevated-container-color: #4caf50;
  --mat-chip-elevated-disabled-container-color: #4caf50;
  --mat-chip-elevated-selected-container-color: #4caf50;
  --mat-chip-flat-disabled-selected-container-color: #4caf50;
  --mat-chip-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-focus-state-layer-opacity: 0.12;
  --mat-chip-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-chip-selected-disabled-trailing-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-selected-focus-state-layer-color: 0.12;
  --mat-chip-selected-focus-state-layer-opacity: 0.12;
  --mat-chip-selected-hover-state-layer-color: 0.04;
  --mat-chip-selected-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-chip-selected-trailing-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-icon-disabled-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-icon-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-icon-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-trailing-icon-disabled-trailing-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-trailing-icon-trailing-icon-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-standard-chip.mat-mdc-chip-selected.mat-warn, .mat-mdc-standard-chip.mat-mdc-chip-highlighted.mat-warn {
  --mat-chip-disabled-label-text-color: white;
  --mat-chip-elevated-container-color: #f44336;
  --mat-chip-elevated-disabled-container-color: #f44336;
  --mat-chip-elevated-selected-container-color: #f44336;
  --mat-chip-flat-disabled-selected-container-color: #f44336;
  --mat-chip-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-focus-state-layer-opacity: 0.12;
  --mat-chip-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-label-text-color: white;
  --mat-chip-selected-disabled-trailing-icon-color: white;
  --mat-chip-selected-focus-state-layer-color: 0.12;
  --mat-chip-selected-focus-state-layer-opacity: 0.12;
  --mat-chip-selected-hover-state-layer-color: 0.04;
  --mat-chip-selected-label-text-color: white;
  --mat-chip-selected-trailing-icon-color: white;
  --mat-chip-with-icon-disabled-icon-color: white;
  --mat-chip-with-icon-icon-color: white;
  --mat-chip-with-icon-selected-icon-color: white;
  --mat-chip-with-trailing-icon-disabled-trailing-icon-color: white;
  --mat-chip-with-trailing-icon-trailing-icon-color: white;
}

.mat-mdc-chip.mat-mdc-standard-chip {
  --mat-chip-container-height: 32px;
}

.mat-mdc-standard-chip {
  --mat-chip-label-text-font: toyota-book;
  --mat-chip-label-text-line-height: 20px;
  --mat-chip-label-text-size: 14px;
  --mat-chip-label-text-tracking: 0.0178571429em;
  --mat-chip-label-text-weight: 400;
}

html {
  --mat-slide-toggle-disabled-handle-opacity: 0.38;
  --mat-slide-toggle-disabled-selected-handle-opacity: 0.38;
  --mat-slide-toggle-disabled-selected-icon-opacity: 0.38;
  --mat-slide-toggle-disabled-track-opacity: 0.12;
  --mat-slide-toggle-disabled-unselected-handle-opacity: 0.38;
  --mat-slide-toggle-disabled-unselected-icon-opacity: 0.38;
  --mat-slide-toggle-disabled-unselected-track-outline-color: transparent;
  --mat-slide-toggle-disabled-unselected-track-outline-width: 1px;
  --mat-slide-toggle-handle-height: 20px;
  --mat-slide-toggle-handle-shape: 10px;
  --mat-slide-toggle-handle-width: 20px;
  --mat-slide-toggle-hidden-track-opacity: 1;
  --mat-slide-toggle-hidden-track-transition: transform 75ms 0ms cubic-bezier(0.4, 0, 0.6, 1);
  --mat-slide-toggle-pressed-handle-size: 20px;
  --mat-slide-toggle-selected-focus-state-layer-opacity: 0.12;
  --mat-slide-toggle-selected-handle-horizontal-margin: 0;
  --mat-slide-toggle-selected-handle-size: 20px;
  --mat-slide-toggle-selected-hover-state-layer-opacity: 0.04;
  --mat-slide-toggle-selected-icon-size: 18px;
  --mat-slide-toggle-selected-pressed-handle-horizontal-margin: 0;
  --mat-slide-toggle-selected-pressed-state-layer-opacity: 0.12;
  --mat-slide-toggle-selected-track-outline-color: transparent;
  --mat-slide-toggle-selected-track-outline-width: 1px;
  --mat-slide-toggle-selected-with-icon-handle-horizontal-margin: 0;
  --mat-slide-toggle-track-height: 14px;
  --mat-slide-toggle-track-outline-color: transparent;
  --mat-slide-toggle-track-outline-width: 1px;
  --mat-slide-toggle-track-shape: 7px;
  --mat-slide-toggle-track-width: 36px;
  --mat-slide-toggle-unselected-focus-state-layer-opacity: 0.12;
  --mat-slide-toggle-unselected-handle-horizontal-margin: 0;
  --mat-slide-toggle-unselected-handle-size: 20px;
  --mat-slide-toggle-unselected-hover-state-layer-opacity: 0.12;
  --mat-slide-toggle-unselected-icon-size: 18px;
  --mat-slide-toggle-unselected-pressed-handle-horizontal-margin: 0;
  --mat-slide-toggle-unselected-pressed-state-layer-opacity: 0.1;
  --mat-slide-toggle-unselected-with-icon-handle-horizontal-margin: 0;
  --mat-slide-toggle-visible-track-opacity: 1;
  --mat-slide-toggle-visible-track-transition: transform 75ms 0ms cubic-bezier(0, 0, 0.2, 1);
  --mat-slide-toggle-with-icon-handle-size: 20px;
  --mat-slide-toggle-touch-target-size: 48px;
}

html {
  --mat-slide-toggle-selected-icon-color: white;
  --mat-slide-toggle-disabled-selected-icon-color: white;
  --mat-slide-toggle-selected-focus-state-layer-color: #03a9f4;
  --mat-slide-toggle-selected-handle-color: #03a9f4;
  --mat-slide-toggle-selected-hover-state-layer-color: #03a9f4;
  --mat-slide-toggle-selected-pressed-state-layer-color: #03a9f4;
  --mat-slide-toggle-selected-focus-handle-color: #03a9f4;
  --mat-slide-toggle-selected-hover-handle-color: #03a9f4;
  --mat-slide-toggle-selected-pressed-handle-color: #03a9f4;
  --mat-slide-toggle-selected-focus-track-color: #4fc3f7;
  --mat-slide-toggle-selected-hover-track-color: #4fc3f7;
  --mat-slide-toggle-selected-pressed-track-color: #4fc3f7;
  --mat-slide-toggle-selected-track-color: #4fc3f7;
  --mat-slide-toggle-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-slide-toggle-disabled-handle-elevation-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-slide-toggle-disabled-selected-handle-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-disabled-selected-track-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-disabled-unselected-handle-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-disabled-unselected-icon-color: #f6f6f6;
  --mat-slide-toggle-disabled-unselected-track-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-handle-elevation-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mat-slide-toggle-handle-surface-color: white;
  --mat-slide-toggle-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-unselected-hover-handle-color: #424242;
  --mat-slide-toggle-unselected-focus-handle-color: #424242;
  --mat-slide-toggle-unselected-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-unselected-focus-track-color: rgba(0, 0, 0, 0.12);
  --mat-slide-toggle-unselected-icon-color: #f6f6f6;
  --mat-slide-toggle-unselected-handle-color: rgba(0, 0, 0, 0.54);
  --mat-slide-toggle-unselected-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-unselected-hover-track-color: rgba(0, 0, 0, 0.12);
  --mat-slide-toggle-unselected-pressed-handle-color: #424242;
  --mat-slide-toggle-unselected-pressed-track-color: rgba(0, 0, 0, 0.12);
  --mat-slide-toggle-unselected-pressed-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-unselected-track-color: rgba(0, 0, 0, 0.12);
}

.mat-mdc-slide-toggle.mat-accent {
  --mat-slide-toggle-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-disabled-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-selected-focus-state-layer-color: #4caf50;
  --mat-slide-toggle-selected-handle-color: #4caf50;
  --mat-slide-toggle-selected-hover-state-layer-color: #4caf50;
  --mat-slide-toggle-selected-pressed-state-layer-color: #4caf50;
  --mat-slide-toggle-selected-focus-handle-color: #4caf50;
  --mat-slide-toggle-selected-hover-handle-color: #4caf50;
  --mat-slide-toggle-selected-pressed-handle-color: #4caf50;
  --mat-slide-toggle-selected-focus-track-color: #81c784;
  --mat-slide-toggle-selected-hover-track-color: #81c784;
  --mat-slide-toggle-selected-pressed-track-color: #81c784;
  --mat-slide-toggle-selected-track-color: #81c784;
}
.mat-mdc-slide-toggle.mat-warn {
  --mat-slide-toggle-selected-icon-color: white;
  --mat-slide-toggle-disabled-selected-icon-color: white;
  --mat-slide-toggle-selected-focus-state-layer-color: #f44336;
  --mat-slide-toggle-selected-handle-color: #f44336;
  --mat-slide-toggle-selected-hover-state-layer-color: #f44336;
  --mat-slide-toggle-selected-pressed-state-layer-color: #f44336;
  --mat-slide-toggle-selected-focus-handle-color: #f44336;
  --mat-slide-toggle-selected-hover-handle-color: #f44336;
  --mat-slide-toggle-selected-pressed-handle-color: #f44336;
  --mat-slide-toggle-selected-focus-track-color: #e57373;
  --mat-slide-toggle-selected-hover-track-color: #e57373;
  --mat-slide-toggle-selected-pressed-track-color: #e57373;
  --mat-slide-toggle-selected-track-color: #e57373;
}

html {
  --mat-slide-toggle-state-layer-size: 40px;
  --mat-slide-toggle-touch-target-display: block;
}

html {
  --mat-slide-toggle-label-text-font: toyota-book;
  --mat-slide-toggle-label-text-line-height: 20px;
  --mat-slide-toggle-label-text-size: 14px;
  --mat-slide-toggle-label-text-tracking: 0.0178571429em;
  --mat-slide-toggle-label-text-weight: 400;
}
html .mat-mdc-slide-toggle {
  --mat-slide-toggle-label-text-font: toyota-book;
  --mat-slide-toggle-label-text-line-height: 20px;
  --mat-slide-toggle-label-text-size: 14px;
  --mat-slide-toggle-label-text-tracking: 0.0178571429em;
  --mat-slide-toggle-label-text-weight: 400;
}

html {
  --mat-radio-disabled-selected-icon-opacity: 0.38;
  --mat-radio-disabled-unselected-icon-opacity: 0.38;
  --mat-radio-state-layer-size: 40px;
  --mat-radio-touch-target-size: 48px;
}

.mat-mdc-radio-button.mat-primary {
  --mat-radio-checked-ripple-color: #03a9f4;
  --mat-radio-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-radio-disabled-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-disabled-unselected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-radio-ripple-color: rgba(0, 0, 0, 0.87);
  --mat-radio-selected-focus-icon-color: #03a9f4;
  --mat-radio-selected-hover-icon-color: #03a9f4;
  --mat-radio-selected-icon-color: #03a9f4;
  --mat-radio-selected-pressed-icon-color: #03a9f4;
  --mat-radio-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-radio-unselected-pressed-icon-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-radio-button.mat-accent {
  --mat-radio-checked-ripple-color: #4caf50;
  --mat-radio-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-radio-disabled-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-disabled-unselected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-radio-ripple-color: rgba(0, 0, 0, 0.87);
  --mat-radio-selected-focus-icon-color: #4caf50;
  --mat-radio-selected-hover-icon-color: #4caf50;
  --mat-radio-selected-icon-color: #4caf50;
  --mat-radio-selected-pressed-icon-color: #4caf50;
  --mat-radio-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-radio-unselected-pressed-icon-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-radio-button.mat-warn {
  --mat-radio-checked-ripple-color: #f44336;
  --mat-radio-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-radio-disabled-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-disabled-unselected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-radio-ripple-color: rgba(0, 0, 0, 0.87);
  --mat-radio-selected-focus-icon-color: #f44336;
  --mat-radio-selected-hover-icon-color: #f44336;
  --mat-radio-selected-icon-color: #f44336;
  --mat-radio-selected-pressed-icon-color: #f44336;
  --mat-radio-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-radio-unselected-pressed-icon-color: rgba(0, 0, 0, 0.87);
}

html {
  --mat-radio-state-layer-size: 40px;
  --mat-radio-touch-target-display: block;
}

html {
  --mat-radio-label-text-font: toyota-book;
  --mat-radio-label-text-line-height: 20px;
  --mat-radio-label-text-size: 14px;
  --mat-radio-label-text-tracking: 0.0178571429em;
  --mat-radio-label-text-weight: 400;
}

html {
  --mat-slider-active-track-height: 6px;
  --mat-slider-active-track-shape: 9999px;
  --mat-slider-handle-elevation: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mat-slider-handle-height: 20px;
  --mat-slider-handle-shape: 50%;
  --mat-slider-handle-width: 20px;
  --mat-slider-inactive-track-height: 4px;
  --mat-slider-inactive-track-shape: 9999px;
  --mat-slider-value-indicator-border-radius: 4px;
  --mat-slider-value-indicator-caret-display: block;
  --mat-slider-value-indicator-container-transform: translateX(-50%);
  --mat-slider-value-indicator-height: 32px;
  --mat-slider-value-indicator-padding: 0 12px;
  --mat-slider-value-indicator-text-transform: none;
  --mat-slider-value-indicator-width: auto;
  --mat-slider-with-overlap-handle-outline-width: 1px;
  --mat-slider-with-tick-marks-active-container-opacity: 0.6;
  --mat-slider-with-tick-marks-container-shape: 50%;
  --mat-slider-with-tick-marks-container-size: 2px;
  --mat-slider-with-tick-marks-inactive-container-opacity: 0.6;
  --mat-slider-value-indicator-transform-origin: bottom;
}

html {
  --mat-slider-active-track-color: #03a9f4;
  --mat-slider-focus-handle-color: #03a9f4;
  --mat-slider-handle-color: #03a9f4;
  --mat-slider-hover-handle-color: #03a9f4;
  --mat-slider-focus-state-layer-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-slider-hover-state-layer-color: color-mix(in srgb, #03a9f4 4%, transparent);
  --mat-slider-inactive-track-color: #03a9f4;
  --mat-slider-ripple-color: #03a9f4;
  --mat-slider-with-tick-marks-active-container-color: white;
  --mat-slider-with-tick-marks-inactive-container-color: #03a9f4;
  --mat-slider-disabled-active-track-color: rgba(0, 0, 0, 0.87);
  --mat-slider-disabled-handle-color: rgba(0, 0, 0, 0.87);
  --mat-slider-disabled-inactive-track-color: rgba(0, 0, 0, 0.87);
  --mat-slider-label-container-color: #424242;
  --mat-slider-label-label-text-color: white;
  --mat-slider-value-indicator-opacity: 1;
  --mat-slider-with-overlap-handle-outline-color: rgba(0, 0, 0, 0.87);
  --mat-slider-with-tick-marks-disabled-container-color: rgba(0, 0, 0, 0.87);
}

.mat-accent {
  --mat-slider-active-track-color: #4caf50;
  --mat-slider-focus-handle-color: #4caf50;
  --mat-slider-handle-color: #4caf50;
  --mat-slider-hover-handle-color: #4caf50;
  --mat-slider-focus-state-layer-color: color-mix(in srgb, #4caf50 12%, transparent);
  --mat-slider-hover-state-layer-color: color-mix(in srgb, #4caf50 4%, transparent);
  --mat-slider-inactive-track-color: #4caf50;
  --mat-slider-ripple-color: #4caf50;
  --mat-slider-with-tick-marks-active-container-color: rgba(0, 0, 0, 0.87);
  --mat-slider-with-tick-marks-inactive-container-color: #4caf50;
}

.mat-warn {
  --mat-slider-active-track-color: #f44336;
  --mat-slider-focus-handle-color: #f44336;
  --mat-slider-handle-color: #f44336;
  --mat-slider-hover-handle-color: #f44336;
  --mat-slider-focus-state-layer-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-slider-hover-state-layer-color: color-mix(in srgb, #f44336 4%, transparent);
  --mat-slider-inactive-track-color: #f44336;
  --mat-slider-ripple-color: #f44336;
  --mat-slider-with-tick-marks-active-container-color: white;
  --mat-slider-with-tick-marks-inactive-container-color: #f44336;
}

html {
  --mat-slider-label-label-text-font: toyota-book;
  --mat-slider-label-label-text-size: 14px;
  --mat-slider-label-label-text-line-height: 22px;
  --mat-slider-label-label-text-tracking: 0.0071428571em;
  --mat-slider-label-label-text-weight: 500;
}

html {
  --mat-menu-container-shape: 4px;
  --mat-menu-divider-bottom-spacing: 0;
  --mat-menu-divider-top-spacing: 0;
  --mat-menu-item-spacing: 16px;
  --mat-menu-item-icon-size: 24px;
  --mat-menu-item-leading-spacing: 16px;
  --mat-menu-item-trailing-spacing: 16px;
  --mat-menu-item-with-icon-leading-spacing: 16px;
  --mat-menu-item-with-icon-trailing-spacing: 16px;
  --mat-menu-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

html {
  --mat-menu-item-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-menu-item-icon-color: rgba(0, 0, 0, 0.87);
  --mat-menu-item-hover-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 4%, transparent);
  --mat-menu-item-focus-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-menu-container-color: white;
  --mat-menu-divider-color: rgba(0, 0, 0, 0.12);
}

html {
  --mat-menu-item-label-text-font: toyota-book;
  --mat-menu-item-label-text-size: 16px;
  --mat-menu-item-label-text-tracking: 0.03125em;
  --mat-menu-item-label-text-line-height: 24px;
  --mat-menu-item-label-text-weight: 400;
}

html {
  --mat-list-active-indicator-color: transparent;
  --mat-list-active-indicator-shape: 4px;
  --mat-list-list-item-container-shape: 0;
  --mat-list-list-item-leading-avatar-shape: 50%;
  --mat-list-list-item-container-color: transparent;
  --mat-list-list-item-selected-container-color: transparent;
  --mat-list-list-item-leading-avatar-color: transparent;
  --mat-list-list-item-leading-icon-size: 24px;
  --mat-list-list-item-leading-avatar-size: 40px;
  --mat-list-list-item-trailing-icon-size: 24px;
  --mat-list-list-item-disabled-state-layer-color: transparent;
  --mat-list-list-item-disabled-state-layer-opacity: 0;
  --mat-list-list-item-disabled-label-text-opacity: 0.38;
  --mat-list-list-item-disabled-leading-icon-opacity: 0.38;
  --mat-list-list-item-disabled-trailing-icon-opacity: 0.38;
}

html {
  --mat-list-list-item-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-supporting-text-color: rgba(0, 0, 0, 0.54);
  --mat-list-list-item-leading-icon-color: rgba(0, 0, 0, 0.54);
  --mat-list-list-item-trailing-supporting-text-color: rgba(0, 0, 0, 0.54);
  --mat-list-list-item-trailing-icon-color: rgba(0, 0, 0, 0.54);
  --mat-list-list-item-selected-trailing-icon-color: rgba(0, 0, 0, 0.54);
  --mat-list-list-item-disabled-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-disabled-leading-icon-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-disabled-trailing-icon-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-hover-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-hover-leading-icon-color: rgba(0, 0, 0, 0.54);
  --mat-list-list-item-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-hover-state-layer-opacity: 0.04;
  --mat-list-list-item-hover-trailing-icon-color: rgba(0, 0, 0, 0.54);
  --mat-list-list-item-focus-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-focus-state-layer-opacity: 0.12;
}

.mdc-list-item__start,
.mdc-list-item__end {
  --mat-radio-checked-ripple-color: #03a9f4;
  --mat-radio-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-radio-disabled-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-disabled-unselected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-radio-ripple-color: rgba(0, 0, 0, 0.87);
  --mat-radio-selected-focus-icon-color: #03a9f4;
  --mat-radio-selected-hover-icon-color: #03a9f4;
  --mat-radio-selected-icon-color: #03a9f4;
  --mat-radio-selected-pressed-icon-color: #03a9f4;
  --mat-radio-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-radio-unselected-pressed-icon-color: rgba(0, 0, 0, 0.87);
}

.mat-accent .mdc-list-item__start,
.mat-accent .mdc-list-item__end {
  --mat-radio-checked-ripple-color: #4caf50;
  --mat-radio-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-radio-disabled-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-disabled-unselected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-radio-ripple-color: rgba(0, 0, 0, 0.87);
  --mat-radio-selected-focus-icon-color: #4caf50;
  --mat-radio-selected-hover-icon-color: #4caf50;
  --mat-radio-selected-icon-color: #4caf50;
  --mat-radio-selected-pressed-icon-color: #4caf50;
  --mat-radio-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-radio-unselected-pressed-icon-color: rgba(0, 0, 0, 0.87);
}

.mat-warn .mdc-list-item__start,
.mat-warn .mdc-list-item__end {
  --mat-radio-checked-ripple-color: #f44336;
  --mat-radio-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-radio-disabled-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-disabled-unselected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-radio-ripple-color: rgba(0, 0, 0, 0.87);
  --mat-radio-selected-focus-icon-color: #f44336;
  --mat-radio-selected-hover-icon-color: #f44336;
  --mat-radio-selected-icon-color: #f44336;
  --mat-radio-selected-pressed-icon-color: #f44336;
  --mat-radio-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-radio-unselected-pressed-icon-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-list-option {
  --mat-checkbox-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-selected-checkmark-color: white;
  --mat-checkbox-selected-focus-icon-color: #03a9f4;
  --mat-checkbox-selected-hover-icon-color: #03a9f4;
  --mat-checkbox-selected-icon-color: #03a9f4;
  --mat-checkbox-selected-pressed-icon-color: #03a9f4;
  --mat-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-checkbox-selected-focus-state-layer-color: #03a9f4;
  --mat-checkbox-selected-hover-state-layer-color: #03a9f4;
  --mat-checkbox-selected-pressed-state-layer-color: #03a9f4;
  --mat-checkbox-unselected-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-pressed-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-list-option.mat-accent {
  --mat-checkbox-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-selected-checkmark-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-selected-focus-icon-color: #4caf50;
  --mat-checkbox-selected-hover-icon-color: #4caf50;
  --mat-checkbox-selected-icon-color: #4caf50;
  --mat-checkbox-selected-pressed-icon-color: #4caf50;
  --mat-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-checkbox-selected-focus-state-layer-color: #4caf50;
  --mat-checkbox-selected-hover-state-layer-color: #4caf50;
  --mat-checkbox-selected-pressed-state-layer-color: #4caf50;
  --mat-checkbox-unselected-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-pressed-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-list-option.mat-warn {
  --mat-checkbox-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-selected-checkmark-color: white;
  --mat-checkbox-selected-focus-icon-color: #f44336;
  --mat-checkbox-selected-hover-icon-color: #f44336;
  --mat-checkbox-selected-icon-color: #f44336;
  --mat-checkbox-selected-pressed-icon-color: #f44336;
  --mat-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-checkbox-selected-focus-state-layer-color: #f44336;
  --mat-checkbox-selected-hover-state-layer-color: #f44336;
  --mat-checkbox-selected-pressed-state-layer-color: #f44336;
  --mat-checkbox-unselected-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-pressed-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-list-base.mat-mdc-list-base .mdc-list-item--selected .mdc-list-item__primary-text,
.mat-mdc-list-base.mat-mdc-list-base .mdc-list-item--selected .mdc-list-item__start,
.mat-mdc-list-base.mat-mdc-list-base .mdc-list-item--activated .mdc-list-item__primary-text,
.mat-mdc-list-base.mat-mdc-list-base .mdc-list-item--activated .mdc-list-item__start {
  color: #03a9f4;
}

.mat-mdc-list-base .mdc-list-item--disabled .mdc-list-item__start,
.mat-mdc-list-base .mdc-list-item--disabled .mdc-list-item__content,
.mat-mdc-list-base .mdc-list-item--disabled .mdc-list-item__end {
  opacity: 1;
}

html {
  --mat-list-list-item-leading-icon-start-space: 16px;
  --mat-list-list-item-leading-icon-end-space: 32px;
  --mat-list-list-item-one-line-container-height: 48px;
  --mat-list-list-item-two-line-container-height: 64px;
  --mat-list-list-item-three-line-container-height: 88px;
}

.mdc-list-item__start,
.mdc-list-item__end {
  --mat-radio-state-layer-size: 40px;
  --mat-radio-touch-target-display: block;
}

.mat-mdc-list-item.mdc-list-item--with-leading-avatar.mdc-list-item--with-one-line, .mat-mdc-list-item.mdc-list-item--with-leading-checkbox.mdc-list-item--with-one-line, .mat-mdc-list-item.mdc-list-item--with-leading-icon.mdc-list-item--with-one-line {
  height: 56px;
}
.mat-mdc-list-item.mdc-list-item--with-leading-avatar.mdc-list-item--with-two-lines, .mat-mdc-list-item.mdc-list-item--with-leading-checkbox.mdc-list-item--with-two-lines, .mat-mdc-list-item.mdc-list-item--with-leading-icon.mdc-list-item--with-two-lines {
  height: 72px;
}

html {
  --mat-list-list-item-label-text-font: toyota-book;
  --mat-list-list-item-label-text-line-height: 24px;
  --mat-list-list-item-label-text-size: 16px;
  --mat-list-list-item-label-text-tracking: 0.03125em;
  --mat-list-list-item-label-text-weight: 400;
  --mat-list-list-item-supporting-text-font: toyota-book;
  --mat-list-list-item-supporting-text-line-height: 20px;
  --mat-list-list-item-supporting-text-size: 14px;
  --mat-list-list-item-supporting-text-tracking: 0.0178571429em;
  --mat-list-list-item-supporting-text-weight: 400;
  --mat-list-list-item-trailing-supporting-text-font: toyota-book;
  --mat-list-list-item-trailing-supporting-text-line-height: 20px;
  --mat-list-list-item-trailing-supporting-text-size: 12px;
  --mat-list-list-item-trailing-supporting-text-tracking: 0.0333333333em;
  --mat-list-list-item-trailing-supporting-text-weight: 400;
}

.mdc-list-group__subheader {
  font: 400 16px / 28px toyota-book;
  letter-spacing: 0.009375em;
}

html {
  --mat-paginator-page-size-select-width: 84px;
  --mat-paginator-page-size-select-touch-target-height: 48px;
}

html {
  --mat-paginator-container-text-color: rgba(0, 0, 0, 0.87);
  --mat-paginator-container-background-color: white;
  --mat-paginator-enabled-icon-color: rgba(0, 0, 0, 0.54);
  --mat-paginator-disabled-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
}

html {
  --mat-paginator-container-size: 56px;
  --mat-paginator-form-field-container-height: 40px;
  --mat-paginator-form-field-container-vertical-padding: 8px;
  --mat-paginator-touch-target-display: block;
}

html {
  --mat-paginator-container-text-font: toyota-book;
  --mat-paginator-container-text-line-height: 20px;
  --mat-paginator-container-text-size: 12px;
  --mat-paginator-container-text-tracking: 0.0333333333em;
  --mat-paginator-container-text-weight: 400;
  --mat-paginator-select-trigger-text-size: 12px;
}

html {
  --mat-tab-container-height: 48px;
  --mat-tab-divider-color: transparent;
  --mat-tab-divider-height: 0;
  --mat-tab-active-indicator-height: 2px;
  --mat-tab-active-indicator-shape: 0;
}

.mat-mdc-tab-group,
.mat-mdc-tab-nav-bar {
  --mat-tab-disabled-ripple-color: rgba(0, 0, 0, 0.54);
  --mat-tab-pagination-icon-color: rgba(0, 0, 0, 0.87);
  --mat-tab-inactive-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-active-label-text-color: #03a9f4;
  --mat-tab-active-ripple-color: #03a9f4;
  --mat-tab-inactive-ripple-color: #03a9f4;
  --mat-tab-inactive-focus-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-inactive-hover-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-active-focus-label-text-color: #03a9f4;
  --mat-tab-active-hover-label-text-color: #03a9f4;
  --mat-tab-active-focus-indicator-color: #03a9f4;
  --mat-tab-active-hover-indicator-color: #03a9f4;
  --mat-tab-active-indicator-color: #03a9f4;
}
.mat-mdc-tab-group.mat-accent,
.mat-mdc-tab-nav-bar.mat-accent {
  --mat-tab-disabled-ripple-color: rgba(0, 0, 0, 0.54);
  --mat-tab-pagination-icon-color: rgba(0, 0, 0, 0.87);
  --mat-tab-inactive-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-active-label-text-color: #4caf50;
  --mat-tab-active-ripple-color: #4caf50;
  --mat-tab-inactive-ripple-color: #4caf50;
  --mat-tab-inactive-focus-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-inactive-hover-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-active-focus-label-text-color: #4caf50;
  --mat-tab-active-hover-label-text-color: #4caf50;
  --mat-tab-active-focus-indicator-color: #4caf50;
  --mat-tab-active-hover-indicator-color: #4caf50;
  --mat-tab-active-indicator-color: #4caf50;
}
.mat-mdc-tab-group.mat-warn,
.mat-mdc-tab-nav-bar.mat-warn {
  --mat-tab-disabled-ripple-color: rgba(0, 0, 0, 0.54);
  --mat-tab-pagination-icon-color: rgba(0, 0, 0, 0.87);
  --mat-tab-inactive-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-active-label-text-color: #f44336;
  --mat-tab-active-ripple-color: #f44336;
  --mat-tab-inactive-ripple-color: #f44336;
  --mat-tab-inactive-focus-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-inactive-hover-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-active-focus-label-text-color: #f44336;
  --mat-tab-active-hover-label-text-color: #f44336;
  --mat-tab-active-focus-indicator-color: #f44336;
  --mat-tab-active-hover-indicator-color: #f44336;
  --mat-tab-active-indicator-color: #f44336;
}
.mat-mdc-tab-group.mat-background-primary,
.mat-mdc-tab-nav-bar.mat-background-primary {
  --mat-tab-background-color: #03a9f4;
  --mat-tab-foreground-color: white;
}
.mat-mdc-tab-group.mat-background-accent,
.mat-mdc-tab-nav-bar.mat-background-accent {
  --mat-tab-background-color: #4caf50;
  --mat-tab-foreground-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-tab-group.mat-background-warn,
.mat-mdc-tab-nav-bar.mat-background-warn {
  --mat-tab-background-color: #f44336;
  --mat-tab-foreground-color: white;
}

.mat-mdc-tab-header {
  --mat-tab-container-height: 48px;
}

.mat-mdc-tab-header {
  --mat-tab-label-text-font: toyota-book;
  --mat-tab-label-text-size: 14px;
  --mat-tab-label-text-tracking: 0.0892857143em;
  --mat-tab-label-text-line-height: 36px;
  --mat-tab-label-text-weight: 500;
}

html {
  --mat-checkbox-disabled-selected-checkmark-color: white;
  --mat-checkbox-selected-focus-state-layer-opacity: 0.12;
  --mat-checkbox-selected-hover-state-layer-opacity: 0.04;
  --mat-checkbox-selected-pressed-state-layer-opacity: 0.12;
  --mat-checkbox-unselected-focus-state-layer-opacity: 0.12;
  --mat-checkbox-unselected-hover-state-layer-opacity: 0.04;
  --mat-checkbox-unselected-pressed-state-layer-opacity: 0.12;
  --mat-checkbox-touch-target-size: 48px;
}

html {
  --mat-checkbox-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-selected-checkmark-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-selected-focus-icon-color: #4caf50;
  --mat-checkbox-selected-hover-icon-color: #4caf50;
  --mat-checkbox-selected-icon-color: #4caf50;
  --mat-checkbox-selected-pressed-icon-color: #4caf50;
  --mat-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-checkbox-selected-focus-state-layer-color: #4caf50;
  --mat-checkbox-selected-hover-state-layer-color: #4caf50;
  --mat-checkbox-selected-pressed-state-layer-color: #4caf50;
  --mat-checkbox-unselected-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-pressed-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-checkbox.mat-primary {
  --mat-checkbox-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-selected-checkmark-color: white;
  --mat-checkbox-selected-focus-icon-color: #03a9f4;
  --mat-checkbox-selected-hover-icon-color: #03a9f4;
  --mat-checkbox-selected-icon-color: #03a9f4;
  --mat-checkbox-selected-pressed-icon-color: #03a9f4;
  --mat-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-checkbox-selected-focus-state-layer-color: #03a9f4;
  --mat-checkbox-selected-hover-state-layer-color: #03a9f4;
  --mat-checkbox-selected-pressed-state-layer-color: #03a9f4;
  --mat-checkbox-unselected-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-pressed-state-layer-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-checkbox.mat-warn {
  --mat-checkbox-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-selected-checkmark-color: white;
  --mat-checkbox-selected-focus-icon-color: #f44336;
  --mat-checkbox-selected-hover-icon-color: #f44336;
  --mat-checkbox-selected-icon-color: #f44336;
  --mat-checkbox-selected-pressed-icon-color: #f44336;
  --mat-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-checkbox-selected-focus-state-layer-color: #f44336;
  --mat-checkbox-selected-hover-state-layer-color: #f44336;
  --mat-checkbox-selected-pressed-state-layer-color: #f44336;
  --mat-checkbox-unselected-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-pressed-state-layer-color: rgba(0, 0, 0, 0.87);
}

html {
  --mat-checkbox-touch-target-display: block;
  --mat-checkbox-state-layer-size: 40px;
}

html {
  --mat-checkbox-label-text-font: toyota-book;
  --mat-checkbox-label-text-line-height: 20px;
  --mat-checkbox-label-text-size: 14px;
  --mat-checkbox-label-text-tracking: 0.0178571429em;
  --mat-checkbox-label-text-weight: 400;
}

html {
  --mat-button-filled-container-shape: 4px;
  --mat-button-filled-horizontal-padding: 16px;
  --mat-button-filled-icon-offset: -4px;
  --mat-button-filled-icon-spacing: 8px;
  --mat-button-filled-touch-target-size: 48px;
  --mat-button-outlined-container-shape: 4px;
  --mat-button-outlined-horizontal-padding: 15px;
  --mat-button-outlined-icon-offset: -4px;
  --mat-button-outlined-icon-spacing: 8px;
  --mat-button-outlined-keep-touch-target: false;
  --mat-button-outlined-outline-width: 1px;
  --mat-button-outlined-touch-target-size: 48px;
  --mat-button-protected-container-elevation-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-container-shape: 4px;
  --mat-button-protected-disabled-container-elevation-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-focus-container-elevation-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-horizontal-padding: 16px;
  --mat-button-protected-hover-container-elevation-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-icon-offset: -4px;
  --mat-button-protected-icon-spacing: 8px;
  --mat-button-protected-pressed-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-button-protected-touch-target-size: 48px;
  --mat-button-text-container-shape: 4px;
  --mat-button-text-horizontal-padding: 8px;
  --mat-button-text-icon-offset: 0;
  --mat-button-text-icon-spacing: 8px;
  --mat-button-text-with-icon-horizontal-padding: 8px;
  --mat-button-text-touch-target-size: 48px;
  --mat-button-tonal-container-shape: 4px;
  --mat-button-tonal-horizontal-padding: 16px;
  --mat-button-tonal-icon-offset: -4px;
  --mat-button-tonal-icon-spacing: 8px;
  --mat-button-tonal-touch-target-size: 48px;
}

html {
  --mat-button-filled-container-color: white;
  --mat-button-filled-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-filled-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-filled-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-filled-focus-state-layer-opacity: 0.12;
  --mat-button-filled-hover-state-layer-opacity: 0.04;
  --mat-button-filled-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-filled-pressed-state-layer-opacity: 0.12;
  --mat-button-filled-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-filled-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-outlined-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-outlined-disabled-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-outlined-focus-state-layer-opacity: 0.12;
  --mat-button-outlined-hover-state-layer-opacity: 0.04;
  --mat-button-outlined-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-pressed-state-layer-opacity: 0.12;
  --mat-button-outlined-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-outlined-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-protected-container-color: white;
  --mat-button-protected-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-protected-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-protected-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-protected-focus-state-layer-opacity: 0.12;
  --mat-button-protected-hover-state-layer-opacity: 0.04;
  --mat-button-protected-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-protected-pressed-state-layer-opacity: 0.12;
  --mat-button-protected-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-protected-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-text-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-text-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-text-focus-state-layer-opacity: 0.12;
  --mat-button-text-hover-state-layer-opacity: 0.04;
  --mat-button-text-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-text-pressed-state-layer-opacity: 0.12;
  --mat-button-text-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-text-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-tonal-container-color: white;
  --mat-button-tonal-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-tonal-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-tonal-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-tonal-focus-state-layer-opacity: 0.12;
  --mat-button-tonal-hover-state-layer-opacity: 0.04;
  --mat-button-tonal-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-tonal-pressed-state-layer-opacity: 0.12;
  --mat-button-tonal-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-tonal-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-button.mat-primary,
.mat-mdc-unelevated-button.mat-primary,
.mat-mdc-raised-button.mat-primary,
.mat-mdc-outlined-button.mat-primary,
.mat-tonal-button.mat-primary {
  --mat-button-filled-container-color: #03a9f4;
  --mat-button-filled-label-text-color: white;
  --mat-button-filled-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-filled-state-layer-color: white;
  --mat-button-outlined-label-text-color: #03a9f4;
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-button-outlined-state-layer-color: #03a9f4;
  --mat-button-protected-container-color: #03a9f4;
  --mat-button-protected-label-text-color: white;
  --mat-button-protected-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-protected-state-layer-color: white;
  --mat-button-text-label-text-color: #03a9f4;
  --mat-button-text-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-button-text-state-layer-color: #03a9f4;
  --mat-button-tonal-container-color: #03a9f4;
  --mat-button-tonal-label-text-color: white;
  --mat-button-tonal-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-tonal-state-layer-color: white;
}
.mat-mdc-button.mat-accent,
.mat-mdc-unelevated-button.mat-accent,
.mat-mdc-raised-button.mat-accent,
.mat-mdc-outlined-button.mat-accent,
.mat-tonal-button.mat-accent {
  --mat-button-filled-container-color: #4caf50;
  --mat-button-filled-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-filled-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-filled-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-outlined-label-text-color: #4caf50;
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-ripple-color: color-mix(in srgb, #4caf50 12%, transparent);
  --mat-button-outlined-state-layer-color: #4caf50;
  --mat-button-protected-container-color: #4caf50;
  --mat-button-protected-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-protected-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-protected-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-text-label-text-color: #4caf50;
  --mat-button-text-ripple-color: color-mix(in srgb, #4caf50 12%, transparent);
  --mat-button-text-state-layer-color: #4caf50;
  --mat-button-tonal-container-color: #4caf50;
  --mat-button-tonal-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-tonal-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-tonal-state-layer-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-button.mat-warn,
.mat-mdc-unelevated-button.mat-warn,
.mat-mdc-raised-button.mat-warn,
.mat-mdc-outlined-button.mat-warn,
.mat-tonal-button.mat-warn {
  --mat-button-filled-container-color: #f44336;
  --mat-button-filled-label-text-color: white;
  --mat-button-filled-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-filled-state-layer-color: white;
  --mat-button-outlined-label-text-color: #f44336;
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-button-outlined-state-layer-color: #f44336;
  --mat-button-protected-container-color: #f44336;
  --mat-button-protected-label-text-color: white;
  --mat-button-protected-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-protected-state-layer-color: white;
  --mat-button-text-label-text-color: #f44336;
  --mat-button-text-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-button-text-state-layer-color: #f44336;
  --mat-button-tonal-container-color: #f44336;
  --mat-button-tonal-label-text-color: white;
  --mat-button-tonal-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-tonal-state-layer-color: white;
}

html {
  --mat-button-filled-container-height: 36px;
  --mat-button-filled-touch-target-display: block;
  --mat-button-outlined-container-height: 36px;
  --mat-button-outlined-touch-target-display: block;
  --mat-button-protected-container-height: 36px;
  --mat-button-protected-touch-target-display: block;
  --mat-button-text-container-height: 36px;
  --mat-button-text-touch-target-display: block;
  --mat-button-tonal-container-height: 36px;
  --mat-button-tonal-touch-target-display: block;
}

html {
  --mat-button-filled-label-text-font: toyota-book;
  --mat-button-filled-label-text-size: 14px;
  --mat-button-filled-label-text-tracking: 0.0892857143em;
  --mat-button-filled-label-text-transform: none;
  --mat-button-filled-label-text-weight: 500;
  --mat-button-outlined-label-text-font: toyota-book;
  --mat-button-outlined-label-text-size: 14px;
  --mat-button-outlined-label-text-tracking: 0.0892857143em;
  --mat-button-outlined-label-text-transform: none;
  --mat-button-outlined-label-text-weight: 500;
  --mat-button-protected-label-text-font: toyota-book;
  --mat-button-protected-label-text-size: 14px;
  --mat-button-protected-label-text-tracking: 0.0892857143em;
  --mat-button-protected-label-text-transform: none;
  --mat-button-protected-label-text-weight: 500;
  --mat-button-text-label-text-font: toyota-book;
  --mat-button-text-label-text-size: 14px;
  --mat-button-text-label-text-tracking: 0.0892857143em;
  --mat-button-text-label-text-transform: none;
  --mat-button-text-label-text-weight: 500;
  --mat-button-tonal-label-text-font: toyota-book;
  --mat-button-tonal-label-text-size: 14px;
  --mat-button-tonal-label-text-tracking: 0.0892857143em;
  --mat-button-tonal-label-text-transform: none;
  --mat-button-tonal-label-text-weight: 500;
}

html {
  --mat-icon-button-icon-size: 24px;
  --mat-icon-button-container-shape: 50%;
  --mat-icon-button-touch-target-size: 48px;
}

html {
  --mat-icon-button-disabled-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-icon-button-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-icon-button-focus-state-layer-opacity: 0.12;
  --mat-icon-button-hover-state-layer-opacity: 0.04;
  --mat-icon-button-icon-color: inherit;
  --mat-icon-button-pressed-state-layer-opacity: 0.12;
  --mat-icon-button-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-icon-button-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-icon-button.mat-primary {
  --mat-icon-button-icon-color: #03a9f4;
  --mat-icon-button-state-layer-color: #03a9f4;
  --mat-icon-button-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
}
.mat-mdc-icon-button.mat-accent {
  --mat-icon-button-icon-color: #4caf50;
  --mat-icon-button-state-layer-color: #4caf50;
  --mat-icon-button-ripple-color: color-mix(in srgb, #4caf50 12%, transparent);
}
.mat-mdc-icon-button.mat-warn {
  --mat-icon-button-icon-color: #f44336;
  --mat-icon-button-state-layer-color: #f44336;
  --mat-icon-button-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
}

html {
  --mat-icon-button-touch-target-display: block;
}

.mat-mdc-icon-button.mat-mdc-button-base {
  --mdc-icon-button-state-layer-size: 48px;
  --mat-icon-button-state-layer-size: 48px;
  width: var(--mat-icon-button-state-layer-size);
  height: var(--mat-icon-button-state-layer-size);
  padding: 12px;
}

html {
  --mat-fab-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-container-shape: 50%;
  --mat-fab-touch-target-size: 48px;
  --mat-fab-extended-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-extended-container-height: 48px;
  --mat-fab-extended-container-shape: 24px;
  --mat-fab-extended-focus-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-extended-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-extended-pressed-container-elevation-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  --mat-fab-focus-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-pressed-container-elevation-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  --mat-fab-small-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-small-container-shape: 50%;
  --mat-fab-small-touch-target-size: 48px;
  --mat-fab-small-focus-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-small-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-small-pressed-container-elevation-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
}

html {
  --mat-fab-container-color: white;
  --mat-fab-disabled-state-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-disabled-state-foreground-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-fab-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-fab-focus-state-layer-opacity: 0.12;
  --mat-fab-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-fab-hover-state-layer-opacity: 0.04;
  --mat-fab-pressed-state-layer-opacity: 0.12;
  --mat-fab-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-small-container-color: white;
  --mat-fab-small-disabled-state-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-small-disabled-state-foreground-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-fab-small-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-fab-small-focus-state-layer-opacity: 0.12;
  --mat-fab-small-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-fab-small-hover-state-layer-opacity: 0.04;
  --mat-fab-small-pressed-state-layer-opacity: 0.12;
  --mat-fab-small-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-small-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-fab-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-fab.mat-primary, .mat-mdc-mini-fab.mat-primary {
  --mat-fab-container-color: #03a9f4;
  --mat-fab-foreground-color: white;
  --mat-fab-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-fab-small-container-color: #03a9f4;
  --mat-fab-small-foreground-color: white;
  --mat-fab-small-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-fab-small-state-layer-color: white;
  --mat-fab-state-layer-color: white;
}
.mat-mdc-fab.mat-accent, .mat-mdc-mini-fab.mat-accent {
  --mat-fab-container-color: #4caf50;
  --mat-fab-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-fab-ripple-color: color-mix(in srgb, #4caf50 12%, transparent);
  --mat-fab-small-container-color: #4caf50;
  --mat-fab-small-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-fab-small-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-small-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-fab-state-layer-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-fab.mat-warn, .mat-mdc-mini-fab.mat-warn {
  --mat-fab-container-color: #f44336;
  --mat-fab-foreground-color: white;
  --mat-fab-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-fab-small-container-color: #f44336;
  --mat-fab-small-foreground-color: white;
  --mat-fab-small-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-fab-small-state-layer-color: white;
  --mat-fab-state-layer-color: white;
}

html {
  --mat-fab-small-touch-target-display: block;
  --mat-fab-touch-target-display: block;
}

html {
  --mat-fab-extended-label-text-font: toyota-book;
  --mat-fab-extended-label-text-size: 14px;
  --mat-fab-extended-label-text-tracking: 0.0892857143em;
  --mat-fab-extended-label-text-weight: 500;
}

html {
  --mat-snack-bar-container-shape: 4px;
}

html {
  --mat-snack-bar-container-color: #424242;
  --mat-snack-bar-supporting-text-color: white;
  --mat-snack-bar-button-color: #4fc3f7;
}

html {
  --mat-snack-bar-supporting-text-font: toyota-book;
  --mat-snack-bar-supporting-text-line-height: 20px;
  --mat-snack-bar-supporting-text-size: 14px;
  --mat-snack-bar-supporting-text-weight: 400;
}

html {
  --mat-table-row-item-outline-width: 1px;
}

html {
  --mat-table-background-color: white;
  --mat-table-header-headline-color: rgba(0, 0, 0, 0.87);
  --mat-table-row-item-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-table-row-item-outline-color: rgba(0, 0, 0, 0.12);
}

html {
  --mat-table-header-container-height: 56px;
  --mat-table-footer-container-height: 52px;
  --mat-table-row-item-container-height: 52px;
}

html {
  --mat-table-header-headline-font: toyota-book;
  --mat-table-header-headline-line-height: 22px;
  --mat-table-header-headline-size: 14px;
  --mat-table-header-headline-weight: 500;
  --mat-table-header-headline-tracking: 0.0071428571em;
  --mat-table-row-item-label-text-font: toyota-book;
  --mat-table-row-item-label-text-line-height: 20px;
  --mat-table-row-item-label-text-size: 14px;
  --mat-table-row-item-label-text-weight: 400;
  --mat-table-row-item-label-text-tracking: 0.0178571429em;
  --mat-table-footer-supporting-text-font: toyota-book;
  --mat-table-footer-supporting-text-line-height: 20px;
  --mat-table-footer-supporting-text-size: 14px;
  --mat-table-footer-supporting-text-weight: 400;
  --mat-table-footer-supporting-text-tracking: 0.0178571429em;
}

html {
  --mat-progress-spinner-active-indicator-width: 4px;
  --mat-progress-spinner-size: 48px;
}

html {
  --mat-progress-spinner-active-indicator-color: #03a9f4;
}

.mat-accent {
  --mat-progress-spinner-active-indicator-color: #4caf50;
}

.mat-warn {
  --mat-progress-spinner-active-indicator-color: #f44336;
}

html {
  --mat-badge-container-shape: 50%;
  --mat-badge-container-size: unset;
  --mat-badge-small-size-container-size: unset;
  --mat-badge-large-size-container-size: unset;
  --mat-badge-legacy-container-size: 22px;
  --mat-badge-legacy-small-size-container-size: 16px;
  --mat-badge-legacy-large-size-container-size: 28px;
  --mat-badge-container-offset: -11px 0;
  --mat-badge-small-size-container-offset: -8px 0;
  --mat-badge-large-size-container-offset: -14px 0;
  --mat-badge-container-overlap-offset: -11px;
  --mat-badge-small-size-container-overlap-offset: -8px;
  --mat-badge-large-size-container-overlap-offset: -14px;
  --mat-badge-container-padding: 0;
  --mat-badge-small-size-container-padding: 0;
  --mat-badge-large-size-container-padding: 0;
}

html {
  --mat-badge-background-color: #03a9f4;
  --mat-badge-text-color: white;
  --mat-badge-disabled-state-background-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-badge-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
}

.mat-badge-accent {
  --mat-badge-background-color: #4caf50;
  --mat-badge-text-color: rgba(0, 0, 0, 0.87);
}

.mat-badge-warn {
  --mat-badge-background-color: #f44336;
  --mat-badge-text-color: white;
}

html {
  --mat-badge-text-font: toyota-book;
  --mat-badge-line-height: 22px;
  --mat-badge-text-size: 12px;
  --mat-badge-text-weight: 600;
  --mat-badge-small-size-text-size: 9px;
  --mat-badge-small-size-line-height: 16px;
  --mat-badge-large-size-text-size: 24px;
  --mat-badge-large-size-line-height: 28px;
}

html {
  --mat-bottom-sheet-container-shape: 4px;
}

html {
  --mat-bottom-sheet-container-text-color: rgba(0, 0, 0, 0.87);
  --mat-bottom-sheet-container-background-color: white;
}

html {
  --mat-bottom-sheet-container-text-font: toyota-book;
  --mat-bottom-sheet-container-text-line-height: 20px;
  --mat-bottom-sheet-container-text-size: 14px;
  --mat-bottom-sheet-container-text-tracking: 0.0178571429em;
  --mat-bottom-sheet-container-text-weight: 400;
}

html {
  --mat-button-toggle-focus-state-layer-opacity: 0.12;
  --mat-button-toggle-hover-state-layer-opacity: 0.04;
  --mat-button-toggle-legacy-focus-state-layer-opacity: 1;
  --mat-button-toggle-legacy-height: 36px;
  --mat-button-toggle-legacy-shape: 2px;
  --mat-button-toggle-shape: 4px;
}

html {
  --mat-button-toggle-background-color: white;
  --mat-button-toggle-disabled-selected-state-background-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-toggle-disabled-selected-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-toggle-disabled-state-background-color: white;
  --mat-button-toggle-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-toggle-divider-color: rgba(0, 0, 0, 0.12);
  --mat-button-toggle-legacy-disabled-selected-state-background-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-toggle-legacy-disabled-state-background-color: white;
  --mat-button-toggle-legacy-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-toggle-legacy-selected-state-background-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-toggle-legacy-selected-state-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-toggle-legacy-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-toggle-legacy-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-toggle-selected-state-background-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-toggle-selected-state-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-toggle-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-toggle-text-color: rgba(0, 0, 0, 0.87);
}

html {
  --mat-button-toggle-height: 48px;
}

html {
  --mat-button-toggle-label-text-font: toyota-book;
  --mat-button-toggle-label-text-line-height: 24px;
  --mat-button-toggle-label-text-size: 16px;
  --mat-button-toggle-label-text-tracking: 0.03125em;
  --mat-button-toggle-label-text-weight: 400;
  --mat-button-toggle-legacy-label-text-font: toyota-book;
  --mat-button-toggle-legacy-label-text-line-height: 24px;
  --mat-button-toggle-legacy-label-text-size: 16px;
  --mat-button-toggle-legacy-label-text-tracking: 0.03125em;
  --mat-button-toggle-legacy-label-text-weight: 400;
}

html {
  --mat-datepicker-calendar-container-shape: 4px;
  --mat-datepicker-calendar-container-touch-shape: 4px;
  --mat-datepicker-calendar-container-elevation-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  --mat-datepicker-calendar-container-touch-elevation-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
}

html {
  --mat-datepicker-calendar-date-in-range-state-background-color: color-mix(in srgb, #03a9f4 20%, transparent);
  --mat-datepicker-calendar-date-in-comparison-range-state-background-color: color-mix(in srgb, #4caf50 20%, transparent);
  --mat-datepicker-calendar-date-in-overlap-range-state-background-color: #a8dab5;
  --mat-datepicker-calendar-date-in-overlap-range-selected-state-background-color: rgb(69.5241935484, 163.4758064516, 93.9516129032);
  --mat-datepicker-calendar-date-selected-state-text-color: white;
  --mat-datepicker-calendar-date-selected-state-background-color: #03a9f4;
  --mat-datepicker-calendar-date-selected-disabled-state-background-color: color-mix(in srgb, #03a9f4 38%, transparent);
  --mat-datepicker-calendar-date-today-selected-state-outline-color: white;
  --mat-datepicker-calendar-date-focus-state-background-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-datepicker-calendar-date-hover-state-background-color: color-mix(in srgb, #03a9f4 4%, transparent);
  --mat-datepicker-toggle-active-state-icon-color: #03a9f4;
  --mat-datepicker-toggle-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-body-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-period-button-text-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-period-button-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-navigation-button-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-header-divider-color: rgba(0, 0, 0, 0.12);
  --mat-datepicker-calendar-header-text-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-date-today-outline-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-date-today-disabled-state-outline-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-date-text-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-date-outline-color: transparent;
  --mat-datepicker-calendar-date-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-date-preview-state-outline-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-range-input-separator-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-range-input-disabled-state-separator-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-range-input-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-container-background-color: white;
  --mat-datepicker-calendar-container-text-color: rgba(0, 0, 0, 0.87);
}

.mat-datepicker-content.mat-accent, .mat-datepicker-toggle-active.mat-accent {
  --mat-datepicker-calendar-date-in-range-state-background-color: color-mix(in srgb, #4caf50 20%, transparent);
  --mat-datepicker-calendar-date-in-comparison-range-state-background-color: color-mix(in srgb, #4caf50 20%, transparent);
  --mat-datepicker-calendar-date-in-overlap-range-state-background-color: #a8dab5;
  --mat-datepicker-calendar-date-in-overlap-range-selected-state-background-color: rgb(69.5241935484, 163.4758064516, 93.9516129032);
  --mat-datepicker-calendar-date-selected-state-text-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-date-selected-state-background-color: #4caf50;
  --mat-datepicker-calendar-date-selected-disabled-state-background-color: color-mix(in srgb, #4caf50 38%, transparent);
  --mat-datepicker-calendar-date-today-selected-state-outline-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-date-focus-state-background-color: color-mix(in srgb, #4caf50 12%, transparent);
  --mat-datepicker-calendar-date-hover-state-background-color: color-mix(in srgb, #4caf50 4%, transparent);
  --mat-datepicker-toggle-active-state-icon-color: #4caf50;
  --mat-datepicker-toggle-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-body-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-period-button-text-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-period-button-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-navigation-button-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-header-divider-color: rgba(0, 0, 0, 0.12);
  --mat-datepicker-calendar-header-text-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-date-today-outline-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-date-today-disabled-state-outline-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-date-text-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-date-outline-color: transparent;
  --mat-datepicker-calendar-date-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-date-preview-state-outline-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-range-input-separator-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-range-input-disabled-state-separator-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-range-input-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-container-background-color: white;
  --mat-datepicker-calendar-container-text-color: rgba(0, 0, 0, 0.87);
}
.mat-datepicker-content.mat-warn, .mat-datepicker-toggle-active.mat-warn {
  --mat-datepicker-calendar-date-in-range-state-background-color: color-mix(in srgb, #f44336 20%, transparent);
  --mat-datepicker-calendar-date-in-comparison-range-state-background-color: color-mix(in srgb, #4caf50 20%, transparent);
  --mat-datepicker-calendar-date-in-overlap-range-state-background-color: #a8dab5;
  --mat-datepicker-calendar-date-in-overlap-range-selected-state-background-color: rgb(69.5241935484, 163.4758064516, 93.9516129032);
  --mat-datepicker-calendar-date-selected-state-text-color: white;
  --mat-datepicker-calendar-date-selected-state-background-color: #f44336;
  --mat-datepicker-calendar-date-selected-disabled-state-background-color: color-mix(in srgb, #f44336 38%, transparent);
  --mat-datepicker-calendar-date-today-selected-state-outline-color: white;
  --mat-datepicker-calendar-date-focus-state-background-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-datepicker-calendar-date-hover-state-background-color: color-mix(in srgb, #f44336 4%, transparent);
  --mat-datepicker-toggle-active-state-icon-color: #f44336;
  --mat-datepicker-toggle-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-body-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-period-button-text-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-period-button-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-navigation-button-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-header-divider-color: rgba(0, 0, 0, 0.12);
  --mat-datepicker-calendar-header-text-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-date-today-outline-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-date-today-disabled-state-outline-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-date-text-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-date-outline-color: transparent;
  --mat-datepicker-calendar-date-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-date-preview-state-outline-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-range-input-separator-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-range-input-disabled-state-separator-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-range-input-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-container-background-color: white;
  --mat-datepicker-calendar-container-text-color: rgba(0, 0, 0, 0.87);
}

.mat-calendar-controls {
  --mat-icon-button-touch-target-display: none;
}
.mat-calendar-controls .mat-mdc-icon-button.mat-mdc-button-base {
  --mdc-icon-button-state-layer-size: 40px;
  --mat-icon-button-state-layer-size: 40px;
  width: var(--mat-icon-button-state-layer-size);
  height: var(--mat-icon-button-state-layer-size);
  padding: 8px;
}

html {
  --mat-datepicker-calendar-text-font: toyota-book;
  --mat-datepicker-calendar-text-size: 13px;
  --mat-datepicker-calendar-body-label-text-size: 14px;
  --mat-datepicker-calendar-body-label-text-weight: 500;
  --mat-datepicker-calendar-period-button-text-size: 14px;
  --mat-datepicker-calendar-period-button-text-weight: 500;
  --mat-datepicker-calendar-header-text-size: 11px;
  --mat-datepicker-calendar-header-text-weight: 400;
}

html {
  --mat-divider-width: 1px;
}

html {
  --mat-divider-color: rgba(0, 0, 0, 0.12);
}

html {
  --mat-expansion-container-shape: 4px;
  --mat-expansion-container-elevation-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  --mat-expansion-legacy-header-indicator-display: inline-block;
  --mat-expansion-header-indicator-display: none;
}

html {
  --mat-expansion-container-background-color: white;
  --mat-expansion-container-text-color: rgba(0, 0, 0, 0.87);
  --mat-expansion-actions-divider-color: rgba(0, 0, 0, 0.12);
  --mat-expansion-header-hover-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 4%, transparent);
  --mat-expansion-header-focus-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-expansion-header-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-expansion-header-text-color: rgba(0, 0, 0, 0.87);
  --mat-expansion-header-description-color: rgba(0, 0, 0, 0.54);
  --mat-expansion-header-indicator-color: rgba(0, 0, 0, 0.54);
}

html {
  --mat-expansion-header-collapsed-state-height: 48px;
  --mat-expansion-header-expanded-state-height: 64px;
}

html {
  --mat-expansion-header-text-font: toyota-book;
  --mat-expansion-header-text-size: 14px;
  --mat-expansion-header-text-weight: 500;
  --mat-expansion-header-text-line-height: inherit;
  --mat-expansion-header-text-tracking: inherit;
  --mat-expansion-container-text-font: toyota-book;
  --mat-expansion-container-text-line-height: 20px;
  --mat-expansion-container-text-size: 14px;
  --mat-expansion-container-text-tracking: 0.0178571429em;
  --mat-expansion-container-text-weight: 400;
}

html {
  --mat-grid-list-tile-header-primary-text-size: 14px;
  --mat-grid-list-tile-header-secondary-text-size: 12px;
  --mat-grid-list-tile-footer-primary-text-size: 14px;
  --mat-grid-list-tile-footer-secondary-text-size: 12px;
}

html {
  --mat-icon-color: inherit;
}

.mat-icon.mat-primary {
  --mat-icon-color: #03a9f4;
}
.mat-icon.mat-accent {
  --mat-icon-color: #4caf50;
}
.mat-icon.mat-warn {
  --mat-icon-color: #f44336;
}

html {
  --mat-sidenav-container-shape: 0;
  --mat-sidenav-container-elevation-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);
  --mat-sidenav-container-width: auto;
}

html {
  --mat-sidenav-container-divider-color: rgba(0, 0, 0, 0.12);
  --mat-sidenav-container-background-color: white;
  --mat-sidenav-container-text-color: rgba(0, 0, 0, 0.87);
  --mat-sidenav-content-background-color: #fafafa;
  --mat-sidenav-content-text-color: rgba(0, 0, 0, 0.87);
  --mat-sidenav-scrim-color: rgba(0, 0, 0, 0.6);
}

html {
  --mat-stepper-header-focus-state-layer-shape: 0;
  --mat-stepper-header-hover-state-layer-shape: 0;
}

html {
  --mat-stepper-header-icon-foreground-color: white;
  --mat-stepper-header-selected-state-icon-background-color: #03a9f4;
  --mat-stepper-header-selected-state-icon-foreground-color: white;
  --mat-stepper-header-done-state-icon-background-color: #03a9f4;
  --mat-stepper-header-done-state-icon-foreground-color: white;
  --mat-stepper-header-edit-state-icon-background-color: #03a9f4;
  --mat-stepper-header-edit-state-icon-foreground-color: white;
  --mat-stepper-container-color: white;
  --mat-stepper-line-color: rgba(0, 0, 0, 0.12);
  --mat-stepper-header-hover-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 4%, transparent);
  --mat-stepper-header-focus-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-stepper-header-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-stepper-header-optional-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-stepper-header-selected-state-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-stepper-header-error-state-label-text-color: #f44336;
  --mat-stepper-header-icon-background-color: rgba(0, 0, 0, 0.54);
  --mat-stepper-header-error-state-icon-foreground-color: #f44336;
  --mat-stepper-header-error-state-icon-background-color: transparent;
}

.mat-step-header.mat-accent {
  --mat-stepper-header-icon-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-stepper-header-selected-state-icon-background-color: #4caf50;
  --mat-stepper-header-selected-state-icon-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-stepper-header-done-state-icon-background-color: #4caf50;
  --mat-stepper-header-done-state-icon-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-stepper-header-edit-state-icon-background-color: #4caf50;
  --mat-stepper-header-edit-state-icon-foreground-color: rgba(0, 0, 0, 0.87);
}

.mat-step-header.mat-warn {
  --mat-stepper-header-icon-foreground-color: white;
  --mat-stepper-header-selected-state-icon-background-color: #f44336;
  --mat-stepper-header-selected-state-icon-foreground-color: white;
  --mat-stepper-header-done-state-icon-background-color: #f44336;
  --mat-stepper-header-done-state-icon-foreground-color: white;
  --mat-stepper-header-edit-state-icon-background-color: #f44336;
  --mat-stepper-header-edit-state-icon-foreground-color: white;
}

html {
  --mat-stepper-header-height: 72px;
}

html {
  --mat-stepper-container-text-font: toyota-book;
  --mat-stepper-header-label-text-font: toyota-book;
  --mat-stepper-header-label-text-size: 14px;
  --mat-stepper-header-label-text-weight: 400;
  --mat-stepper-header-error-state-label-text-size: 16px;
  --mat-stepper-header-selected-state-label-text-size: 16px;
  --mat-stepper-header-selected-state-label-text-weight: 400;
}

html {
  --mat-sort-arrow-color: rgba(0, 0, 0, 0.87);
}

html {
  --mat-toolbar-container-background-color: white;
  --mat-toolbar-container-text-color: rgba(0, 0, 0, 0.87);
}

.mat-toolbar.mat-primary {
  --mat-toolbar-container-background-color: #03a9f4;
  --mat-toolbar-container-text-color: white;
}
.mat-toolbar.mat-accent {
  --mat-toolbar-container-background-color: #4caf50;
  --mat-toolbar-container-text-color: rgba(0, 0, 0, 0.87);
}
.mat-toolbar.mat-warn {
  --mat-toolbar-container-background-color: #f44336;
  --mat-toolbar-container-text-color: white;
}

html {
  --mat-toolbar-standard-height: 64px;
  --mat-toolbar-mobile-height: 56px;
}

html {
  --mat-toolbar-title-text-font: toyota-book;
  --mat-toolbar-title-text-line-height: 32px;
  --mat-toolbar-title-text-size: 20px;
  --mat-toolbar-title-text-tracking: 0.0125em;
  --mat-toolbar-title-text-weight: 500;
}

html {
  --mat-tree-container-background-color: white;
  --mat-tree-node-text-color: rgba(0, 0, 0, 0.87);
}

html {
  --mat-tree-node-min-height: 48px;
}

html {
  --mat-tree-node-text-font: toyota-book;
  --mat-tree-node-text-size: 14px;
  --mat-tree-node-text-weight: 400;
}

html {
  --mat-timepicker-container-shape: 4px;
  --mat-timepicker-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

html {
  --mat-timepicker-container-background-color: white;
}

html {
  --mat-button-filled-container-shape: 4px;
  --mat-button-filled-horizontal-padding: 16px;
  --mat-button-filled-icon-offset: -4px;
  --mat-button-filled-icon-spacing: 8px;
  --mat-button-filled-touch-target-size: 48px;
  --mat-button-outlined-container-shape: 4px;
  --mat-button-outlined-horizontal-padding: 15px;
  --mat-button-outlined-icon-offset: -4px;
  --mat-button-outlined-icon-spacing: 8px;
  --mat-button-outlined-keep-touch-target: false;
  --mat-button-outlined-outline-width: 1px;
  --mat-button-outlined-touch-target-size: 48px;
  --mat-button-protected-container-elevation-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-container-shape: 4px;
  --mat-button-protected-disabled-container-elevation-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-focus-container-elevation-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-horizontal-padding: 16px;
  --mat-button-protected-hover-container-elevation-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-icon-offset: -4px;
  --mat-button-protected-icon-spacing: 8px;
  --mat-button-protected-pressed-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-button-protected-touch-target-size: 48px;
  --mat-button-text-container-shape: 4px;
  --mat-button-text-horizontal-padding: 8px;
  --mat-button-text-icon-offset: 0;
  --mat-button-text-icon-spacing: 8px;
  --mat-button-text-with-icon-horizontal-padding: 8px;
  --mat-button-text-touch-target-size: 48px;
  --mat-button-tonal-container-shape: 4px;
  --mat-button-tonal-horizontal-padding: 16px;
  --mat-button-tonal-icon-offset: -4px;
  --mat-button-tonal-icon-spacing: 8px;
  --mat-button-tonal-touch-target-size: 48px;
}

html {
  --mat-button-filled-container-color: white;
  --mat-button-filled-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-filled-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-filled-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-filled-focus-state-layer-opacity: 0.12;
  --mat-button-filled-hover-state-layer-opacity: 0.04;
  --mat-button-filled-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-filled-pressed-state-layer-opacity: 0.12;
  --mat-button-filled-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-filled-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-outlined-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-outlined-disabled-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-outlined-focus-state-layer-opacity: 0.12;
  --mat-button-outlined-hover-state-layer-opacity: 0.04;
  --mat-button-outlined-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-pressed-state-layer-opacity: 0.12;
  --mat-button-outlined-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-outlined-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-protected-container-color: white;
  --mat-button-protected-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-protected-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-protected-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-protected-focus-state-layer-opacity: 0.12;
  --mat-button-protected-hover-state-layer-opacity: 0.04;
  --mat-button-protected-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-protected-pressed-state-layer-opacity: 0.12;
  --mat-button-protected-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-protected-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-text-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-text-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-text-focus-state-layer-opacity: 0.12;
  --mat-button-text-hover-state-layer-opacity: 0.04;
  --mat-button-text-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-text-pressed-state-layer-opacity: 0.12;
  --mat-button-text-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-text-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-tonal-container-color: white;
  --mat-button-tonal-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-tonal-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-tonal-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-tonal-focus-state-layer-opacity: 0.12;
  --mat-button-tonal-hover-state-layer-opacity: 0.04;
  --mat-button-tonal-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-tonal-pressed-state-layer-opacity: 0.12;
  --mat-button-tonal-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-tonal-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-button.mat-primary,
.mat-mdc-unelevated-button.mat-primary,
.mat-mdc-raised-button.mat-primary,
.mat-mdc-outlined-button.mat-primary,
.mat-tonal-button.mat-primary {
  --mat-button-filled-container-color: #03a9f4;
  --mat-button-filled-label-text-color: white;
  --mat-button-filled-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-filled-state-layer-color: white;
  --mat-button-outlined-label-text-color: #03a9f4;
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-button-outlined-state-layer-color: #03a9f4;
  --mat-button-protected-container-color: #03a9f4;
  --mat-button-protected-label-text-color: white;
  --mat-button-protected-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-protected-state-layer-color: white;
  --mat-button-text-label-text-color: #03a9f4;
  --mat-button-text-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-button-text-state-layer-color: #03a9f4;
  --mat-button-tonal-container-color: #03a9f4;
  --mat-button-tonal-label-text-color: white;
  --mat-button-tonal-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-tonal-state-layer-color: white;
}
.mat-mdc-button.mat-accent,
.mat-mdc-unelevated-button.mat-accent,
.mat-mdc-raised-button.mat-accent,
.mat-mdc-outlined-button.mat-accent,
.mat-tonal-button.mat-accent {
  --mat-button-filled-container-color: #d50000;
  --mat-button-filled-label-text-color: white;
  --mat-button-filled-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-filled-state-layer-color: white;
  --mat-button-outlined-label-text-color: #d50000;
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-ripple-color: color-mix(in srgb, #d50000 12%, transparent);
  --mat-button-outlined-state-layer-color: #d50000;
  --mat-button-protected-container-color: #d50000;
  --mat-button-protected-label-text-color: white;
  --mat-button-protected-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-protected-state-layer-color: white;
  --mat-button-text-label-text-color: #d50000;
  --mat-button-text-ripple-color: color-mix(in srgb, #d50000 12%, transparent);
  --mat-button-text-state-layer-color: #d50000;
  --mat-button-tonal-container-color: #d50000;
  --mat-button-tonal-label-text-color: white;
  --mat-button-tonal-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-tonal-state-layer-color: white;
}
.mat-mdc-button.mat-warn,
.mat-mdc-unelevated-button.mat-warn,
.mat-mdc-raised-button.mat-warn,
.mat-mdc-outlined-button.mat-warn,
.mat-tonal-button.mat-warn {
  --mat-button-filled-container-color: #f44336;
  --mat-button-filled-label-text-color: white;
  --mat-button-filled-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-filled-state-layer-color: white;
  --mat-button-outlined-label-text-color: #f44336;
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-button-outlined-state-layer-color: #f44336;
  --mat-button-protected-container-color: #f44336;
  --mat-button-protected-label-text-color: white;
  --mat-button-protected-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-protected-state-layer-color: white;
  --mat-button-text-label-text-color: #f44336;
  --mat-button-text-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-button-text-state-layer-color: #f44336;
  --mat-button-tonal-container-color: #f44336;
  --mat-button-tonal-label-text-color: white;
  --mat-button-tonal-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-tonal-state-layer-color: white;
}

html {
  --mat-button-filled-container-height: 36px;
  --mat-button-filled-touch-target-display: block;
  --mat-button-outlined-container-height: 36px;
  --mat-button-outlined-touch-target-display: block;
  --mat-button-protected-container-height: 36px;
  --mat-button-protected-touch-target-display: block;
  --mat-button-text-container-height: 36px;
  --mat-button-text-touch-target-display: block;
  --mat-button-tonal-container-height: 36px;
  --mat-button-tonal-touch-target-display: block;
}

html {
  --mat-fab-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-container-shape: 50%;
  --mat-fab-touch-target-size: 48px;
  --mat-fab-extended-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-extended-container-height: 48px;
  --mat-fab-extended-container-shape: 24px;
  --mat-fab-extended-focus-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-extended-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-extended-pressed-container-elevation-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  --mat-fab-focus-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-pressed-container-elevation-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  --mat-fab-small-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-small-container-shape: 50%;
  --mat-fab-small-touch-target-size: 48px;
  --mat-fab-small-focus-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-small-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-small-pressed-container-elevation-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
}

html {
  --mat-fab-container-color: white;
  --mat-fab-disabled-state-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-disabled-state-foreground-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-fab-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-fab-focus-state-layer-opacity: 0.12;
  --mat-fab-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-fab-hover-state-layer-opacity: 0.04;
  --mat-fab-pressed-state-layer-opacity: 0.12;
  --mat-fab-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-small-container-color: white;
  --mat-fab-small-disabled-state-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-small-disabled-state-foreground-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-fab-small-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-fab-small-focus-state-layer-opacity: 0.12;
  --mat-fab-small-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-fab-small-hover-state-layer-opacity: 0.04;
  --mat-fab-small-pressed-state-layer-opacity: 0.12;
  --mat-fab-small-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-small-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-fab-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-fab.mat-primary, .mat-mdc-mini-fab.mat-primary {
  --mat-fab-container-color: #03a9f4;
  --mat-fab-foreground-color: white;
  --mat-fab-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-fab-small-container-color: #03a9f4;
  --mat-fab-small-foreground-color: white;
  --mat-fab-small-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-fab-small-state-layer-color: white;
  --mat-fab-state-layer-color: white;
}
.mat-mdc-fab.mat-accent, .mat-mdc-mini-fab.mat-accent {
  --mat-fab-container-color: #d50000;
  --mat-fab-foreground-color: white;
  --mat-fab-ripple-color: color-mix(in srgb, #d50000 12%, transparent);
  --mat-fab-small-container-color: #d50000;
  --mat-fab-small-foreground-color: white;
  --mat-fab-small-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-fab-small-state-layer-color: white;
  --mat-fab-state-layer-color: white;
}
.mat-mdc-fab.mat-warn, .mat-mdc-mini-fab.mat-warn {
  --mat-fab-container-color: #f44336;
  --mat-fab-foreground-color: white;
  --mat-fab-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-fab-small-container-color: #f44336;
  --mat-fab-small-foreground-color: white;
  --mat-fab-small-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-fab-small-state-layer-color: white;
  --mat-fab-state-layer-color: white;
}

html {
  --mat-fab-small-touch-target-display: block;
  --mat-fab-touch-target-display: block;
}

html {
  --mat-icon-button-icon-size: 24px;
  --mat-icon-button-container-shape: 50%;
  --mat-icon-button-touch-target-size: 48px;
}

html {
  --mat-icon-button-disabled-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-icon-button-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-icon-button-focus-state-layer-opacity: 0.12;
  --mat-icon-button-hover-state-layer-opacity: 0.04;
  --mat-icon-button-icon-color: inherit;
  --mat-icon-button-pressed-state-layer-opacity: 0.12;
  --mat-icon-button-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-icon-button-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-icon-button.mat-primary {
  --mat-icon-button-icon-color: #03a9f4;
  --mat-icon-button-state-layer-color: #03a9f4;
  --mat-icon-button-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
}
.mat-mdc-icon-button.mat-accent {
  --mat-icon-button-icon-color: #d50000;
  --mat-icon-button-state-layer-color: #d50000;
  --mat-icon-button-ripple-color: color-mix(in srgb, #d50000 12%, transparent);
}
.mat-mdc-icon-button.mat-warn {
  --mat-icon-button-icon-color: #f44336;
  --mat-icon-button-state-layer-color: #f44336;
  --mat-icon-button-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
}

html {
  --mat-icon-button-touch-target-display: block;
}

.mat-mdc-icon-button.mat-mdc-button-base {
  --mdc-icon-button-state-layer-size: 48px;
  --mat-icon-button-state-layer-size: 48px;
  width: var(--mat-icon-button-state-layer-size);
  height: var(--mat-icon-button-state-layer-size);
  padding: 12px;
}

html {
  --mat-toolbar-container-background-color: white;
  --mat-toolbar-container-text-color: rgba(0, 0, 0, 0.87);
}

.mat-toolbar.mat-primary {
  --mat-toolbar-container-background-color: #263238;
  --mat-toolbar-container-text-color: white;
}
.mat-toolbar.mat-accent {
  --mat-toolbar-container-background-color: #4caf50;
  --mat-toolbar-container-text-color: rgba(0, 0, 0, 0.87);
}
.mat-toolbar.mat-warn {
  --mat-toolbar-container-background-color: #f44336;
  --mat-toolbar-container-text-color: white;
}

html {
  --mat-toolbar-standard-height: 64px;
  --mat-toolbar-mobile-height: 56px;
}

html {
  --mat-progress-spinner-active-indicator-width: 4px;
  --mat-progress-spinner-size: 48px;
}

html {
  --mat-progress-spinner-active-indicator-color: #f44336;
}

.mat-accent {
  --mat-progress-spinner-active-indicator-color: #4caf50;
}

.mat-warn {
  --mat-progress-spinner-active-indicator-color: #f44336;
}

/* Toyota costumers theme*/
@font-face {
  font-family: "toyota-bold";
  src: url("/fonts/ToyotaType-Bold.ttf") format("truetype");
}
@font-face {
  font-family: "toyota-book";
  src: url("/fonts/ToyotaType-Book.ttf") format("truetype");
}
@font-face {
  font-family: "toyota-regular";
  src: url("/fonts/ToyotaType-Regular.ttf") format("truetype");
}
::ng-deep .link__tooltip {
  padding: 1em;
  width: auto;
  height: auto;
  border-radius: 0.2em;
  font-size: 1em;
  line-height: 1.5;
  text-align: center;
}

@media only print {
  * {
    margin: 0;
    padding: 0;
    font-size: 1em;
  }
  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/
  ::ng-deep .mat-select-value-text {
    display: none;
  }
  ::ng-deep .message__title,
  .message__description {
    display: none;
  }
  ::ng-deep .search-section {
    display: none;
  }
  ::ng-deep .print__confirmation {
    display: none;
  }
  ::ng-deep .button__confirmation {
    display: none;
  }
  .mat-mdc-card {
    box-shadow: none;
  }
}
.half-width {
  width: 50% !important;
}

.full-width {
  width: 100% !important;
}

.spacer {
  flex: 1 1 auto;
}

.bold {
  font-weight: "toyota-bold";
}

@font-face {
  font-family: "toyota-bold";
  src: url("/fonts/ToyotaType-Bold.ttf") format("truetype");
}
@font-face {
  font-family: "toyota-book";
  src: url("/fonts/ToyotaType-Book.ttf") format("truetype");
}
@font-face {
  font-family: "toyota-regular";
  src: url("/fonts/ToyotaType-Regular.ttf") format("truetype");
}
.admin-card {
  height: 100%;
}
.admin-card .card-title {
  color: rgb(255, 5, 0);
  border-bottom: 0.01em solid rgba(248, 248, 248, 0.8);
  padding: 1em 1.3em 0.5em;
  font-size: 1.2em;
  font-weight: bold;
  display: flex;
  font-family: "toyota-regular";
}
.admin-card .card-body {
  padding: 1em 1em;
}

.address-row mat-form-field {
  width: calc(33.3333333333% - 2em);
}

.card-footer {
  padding: 0 1em;
  font-size: 0.7em;
}
.card-footer .card-footer-title {
  font-weight: bold;
}

.customer-state * {
  color: black !important;
}

.save-button {
  padding: 0em 0em 0.3em;
  background-color: rgb(180, 57, 53) !important;
  color: rgb(255, 255, 255) !important;
}

.disabled-save-button {
  color: rgb(255, 255, 255) !important;
  opacity: 0.6;
}

html {
  --mat-badge-text-font: toyota-book;
  --mat-badge-line-height: 22px;
  --mat-badge-text-size: 12px;
  --mat-badge-text-weight: 600;
  --mat-badge-small-size-text-size: 9px;
  --mat-badge-small-size-line-height: 16px;
  --mat-badge-large-size-text-size: 24px;
  --mat-badge-large-size-line-height: 28px;
}

.mat-h1,
.mat-headline-5,
.mat-typography .mat-h1,
.mat-typography .mat-headline-5,
.mat-typography h1 {
  font: 400 24px / 32px toyota-book;
  letter-spacing: normal;
  margin: 0 0 16px;
}

.mat-h2,
.mat-headline-6,
.mat-typography .mat-h2,
.mat-typography .mat-headline-6,
.mat-typography h2 {
  font: 500 20px / 32px toyota-book;
  letter-spacing: 0.0125em;
  margin: 0 0 16px;
}

.mat-h3,
.mat-subtitle-1,
.mat-typography .mat-h3,
.mat-typography .mat-subtitle-1,
.mat-typography h3 {
  font: 400 16px / 28px toyota-book;
  letter-spacing: 0.009375em;
  margin: 0 0 16px;
}

.mat-h4,
.mat-body-1,
.mat-typography .mat-h4,
.mat-typography .mat-body-1,
.mat-typography h4 {
  font: 400 16px / 24px toyota-book;
  letter-spacing: 0.03125em;
  margin: 0 0 16px;
}

.mat-h5,
.mat-typography .mat-h5,
.mat-typography h5 {
  font: 400 calc(14px * 0.83) / 20px toyota-book;
  margin: 0 0 12px;
}

.mat-h6,
.mat-typography .mat-h6,
.mat-typography h6 {
  font: 400 calc(14px * 0.67) / 20px toyota-book;
  margin: 0 0 12px;
}

.mat-body-strong,
.mat-subtitle-2,
.mat-typography .mat-body-strong,
.mat-typography .mat-subtitle-2 {
  font: 500 14px / 22px toyota-book;
  letter-spacing: 0.0071428571em;
}

.mat-body,
.mat-body-2,
.mat-typography .mat-body,
.mat-typography .mat-body-2,
.mat-typography {
  font: 400 14px / 20px toyota-book;
  letter-spacing: 0.0178571429em;
}
.mat-body p,
.mat-body-2 p,
.mat-typography .mat-body p,
.mat-typography .mat-body-2 p,
.mat-typography p {
  margin: 0 0 12px;
}

.mat-small,
.mat-caption,
.mat-typography .mat-small,
.mat-typography .mat-caption {
  font: 400 12px / 20px toyota-book;
  letter-spacing: 0.0333333333em;
}

.mat-headline-1,
.mat-typography .mat-headline-1 {
  font: 300 96px / 96px toyota-book;
  letter-spacing: -0.015625em;
  margin: 0 0 56px;
}

.mat-headline-2,
.mat-typography .mat-headline-2 {
  font: 300 60px / 60px toyota-book;
  letter-spacing: -0.0083333333em;
  margin: 0 0 64px;
}

.mat-headline-3,
.mat-typography .mat-headline-3 {
  font: 400 48px / 50px toyota-book;
  letter-spacing: normal;
  margin: 0 0 64px;
}

.mat-headline-4,
.mat-typography .mat-headline-4 {
  font: 400 34px / 40px toyota-book;
  letter-spacing: 0.0073529412em;
  margin: 0 0 64px;
}

html {
  --mat-bottom-sheet-container-text-font: toyota-book;
  --mat-bottom-sheet-container-text-line-height: 20px;
  --mat-bottom-sheet-container-text-size: 14px;
  --mat-bottom-sheet-container-text-tracking: 0.0178571429em;
  --mat-bottom-sheet-container-text-weight: 400;
}

html {
  --mat-button-toggle-label-text-font: toyota-book;
  --mat-button-toggle-label-text-line-height: 24px;
  --mat-button-toggle-label-text-size: 16px;
  --mat-button-toggle-label-text-tracking: 0.03125em;
  --mat-button-toggle-label-text-weight: 400;
  --mat-button-toggle-legacy-label-text-font: toyota-book;
  --mat-button-toggle-legacy-label-text-line-height: 24px;
  --mat-button-toggle-legacy-label-text-size: 16px;
  --mat-button-toggle-legacy-label-text-tracking: 0.03125em;
  --mat-button-toggle-legacy-label-text-weight: 400;
}

html {
  --mat-datepicker-calendar-text-font: toyota-book;
  --mat-datepicker-calendar-text-size: 13px;
  --mat-datepicker-calendar-body-label-text-size: 14px;
  --mat-datepicker-calendar-body-label-text-weight: 500;
  --mat-datepicker-calendar-period-button-text-size: 14px;
  --mat-datepicker-calendar-period-button-text-weight: 500;
  --mat-datepicker-calendar-header-text-size: 11px;
  --mat-datepicker-calendar-header-text-weight: 400;
}

html {
  --mat-expansion-header-text-font: toyota-book;
  --mat-expansion-header-text-size: 14px;
  --mat-expansion-header-text-weight: 500;
  --mat-expansion-header-text-line-height: inherit;
  --mat-expansion-header-text-tracking: inherit;
  --mat-expansion-container-text-font: toyota-book;
  --mat-expansion-container-text-line-height: 20px;
  --mat-expansion-container-text-size: 14px;
  --mat-expansion-container-text-tracking: 0.0178571429em;
  --mat-expansion-container-text-weight: 400;
}

html {
  --mat-grid-list-tile-header-primary-text-size: 14px;
  --mat-grid-list-tile-header-secondary-text-size: 12px;
  --mat-grid-list-tile-footer-primary-text-size: 14px;
  --mat-grid-list-tile-footer-secondary-text-size: 12px;
}

html {
  --mat-stepper-container-text-font: toyota-book;
  --mat-stepper-header-label-text-font: toyota-book;
  --mat-stepper-header-label-text-size: 14px;
  --mat-stepper-header-label-text-weight: 400;
  --mat-stepper-header-error-state-label-text-size: 16px;
  --mat-stepper-header-selected-state-label-text-size: 16px;
  --mat-stepper-header-selected-state-label-text-weight: 400;
}

html {
  --mat-toolbar-title-text-font: toyota-book;
  --mat-toolbar-title-text-line-height: 32px;
  --mat-toolbar-title-text-size: 20px;
  --mat-toolbar-title-text-tracking: 0.0125em;
  --mat-toolbar-title-text-weight: 500;
}

html {
  --mat-tree-node-text-font: toyota-book;
  --mat-tree-node-text-size: 14px;
  --mat-tree-node-text-weight: 400;
}

html {
  --mat-option-label-text-font: toyota-book;
  --mat-option-label-text-line-height: 24px;
  --mat-option-label-text-size: 16px;
  --mat-option-label-text-tracking: 0.03125em;
  --mat-option-label-text-weight: 400;
}

html {
  --mat-optgroup-label-text-font: toyota-book;
  --mat-optgroup-label-text-line-height: 24px;
  --mat-optgroup-label-text-size: 16px;
  --mat-optgroup-label-text-tracking: 0.03125em;
  --mat-optgroup-label-text-weight: 400;
}

html {
  --mat-card-title-text-font: toyota-book;
  --mat-card-title-text-line-height: 32px;
  --mat-card-title-text-size: 20px;
  --mat-card-title-text-tracking: 0.0125em;
  --mat-card-title-text-weight: 500;
  --mat-card-subtitle-text-font: toyota-book;
  --mat-card-subtitle-text-line-height: 22px;
  --mat-card-subtitle-text-size: 14px;
  --mat-card-subtitle-text-tracking: 0.0071428571em;
  --mat-card-subtitle-text-weight: 500;
}

html {
  --mat-tooltip-supporting-text-font: toyota-book;
  --mat-tooltip-supporting-text-size: 12px;
  --mat-tooltip-supporting-text-weight: 400;
  --mat-tooltip-supporting-text-tracking: 0.0333333333em;
}

html {
  --mat-form-field-container-text-font: toyota-book;
  --mat-form-field-container-text-line-height: 24px;
  --mat-form-field-container-text-size: 16px;
  --mat-form-field-container-text-tracking: 0.03125em;
  --mat-form-field-container-text-weight: 400;
  --mat-form-field-outlined-label-text-populated-size: 16px;
  --mat-form-field-subscript-text-font: toyota-book;
  --mat-form-field-subscript-text-line-height: 20px;
  --mat-form-field-subscript-text-size: 12px;
  --mat-form-field-subscript-text-tracking: 0.0333333333em;
  --mat-form-field-subscript-text-weight: 400;
  --mat-form-field-filled-label-text-font: toyota-book;
  --mat-form-field-filled-label-text-size: 16px;
  --mat-form-field-filled-label-text-tracking: 0.03125em;
  --mat-form-field-filled-label-text-weight: 400;
  --mat-form-field-outlined-label-text-font: toyota-book;
  --mat-form-field-outlined-label-text-size: 16px;
  --mat-form-field-outlined-label-text-tracking: 0.03125em;
  --mat-form-field-outlined-label-text-weight: 400;
}

html {
  --mat-select-trigger-text-font: toyota-book;
  --mat-select-trigger-text-line-height: 24px;
  --mat-select-trigger-text-size: 16px;
  --mat-select-trigger-text-tracking: 0.03125em;
  --mat-select-trigger-text-weight: 400;
}

html {
  --mat-dialog-subhead-font: toyota-book;
  --mat-dialog-subhead-line-height: 32px;
  --mat-dialog-subhead-size: 20px;
  --mat-dialog-subhead-weight: 500;
  --mat-dialog-subhead-tracking: 0.0125em;
  --mat-dialog-supporting-text-font: toyota-book;
  --mat-dialog-supporting-text-line-height: 24px;
  --mat-dialog-supporting-text-size: 16px;
  --mat-dialog-supporting-text-weight: 400;
  --mat-dialog-supporting-text-tracking: 0.03125em;
}

.mat-mdc-standard-chip {
  --mat-chip-label-text-font: toyota-book;
  --mat-chip-label-text-line-height: 20px;
  --mat-chip-label-text-size: 14px;
  --mat-chip-label-text-tracking: 0.0178571429em;
  --mat-chip-label-text-weight: 400;
}

html {
  --mat-slide-toggle-label-text-font: toyota-book;
  --mat-slide-toggle-label-text-line-height: 20px;
  --mat-slide-toggle-label-text-size: 14px;
  --mat-slide-toggle-label-text-tracking: 0.0178571429em;
  --mat-slide-toggle-label-text-weight: 400;
}
html .mat-mdc-slide-toggle {
  --mat-slide-toggle-label-text-font: toyota-book;
  --mat-slide-toggle-label-text-line-height: 20px;
  --mat-slide-toggle-label-text-size: 14px;
  --mat-slide-toggle-label-text-tracking: 0.0178571429em;
  --mat-slide-toggle-label-text-weight: 400;
}

html {
  --mat-radio-label-text-font: toyota-book;
  --mat-radio-label-text-line-height: 20px;
  --mat-radio-label-text-size: 14px;
  --mat-radio-label-text-tracking: 0.0178571429em;
  --mat-radio-label-text-weight: 400;
}

html {
  --mat-slider-label-label-text-font: toyota-book;
  --mat-slider-label-label-text-size: 14px;
  --mat-slider-label-label-text-line-height: 22px;
  --mat-slider-label-label-text-tracking: 0.0071428571em;
  --mat-slider-label-label-text-weight: 500;
}

html {
  --mat-menu-item-label-text-font: toyota-book;
  --mat-menu-item-label-text-size: 16px;
  --mat-menu-item-label-text-tracking: 0.03125em;
  --mat-menu-item-label-text-line-height: 24px;
  --mat-menu-item-label-text-weight: 400;
}

html {
  --mat-list-list-item-label-text-font: toyota-book;
  --mat-list-list-item-label-text-line-height: 24px;
  --mat-list-list-item-label-text-size: 16px;
  --mat-list-list-item-label-text-tracking: 0.03125em;
  --mat-list-list-item-label-text-weight: 400;
  --mat-list-list-item-supporting-text-font: toyota-book;
  --mat-list-list-item-supporting-text-line-height: 20px;
  --mat-list-list-item-supporting-text-size: 14px;
  --mat-list-list-item-supporting-text-tracking: 0.0178571429em;
  --mat-list-list-item-supporting-text-weight: 400;
  --mat-list-list-item-trailing-supporting-text-font: toyota-book;
  --mat-list-list-item-trailing-supporting-text-line-height: 20px;
  --mat-list-list-item-trailing-supporting-text-size: 12px;
  --mat-list-list-item-trailing-supporting-text-tracking: 0.0333333333em;
  --mat-list-list-item-trailing-supporting-text-weight: 400;
}

.mdc-list-group__subheader {
  font: 400 16px / 28px toyota-book;
  letter-spacing: 0.009375em;
}

html {
  --mat-paginator-container-text-font: toyota-book;
  --mat-paginator-container-text-line-height: 20px;
  --mat-paginator-container-text-size: 12px;
  --mat-paginator-container-text-tracking: 0.0333333333em;
  --mat-paginator-container-text-weight: 400;
  --mat-paginator-select-trigger-text-size: 12px;
}

.mat-mdc-tab-header {
  --mat-tab-label-text-font: toyota-book;
  --mat-tab-label-text-size: 14px;
  --mat-tab-label-text-tracking: 0.0892857143em;
  --mat-tab-label-text-line-height: 36px;
  --mat-tab-label-text-weight: 500;
}

html {
  --mat-checkbox-label-text-font: toyota-book;
  --mat-checkbox-label-text-line-height: 20px;
  --mat-checkbox-label-text-size: 14px;
  --mat-checkbox-label-text-tracking: 0.0178571429em;
  --mat-checkbox-label-text-weight: 400;
}

html {
  --mat-button-filled-label-text-font: toyota-book;
  --mat-button-filled-label-text-size: 14px;
  --mat-button-filled-label-text-tracking: 0.0892857143em;
  --mat-button-filled-label-text-transform: none;
  --mat-button-filled-label-text-weight: 500;
  --mat-button-outlined-label-text-font: toyota-book;
  --mat-button-outlined-label-text-size: 14px;
  --mat-button-outlined-label-text-tracking: 0.0892857143em;
  --mat-button-outlined-label-text-transform: none;
  --mat-button-outlined-label-text-weight: 500;
  --mat-button-protected-label-text-font: toyota-book;
  --mat-button-protected-label-text-size: 14px;
  --mat-button-protected-label-text-tracking: 0.0892857143em;
  --mat-button-protected-label-text-transform: none;
  --mat-button-protected-label-text-weight: 500;
  --mat-button-text-label-text-font: toyota-book;
  --mat-button-text-label-text-size: 14px;
  --mat-button-text-label-text-tracking: 0.0892857143em;
  --mat-button-text-label-text-transform: none;
  --mat-button-text-label-text-weight: 500;
  --mat-button-tonal-label-text-font: toyota-book;
  --mat-button-tonal-label-text-size: 14px;
  --mat-button-tonal-label-text-tracking: 0.0892857143em;
  --mat-button-tonal-label-text-transform: none;
  --mat-button-tonal-label-text-weight: 500;
}

html {
  --mat-fab-extended-label-text-font: toyota-book;
  --mat-fab-extended-label-text-size: 14px;
  --mat-fab-extended-label-text-tracking: 0.0892857143em;
  --mat-fab-extended-label-text-weight: 500;
}

html {
  --mat-snack-bar-supporting-text-font: toyota-book;
  --mat-snack-bar-supporting-text-line-height: 20px;
  --mat-snack-bar-supporting-text-size: 14px;
  --mat-snack-bar-supporting-text-weight: 400;
}

html {
  --mat-table-header-headline-font: toyota-book;
  --mat-table-header-headline-line-height: 22px;
  --mat-table-header-headline-size: 14px;
  --mat-table-header-headline-weight: 500;
  --mat-table-header-headline-tracking: 0.0071428571em;
  --mat-table-row-item-label-text-font: toyota-book;
  --mat-table-row-item-label-text-line-height: 20px;
  --mat-table-row-item-label-text-size: 14px;
  --mat-table-row-item-label-text-weight: 400;
  --mat-table-row-item-label-text-tracking: 0.0178571429em;
  --mat-table-footer-supporting-text-font: toyota-book;
  --mat-table-footer-supporting-text-line-height: 20px;
  --mat-table-footer-supporting-text-size: 14px;
  --mat-table-footer-supporting-text-weight: 400;
  --mat-table-footer-supporting-text-tracking: 0.0178571429em;
}

.mat-elevation-z0, .mat-mdc-elevation-specific.mat-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0, 0px 0px 0px 0px --mat-sys-shadow, 0px 0px 0px 0px --mat-sys-shadow, 0px 0px 0px 0px --mat-sys-shadow);
}

.mat-elevation-z1, .mat-mdc-elevation-specific.mat-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1, 0px 2px 1px -1px --mat-sys-shadow, 0px 1px 1px 0px --mat-sys-shadow, 0px 1px 3px 0px --mat-sys-shadow);
}

.mat-elevation-z2, .mat-mdc-elevation-specific.mat-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2, 0px 3px 1px -2px --mat-sys-shadow, 0px 2px 2px 0px --mat-sys-shadow, 0px 1px 5px 0px --mat-sys-shadow);
}

.mat-elevation-z3, .mat-mdc-elevation-specific.mat-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3, 0px 3px 3px -2px --mat-sys-shadow, 0px 3px 4px 0px --mat-sys-shadow, 0px 1px 8px 0px --mat-sys-shadow);
}

.mat-elevation-z4, .mat-mdc-elevation-specific.mat-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4, 0px 2px 4px -1px --mat-sys-shadow, 0px 4px 5px 0px --mat-sys-shadow, 0px 1px 10px 0px --mat-sys-shadow);
}

.mat-elevation-z5, .mat-mdc-elevation-specific.mat-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5, 0px 3px 5px -1px --mat-sys-shadow, 0px 5px 8px 0px --mat-sys-shadow, 0px 1px 14px 0px --mat-sys-shadow);
}

.mat-elevation-z6, .mat-mdc-elevation-specific.mat-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6, 0px 3px 5px -1px --mat-sys-shadow, 0px 6px 10px 0px --mat-sys-shadow, 0px 1px 18px 0px --mat-sys-shadow);
}

.mat-elevation-z7, .mat-mdc-elevation-specific.mat-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7, 0px 4px 5px -2px --mat-sys-shadow, 0px 7px 10px 1px --mat-sys-shadow, 0px 2px 16px 1px --mat-sys-shadow);
}

.mat-elevation-z8, .mat-mdc-elevation-specific.mat-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8, 0px 5px 5px -3px --mat-sys-shadow, 0px 8px 10px 1px --mat-sys-shadow, 0px 3px 14px 2px --mat-sys-shadow);
}

.mat-elevation-z9, .mat-mdc-elevation-specific.mat-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9, 0px 5px 6px -3px --mat-sys-shadow, 0px 9px 12px 1px --mat-sys-shadow, 0px 3px 16px 2px --mat-sys-shadow);
}

.mat-elevation-z10, .mat-mdc-elevation-specific.mat-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10, 0px 6px 6px -3px --mat-sys-shadow, 0px 10px 14px 1px --mat-sys-shadow, 0px 4px 18px 3px --mat-sys-shadow);
}

.mat-elevation-z11, .mat-mdc-elevation-specific.mat-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11, 0px 6px 7px -4px --mat-sys-shadow, 0px 11px 15px 1px --mat-sys-shadow, 0px 4px 20px 3px --mat-sys-shadow);
}

.mat-elevation-z12, .mat-mdc-elevation-specific.mat-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12, 0px 7px 8px -4px --mat-sys-shadow, 0px 12px 17px 2px --mat-sys-shadow, 0px 5px 22px 4px --mat-sys-shadow);
}

.mat-elevation-z13, .mat-mdc-elevation-specific.mat-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13, 0px 7px 8px -4px --mat-sys-shadow, 0px 13px 19px 2px --mat-sys-shadow, 0px 5px 24px 4px --mat-sys-shadow);
}

.mat-elevation-z14, .mat-mdc-elevation-specific.mat-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14, 0px 7px 9px -4px --mat-sys-shadow, 0px 14px 21px 2px --mat-sys-shadow, 0px 5px 26px 4px --mat-sys-shadow);
}

.mat-elevation-z15, .mat-mdc-elevation-specific.mat-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15, 0px 8px 9px -5px --mat-sys-shadow, 0px 15px 22px 2px --mat-sys-shadow, 0px 6px 28px 5px --mat-sys-shadow);
}

.mat-elevation-z16, .mat-mdc-elevation-specific.mat-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16, 0px 8px 10px -5px --mat-sys-shadow, 0px 16px 24px 2px --mat-sys-shadow, 0px 6px 30px 5px --mat-sys-shadow);
}

.mat-elevation-z17, .mat-mdc-elevation-specific.mat-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17, 0px 8px 11px -5px --mat-sys-shadow, 0px 17px 26px 2px --mat-sys-shadow, 0px 6px 32px 5px --mat-sys-shadow);
}

.mat-elevation-z18, .mat-mdc-elevation-specific.mat-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18, 0px 9px 11px -5px --mat-sys-shadow, 0px 18px 28px 2px --mat-sys-shadow, 0px 7px 34px 6px --mat-sys-shadow);
}

.mat-elevation-z19, .mat-mdc-elevation-specific.mat-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19, 0px 9px 12px -6px --mat-sys-shadow, 0px 19px 29px 2px --mat-sys-shadow, 0px 7px 36px 6px --mat-sys-shadow);
}

.mat-elevation-z20, .mat-mdc-elevation-specific.mat-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20, 0px 10px 13px -6px --mat-sys-shadow, 0px 20px 31px 3px --mat-sys-shadow, 0px 8px 38px 7px --mat-sys-shadow);
}

.mat-elevation-z21, .mat-mdc-elevation-specific.mat-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21, 0px 10px 13px -6px --mat-sys-shadow, 0px 21px 33px 3px --mat-sys-shadow, 0px 8px 40px 7px --mat-sys-shadow);
}

.mat-elevation-z22, .mat-mdc-elevation-specific.mat-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22, 0px 10px 14px -6px --mat-sys-shadow, 0px 22px 35px 3px --mat-sys-shadow, 0px 8px 42px 7px --mat-sys-shadow);
}

.mat-elevation-z23, .mat-mdc-elevation-specific.mat-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23, 0px 11px 14px -7px --mat-sys-shadow, 0px 23px 36px 3px --mat-sys-shadow, 0px 9px 44px 8px --mat-sys-shadow);
}

.mat-elevation-z24, .mat-mdc-elevation-specific.mat-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24, 0px 11px 15px -7px --mat-sys-shadow, 0px 24px 38px 3px --mat-sys-shadow, 0px 9px 46px 8px --mat-sys-shadow);
}

html {
  --mat-sys-on-surface: initial;
}

.mat-app-background {
  background-color: var(--mat-app-background-color, var(--mat-sys-background, transparent));
  color: var(--mat-app-text-color, var(--mat-sys-on-background, inherit));
}

html {
  --mat-app-background-color: #fafafa;
  --mat-app-text-color: rgba(0, 0, 0, 0.87);
  --mat-app-elevation-shadow-level-0: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-1: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-2: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-3: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-4: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-5: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-6: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-7: 0px 4px 5px -2px rgba(0, 0, 0, 0.2), 0px 7px 10px 1px rgba(0, 0, 0, 0.14), 0px 2px 16px 1px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-8: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-9: 0px 5px 6px -3px rgba(0, 0, 0, 0.2), 0px 9px 12px 1px rgba(0, 0, 0, 0.14), 0px 3px 16px 2px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-10: 0px 6px 6px -3px rgba(0, 0, 0, 0.2), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-11: 0px 6px 7px -4px rgba(0, 0, 0, 0.2), 0px 11px 15px 1px rgba(0, 0, 0, 0.14), 0px 4px 20px 3px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-12: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-13: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 13px 19px 2px rgba(0, 0, 0, 0.14), 0px 5px 24px 4px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-14: 0px 7px 9px -4px rgba(0, 0, 0, 0.2), 0px 14px 21px 2px rgba(0, 0, 0, 0.14), 0px 5px 26px 4px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-15: 0px 8px 9px -5px rgba(0, 0, 0, 0.2), 0px 15px 22px 2px rgba(0, 0, 0, 0.14), 0px 6px 28px 5px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-16: 0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-17: 0px 8px 11px -5px rgba(0, 0, 0, 0.2), 0px 17px 26px 2px rgba(0, 0, 0, 0.14), 0px 6px 32px 5px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-18: 0px 9px 11px -5px rgba(0, 0, 0, 0.2), 0px 18px 28px 2px rgba(0, 0, 0, 0.14), 0px 7px 34px 6px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-19: 0px 9px 12px -6px rgba(0, 0, 0, 0.2), 0px 19px 29px 2px rgba(0, 0, 0, 0.14), 0px 7px 36px 6px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-20: 0px 10px 13px -6px rgba(0, 0, 0, 0.2), 0px 20px 31px 3px rgba(0, 0, 0, 0.14), 0px 8px 38px 7px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-21: 0px 10px 13px -6px rgba(0, 0, 0, 0.2), 0px 21px 33px 3px rgba(0, 0, 0, 0.14), 0px 8px 40px 7px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-22: 0px 10px 14px -6px rgba(0, 0, 0, 0.2), 0px 22px 35px 3px rgba(0, 0, 0, 0.14), 0px 8px 42px 7px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-23: 0px 11px 14px -7px rgba(0, 0, 0, 0.2), 0px 23px 36px 3px rgba(0, 0, 0, 0.14), 0px 9px 44px 8px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-24: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
}

html {
  --mat-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
}

html {
  --mat-option-selected-state-label-text-color: #03a9f4;
  --mat-option-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-option-hover-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 4%, transparent);
  --mat-option-focus-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-option-selected-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
}

.mat-accent {
  --mat-option-selected-state-label-text-color: #4caf50;
  --mat-option-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-option-hover-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 4%, transparent);
  --mat-option-focus-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-option-selected-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
}

.mat-warn {
  --mat-option-selected-state-label-text-color: #f44336;
  --mat-option-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-option-hover-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 4%, transparent);
  --mat-option-focus-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-option-selected-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
}

html {
  --mat-optgroup-label-text-color: rgba(0, 0, 0, 0.87);
}

html {
  --mat-pseudo-checkbox-full-selected-icon-color: #4caf50;
  --mat-pseudo-checkbox-full-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-pseudo-checkbox-full-disabled-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-full-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-minimal-selected-checkmark-color: #4caf50;
  --mat-pseudo-checkbox-minimal-disabled-selected-checkmark-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
}

.mat-primary {
  --mat-pseudo-checkbox-full-selected-icon-color: #03a9f4;
  --mat-pseudo-checkbox-full-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-pseudo-checkbox-full-disabled-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-full-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-minimal-selected-checkmark-color: #03a9f4;
  --mat-pseudo-checkbox-minimal-disabled-selected-checkmark-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
}

.mat-accent {
  --mat-pseudo-checkbox-full-selected-icon-color: #4caf50;
  --mat-pseudo-checkbox-full-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-pseudo-checkbox-full-disabled-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-full-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-minimal-selected-checkmark-color: #4caf50;
  --mat-pseudo-checkbox-minimal-disabled-selected-checkmark-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
}

.mat-warn {
  --mat-pseudo-checkbox-full-selected-icon-color: #f44336;
  --mat-pseudo-checkbox-full-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-pseudo-checkbox-full-disabled-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-full-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-minimal-selected-checkmark-color: #f44336;
  --mat-pseudo-checkbox-minimal-disabled-selected-checkmark-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
}

html {
  --mat-option-label-text-font: toyota-book;
  --mat-option-label-text-line-height: 24px;
  --mat-option-label-text-size: 16px;
  --mat-option-label-text-tracking: 0.03125em;
  --mat-option-label-text-weight: 400;
}

html {
  --mat-optgroup-label-text-font: toyota-book;
  --mat-optgroup-label-text-line-height: 24px;
  --mat-optgroup-label-text-size: 16px;
  --mat-optgroup-label-text-tracking: 0.03125em;
  --mat-optgroup-label-text-weight: 400;
}

html {
  --mat-card-elevated-container-shape: 4px;
  --mat-card-outlined-container-shape: 4px;
  --mat-card-filled-container-shape: 4px;
  --mat-card-outlined-outline-width: 1px;
}

html {
  --mat-card-elevated-container-color: white;
  --mat-card-elevated-container-elevation: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mat-card-outlined-container-color: white;
  --mat-card-outlined-container-elevation: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-card-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-card-subtitle-text-color: rgba(0, 0, 0, 0.54);
  --mat-card-filled-container-color: white;
  --mat-card-filled-container-elevation: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
}

html {
  --mat-card-title-text-font: toyota-book;
  --mat-card-title-text-line-height: 32px;
  --mat-card-title-text-size: 20px;
  --mat-card-title-text-tracking: 0.0125em;
  --mat-card-title-text-weight: 500;
  --mat-card-subtitle-text-font: toyota-book;
  --mat-card-subtitle-text-line-height: 22px;
  --mat-card-subtitle-text-size: 14px;
  --mat-card-subtitle-text-tracking: 0.0071428571em;
  --mat-card-subtitle-text-weight: 500;
}

html {
  --mat-progress-bar-active-indicator-height: 4px;
  --mat-progress-bar-track-height: 4px;
  --mat-progress-bar-track-shape: 0;
}

.mat-mdc-progress-bar {
  --mat-progress-bar-active-indicator-color: #03a9f4;
  --mat-progress-bar-track-color: rgba(3, 169, 244, 0.25);
}
.mat-mdc-progress-bar.mat-accent {
  --mat-progress-bar-active-indicator-color: #4caf50;
  --mat-progress-bar-track-color: rgba(76, 175, 80, 0.25);
}
.mat-mdc-progress-bar.mat-warn {
  --mat-progress-bar-active-indicator-color: #f44336;
  --mat-progress-bar-track-color: rgba(244, 67, 54, 0.25);
}

html {
  --mat-tooltip-container-shape: 4px;
  --mat-tooltip-supporting-text-line-height: 16px;
}

html {
  --mat-tooltip-container-color: #424242;
  --mat-tooltip-supporting-text-color: white;
}

html {
  --mat-tooltip-supporting-text-font: toyota-book;
  --mat-tooltip-supporting-text-size: 12px;
  --mat-tooltip-supporting-text-weight: 400;
  --mat-tooltip-supporting-text-tracking: 0.0333333333em;
}

html {
  --mat-form-field-filled-active-indicator-height: 1px;
  --mat-form-field-filled-focus-active-indicator-height: 2px;
  --mat-form-field-filled-container-shape: 4px;
  --mat-form-field-outlined-outline-width: 1px;
  --mat-form-field-outlined-focus-outline-width: 2px;
  --mat-form-field-outlined-container-shape: 4px;
}

html {
  --mat-form-field-focus-select-arrow-color: color-mix(in srgb, #03a9f4 87%, transparent);
  --mat-form-field-filled-caret-color: #03a9f4;
  --mat-form-field-filled-focus-active-indicator-color: #03a9f4;
  --mat-form-field-filled-focus-label-text-color: color-mix(in srgb, #03a9f4 87%, transparent);
  --mat-form-field-outlined-caret-color: #03a9f4;
  --mat-form-field-outlined-focus-outline-color: #03a9f4;
  --mat-form-field-outlined-focus-label-text-color: color-mix(in srgb, #03a9f4 87%, transparent);
  --mat-form-field-disabled-input-text-placeholder-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-form-field-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-form-field-error-text-color: #f44336;
  --mat-form-field-select-option-text-color: inherit;
  --mat-form-field-select-disabled-option-text-color: GrayText;
  --mat-form-field-leading-icon-color: unset;
  --mat-form-field-disabled-leading-icon-color: unset;
  --mat-form-field-trailing-icon-color: unset;
  --mat-form-field-disabled-trailing-icon-color: unset;
  --mat-form-field-error-focus-trailing-icon-color: unset;
  --mat-form-field-error-hover-trailing-icon-color: unset;
  --mat-form-field-error-trailing-icon-color: unset;
  --mat-form-field-enabled-select-arrow-color: rgba(0, 0, 0, 0.54);
  --mat-form-field-disabled-select-arrow-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-form-field-hover-state-layer-opacity: 0.04;
  --mat-form-field-focus-state-layer-opacity: 0.12;
  --mat-form-field-filled-container-color: #f6f6f6;
  --mat-form-field-filled-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 4%, transparent);
  --mat-form-field-filled-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-form-field-filled-hover-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-form-field-filled-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-form-field-filled-input-text-color: rgba(0, 0, 0, 0.87);
  --mat-form-field-filled-disabled-input-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-form-field-filled-input-text-placeholder-color: rgba(0, 0, 0, 0.54);
  --mat-form-field-filled-error-hover-label-text-color: #f44336;
  --mat-form-field-filled-error-focus-label-text-color: #f44336;
  --mat-form-field-filled-error-label-text-color: #f44336;
  --mat-form-field-filled-error-caret-color: #f44336;
  --mat-form-field-filled-active-indicator-color: rgba(0, 0, 0, 0.54);
  --mat-form-field-filled-disabled-active-indicator-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-form-field-filled-hover-active-indicator-color: rgba(0, 0, 0, 0.87);
  --mat-form-field-filled-error-active-indicator-color: #f44336;
  --mat-form-field-filled-error-focus-active-indicator-color: #f44336;
  --mat-form-field-filled-error-hover-active-indicator-color: #f44336;
  --mat-form-field-outlined-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-form-field-outlined-hover-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-form-field-outlined-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-form-field-outlined-input-text-color: rgba(0, 0, 0, 0.87);
  --mat-form-field-outlined-disabled-input-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-form-field-outlined-input-text-placeholder-color: rgba(0, 0, 0, 0.54);
  --mat-form-field-outlined-error-caret-color: #f44336;
  --mat-form-field-outlined-error-focus-label-text-color: #f44336;
  --mat-form-field-outlined-error-label-text-color: #f44336;
  --mat-form-field-outlined-error-hover-label-text-color: #f44336;
  --mat-form-field-outlined-outline-color: rgba(0, 0, 0, 0.38);
  --mat-form-field-outlined-disabled-outline-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-form-field-outlined-hover-outline-color: rgba(0, 0, 0, 0.87);
  --mat-form-field-outlined-error-focus-outline-color: #f44336;
  --mat-form-field-outlined-error-hover-outline-color: #f44336;
  --mat-form-field-outlined-error-outline-color: #f44336;
}

.mat-mdc-form-field.mat-accent {
  --mat-form-field-focus-select-arrow-color: color-mix(in srgb, #4caf50 87%, transparent);
  --mat-form-field-filled-caret-color: #4caf50;
  --mat-form-field-filled-focus-active-indicator-color: #4caf50;
  --mat-form-field-filled-focus-label-text-color: color-mix(in srgb, #4caf50 87%, transparent);
  --mat-form-field-outlined-caret-color: #4caf50;
  --mat-form-field-outlined-focus-outline-color: #4caf50;
  --mat-form-field-outlined-focus-label-text-color: color-mix(in srgb, #4caf50 87%, transparent);
}

.mat-mdc-form-field.mat-warn {
  --mat-form-field-focus-select-arrow-color: color-mix(in srgb, #f44336 87%, transparent);
  --mat-form-field-filled-caret-color: #f44336;
  --mat-form-field-filled-focus-active-indicator-color: #f44336;
  --mat-form-field-filled-focus-label-text-color: color-mix(in srgb, #f44336 87%, transparent);
  --mat-form-field-outlined-caret-color: #f44336;
  --mat-form-field-outlined-focus-outline-color: #f44336;
  --mat-form-field-outlined-focus-label-text-color: color-mix(in srgb, #f44336 87%, transparent);
}

html {
  --mat-form-field-container-height: 56px;
  --mat-form-field-filled-label-display: block;
  --mat-form-field-container-vertical-padding: 16px;
  --mat-form-field-filled-with-label-container-padding-top: 24px;
  --mat-form-field-filled-with-label-container-padding-bottom: 8px;
}

html {
  --mat-form-field-container-text-font: toyota-book;
  --mat-form-field-container-text-line-height: 24px;
  --mat-form-field-container-text-size: 16px;
  --mat-form-field-container-text-tracking: 0.03125em;
  --mat-form-field-container-text-weight: 400;
  --mat-form-field-outlined-label-text-populated-size: 16px;
  --mat-form-field-subscript-text-font: toyota-book;
  --mat-form-field-subscript-text-line-height: 20px;
  --mat-form-field-subscript-text-size: 12px;
  --mat-form-field-subscript-text-tracking: 0.0333333333em;
  --mat-form-field-subscript-text-weight: 400;
  --mat-form-field-filled-label-text-font: toyota-book;
  --mat-form-field-filled-label-text-size: 16px;
  --mat-form-field-filled-label-text-tracking: 0.03125em;
  --mat-form-field-filled-label-text-weight: 400;
  --mat-form-field-outlined-label-text-font: toyota-book;
  --mat-form-field-outlined-label-text-size: 16px;
  --mat-form-field-outlined-label-text-tracking: 0.03125em;
  --mat-form-field-outlined-label-text-weight: 400;
}

html {
  --mat-select-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

html {
  --mat-select-panel-background-color: white;
  --mat-select-enabled-trigger-text-color: rgba(0, 0, 0, 0.87);
  --mat-select-disabled-trigger-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-select-placeholder-text-color: rgba(0, 0, 0, 0.54);
  --mat-select-enabled-arrow-color: rgba(0, 0, 0, 0.54);
  --mat-select-disabled-arrow-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-select-focused-arrow-color: #03a9f4;
  --mat-select-invalid-arrow-color: #f44336;
}

.mat-mdc-form-field.mat-accent {
  --mat-select-panel-background-color: white;
  --mat-select-enabled-trigger-text-color: rgba(0, 0, 0, 0.87);
  --mat-select-disabled-trigger-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-select-placeholder-text-color: rgba(0, 0, 0, 0.54);
  --mat-select-enabled-arrow-color: rgba(0, 0, 0, 0.54);
  --mat-select-disabled-arrow-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-select-focused-arrow-color: #4caf50;
  --mat-select-invalid-arrow-color: #f44336;
}

.mat-mdc-form-field.mat-warn {
  --mat-select-panel-background-color: white;
  --mat-select-enabled-trigger-text-color: rgba(0, 0, 0, 0.87);
  --mat-select-disabled-trigger-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-select-placeholder-text-color: rgba(0, 0, 0, 0.54);
  --mat-select-enabled-arrow-color: rgba(0, 0, 0, 0.54);
  --mat-select-disabled-arrow-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-select-focused-arrow-color: #f44336;
  --mat-select-invalid-arrow-color: #f44336;
}

html {
  --mat-select-arrow-transform: translateY(-8px);
}

html {
  --mat-select-trigger-text-font: toyota-book;
  --mat-select-trigger-text-line-height: 24px;
  --mat-select-trigger-text-size: 16px;
  --mat-select-trigger-text-tracking: 0.03125em;
  --mat-select-trigger-text-weight: 400;
}

html {
  --mat-autocomplete-container-shape: 4px;
  --mat-autocomplete-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

html {
  --mat-autocomplete-background-color: white;
}

html {
  --mat-dialog-container-shape: 4px;
  --mat-dialog-container-elevation-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
  --mat-dialog-container-max-width: 80vw;
  --mat-dialog-container-small-max-width: 80vw;
  --mat-dialog-container-min-width: 0;
  --mat-dialog-actions-alignment: start;
  --mat-dialog-actions-padding: 8px;
  --mat-dialog-content-padding: 20px 24px;
  --mat-dialog-with-actions-content-padding: 20px 24px;
  --mat-dialog-headline-padding: 0 24px 9px;
}

html {
  --mat-dialog-container-color: white;
  --mat-dialog-subhead-color: rgba(0, 0, 0, 0.87);
  --mat-dialog-supporting-text-color: rgba(0, 0, 0, 0.54);
}

html {
  --mat-dialog-subhead-font: toyota-book;
  --mat-dialog-subhead-line-height: 32px;
  --mat-dialog-subhead-size: 20px;
  --mat-dialog-subhead-weight: 500;
  --mat-dialog-subhead-tracking: 0.0125em;
  --mat-dialog-supporting-text-font: toyota-book;
  --mat-dialog-supporting-text-line-height: 24px;
  --mat-dialog-supporting-text-size: 16px;
  --mat-dialog-supporting-text-weight: 400;
  --mat-dialog-supporting-text-tracking: 0.03125em;
}

.mat-mdc-standard-chip {
  --mat-chip-container-shape-radius: 16px;
  --mat-chip-disabled-container-opacity: 0.4;
  --mat-chip-disabled-outline-color: transparent;
  --mat-chip-flat-selected-outline-width: 0;
  --mat-chip-focus-outline-color: transparent;
  --mat-chip-hover-state-layer-opacity: 0.04;
  --mat-chip-outline-color: transparent;
  --mat-chip-outline-width: 0;
  --mat-chip-selected-hover-state-layer-opacity: 0.04;
  --mat-chip-selected-trailing-action-state-layer-color: transparent;
  --mat-chip-trailing-action-focus-opacity: 1;
  --mat-chip-trailing-action-focus-state-layer-opacity: 0;
  --mat-chip-trailing-action-hover-state-layer-opacity: 0;
  --mat-chip-trailing-action-opacity: 0.54;
  --mat-chip-trailing-action-state-layer-color: transparent;
  --mat-chip-with-avatar-avatar-shape-radius: 14px;
  --mat-chip-with-avatar-avatar-size: 28px;
  --mat-chip-with-avatar-disabled-avatar-opacity: 1;
  --mat-chip-with-icon-disabled-icon-opacity: 1;
  --mat-chip-with-icon-icon-size: 18px;
  --mat-chip-with-trailing-icon-disabled-trailing-icon-opacity: 1;
}

.mat-mdc-standard-chip {
  --mat-chip-disabled-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-chip-elevated-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-chip-elevated-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-chip-elevated-selected-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-chip-flat-disabled-selected-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-chip-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-focus-state-layer-opacity: 0.12;
  --mat-chip-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-chip-selected-disabled-trailing-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-selected-focus-state-layer-color: 0.12;
  --mat-chip-selected-focus-state-layer-opacity: 0.12;
  --mat-chip-selected-hover-state-layer-color: 0.04;
  --mat-chip-selected-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-chip-selected-trailing-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-icon-disabled-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-icon-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-icon-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-trailing-icon-disabled-trailing-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-trailing-icon-trailing-icon-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-standard-chip.mat-mdc-chip-selected.mat-primary, .mat-mdc-standard-chip.mat-mdc-chip-highlighted.mat-primary {
  --mat-chip-disabled-label-text-color: white;
  --mat-chip-elevated-container-color: #03a9f4;
  --mat-chip-elevated-disabled-container-color: #03a9f4;
  --mat-chip-elevated-selected-container-color: #03a9f4;
  --mat-chip-flat-disabled-selected-container-color: #03a9f4;
  --mat-chip-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-focus-state-layer-opacity: 0.12;
  --mat-chip-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-label-text-color: white;
  --mat-chip-selected-disabled-trailing-icon-color: white;
  --mat-chip-selected-focus-state-layer-color: 0.12;
  --mat-chip-selected-focus-state-layer-opacity: 0.12;
  --mat-chip-selected-hover-state-layer-color: 0.04;
  --mat-chip-selected-label-text-color: white;
  --mat-chip-selected-trailing-icon-color: white;
  --mat-chip-with-icon-disabled-icon-color: white;
  --mat-chip-with-icon-icon-color: white;
  --mat-chip-with-icon-selected-icon-color: white;
  --mat-chip-with-trailing-icon-disabled-trailing-icon-color: white;
  --mat-chip-with-trailing-icon-trailing-icon-color: white;
}
.mat-mdc-standard-chip.mat-mdc-chip-selected.mat-accent, .mat-mdc-standard-chip.mat-mdc-chip-highlighted.mat-accent {
  --mat-chip-disabled-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-chip-elevated-container-color: #4caf50;
  --mat-chip-elevated-disabled-container-color: #4caf50;
  --mat-chip-elevated-selected-container-color: #4caf50;
  --mat-chip-flat-disabled-selected-container-color: #4caf50;
  --mat-chip-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-focus-state-layer-opacity: 0.12;
  --mat-chip-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-chip-selected-disabled-trailing-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-selected-focus-state-layer-color: 0.12;
  --mat-chip-selected-focus-state-layer-opacity: 0.12;
  --mat-chip-selected-hover-state-layer-color: 0.04;
  --mat-chip-selected-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-chip-selected-trailing-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-icon-disabled-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-icon-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-icon-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-trailing-icon-disabled-trailing-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-trailing-icon-trailing-icon-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-standard-chip.mat-mdc-chip-selected.mat-warn, .mat-mdc-standard-chip.mat-mdc-chip-highlighted.mat-warn {
  --mat-chip-disabled-label-text-color: white;
  --mat-chip-elevated-container-color: #f44336;
  --mat-chip-elevated-disabled-container-color: #f44336;
  --mat-chip-elevated-selected-container-color: #f44336;
  --mat-chip-flat-disabled-selected-container-color: #f44336;
  --mat-chip-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-focus-state-layer-opacity: 0.12;
  --mat-chip-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-label-text-color: white;
  --mat-chip-selected-disabled-trailing-icon-color: white;
  --mat-chip-selected-focus-state-layer-color: 0.12;
  --mat-chip-selected-focus-state-layer-opacity: 0.12;
  --mat-chip-selected-hover-state-layer-color: 0.04;
  --mat-chip-selected-label-text-color: white;
  --mat-chip-selected-trailing-icon-color: white;
  --mat-chip-with-icon-disabled-icon-color: white;
  --mat-chip-with-icon-icon-color: white;
  --mat-chip-with-icon-selected-icon-color: white;
  --mat-chip-with-trailing-icon-disabled-trailing-icon-color: white;
  --mat-chip-with-trailing-icon-trailing-icon-color: white;
}

.mat-mdc-chip.mat-mdc-standard-chip {
  --mat-chip-container-height: 32px;
}

.mat-mdc-standard-chip {
  --mat-chip-label-text-font: toyota-book;
  --mat-chip-label-text-line-height: 20px;
  --mat-chip-label-text-size: 14px;
  --mat-chip-label-text-tracking: 0.0178571429em;
  --mat-chip-label-text-weight: 400;
}

html {
  --mat-slide-toggle-disabled-handle-opacity: 0.38;
  --mat-slide-toggle-disabled-selected-handle-opacity: 0.38;
  --mat-slide-toggle-disabled-selected-icon-opacity: 0.38;
  --mat-slide-toggle-disabled-track-opacity: 0.12;
  --mat-slide-toggle-disabled-unselected-handle-opacity: 0.38;
  --mat-slide-toggle-disabled-unselected-icon-opacity: 0.38;
  --mat-slide-toggle-disabled-unselected-track-outline-color: transparent;
  --mat-slide-toggle-disabled-unselected-track-outline-width: 1px;
  --mat-slide-toggle-handle-height: 20px;
  --mat-slide-toggle-handle-shape: 10px;
  --mat-slide-toggle-handle-width: 20px;
  --mat-slide-toggle-hidden-track-opacity: 1;
  --mat-slide-toggle-hidden-track-transition: transform 75ms 0ms cubic-bezier(0.4, 0, 0.6, 1);
  --mat-slide-toggle-pressed-handle-size: 20px;
  --mat-slide-toggle-selected-focus-state-layer-opacity: 0.12;
  --mat-slide-toggle-selected-handle-horizontal-margin: 0;
  --mat-slide-toggle-selected-handle-size: 20px;
  --mat-slide-toggle-selected-hover-state-layer-opacity: 0.04;
  --mat-slide-toggle-selected-icon-size: 18px;
  --mat-slide-toggle-selected-pressed-handle-horizontal-margin: 0;
  --mat-slide-toggle-selected-pressed-state-layer-opacity: 0.12;
  --mat-slide-toggle-selected-track-outline-color: transparent;
  --mat-slide-toggle-selected-track-outline-width: 1px;
  --mat-slide-toggle-selected-with-icon-handle-horizontal-margin: 0;
  --mat-slide-toggle-track-height: 14px;
  --mat-slide-toggle-track-outline-color: transparent;
  --mat-slide-toggle-track-outline-width: 1px;
  --mat-slide-toggle-track-shape: 7px;
  --mat-slide-toggle-track-width: 36px;
  --mat-slide-toggle-unselected-focus-state-layer-opacity: 0.12;
  --mat-slide-toggle-unselected-handle-horizontal-margin: 0;
  --mat-slide-toggle-unselected-handle-size: 20px;
  --mat-slide-toggle-unselected-hover-state-layer-opacity: 0.12;
  --mat-slide-toggle-unselected-icon-size: 18px;
  --mat-slide-toggle-unselected-pressed-handle-horizontal-margin: 0;
  --mat-slide-toggle-unselected-pressed-state-layer-opacity: 0.1;
  --mat-slide-toggle-unselected-with-icon-handle-horizontal-margin: 0;
  --mat-slide-toggle-visible-track-opacity: 1;
  --mat-slide-toggle-visible-track-transition: transform 75ms 0ms cubic-bezier(0, 0, 0.2, 1);
  --mat-slide-toggle-with-icon-handle-size: 20px;
  --mat-slide-toggle-touch-target-size: 48px;
}

html {
  --mat-slide-toggle-selected-icon-color: white;
  --mat-slide-toggle-disabled-selected-icon-color: white;
  --mat-slide-toggle-selected-focus-state-layer-color: #03a9f4;
  --mat-slide-toggle-selected-handle-color: #03a9f4;
  --mat-slide-toggle-selected-hover-state-layer-color: #03a9f4;
  --mat-slide-toggle-selected-pressed-state-layer-color: #03a9f4;
  --mat-slide-toggle-selected-focus-handle-color: #03a9f4;
  --mat-slide-toggle-selected-hover-handle-color: #03a9f4;
  --mat-slide-toggle-selected-pressed-handle-color: #03a9f4;
  --mat-slide-toggle-selected-focus-track-color: #4fc3f7;
  --mat-slide-toggle-selected-hover-track-color: #4fc3f7;
  --mat-slide-toggle-selected-pressed-track-color: #4fc3f7;
  --mat-slide-toggle-selected-track-color: #4fc3f7;
  --mat-slide-toggle-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-slide-toggle-disabled-handle-elevation-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-slide-toggle-disabled-selected-handle-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-disabled-selected-track-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-disabled-unselected-handle-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-disabled-unselected-icon-color: #f6f6f6;
  --mat-slide-toggle-disabled-unselected-track-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-handle-elevation-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mat-slide-toggle-handle-surface-color: white;
  --mat-slide-toggle-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-unselected-hover-handle-color: #424242;
  --mat-slide-toggle-unselected-focus-handle-color: #424242;
  --mat-slide-toggle-unselected-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-unselected-focus-track-color: rgba(0, 0, 0, 0.12);
  --mat-slide-toggle-unselected-icon-color: #f6f6f6;
  --mat-slide-toggle-unselected-handle-color: rgba(0, 0, 0, 0.54);
  --mat-slide-toggle-unselected-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-unselected-hover-track-color: rgba(0, 0, 0, 0.12);
  --mat-slide-toggle-unselected-pressed-handle-color: #424242;
  --mat-slide-toggle-unselected-pressed-track-color: rgba(0, 0, 0, 0.12);
  --mat-slide-toggle-unselected-pressed-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-unselected-track-color: rgba(0, 0, 0, 0.12);
}

.mat-mdc-slide-toggle.mat-accent {
  --mat-slide-toggle-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-disabled-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-selected-focus-state-layer-color: #4caf50;
  --mat-slide-toggle-selected-handle-color: #4caf50;
  --mat-slide-toggle-selected-hover-state-layer-color: #4caf50;
  --mat-slide-toggle-selected-pressed-state-layer-color: #4caf50;
  --mat-slide-toggle-selected-focus-handle-color: #4caf50;
  --mat-slide-toggle-selected-hover-handle-color: #4caf50;
  --mat-slide-toggle-selected-pressed-handle-color: #4caf50;
  --mat-slide-toggle-selected-focus-track-color: #81c784;
  --mat-slide-toggle-selected-hover-track-color: #81c784;
  --mat-slide-toggle-selected-pressed-track-color: #81c784;
  --mat-slide-toggle-selected-track-color: #81c784;
}
.mat-mdc-slide-toggle.mat-warn {
  --mat-slide-toggle-selected-icon-color: white;
  --mat-slide-toggle-disabled-selected-icon-color: white;
  --mat-slide-toggle-selected-focus-state-layer-color: #f44336;
  --mat-slide-toggle-selected-handle-color: #f44336;
  --mat-slide-toggle-selected-hover-state-layer-color: #f44336;
  --mat-slide-toggle-selected-pressed-state-layer-color: #f44336;
  --mat-slide-toggle-selected-focus-handle-color: #f44336;
  --mat-slide-toggle-selected-hover-handle-color: #f44336;
  --mat-slide-toggle-selected-pressed-handle-color: #f44336;
  --mat-slide-toggle-selected-focus-track-color: #e57373;
  --mat-slide-toggle-selected-hover-track-color: #e57373;
  --mat-slide-toggle-selected-pressed-track-color: #e57373;
  --mat-slide-toggle-selected-track-color: #e57373;
}

html {
  --mat-slide-toggle-state-layer-size: 40px;
  --mat-slide-toggle-touch-target-display: block;
}

html {
  --mat-slide-toggle-label-text-font: toyota-book;
  --mat-slide-toggle-label-text-line-height: 20px;
  --mat-slide-toggle-label-text-size: 14px;
  --mat-slide-toggle-label-text-tracking: 0.0178571429em;
  --mat-slide-toggle-label-text-weight: 400;
}
html .mat-mdc-slide-toggle {
  --mat-slide-toggle-label-text-font: toyota-book;
  --mat-slide-toggle-label-text-line-height: 20px;
  --mat-slide-toggle-label-text-size: 14px;
  --mat-slide-toggle-label-text-tracking: 0.0178571429em;
  --mat-slide-toggle-label-text-weight: 400;
}

html {
  --mat-radio-disabled-selected-icon-opacity: 0.38;
  --mat-radio-disabled-unselected-icon-opacity: 0.38;
  --mat-radio-state-layer-size: 40px;
  --mat-radio-touch-target-size: 48px;
}

.mat-mdc-radio-button.mat-primary {
  --mat-radio-checked-ripple-color: #03a9f4;
  --mat-radio-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-radio-disabled-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-disabled-unselected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-radio-ripple-color: rgba(0, 0, 0, 0.87);
  --mat-radio-selected-focus-icon-color: #03a9f4;
  --mat-radio-selected-hover-icon-color: #03a9f4;
  --mat-radio-selected-icon-color: #03a9f4;
  --mat-radio-selected-pressed-icon-color: #03a9f4;
  --mat-radio-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-radio-unselected-pressed-icon-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-radio-button.mat-accent {
  --mat-radio-checked-ripple-color: #4caf50;
  --mat-radio-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-radio-disabled-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-disabled-unselected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-radio-ripple-color: rgba(0, 0, 0, 0.87);
  --mat-radio-selected-focus-icon-color: #4caf50;
  --mat-radio-selected-hover-icon-color: #4caf50;
  --mat-radio-selected-icon-color: #4caf50;
  --mat-radio-selected-pressed-icon-color: #4caf50;
  --mat-radio-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-radio-unselected-pressed-icon-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-radio-button.mat-warn {
  --mat-radio-checked-ripple-color: #f44336;
  --mat-radio-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-radio-disabled-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-disabled-unselected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-radio-ripple-color: rgba(0, 0, 0, 0.87);
  --mat-radio-selected-focus-icon-color: #f44336;
  --mat-radio-selected-hover-icon-color: #f44336;
  --mat-radio-selected-icon-color: #f44336;
  --mat-radio-selected-pressed-icon-color: #f44336;
  --mat-radio-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-radio-unselected-pressed-icon-color: rgba(0, 0, 0, 0.87);
}

html {
  --mat-radio-state-layer-size: 40px;
  --mat-radio-touch-target-display: block;
}

html {
  --mat-radio-label-text-font: toyota-book;
  --mat-radio-label-text-line-height: 20px;
  --mat-radio-label-text-size: 14px;
  --mat-radio-label-text-tracking: 0.0178571429em;
  --mat-radio-label-text-weight: 400;
}

html {
  --mat-slider-active-track-height: 6px;
  --mat-slider-active-track-shape: 9999px;
  --mat-slider-handle-elevation: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mat-slider-handle-height: 20px;
  --mat-slider-handle-shape: 50%;
  --mat-slider-handle-width: 20px;
  --mat-slider-inactive-track-height: 4px;
  --mat-slider-inactive-track-shape: 9999px;
  --mat-slider-value-indicator-border-radius: 4px;
  --mat-slider-value-indicator-caret-display: block;
  --mat-slider-value-indicator-container-transform: translateX(-50%);
  --mat-slider-value-indicator-height: 32px;
  --mat-slider-value-indicator-padding: 0 12px;
  --mat-slider-value-indicator-text-transform: none;
  --mat-slider-value-indicator-width: auto;
  --mat-slider-with-overlap-handle-outline-width: 1px;
  --mat-slider-with-tick-marks-active-container-opacity: 0.6;
  --mat-slider-with-tick-marks-container-shape: 50%;
  --mat-slider-with-tick-marks-container-size: 2px;
  --mat-slider-with-tick-marks-inactive-container-opacity: 0.6;
  --mat-slider-value-indicator-transform-origin: bottom;
}

html {
  --mat-slider-active-track-color: #03a9f4;
  --mat-slider-focus-handle-color: #03a9f4;
  --mat-slider-handle-color: #03a9f4;
  --mat-slider-hover-handle-color: #03a9f4;
  --mat-slider-focus-state-layer-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-slider-hover-state-layer-color: color-mix(in srgb, #03a9f4 4%, transparent);
  --mat-slider-inactive-track-color: #03a9f4;
  --mat-slider-ripple-color: #03a9f4;
  --mat-slider-with-tick-marks-active-container-color: white;
  --mat-slider-with-tick-marks-inactive-container-color: #03a9f4;
  --mat-slider-disabled-active-track-color: rgba(0, 0, 0, 0.87);
  --mat-slider-disabled-handle-color: rgba(0, 0, 0, 0.87);
  --mat-slider-disabled-inactive-track-color: rgba(0, 0, 0, 0.87);
  --mat-slider-label-container-color: #424242;
  --mat-slider-label-label-text-color: white;
  --mat-slider-value-indicator-opacity: 1;
  --mat-slider-with-overlap-handle-outline-color: rgba(0, 0, 0, 0.87);
  --mat-slider-with-tick-marks-disabled-container-color: rgba(0, 0, 0, 0.87);
}

.mat-accent {
  --mat-slider-active-track-color: #4caf50;
  --mat-slider-focus-handle-color: #4caf50;
  --mat-slider-handle-color: #4caf50;
  --mat-slider-hover-handle-color: #4caf50;
  --mat-slider-focus-state-layer-color: color-mix(in srgb, #4caf50 12%, transparent);
  --mat-slider-hover-state-layer-color: color-mix(in srgb, #4caf50 4%, transparent);
  --mat-slider-inactive-track-color: #4caf50;
  --mat-slider-ripple-color: #4caf50;
  --mat-slider-with-tick-marks-active-container-color: rgba(0, 0, 0, 0.87);
  --mat-slider-with-tick-marks-inactive-container-color: #4caf50;
}

.mat-warn {
  --mat-slider-active-track-color: #f44336;
  --mat-slider-focus-handle-color: #f44336;
  --mat-slider-handle-color: #f44336;
  --mat-slider-hover-handle-color: #f44336;
  --mat-slider-focus-state-layer-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-slider-hover-state-layer-color: color-mix(in srgb, #f44336 4%, transparent);
  --mat-slider-inactive-track-color: #f44336;
  --mat-slider-ripple-color: #f44336;
  --mat-slider-with-tick-marks-active-container-color: white;
  --mat-slider-with-tick-marks-inactive-container-color: #f44336;
}

html {
  --mat-slider-label-label-text-font: toyota-book;
  --mat-slider-label-label-text-size: 14px;
  --mat-slider-label-label-text-line-height: 22px;
  --mat-slider-label-label-text-tracking: 0.0071428571em;
  --mat-slider-label-label-text-weight: 500;
}

html {
  --mat-menu-container-shape: 4px;
  --mat-menu-divider-bottom-spacing: 0;
  --mat-menu-divider-top-spacing: 0;
  --mat-menu-item-spacing: 16px;
  --mat-menu-item-icon-size: 24px;
  --mat-menu-item-leading-spacing: 16px;
  --mat-menu-item-trailing-spacing: 16px;
  --mat-menu-item-with-icon-leading-spacing: 16px;
  --mat-menu-item-with-icon-trailing-spacing: 16px;
  --mat-menu-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

html {
  --mat-menu-item-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-menu-item-icon-color: rgba(0, 0, 0, 0.87);
  --mat-menu-item-hover-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 4%, transparent);
  --mat-menu-item-focus-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-menu-container-color: white;
  --mat-menu-divider-color: rgba(0, 0, 0, 0.12);
}

html {
  --mat-menu-item-label-text-font: toyota-book;
  --mat-menu-item-label-text-size: 16px;
  --mat-menu-item-label-text-tracking: 0.03125em;
  --mat-menu-item-label-text-line-height: 24px;
  --mat-menu-item-label-text-weight: 400;
}

html {
  --mat-list-active-indicator-color: transparent;
  --mat-list-active-indicator-shape: 4px;
  --mat-list-list-item-container-shape: 0;
  --mat-list-list-item-leading-avatar-shape: 50%;
  --mat-list-list-item-container-color: transparent;
  --mat-list-list-item-selected-container-color: transparent;
  --mat-list-list-item-leading-avatar-color: transparent;
  --mat-list-list-item-leading-icon-size: 24px;
  --mat-list-list-item-leading-avatar-size: 40px;
  --mat-list-list-item-trailing-icon-size: 24px;
  --mat-list-list-item-disabled-state-layer-color: transparent;
  --mat-list-list-item-disabled-state-layer-opacity: 0;
  --mat-list-list-item-disabled-label-text-opacity: 0.38;
  --mat-list-list-item-disabled-leading-icon-opacity: 0.38;
  --mat-list-list-item-disabled-trailing-icon-opacity: 0.38;
}

html {
  --mat-list-list-item-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-supporting-text-color: rgba(0, 0, 0, 0.54);
  --mat-list-list-item-leading-icon-color: rgba(0, 0, 0, 0.54);
  --mat-list-list-item-trailing-supporting-text-color: rgba(0, 0, 0, 0.54);
  --mat-list-list-item-trailing-icon-color: rgba(0, 0, 0, 0.54);
  --mat-list-list-item-selected-trailing-icon-color: rgba(0, 0, 0, 0.54);
  --mat-list-list-item-disabled-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-disabled-leading-icon-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-disabled-trailing-icon-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-hover-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-hover-leading-icon-color: rgba(0, 0, 0, 0.54);
  --mat-list-list-item-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-hover-state-layer-opacity: 0.04;
  --mat-list-list-item-hover-trailing-icon-color: rgba(0, 0, 0, 0.54);
  --mat-list-list-item-focus-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-focus-state-layer-opacity: 0.12;
}

.mdc-list-item__start,
.mdc-list-item__end {
  --mat-radio-checked-ripple-color: #03a9f4;
  --mat-radio-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-radio-disabled-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-disabled-unselected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-radio-ripple-color: rgba(0, 0, 0, 0.87);
  --mat-radio-selected-focus-icon-color: #03a9f4;
  --mat-radio-selected-hover-icon-color: #03a9f4;
  --mat-radio-selected-icon-color: #03a9f4;
  --mat-radio-selected-pressed-icon-color: #03a9f4;
  --mat-radio-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-radio-unselected-pressed-icon-color: rgba(0, 0, 0, 0.87);
}

.mat-accent .mdc-list-item__start,
.mat-accent .mdc-list-item__end {
  --mat-radio-checked-ripple-color: #4caf50;
  --mat-radio-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-radio-disabled-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-disabled-unselected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-radio-ripple-color: rgba(0, 0, 0, 0.87);
  --mat-radio-selected-focus-icon-color: #4caf50;
  --mat-radio-selected-hover-icon-color: #4caf50;
  --mat-radio-selected-icon-color: #4caf50;
  --mat-radio-selected-pressed-icon-color: #4caf50;
  --mat-radio-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-radio-unselected-pressed-icon-color: rgba(0, 0, 0, 0.87);
}

.mat-warn .mdc-list-item__start,
.mat-warn .mdc-list-item__end {
  --mat-radio-checked-ripple-color: #f44336;
  --mat-radio-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-radio-disabled-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-disabled-unselected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-radio-ripple-color: rgba(0, 0, 0, 0.87);
  --mat-radio-selected-focus-icon-color: #f44336;
  --mat-radio-selected-hover-icon-color: #f44336;
  --mat-radio-selected-icon-color: #f44336;
  --mat-radio-selected-pressed-icon-color: #f44336;
  --mat-radio-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-radio-unselected-pressed-icon-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-list-option {
  --mat-checkbox-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-selected-checkmark-color: white;
  --mat-checkbox-selected-focus-icon-color: #03a9f4;
  --mat-checkbox-selected-hover-icon-color: #03a9f4;
  --mat-checkbox-selected-icon-color: #03a9f4;
  --mat-checkbox-selected-pressed-icon-color: #03a9f4;
  --mat-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-checkbox-selected-focus-state-layer-color: #03a9f4;
  --mat-checkbox-selected-hover-state-layer-color: #03a9f4;
  --mat-checkbox-selected-pressed-state-layer-color: #03a9f4;
  --mat-checkbox-unselected-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-pressed-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-list-option.mat-accent {
  --mat-checkbox-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-selected-checkmark-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-selected-focus-icon-color: #4caf50;
  --mat-checkbox-selected-hover-icon-color: #4caf50;
  --mat-checkbox-selected-icon-color: #4caf50;
  --mat-checkbox-selected-pressed-icon-color: #4caf50;
  --mat-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-checkbox-selected-focus-state-layer-color: #4caf50;
  --mat-checkbox-selected-hover-state-layer-color: #4caf50;
  --mat-checkbox-selected-pressed-state-layer-color: #4caf50;
  --mat-checkbox-unselected-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-pressed-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-list-option.mat-warn {
  --mat-checkbox-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-selected-checkmark-color: white;
  --mat-checkbox-selected-focus-icon-color: #f44336;
  --mat-checkbox-selected-hover-icon-color: #f44336;
  --mat-checkbox-selected-icon-color: #f44336;
  --mat-checkbox-selected-pressed-icon-color: #f44336;
  --mat-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-checkbox-selected-focus-state-layer-color: #f44336;
  --mat-checkbox-selected-hover-state-layer-color: #f44336;
  --mat-checkbox-selected-pressed-state-layer-color: #f44336;
  --mat-checkbox-unselected-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-pressed-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-list-base.mat-mdc-list-base .mdc-list-item--selected .mdc-list-item__primary-text,
.mat-mdc-list-base.mat-mdc-list-base .mdc-list-item--selected .mdc-list-item__start,
.mat-mdc-list-base.mat-mdc-list-base .mdc-list-item--activated .mdc-list-item__primary-text,
.mat-mdc-list-base.mat-mdc-list-base .mdc-list-item--activated .mdc-list-item__start {
  color: #03a9f4;
}

.mat-mdc-list-base .mdc-list-item--disabled .mdc-list-item__start,
.mat-mdc-list-base .mdc-list-item--disabled .mdc-list-item__content,
.mat-mdc-list-base .mdc-list-item--disabled .mdc-list-item__end {
  opacity: 1;
}

html {
  --mat-list-list-item-leading-icon-start-space: 16px;
  --mat-list-list-item-leading-icon-end-space: 32px;
  --mat-list-list-item-one-line-container-height: 48px;
  --mat-list-list-item-two-line-container-height: 64px;
  --mat-list-list-item-three-line-container-height: 88px;
}

.mdc-list-item__start,
.mdc-list-item__end {
  --mat-radio-state-layer-size: 40px;
  --mat-radio-touch-target-display: block;
}

.mat-mdc-list-item.mdc-list-item--with-leading-avatar.mdc-list-item--with-one-line, .mat-mdc-list-item.mdc-list-item--with-leading-checkbox.mdc-list-item--with-one-line, .mat-mdc-list-item.mdc-list-item--with-leading-icon.mdc-list-item--with-one-line {
  height: 56px;
}
.mat-mdc-list-item.mdc-list-item--with-leading-avatar.mdc-list-item--with-two-lines, .mat-mdc-list-item.mdc-list-item--with-leading-checkbox.mdc-list-item--with-two-lines, .mat-mdc-list-item.mdc-list-item--with-leading-icon.mdc-list-item--with-two-lines {
  height: 72px;
}

html {
  --mat-list-list-item-label-text-font: toyota-book;
  --mat-list-list-item-label-text-line-height: 24px;
  --mat-list-list-item-label-text-size: 16px;
  --mat-list-list-item-label-text-tracking: 0.03125em;
  --mat-list-list-item-label-text-weight: 400;
  --mat-list-list-item-supporting-text-font: toyota-book;
  --mat-list-list-item-supporting-text-line-height: 20px;
  --mat-list-list-item-supporting-text-size: 14px;
  --mat-list-list-item-supporting-text-tracking: 0.0178571429em;
  --mat-list-list-item-supporting-text-weight: 400;
  --mat-list-list-item-trailing-supporting-text-font: toyota-book;
  --mat-list-list-item-trailing-supporting-text-line-height: 20px;
  --mat-list-list-item-trailing-supporting-text-size: 12px;
  --mat-list-list-item-trailing-supporting-text-tracking: 0.0333333333em;
  --mat-list-list-item-trailing-supporting-text-weight: 400;
}

.mdc-list-group__subheader {
  font: 400 16px / 28px toyota-book;
  letter-spacing: 0.009375em;
}

html {
  --mat-paginator-page-size-select-width: 84px;
  --mat-paginator-page-size-select-touch-target-height: 48px;
}

html {
  --mat-paginator-container-text-color: rgba(0, 0, 0, 0.87);
  --mat-paginator-container-background-color: white;
  --mat-paginator-enabled-icon-color: rgba(0, 0, 0, 0.54);
  --mat-paginator-disabled-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
}

html {
  --mat-paginator-container-size: 56px;
  --mat-paginator-form-field-container-height: 40px;
  --mat-paginator-form-field-container-vertical-padding: 8px;
  --mat-paginator-touch-target-display: block;
}

html {
  --mat-paginator-container-text-font: toyota-book;
  --mat-paginator-container-text-line-height: 20px;
  --mat-paginator-container-text-size: 12px;
  --mat-paginator-container-text-tracking: 0.0333333333em;
  --mat-paginator-container-text-weight: 400;
  --mat-paginator-select-trigger-text-size: 12px;
}

html {
  --mat-tab-container-height: 48px;
  --mat-tab-divider-color: transparent;
  --mat-tab-divider-height: 0;
  --mat-tab-active-indicator-height: 2px;
  --mat-tab-active-indicator-shape: 0;
}

.mat-mdc-tab-group,
.mat-mdc-tab-nav-bar {
  --mat-tab-disabled-ripple-color: rgba(0, 0, 0, 0.54);
  --mat-tab-pagination-icon-color: rgba(0, 0, 0, 0.87);
  --mat-tab-inactive-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-active-label-text-color: #03a9f4;
  --mat-tab-active-ripple-color: #03a9f4;
  --mat-tab-inactive-ripple-color: #03a9f4;
  --mat-tab-inactive-focus-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-inactive-hover-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-active-focus-label-text-color: #03a9f4;
  --mat-tab-active-hover-label-text-color: #03a9f4;
  --mat-tab-active-focus-indicator-color: #03a9f4;
  --mat-tab-active-hover-indicator-color: #03a9f4;
  --mat-tab-active-indicator-color: #03a9f4;
}
.mat-mdc-tab-group.mat-accent,
.mat-mdc-tab-nav-bar.mat-accent {
  --mat-tab-disabled-ripple-color: rgba(0, 0, 0, 0.54);
  --mat-tab-pagination-icon-color: rgba(0, 0, 0, 0.87);
  --mat-tab-inactive-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-active-label-text-color: #4caf50;
  --mat-tab-active-ripple-color: #4caf50;
  --mat-tab-inactive-ripple-color: #4caf50;
  --mat-tab-inactive-focus-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-inactive-hover-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-active-focus-label-text-color: #4caf50;
  --mat-tab-active-hover-label-text-color: #4caf50;
  --mat-tab-active-focus-indicator-color: #4caf50;
  --mat-tab-active-hover-indicator-color: #4caf50;
  --mat-tab-active-indicator-color: #4caf50;
}
.mat-mdc-tab-group.mat-warn,
.mat-mdc-tab-nav-bar.mat-warn {
  --mat-tab-disabled-ripple-color: rgba(0, 0, 0, 0.54);
  --mat-tab-pagination-icon-color: rgba(0, 0, 0, 0.87);
  --mat-tab-inactive-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-active-label-text-color: #f44336;
  --mat-tab-active-ripple-color: #f44336;
  --mat-tab-inactive-ripple-color: #f44336;
  --mat-tab-inactive-focus-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-inactive-hover-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-active-focus-label-text-color: #f44336;
  --mat-tab-active-hover-label-text-color: #f44336;
  --mat-tab-active-focus-indicator-color: #f44336;
  --mat-tab-active-hover-indicator-color: #f44336;
  --mat-tab-active-indicator-color: #f44336;
}
.mat-mdc-tab-group.mat-background-primary,
.mat-mdc-tab-nav-bar.mat-background-primary {
  --mat-tab-background-color: #03a9f4;
  --mat-tab-foreground-color: white;
}
.mat-mdc-tab-group.mat-background-accent,
.mat-mdc-tab-nav-bar.mat-background-accent {
  --mat-tab-background-color: #4caf50;
  --mat-tab-foreground-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-tab-group.mat-background-warn,
.mat-mdc-tab-nav-bar.mat-background-warn {
  --mat-tab-background-color: #f44336;
  --mat-tab-foreground-color: white;
}

.mat-mdc-tab-header {
  --mat-tab-container-height: 48px;
}

.mat-mdc-tab-header {
  --mat-tab-label-text-font: toyota-book;
  --mat-tab-label-text-size: 14px;
  --mat-tab-label-text-tracking: 0.0892857143em;
  --mat-tab-label-text-line-height: 36px;
  --mat-tab-label-text-weight: 500;
}

html {
  --mat-checkbox-disabled-selected-checkmark-color: white;
  --mat-checkbox-selected-focus-state-layer-opacity: 0.12;
  --mat-checkbox-selected-hover-state-layer-opacity: 0.04;
  --mat-checkbox-selected-pressed-state-layer-opacity: 0.12;
  --mat-checkbox-unselected-focus-state-layer-opacity: 0.12;
  --mat-checkbox-unselected-hover-state-layer-opacity: 0.04;
  --mat-checkbox-unselected-pressed-state-layer-opacity: 0.12;
  --mat-checkbox-touch-target-size: 48px;
}

html {
  --mat-checkbox-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-selected-checkmark-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-selected-focus-icon-color: #4caf50;
  --mat-checkbox-selected-hover-icon-color: #4caf50;
  --mat-checkbox-selected-icon-color: #4caf50;
  --mat-checkbox-selected-pressed-icon-color: #4caf50;
  --mat-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-checkbox-selected-focus-state-layer-color: #4caf50;
  --mat-checkbox-selected-hover-state-layer-color: #4caf50;
  --mat-checkbox-selected-pressed-state-layer-color: #4caf50;
  --mat-checkbox-unselected-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-pressed-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-checkbox.mat-primary {
  --mat-checkbox-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-selected-checkmark-color: white;
  --mat-checkbox-selected-focus-icon-color: #03a9f4;
  --mat-checkbox-selected-hover-icon-color: #03a9f4;
  --mat-checkbox-selected-icon-color: #03a9f4;
  --mat-checkbox-selected-pressed-icon-color: #03a9f4;
  --mat-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-checkbox-selected-focus-state-layer-color: #03a9f4;
  --mat-checkbox-selected-hover-state-layer-color: #03a9f4;
  --mat-checkbox-selected-pressed-state-layer-color: #03a9f4;
  --mat-checkbox-unselected-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-pressed-state-layer-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-checkbox.mat-warn {
  --mat-checkbox-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-selected-checkmark-color: white;
  --mat-checkbox-selected-focus-icon-color: #f44336;
  --mat-checkbox-selected-hover-icon-color: #f44336;
  --mat-checkbox-selected-icon-color: #f44336;
  --mat-checkbox-selected-pressed-icon-color: #f44336;
  --mat-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-checkbox-selected-focus-state-layer-color: #f44336;
  --mat-checkbox-selected-hover-state-layer-color: #f44336;
  --mat-checkbox-selected-pressed-state-layer-color: #f44336;
  --mat-checkbox-unselected-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-pressed-state-layer-color: rgba(0, 0, 0, 0.87);
}

html {
  --mat-checkbox-touch-target-display: block;
  --mat-checkbox-state-layer-size: 40px;
}

html {
  --mat-checkbox-label-text-font: toyota-book;
  --mat-checkbox-label-text-line-height: 20px;
  --mat-checkbox-label-text-size: 14px;
  --mat-checkbox-label-text-tracking: 0.0178571429em;
  --mat-checkbox-label-text-weight: 400;
}

html {
  --mat-button-filled-container-shape: 4px;
  --mat-button-filled-horizontal-padding: 16px;
  --mat-button-filled-icon-offset: -4px;
  --mat-button-filled-icon-spacing: 8px;
  --mat-button-filled-touch-target-size: 48px;
  --mat-button-outlined-container-shape: 4px;
  --mat-button-outlined-horizontal-padding: 15px;
  --mat-button-outlined-icon-offset: -4px;
  --mat-button-outlined-icon-spacing: 8px;
  --mat-button-outlined-keep-touch-target: false;
  --mat-button-outlined-outline-width: 1px;
  --mat-button-outlined-touch-target-size: 48px;
  --mat-button-protected-container-elevation-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-container-shape: 4px;
  --mat-button-protected-disabled-container-elevation-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-focus-container-elevation-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-horizontal-padding: 16px;
  --mat-button-protected-hover-container-elevation-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-icon-offset: -4px;
  --mat-button-protected-icon-spacing: 8px;
  --mat-button-protected-pressed-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-button-protected-touch-target-size: 48px;
  --mat-button-text-container-shape: 4px;
  --mat-button-text-horizontal-padding: 8px;
  --mat-button-text-icon-offset: 0;
  --mat-button-text-icon-spacing: 8px;
  --mat-button-text-with-icon-horizontal-padding: 8px;
  --mat-button-text-touch-target-size: 48px;
  --mat-button-tonal-container-shape: 4px;
  --mat-button-tonal-horizontal-padding: 16px;
  --mat-button-tonal-icon-offset: -4px;
  --mat-button-tonal-icon-spacing: 8px;
  --mat-button-tonal-touch-target-size: 48px;
}

html {
  --mat-button-filled-container-color: white;
  --mat-button-filled-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-filled-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-filled-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-filled-focus-state-layer-opacity: 0.12;
  --mat-button-filled-hover-state-layer-opacity: 0.04;
  --mat-button-filled-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-filled-pressed-state-layer-opacity: 0.12;
  --mat-button-filled-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-filled-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-outlined-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-outlined-disabled-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-outlined-focus-state-layer-opacity: 0.12;
  --mat-button-outlined-hover-state-layer-opacity: 0.04;
  --mat-button-outlined-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-pressed-state-layer-opacity: 0.12;
  --mat-button-outlined-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-outlined-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-protected-container-color: white;
  --mat-button-protected-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-protected-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-protected-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-protected-focus-state-layer-opacity: 0.12;
  --mat-button-protected-hover-state-layer-opacity: 0.04;
  --mat-button-protected-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-protected-pressed-state-layer-opacity: 0.12;
  --mat-button-protected-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-protected-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-text-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-text-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-text-focus-state-layer-opacity: 0.12;
  --mat-button-text-hover-state-layer-opacity: 0.04;
  --mat-button-text-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-text-pressed-state-layer-opacity: 0.12;
  --mat-button-text-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-text-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-tonal-container-color: white;
  --mat-button-tonal-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-tonal-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-tonal-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-tonal-focus-state-layer-opacity: 0.12;
  --mat-button-tonal-hover-state-layer-opacity: 0.04;
  --mat-button-tonal-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-tonal-pressed-state-layer-opacity: 0.12;
  --mat-button-tonal-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-tonal-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-button.mat-primary,
.mat-mdc-unelevated-button.mat-primary,
.mat-mdc-raised-button.mat-primary,
.mat-mdc-outlined-button.mat-primary,
.mat-tonal-button.mat-primary {
  --mat-button-filled-container-color: #03a9f4;
  --mat-button-filled-label-text-color: white;
  --mat-button-filled-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-filled-state-layer-color: white;
  --mat-button-outlined-label-text-color: #03a9f4;
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-button-outlined-state-layer-color: #03a9f4;
  --mat-button-protected-container-color: #03a9f4;
  --mat-button-protected-label-text-color: white;
  --mat-button-protected-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-protected-state-layer-color: white;
  --mat-button-text-label-text-color: #03a9f4;
  --mat-button-text-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-button-text-state-layer-color: #03a9f4;
  --mat-button-tonal-container-color: #03a9f4;
  --mat-button-tonal-label-text-color: white;
  --mat-button-tonal-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-tonal-state-layer-color: white;
}
.mat-mdc-button.mat-accent,
.mat-mdc-unelevated-button.mat-accent,
.mat-mdc-raised-button.mat-accent,
.mat-mdc-outlined-button.mat-accent,
.mat-tonal-button.mat-accent {
  --mat-button-filled-container-color: #4caf50;
  --mat-button-filled-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-filled-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-filled-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-outlined-label-text-color: #4caf50;
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-ripple-color: color-mix(in srgb, #4caf50 12%, transparent);
  --mat-button-outlined-state-layer-color: #4caf50;
  --mat-button-protected-container-color: #4caf50;
  --mat-button-protected-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-protected-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-protected-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-text-label-text-color: #4caf50;
  --mat-button-text-ripple-color: color-mix(in srgb, #4caf50 12%, transparent);
  --mat-button-text-state-layer-color: #4caf50;
  --mat-button-tonal-container-color: #4caf50;
  --mat-button-tonal-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-tonal-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-tonal-state-layer-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-button.mat-warn,
.mat-mdc-unelevated-button.mat-warn,
.mat-mdc-raised-button.mat-warn,
.mat-mdc-outlined-button.mat-warn,
.mat-tonal-button.mat-warn {
  --mat-button-filled-container-color: #f44336;
  --mat-button-filled-label-text-color: white;
  --mat-button-filled-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-filled-state-layer-color: white;
  --mat-button-outlined-label-text-color: #f44336;
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-button-outlined-state-layer-color: #f44336;
  --mat-button-protected-container-color: #f44336;
  --mat-button-protected-label-text-color: white;
  --mat-button-protected-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-protected-state-layer-color: white;
  --mat-button-text-label-text-color: #f44336;
  --mat-button-text-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-button-text-state-layer-color: #f44336;
  --mat-button-tonal-container-color: #f44336;
  --mat-button-tonal-label-text-color: white;
  --mat-button-tonal-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-tonal-state-layer-color: white;
}

html {
  --mat-button-filled-container-height: 36px;
  --mat-button-filled-touch-target-display: block;
  --mat-button-outlined-container-height: 36px;
  --mat-button-outlined-touch-target-display: block;
  --mat-button-protected-container-height: 36px;
  --mat-button-protected-touch-target-display: block;
  --mat-button-text-container-height: 36px;
  --mat-button-text-touch-target-display: block;
  --mat-button-tonal-container-height: 36px;
  --mat-button-tonal-touch-target-display: block;
}

html {
  --mat-button-filled-label-text-font: toyota-book;
  --mat-button-filled-label-text-size: 14px;
  --mat-button-filled-label-text-tracking: 0.0892857143em;
  --mat-button-filled-label-text-transform: none;
  --mat-button-filled-label-text-weight: 500;
  --mat-button-outlined-label-text-font: toyota-book;
  --mat-button-outlined-label-text-size: 14px;
  --mat-button-outlined-label-text-tracking: 0.0892857143em;
  --mat-button-outlined-label-text-transform: none;
  --mat-button-outlined-label-text-weight: 500;
  --mat-button-protected-label-text-font: toyota-book;
  --mat-button-protected-label-text-size: 14px;
  --mat-button-protected-label-text-tracking: 0.0892857143em;
  --mat-button-protected-label-text-transform: none;
  --mat-button-protected-label-text-weight: 500;
  --mat-button-text-label-text-font: toyota-book;
  --mat-button-text-label-text-size: 14px;
  --mat-button-text-label-text-tracking: 0.0892857143em;
  --mat-button-text-label-text-transform: none;
  --mat-button-text-label-text-weight: 500;
  --mat-button-tonal-label-text-font: toyota-book;
  --mat-button-tonal-label-text-size: 14px;
  --mat-button-tonal-label-text-tracking: 0.0892857143em;
  --mat-button-tonal-label-text-transform: none;
  --mat-button-tonal-label-text-weight: 500;
}

html {
  --mat-icon-button-icon-size: 24px;
  --mat-icon-button-container-shape: 50%;
  --mat-icon-button-touch-target-size: 48px;
}

html {
  --mat-icon-button-disabled-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-icon-button-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-icon-button-focus-state-layer-opacity: 0.12;
  --mat-icon-button-hover-state-layer-opacity: 0.04;
  --mat-icon-button-icon-color: inherit;
  --mat-icon-button-pressed-state-layer-opacity: 0.12;
  --mat-icon-button-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-icon-button-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-icon-button.mat-primary {
  --mat-icon-button-icon-color: #03a9f4;
  --mat-icon-button-state-layer-color: #03a9f4;
  --mat-icon-button-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
}
.mat-mdc-icon-button.mat-accent {
  --mat-icon-button-icon-color: #4caf50;
  --mat-icon-button-state-layer-color: #4caf50;
  --mat-icon-button-ripple-color: color-mix(in srgb, #4caf50 12%, transparent);
}
.mat-mdc-icon-button.mat-warn {
  --mat-icon-button-icon-color: #f44336;
  --mat-icon-button-state-layer-color: #f44336;
  --mat-icon-button-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
}

html {
  --mat-icon-button-touch-target-display: block;
}

.mat-mdc-icon-button.mat-mdc-button-base {
  --mdc-icon-button-state-layer-size: 48px;
  --mat-icon-button-state-layer-size: 48px;
  width: var(--mat-icon-button-state-layer-size);
  height: var(--mat-icon-button-state-layer-size);
  padding: 12px;
}

html {
  --mat-fab-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-container-shape: 50%;
  --mat-fab-touch-target-size: 48px;
  --mat-fab-extended-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-extended-container-height: 48px;
  --mat-fab-extended-container-shape: 24px;
  --mat-fab-extended-focus-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-extended-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-extended-pressed-container-elevation-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  --mat-fab-focus-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-pressed-container-elevation-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  --mat-fab-small-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-small-container-shape: 50%;
  --mat-fab-small-touch-target-size: 48px;
  --mat-fab-small-focus-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-small-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-small-pressed-container-elevation-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
}

html {
  --mat-fab-container-color: white;
  --mat-fab-disabled-state-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-disabled-state-foreground-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-fab-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-fab-focus-state-layer-opacity: 0.12;
  --mat-fab-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-fab-hover-state-layer-opacity: 0.04;
  --mat-fab-pressed-state-layer-opacity: 0.12;
  --mat-fab-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-small-container-color: white;
  --mat-fab-small-disabled-state-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-small-disabled-state-foreground-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-fab-small-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-fab-small-focus-state-layer-opacity: 0.12;
  --mat-fab-small-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-fab-small-hover-state-layer-opacity: 0.04;
  --mat-fab-small-pressed-state-layer-opacity: 0.12;
  --mat-fab-small-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-small-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-fab-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-fab.mat-primary, .mat-mdc-mini-fab.mat-primary {
  --mat-fab-container-color: #03a9f4;
  --mat-fab-foreground-color: white;
  --mat-fab-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-fab-small-container-color: #03a9f4;
  --mat-fab-small-foreground-color: white;
  --mat-fab-small-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-fab-small-state-layer-color: white;
  --mat-fab-state-layer-color: white;
}
.mat-mdc-fab.mat-accent, .mat-mdc-mini-fab.mat-accent {
  --mat-fab-container-color: #4caf50;
  --mat-fab-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-fab-ripple-color: color-mix(in srgb, #4caf50 12%, transparent);
  --mat-fab-small-container-color: #4caf50;
  --mat-fab-small-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-fab-small-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-small-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-fab-state-layer-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-fab.mat-warn, .mat-mdc-mini-fab.mat-warn {
  --mat-fab-container-color: #f44336;
  --mat-fab-foreground-color: white;
  --mat-fab-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-fab-small-container-color: #f44336;
  --mat-fab-small-foreground-color: white;
  --mat-fab-small-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-fab-small-state-layer-color: white;
  --mat-fab-state-layer-color: white;
}

html {
  --mat-fab-small-touch-target-display: block;
  --mat-fab-touch-target-display: block;
}

html {
  --mat-fab-extended-label-text-font: toyota-book;
  --mat-fab-extended-label-text-size: 14px;
  --mat-fab-extended-label-text-tracking: 0.0892857143em;
  --mat-fab-extended-label-text-weight: 500;
}

html {
  --mat-snack-bar-container-shape: 4px;
}

html {
  --mat-snack-bar-container-color: #424242;
  --mat-snack-bar-supporting-text-color: white;
  --mat-snack-bar-button-color: #4fc3f7;
}

html {
  --mat-snack-bar-supporting-text-font: toyota-book;
  --mat-snack-bar-supporting-text-line-height: 20px;
  --mat-snack-bar-supporting-text-size: 14px;
  --mat-snack-bar-supporting-text-weight: 400;
}

html {
  --mat-table-row-item-outline-width: 1px;
}

html {
  --mat-table-background-color: white;
  --mat-table-header-headline-color: rgba(0, 0, 0, 0.87);
  --mat-table-row-item-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-table-row-item-outline-color: rgba(0, 0, 0, 0.12);
}

html {
  --mat-table-header-container-height: 56px;
  --mat-table-footer-container-height: 52px;
  --mat-table-row-item-container-height: 52px;
}

html {
  --mat-table-header-headline-font: toyota-book;
  --mat-table-header-headline-line-height: 22px;
  --mat-table-header-headline-size: 14px;
  --mat-table-header-headline-weight: 500;
  --mat-table-header-headline-tracking: 0.0071428571em;
  --mat-table-row-item-label-text-font: toyota-book;
  --mat-table-row-item-label-text-line-height: 20px;
  --mat-table-row-item-label-text-size: 14px;
  --mat-table-row-item-label-text-weight: 400;
  --mat-table-row-item-label-text-tracking: 0.0178571429em;
  --mat-table-footer-supporting-text-font: toyota-book;
  --mat-table-footer-supporting-text-line-height: 20px;
  --mat-table-footer-supporting-text-size: 14px;
  --mat-table-footer-supporting-text-weight: 400;
  --mat-table-footer-supporting-text-tracking: 0.0178571429em;
}

html {
  --mat-progress-spinner-active-indicator-width: 4px;
  --mat-progress-spinner-size: 48px;
}

html {
  --mat-progress-spinner-active-indicator-color: #03a9f4;
}

.mat-accent {
  --mat-progress-spinner-active-indicator-color: #4caf50;
}

.mat-warn {
  --mat-progress-spinner-active-indicator-color: #f44336;
}

html {
  --mat-badge-container-shape: 50%;
  --mat-badge-container-size: unset;
  --mat-badge-small-size-container-size: unset;
  --mat-badge-large-size-container-size: unset;
  --mat-badge-legacy-container-size: 22px;
  --mat-badge-legacy-small-size-container-size: 16px;
  --mat-badge-legacy-large-size-container-size: 28px;
  --mat-badge-container-offset: -11px 0;
  --mat-badge-small-size-container-offset: -8px 0;
  --mat-badge-large-size-container-offset: -14px 0;
  --mat-badge-container-overlap-offset: -11px;
  --mat-badge-small-size-container-overlap-offset: -8px;
  --mat-badge-large-size-container-overlap-offset: -14px;
  --mat-badge-container-padding: 0;
  --mat-badge-small-size-container-padding: 0;
  --mat-badge-large-size-container-padding: 0;
}

html {
  --mat-badge-background-color: #03a9f4;
  --mat-badge-text-color: white;
  --mat-badge-disabled-state-background-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-badge-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
}

.mat-badge-accent {
  --mat-badge-background-color: #4caf50;
  --mat-badge-text-color: rgba(0, 0, 0, 0.87);
}

.mat-badge-warn {
  --mat-badge-background-color: #f44336;
  --mat-badge-text-color: white;
}

html {
  --mat-badge-text-font: toyota-book;
  --mat-badge-line-height: 22px;
  --mat-badge-text-size: 12px;
  --mat-badge-text-weight: 600;
  --mat-badge-small-size-text-size: 9px;
  --mat-badge-small-size-line-height: 16px;
  --mat-badge-large-size-text-size: 24px;
  --mat-badge-large-size-line-height: 28px;
}

html {
  --mat-bottom-sheet-container-shape: 4px;
}

html {
  --mat-bottom-sheet-container-text-color: rgba(0, 0, 0, 0.87);
  --mat-bottom-sheet-container-background-color: white;
}

html {
  --mat-bottom-sheet-container-text-font: toyota-book;
  --mat-bottom-sheet-container-text-line-height: 20px;
  --mat-bottom-sheet-container-text-size: 14px;
  --mat-bottom-sheet-container-text-tracking: 0.0178571429em;
  --mat-bottom-sheet-container-text-weight: 400;
}

html {
  --mat-button-toggle-focus-state-layer-opacity: 0.12;
  --mat-button-toggle-hover-state-layer-opacity: 0.04;
  --mat-button-toggle-legacy-focus-state-layer-opacity: 1;
  --mat-button-toggle-legacy-height: 36px;
  --mat-button-toggle-legacy-shape: 2px;
  --mat-button-toggle-shape: 4px;
}

html {
  --mat-button-toggle-background-color: white;
  --mat-button-toggle-disabled-selected-state-background-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-toggle-disabled-selected-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-toggle-disabled-state-background-color: white;
  --mat-button-toggle-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-toggle-divider-color: rgba(0, 0, 0, 0.12);
  --mat-button-toggle-legacy-disabled-selected-state-background-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-toggle-legacy-disabled-state-background-color: white;
  --mat-button-toggle-legacy-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-toggle-legacy-selected-state-background-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-toggle-legacy-selected-state-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-toggle-legacy-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-toggle-legacy-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-toggle-selected-state-background-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-toggle-selected-state-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-toggle-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-toggle-text-color: rgba(0, 0, 0, 0.87);
}

html {
  --mat-button-toggle-height: 48px;
}

html {
  --mat-button-toggle-label-text-font: toyota-book;
  --mat-button-toggle-label-text-line-height: 24px;
  --mat-button-toggle-label-text-size: 16px;
  --mat-button-toggle-label-text-tracking: 0.03125em;
  --mat-button-toggle-label-text-weight: 400;
  --mat-button-toggle-legacy-label-text-font: toyota-book;
  --mat-button-toggle-legacy-label-text-line-height: 24px;
  --mat-button-toggle-legacy-label-text-size: 16px;
  --mat-button-toggle-legacy-label-text-tracking: 0.03125em;
  --mat-button-toggle-legacy-label-text-weight: 400;
}

html {
  --mat-datepicker-calendar-container-shape: 4px;
  --mat-datepicker-calendar-container-touch-shape: 4px;
  --mat-datepicker-calendar-container-elevation-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  --mat-datepicker-calendar-container-touch-elevation-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
}

html {
  --mat-datepicker-calendar-date-in-range-state-background-color: color-mix(in srgb, #03a9f4 20%, transparent);
  --mat-datepicker-calendar-date-in-comparison-range-state-background-color: color-mix(in srgb, #4caf50 20%, transparent);
  --mat-datepicker-calendar-date-in-overlap-range-state-background-color: #a8dab5;
  --mat-datepicker-calendar-date-in-overlap-range-selected-state-background-color: rgb(69.5241935484, 163.4758064516, 93.9516129032);
  --mat-datepicker-calendar-date-selected-state-text-color: white;
  --mat-datepicker-calendar-date-selected-state-background-color: #03a9f4;
  --mat-datepicker-calendar-date-selected-disabled-state-background-color: color-mix(in srgb, #03a9f4 38%, transparent);
  --mat-datepicker-calendar-date-today-selected-state-outline-color: white;
  --mat-datepicker-calendar-date-focus-state-background-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-datepicker-calendar-date-hover-state-background-color: color-mix(in srgb, #03a9f4 4%, transparent);
  --mat-datepicker-toggle-active-state-icon-color: #03a9f4;
  --mat-datepicker-toggle-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-body-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-period-button-text-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-period-button-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-navigation-button-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-header-divider-color: rgba(0, 0, 0, 0.12);
  --mat-datepicker-calendar-header-text-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-date-today-outline-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-date-today-disabled-state-outline-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-date-text-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-date-outline-color: transparent;
  --mat-datepicker-calendar-date-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-date-preview-state-outline-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-range-input-separator-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-range-input-disabled-state-separator-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-range-input-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-container-background-color: white;
  --mat-datepicker-calendar-container-text-color: rgba(0, 0, 0, 0.87);
}

.mat-datepicker-content.mat-accent, .mat-datepicker-toggle-active.mat-accent {
  --mat-datepicker-calendar-date-in-range-state-background-color: color-mix(in srgb, #4caf50 20%, transparent);
  --mat-datepicker-calendar-date-in-comparison-range-state-background-color: color-mix(in srgb, #4caf50 20%, transparent);
  --mat-datepicker-calendar-date-in-overlap-range-state-background-color: #a8dab5;
  --mat-datepicker-calendar-date-in-overlap-range-selected-state-background-color: rgb(69.5241935484, 163.4758064516, 93.9516129032);
  --mat-datepicker-calendar-date-selected-state-text-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-date-selected-state-background-color: #4caf50;
  --mat-datepicker-calendar-date-selected-disabled-state-background-color: color-mix(in srgb, #4caf50 38%, transparent);
  --mat-datepicker-calendar-date-today-selected-state-outline-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-date-focus-state-background-color: color-mix(in srgb, #4caf50 12%, transparent);
  --mat-datepicker-calendar-date-hover-state-background-color: color-mix(in srgb, #4caf50 4%, transparent);
  --mat-datepicker-toggle-active-state-icon-color: #4caf50;
  --mat-datepicker-toggle-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-body-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-period-button-text-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-period-button-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-navigation-button-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-header-divider-color: rgba(0, 0, 0, 0.12);
  --mat-datepicker-calendar-header-text-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-date-today-outline-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-date-today-disabled-state-outline-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-date-text-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-date-outline-color: transparent;
  --mat-datepicker-calendar-date-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-date-preview-state-outline-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-range-input-separator-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-range-input-disabled-state-separator-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-range-input-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-container-background-color: white;
  --mat-datepicker-calendar-container-text-color: rgba(0, 0, 0, 0.87);
}
.mat-datepicker-content.mat-warn, .mat-datepicker-toggle-active.mat-warn {
  --mat-datepicker-calendar-date-in-range-state-background-color: color-mix(in srgb, #f44336 20%, transparent);
  --mat-datepicker-calendar-date-in-comparison-range-state-background-color: color-mix(in srgb, #4caf50 20%, transparent);
  --mat-datepicker-calendar-date-in-overlap-range-state-background-color: #a8dab5;
  --mat-datepicker-calendar-date-in-overlap-range-selected-state-background-color: rgb(69.5241935484, 163.4758064516, 93.9516129032);
  --mat-datepicker-calendar-date-selected-state-text-color: white;
  --mat-datepicker-calendar-date-selected-state-background-color: #f44336;
  --mat-datepicker-calendar-date-selected-disabled-state-background-color: color-mix(in srgb, #f44336 38%, transparent);
  --mat-datepicker-calendar-date-today-selected-state-outline-color: white;
  --mat-datepicker-calendar-date-focus-state-background-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-datepicker-calendar-date-hover-state-background-color: color-mix(in srgb, #f44336 4%, transparent);
  --mat-datepicker-toggle-active-state-icon-color: #f44336;
  --mat-datepicker-toggle-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-body-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-period-button-text-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-period-button-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-navigation-button-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-header-divider-color: rgba(0, 0, 0, 0.12);
  --mat-datepicker-calendar-header-text-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-date-today-outline-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-date-today-disabled-state-outline-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-date-text-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-date-outline-color: transparent;
  --mat-datepicker-calendar-date-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-date-preview-state-outline-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-range-input-separator-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-range-input-disabled-state-separator-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-range-input-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-container-background-color: white;
  --mat-datepicker-calendar-container-text-color: rgba(0, 0, 0, 0.87);
}

.mat-calendar-controls {
  --mat-icon-button-touch-target-display: none;
}
.mat-calendar-controls .mat-mdc-icon-button.mat-mdc-button-base {
  --mdc-icon-button-state-layer-size: 40px;
  --mat-icon-button-state-layer-size: 40px;
  width: var(--mat-icon-button-state-layer-size);
  height: var(--mat-icon-button-state-layer-size);
  padding: 8px;
}

html {
  --mat-datepicker-calendar-text-font: toyota-book;
  --mat-datepicker-calendar-text-size: 13px;
  --mat-datepicker-calendar-body-label-text-size: 14px;
  --mat-datepicker-calendar-body-label-text-weight: 500;
  --mat-datepicker-calendar-period-button-text-size: 14px;
  --mat-datepicker-calendar-period-button-text-weight: 500;
  --mat-datepicker-calendar-header-text-size: 11px;
  --mat-datepicker-calendar-header-text-weight: 400;
}

html {
  --mat-divider-width: 1px;
}

html {
  --mat-divider-color: rgba(0, 0, 0, 0.12);
}

html {
  --mat-expansion-container-shape: 4px;
  --mat-expansion-container-elevation-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  --mat-expansion-legacy-header-indicator-display: inline-block;
  --mat-expansion-header-indicator-display: none;
}

html {
  --mat-expansion-container-background-color: white;
  --mat-expansion-container-text-color: rgba(0, 0, 0, 0.87);
  --mat-expansion-actions-divider-color: rgba(0, 0, 0, 0.12);
  --mat-expansion-header-hover-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 4%, transparent);
  --mat-expansion-header-focus-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-expansion-header-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-expansion-header-text-color: rgba(0, 0, 0, 0.87);
  --mat-expansion-header-description-color: rgba(0, 0, 0, 0.54);
  --mat-expansion-header-indicator-color: rgba(0, 0, 0, 0.54);
}

html {
  --mat-expansion-header-collapsed-state-height: 48px;
  --mat-expansion-header-expanded-state-height: 64px;
}

html {
  --mat-expansion-header-text-font: toyota-book;
  --mat-expansion-header-text-size: 14px;
  --mat-expansion-header-text-weight: 500;
  --mat-expansion-header-text-line-height: inherit;
  --mat-expansion-header-text-tracking: inherit;
  --mat-expansion-container-text-font: toyota-book;
  --mat-expansion-container-text-line-height: 20px;
  --mat-expansion-container-text-size: 14px;
  --mat-expansion-container-text-tracking: 0.0178571429em;
  --mat-expansion-container-text-weight: 400;
}

html {
  --mat-grid-list-tile-header-primary-text-size: 14px;
  --mat-grid-list-tile-header-secondary-text-size: 12px;
  --mat-grid-list-tile-footer-primary-text-size: 14px;
  --mat-grid-list-tile-footer-secondary-text-size: 12px;
}

html {
  --mat-icon-color: inherit;
}

.mat-icon.mat-primary {
  --mat-icon-color: #03a9f4;
}
.mat-icon.mat-accent {
  --mat-icon-color: #4caf50;
}
.mat-icon.mat-warn {
  --mat-icon-color: #f44336;
}

html {
  --mat-sidenav-container-shape: 0;
  --mat-sidenav-container-elevation-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);
  --mat-sidenav-container-width: auto;
}

html {
  --mat-sidenav-container-divider-color: rgba(0, 0, 0, 0.12);
  --mat-sidenav-container-background-color: white;
  --mat-sidenav-container-text-color: rgba(0, 0, 0, 0.87);
  --mat-sidenav-content-background-color: #fafafa;
  --mat-sidenav-content-text-color: rgba(0, 0, 0, 0.87);
  --mat-sidenav-scrim-color: rgba(0, 0, 0, 0.6);
}

html {
  --mat-stepper-header-focus-state-layer-shape: 0;
  --mat-stepper-header-hover-state-layer-shape: 0;
}

html {
  --mat-stepper-header-icon-foreground-color: white;
  --mat-stepper-header-selected-state-icon-background-color: #03a9f4;
  --mat-stepper-header-selected-state-icon-foreground-color: white;
  --mat-stepper-header-done-state-icon-background-color: #03a9f4;
  --mat-stepper-header-done-state-icon-foreground-color: white;
  --mat-stepper-header-edit-state-icon-background-color: #03a9f4;
  --mat-stepper-header-edit-state-icon-foreground-color: white;
  --mat-stepper-container-color: white;
  --mat-stepper-line-color: rgba(0, 0, 0, 0.12);
  --mat-stepper-header-hover-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 4%, transparent);
  --mat-stepper-header-focus-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-stepper-header-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-stepper-header-optional-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-stepper-header-selected-state-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-stepper-header-error-state-label-text-color: #f44336;
  --mat-stepper-header-icon-background-color: rgba(0, 0, 0, 0.54);
  --mat-stepper-header-error-state-icon-foreground-color: #f44336;
  --mat-stepper-header-error-state-icon-background-color: transparent;
}

.mat-step-header.mat-accent {
  --mat-stepper-header-icon-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-stepper-header-selected-state-icon-background-color: #4caf50;
  --mat-stepper-header-selected-state-icon-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-stepper-header-done-state-icon-background-color: #4caf50;
  --mat-stepper-header-done-state-icon-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-stepper-header-edit-state-icon-background-color: #4caf50;
  --mat-stepper-header-edit-state-icon-foreground-color: rgba(0, 0, 0, 0.87);
}

.mat-step-header.mat-warn {
  --mat-stepper-header-icon-foreground-color: white;
  --mat-stepper-header-selected-state-icon-background-color: #f44336;
  --mat-stepper-header-selected-state-icon-foreground-color: white;
  --mat-stepper-header-done-state-icon-background-color: #f44336;
  --mat-stepper-header-done-state-icon-foreground-color: white;
  --mat-stepper-header-edit-state-icon-background-color: #f44336;
  --mat-stepper-header-edit-state-icon-foreground-color: white;
}

html {
  --mat-stepper-header-height: 72px;
}

html {
  --mat-stepper-container-text-font: toyota-book;
  --mat-stepper-header-label-text-font: toyota-book;
  --mat-stepper-header-label-text-size: 14px;
  --mat-stepper-header-label-text-weight: 400;
  --mat-stepper-header-error-state-label-text-size: 16px;
  --mat-stepper-header-selected-state-label-text-size: 16px;
  --mat-stepper-header-selected-state-label-text-weight: 400;
}

html {
  --mat-sort-arrow-color: rgba(0, 0, 0, 0.87);
}

html {
  --mat-toolbar-container-background-color: white;
  --mat-toolbar-container-text-color: rgba(0, 0, 0, 0.87);
}

.mat-toolbar.mat-primary {
  --mat-toolbar-container-background-color: #03a9f4;
  --mat-toolbar-container-text-color: white;
}
.mat-toolbar.mat-accent {
  --mat-toolbar-container-background-color: #4caf50;
  --mat-toolbar-container-text-color: rgba(0, 0, 0, 0.87);
}
.mat-toolbar.mat-warn {
  --mat-toolbar-container-background-color: #f44336;
  --mat-toolbar-container-text-color: white;
}

html {
  --mat-toolbar-standard-height: 64px;
  --mat-toolbar-mobile-height: 56px;
}

html {
  --mat-toolbar-title-text-font: toyota-book;
  --mat-toolbar-title-text-line-height: 32px;
  --mat-toolbar-title-text-size: 20px;
  --mat-toolbar-title-text-tracking: 0.0125em;
  --mat-toolbar-title-text-weight: 500;
}

html {
  --mat-tree-container-background-color: white;
  --mat-tree-node-text-color: rgba(0, 0, 0, 0.87);
}

html {
  --mat-tree-node-min-height: 48px;
}

html {
  --mat-tree-node-text-font: toyota-book;
  --mat-tree-node-text-size: 14px;
  --mat-tree-node-text-weight: 400;
}

html {
  --mat-timepicker-container-shape: 4px;
  --mat-timepicker-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

html {
  --mat-timepicker-container-background-color: white;
}

html {
  --mat-button-filled-container-shape: 4px;
  --mat-button-filled-horizontal-padding: 16px;
  --mat-button-filled-icon-offset: -4px;
  --mat-button-filled-icon-spacing: 8px;
  --mat-button-filled-touch-target-size: 48px;
  --mat-button-outlined-container-shape: 4px;
  --mat-button-outlined-horizontal-padding: 15px;
  --mat-button-outlined-icon-offset: -4px;
  --mat-button-outlined-icon-spacing: 8px;
  --mat-button-outlined-keep-touch-target: false;
  --mat-button-outlined-outline-width: 1px;
  --mat-button-outlined-touch-target-size: 48px;
  --mat-button-protected-container-elevation-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-container-shape: 4px;
  --mat-button-protected-disabled-container-elevation-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-focus-container-elevation-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-horizontal-padding: 16px;
  --mat-button-protected-hover-container-elevation-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-icon-offset: -4px;
  --mat-button-protected-icon-spacing: 8px;
  --mat-button-protected-pressed-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-button-protected-touch-target-size: 48px;
  --mat-button-text-container-shape: 4px;
  --mat-button-text-horizontal-padding: 8px;
  --mat-button-text-icon-offset: 0;
  --mat-button-text-icon-spacing: 8px;
  --mat-button-text-with-icon-horizontal-padding: 8px;
  --mat-button-text-touch-target-size: 48px;
  --mat-button-tonal-container-shape: 4px;
  --mat-button-tonal-horizontal-padding: 16px;
  --mat-button-tonal-icon-offset: -4px;
  --mat-button-tonal-icon-spacing: 8px;
  --mat-button-tonal-touch-target-size: 48px;
}

html {
  --mat-button-filled-container-color: white;
  --mat-button-filled-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-filled-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-filled-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-filled-focus-state-layer-opacity: 0.12;
  --mat-button-filled-hover-state-layer-opacity: 0.04;
  --mat-button-filled-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-filled-pressed-state-layer-opacity: 0.12;
  --mat-button-filled-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-filled-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-outlined-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-outlined-disabled-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-outlined-focus-state-layer-opacity: 0.12;
  --mat-button-outlined-hover-state-layer-opacity: 0.04;
  --mat-button-outlined-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-pressed-state-layer-opacity: 0.12;
  --mat-button-outlined-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-outlined-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-protected-container-color: white;
  --mat-button-protected-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-protected-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-protected-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-protected-focus-state-layer-opacity: 0.12;
  --mat-button-protected-hover-state-layer-opacity: 0.04;
  --mat-button-protected-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-protected-pressed-state-layer-opacity: 0.12;
  --mat-button-protected-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-protected-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-text-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-text-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-text-focus-state-layer-opacity: 0.12;
  --mat-button-text-hover-state-layer-opacity: 0.04;
  --mat-button-text-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-text-pressed-state-layer-opacity: 0.12;
  --mat-button-text-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-text-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-tonal-container-color: white;
  --mat-button-tonal-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-tonal-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-tonal-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-tonal-focus-state-layer-opacity: 0.12;
  --mat-button-tonal-hover-state-layer-opacity: 0.04;
  --mat-button-tonal-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-tonal-pressed-state-layer-opacity: 0.12;
  --mat-button-tonal-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-tonal-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-button.mat-primary,
.mat-mdc-unelevated-button.mat-primary,
.mat-mdc-raised-button.mat-primary,
.mat-mdc-outlined-button.mat-primary,
.mat-tonal-button.mat-primary {
  --mat-button-filled-container-color: #03a9f4;
  --mat-button-filled-label-text-color: white;
  --mat-button-filled-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-filled-state-layer-color: white;
  --mat-button-outlined-label-text-color: #03a9f4;
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-button-outlined-state-layer-color: #03a9f4;
  --mat-button-protected-container-color: #03a9f4;
  --mat-button-protected-label-text-color: white;
  --mat-button-protected-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-protected-state-layer-color: white;
  --mat-button-text-label-text-color: #03a9f4;
  --mat-button-text-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-button-text-state-layer-color: #03a9f4;
  --mat-button-tonal-container-color: #03a9f4;
  --mat-button-tonal-label-text-color: white;
  --mat-button-tonal-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-tonal-state-layer-color: white;
}
.mat-mdc-button.mat-accent,
.mat-mdc-unelevated-button.mat-accent,
.mat-mdc-raised-button.mat-accent,
.mat-mdc-outlined-button.mat-accent,
.mat-tonal-button.mat-accent {
  --mat-button-filled-container-color: #d50000;
  --mat-button-filled-label-text-color: white;
  --mat-button-filled-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-filled-state-layer-color: white;
  --mat-button-outlined-label-text-color: #d50000;
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-ripple-color: color-mix(in srgb, #d50000 12%, transparent);
  --mat-button-outlined-state-layer-color: #d50000;
  --mat-button-protected-container-color: #d50000;
  --mat-button-protected-label-text-color: white;
  --mat-button-protected-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-protected-state-layer-color: white;
  --mat-button-text-label-text-color: #d50000;
  --mat-button-text-ripple-color: color-mix(in srgb, #d50000 12%, transparent);
  --mat-button-text-state-layer-color: #d50000;
  --mat-button-tonal-container-color: #d50000;
  --mat-button-tonal-label-text-color: white;
  --mat-button-tonal-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-tonal-state-layer-color: white;
}
.mat-mdc-button.mat-warn,
.mat-mdc-unelevated-button.mat-warn,
.mat-mdc-raised-button.mat-warn,
.mat-mdc-outlined-button.mat-warn,
.mat-tonal-button.mat-warn {
  --mat-button-filled-container-color: #f44336;
  --mat-button-filled-label-text-color: white;
  --mat-button-filled-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-filled-state-layer-color: white;
  --mat-button-outlined-label-text-color: #f44336;
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-button-outlined-state-layer-color: #f44336;
  --mat-button-protected-container-color: #f44336;
  --mat-button-protected-label-text-color: white;
  --mat-button-protected-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-protected-state-layer-color: white;
  --mat-button-text-label-text-color: #f44336;
  --mat-button-text-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-button-text-state-layer-color: #f44336;
  --mat-button-tonal-container-color: #f44336;
  --mat-button-tonal-label-text-color: white;
  --mat-button-tonal-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-tonal-state-layer-color: white;
}

html {
  --mat-button-filled-container-height: 36px;
  --mat-button-filled-touch-target-display: block;
  --mat-button-outlined-container-height: 36px;
  --mat-button-outlined-touch-target-display: block;
  --mat-button-protected-container-height: 36px;
  --mat-button-protected-touch-target-display: block;
  --mat-button-text-container-height: 36px;
  --mat-button-text-touch-target-display: block;
  --mat-button-tonal-container-height: 36px;
  --mat-button-tonal-touch-target-display: block;
}

html {
  --mat-fab-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-container-shape: 50%;
  --mat-fab-touch-target-size: 48px;
  --mat-fab-extended-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-extended-container-height: 48px;
  --mat-fab-extended-container-shape: 24px;
  --mat-fab-extended-focus-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-extended-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-extended-pressed-container-elevation-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  --mat-fab-focus-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-pressed-container-elevation-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  --mat-fab-small-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-small-container-shape: 50%;
  --mat-fab-small-touch-target-size: 48px;
  --mat-fab-small-focus-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-small-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-small-pressed-container-elevation-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
}

html {
  --mat-fab-container-color: white;
  --mat-fab-disabled-state-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-disabled-state-foreground-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-fab-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-fab-focus-state-layer-opacity: 0.12;
  --mat-fab-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-fab-hover-state-layer-opacity: 0.04;
  --mat-fab-pressed-state-layer-opacity: 0.12;
  --mat-fab-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-small-container-color: white;
  --mat-fab-small-disabled-state-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-small-disabled-state-foreground-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-fab-small-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-fab-small-focus-state-layer-opacity: 0.12;
  --mat-fab-small-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-fab-small-hover-state-layer-opacity: 0.04;
  --mat-fab-small-pressed-state-layer-opacity: 0.12;
  --mat-fab-small-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-small-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-fab-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-fab.mat-primary, .mat-mdc-mini-fab.mat-primary {
  --mat-fab-container-color: #03a9f4;
  --mat-fab-foreground-color: white;
  --mat-fab-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-fab-small-container-color: #03a9f4;
  --mat-fab-small-foreground-color: white;
  --mat-fab-small-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-fab-small-state-layer-color: white;
  --mat-fab-state-layer-color: white;
}
.mat-mdc-fab.mat-accent, .mat-mdc-mini-fab.mat-accent {
  --mat-fab-container-color: #d50000;
  --mat-fab-foreground-color: white;
  --mat-fab-ripple-color: color-mix(in srgb, #d50000 12%, transparent);
  --mat-fab-small-container-color: #d50000;
  --mat-fab-small-foreground-color: white;
  --mat-fab-small-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-fab-small-state-layer-color: white;
  --mat-fab-state-layer-color: white;
}
.mat-mdc-fab.mat-warn, .mat-mdc-mini-fab.mat-warn {
  --mat-fab-container-color: #f44336;
  --mat-fab-foreground-color: white;
  --mat-fab-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-fab-small-container-color: #f44336;
  --mat-fab-small-foreground-color: white;
  --mat-fab-small-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-fab-small-state-layer-color: white;
  --mat-fab-state-layer-color: white;
}

html {
  --mat-fab-small-touch-target-display: block;
  --mat-fab-touch-target-display: block;
}

html {
  --mat-icon-button-icon-size: 24px;
  --mat-icon-button-container-shape: 50%;
  --mat-icon-button-touch-target-size: 48px;
}

html {
  --mat-icon-button-disabled-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-icon-button-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-icon-button-focus-state-layer-opacity: 0.12;
  --mat-icon-button-hover-state-layer-opacity: 0.04;
  --mat-icon-button-icon-color: inherit;
  --mat-icon-button-pressed-state-layer-opacity: 0.12;
  --mat-icon-button-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-icon-button-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-icon-button.mat-primary {
  --mat-icon-button-icon-color: #03a9f4;
  --mat-icon-button-state-layer-color: #03a9f4;
  --mat-icon-button-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
}
.mat-mdc-icon-button.mat-accent {
  --mat-icon-button-icon-color: #d50000;
  --mat-icon-button-state-layer-color: #d50000;
  --mat-icon-button-ripple-color: color-mix(in srgb, #d50000 12%, transparent);
}
.mat-mdc-icon-button.mat-warn {
  --mat-icon-button-icon-color: #f44336;
  --mat-icon-button-state-layer-color: #f44336;
  --mat-icon-button-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
}

html {
  --mat-icon-button-touch-target-display: block;
}

.mat-mdc-icon-button.mat-mdc-button-base {
  --mdc-icon-button-state-layer-size: 48px;
  --mat-icon-button-state-layer-size: 48px;
  width: var(--mat-icon-button-state-layer-size);
  height: var(--mat-icon-button-state-layer-size);
  padding: 12px;
}

html {
  --mat-toolbar-container-background-color: white;
  --mat-toolbar-container-text-color: rgba(0, 0, 0, 0.87);
}

.mat-toolbar.mat-primary {
  --mat-toolbar-container-background-color: #263238;
  --mat-toolbar-container-text-color: white;
}
.mat-toolbar.mat-accent {
  --mat-toolbar-container-background-color: #4caf50;
  --mat-toolbar-container-text-color: rgba(0, 0, 0, 0.87);
}
.mat-toolbar.mat-warn {
  --mat-toolbar-container-background-color: #f44336;
  --mat-toolbar-container-text-color: white;
}

html {
  --mat-toolbar-standard-height: 64px;
  --mat-toolbar-mobile-height: 56px;
}

html {
  --mat-progress-spinner-active-indicator-width: 4px;
  --mat-progress-spinner-size: 48px;
}

html {
  --mat-progress-spinner-active-indicator-color: #f44336;
}

.mat-accent {
  --mat-progress-spinner-active-indicator-color: #4caf50;
}

.mat-warn {
  --mat-progress-spinner-active-indicator-color: #f44336;
}

/* Toyota costumers theme*/
@font-face {
  font-family: "toyota-bold";
  src: url("/fonts/ToyotaType-Bold.ttf") format("truetype");
}
@font-face {
  font-family: "toyota-book";
  src: url("/fonts/ToyotaType-Book.ttf") format("truetype");
}
@font-face {
  font-family: "toyota-regular";
  src: url("/fonts/ToyotaType-Regular.ttf") format("truetype");
}
::ng-deep .link__tooltip {
  padding: 1em;
  width: auto;
  height: auto;
  border-radius: 0.2em;
  font-size: 1em;
  line-height: 1.5;
  text-align: center;
}

@media only print {
  * {
    margin: 0;
    padding: 0;
    font-size: 1em;
  }
  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/
  ::ng-deep .mat-select-value-text {
    display: none;
  }
  ::ng-deep .message__title,
  .message__description {
    display: none;
  }
  ::ng-deep .search-section {
    display: none;
  }
  ::ng-deep .print__confirmation {
    display: none;
  }
  ::ng-deep .button__confirmation {
    display: none;
  }
  .mat-mdc-card {
    box-shadow: none;
  }
}
.half-width {
  width: 50% !important;
}

.full-width {
  width: 100% !important;
}

.spacer {
  flex: 1 1 auto;
}

.bold {
  font-weight: "toyota-bold";
}

@font-face {
  font-family: "toyota-bold";
  src: url("/fonts/ToyotaType-Bold.ttf") format("truetype");
}
@font-face {
  font-family: "toyota-book";
  src: url("/fonts/ToyotaType-Book.ttf") format("truetype");
}
@font-face {
  font-family: "toyota-regular";
  src: url("/fonts/ToyotaType-Regular.ttf") format("truetype");
}
.admin-card {
  height: 100%;
}
.admin-card .card-title {
  color: rgb(255, 5, 0);
  border-bottom: 0.01em solid rgba(248, 248, 248, 0.8);
  padding: 1em 1.3em 0.5em;
  font-size: 1.2em;
  font-weight: bold;
  display: flex;
  font-family: "toyota-regular";
}
.admin-card .card-body {
  padding: 1em 1em;
}

.address-row mat-form-field {
  width: calc(33.3333333333% - 2em);
}

.card-footer {
  padding: 0 1em;
  font-size: 0.7em;
}
.card-footer .card-footer-title {
  font-weight: bold;
}

.customer-state * {
  color: black !important;
}

.save-button {
  padding: 0em 0em 0.3em;
  background-color: rgb(180, 57, 53) !important;
  color: rgb(255, 255, 255) !important;
}

.disabled-save-button {
  color: rgb(255, 255, 255) !important;
  opacity: 0.6;
}

html {
  --mat-badge-text-font: toyota-book;
  --mat-badge-line-height: 22px;
  --mat-badge-text-size: 12px;
  --mat-badge-text-weight: 600;
  --mat-badge-small-size-text-size: 9px;
  --mat-badge-small-size-line-height: 16px;
  --mat-badge-large-size-text-size: 24px;
  --mat-badge-large-size-line-height: 28px;
}

.mat-h1,
.mat-headline-5,
.mat-typography .mat-h1,
.mat-typography .mat-headline-5,
.mat-typography h1 {
  font: 400 24px / 32px toyota-book;
  letter-spacing: normal;
  margin: 0 0 16px;
}

.mat-h2,
.mat-headline-6,
.mat-typography .mat-h2,
.mat-typography .mat-headline-6,
.mat-typography h2 {
  font: 500 20px / 32px toyota-book;
  letter-spacing: 0.0125em;
  margin: 0 0 16px;
}

.mat-h3,
.mat-subtitle-1,
.mat-typography .mat-h3,
.mat-typography .mat-subtitle-1,
.mat-typography h3 {
  font: 400 16px / 28px toyota-book;
  letter-spacing: 0.009375em;
  margin: 0 0 16px;
}

.mat-h4,
.mat-body-1,
.mat-typography .mat-h4,
.mat-typography .mat-body-1,
.mat-typography h4 {
  font: 400 16px / 24px toyota-book;
  letter-spacing: 0.03125em;
  margin: 0 0 16px;
}

.mat-h5,
.mat-typography .mat-h5,
.mat-typography h5 {
  font: 400 calc(14px * 0.83) / 20px toyota-book;
  margin: 0 0 12px;
}

.mat-h6,
.mat-typography .mat-h6,
.mat-typography h6 {
  font: 400 calc(14px * 0.67) / 20px toyota-book;
  margin: 0 0 12px;
}

.mat-body-strong,
.mat-subtitle-2,
.mat-typography .mat-body-strong,
.mat-typography .mat-subtitle-2 {
  font: 500 14px / 22px toyota-book;
  letter-spacing: 0.0071428571em;
}

.mat-body,
.mat-body-2,
.mat-typography .mat-body,
.mat-typography .mat-body-2,
.mat-typography {
  font: 400 14px / 20px toyota-book;
  letter-spacing: 0.0178571429em;
}
.mat-body p,
.mat-body-2 p,
.mat-typography .mat-body p,
.mat-typography .mat-body-2 p,
.mat-typography p {
  margin: 0 0 12px;
}

.mat-small,
.mat-caption,
.mat-typography .mat-small,
.mat-typography .mat-caption {
  font: 400 12px / 20px toyota-book;
  letter-spacing: 0.0333333333em;
}

.mat-headline-1,
.mat-typography .mat-headline-1 {
  font: 300 96px / 96px toyota-book;
  letter-spacing: -0.015625em;
  margin: 0 0 56px;
}

.mat-headline-2,
.mat-typography .mat-headline-2 {
  font: 300 60px / 60px toyota-book;
  letter-spacing: -0.0083333333em;
  margin: 0 0 64px;
}

.mat-headline-3,
.mat-typography .mat-headline-3 {
  font: 400 48px / 50px toyota-book;
  letter-spacing: normal;
  margin: 0 0 64px;
}

.mat-headline-4,
.mat-typography .mat-headline-4 {
  font: 400 34px / 40px toyota-book;
  letter-spacing: 0.0073529412em;
  margin: 0 0 64px;
}

html {
  --mat-bottom-sheet-container-text-font: toyota-book;
  --mat-bottom-sheet-container-text-line-height: 20px;
  --mat-bottom-sheet-container-text-size: 14px;
  --mat-bottom-sheet-container-text-tracking: 0.0178571429em;
  --mat-bottom-sheet-container-text-weight: 400;
}

html {
  --mat-button-toggle-label-text-font: toyota-book;
  --mat-button-toggle-label-text-line-height: 24px;
  --mat-button-toggle-label-text-size: 16px;
  --mat-button-toggle-label-text-tracking: 0.03125em;
  --mat-button-toggle-label-text-weight: 400;
  --mat-button-toggle-legacy-label-text-font: toyota-book;
  --mat-button-toggle-legacy-label-text-line-height: 24px;
  --mat-button-toggle-legacy-label-text-size: 16px;
  --mat-button-toggle-legacy-label-text-tracking: 0.03125em;
  --mat-button-toggle-legacy-label-text-weight: 400;
}

html {
  --mat-datepicker-calendar-text-font: toyota-book;
  --mat-datepicker-calendar-text-size: 13px;
  --mat-datepicker-calendar-body-label-text-size: 14px;
  --mat-datepicker-calendar-body-label-text-weight: 500;
  --mat-datepicker-calendar-period-button-text-size: 14px;
  --mat-datepicker-calendar-period-button-text-weight: 500;
  --mat-datepicker-calendar-header-text-size: 11px;
  --mat-datepicker-calendar-header-text-weight: 400;
}

html {
  --mat-expansion-header-text-font: toyota-book;
  --mat-expansion-header-text-size: 14px;
  --mat-expansion-header-text-weight: 500;
  --mat-expansion-header-text-line-height: inherit;
  --mat-expansion-header-text-tracking: inherit;
  --mat-expansion-container-text-font: toyota-book;
  --mat-expansion-container-text-line-height: 20px;
  --mat-expansion-container-text-size: 14px;
  --mat-expansion-container-text-tracking: 0.0178571429em;
  --mat-expansion-container-text-weight: 400;
}

html {
  --mat-grid-list-tile-header-primary-text-size: 14px;
  --mat-grid-list-tile-header-secondary-text-size: 12px;
  --mat-grid-list-tile-footer-primary-text-size: 14px;
  --mat-grid-list-tile-footer-secondary-text-size: 12px;
}

html {
  --mat-stepper-container-text-font: toyota-book;
  --mat-stepper-header-label-text-font: toyota-book;
  --mat-stepper-header-label-text-size: 14px;
  --mat-stepper-header-label-text-weight: 400;
  --mat-stepper-header-error-state-label-text-size: 16px;
  --mat-stepper-header-selected-state-label-text-size: 16px;
  --mat-stepper-header-selected-state-label-text-weight: 400;
}

html {
  --mat-toolbar-title-text-font: toyota-book;
  --mat-toolbar-title-text-line-height: 32px;
  --mat-toolbar-title-text-size: 20px;
  --mat-toolbar-title-text-tracking: 0.0125em;
  --mat-toolbar-title-text-weight: 500;
}

html {
  --mat-tree-node-text-font: toyota-book;
  --mat-tree-node-text-size: 14px;
  --mat-tree-node-text-weight: 400;
}

html {
  --mat-option-label-text-font: toyota-book;
  --mat-option-label-text-line-height: 24px;
  --mat-option-label-text-size: 16px;
  --mat-option-label-text-tracking: 0.03125em;
  --mat-option-label-text-weight: 400;
}

html {
  --mat-optgroup-label-text-font: toyota-book;
  --mat-optgroup-label-text-line-height: 24px;
  --mat-optgroup-label-text-size: 16px;
  --mat-optgroup-label-text-tracking: 0.03125em;
  --mat-optgroup-label-text-weight: 400;
}

html {
  --mat-card-title-text-font: toyota-book;
  --mat-card-title-text-line-height: 32px;
  --mat-card-title-text-size: 20px;
  --mat-card-title-text-tracking: 0.0125em;
  --mat-card-title-text-weight: 500;
  --mat-card-subtitle-text-font: toyota-book;
  --mat-card-subtitle-text-line-height: 22px;
  --mat-card-subtitle-text-size: 14px;
  --mat-card-subtitle-text-tracking: 0.0071428571em;
  --mat-card-subtitle-text-weight: 500;
}

html {
  --mat-tooltip-supporting-text-font: toyota-book;
  --mat-tooltip-supporting-text-size: 12px;
  --mat-tooltip-supporting-text-weight: 400;
  --mat-tooltip-supporting-text-tracking: 0.0333333333em;
}

html {
  --mat-form-field-container-text-font: toyota-book;
  --mat-form-field-container-text-line-height: 24px;
  --mat-form-field-container-text-size: 16px;
  --mat-form-field-container-text-tracking: 0.03125em;
  --mat-form-field-container-text-weight: 400;
  --mat-form-field-outlined-label-text-populated-size: 16px;
  --mat-form-field-subscript-text-font: toyota-book;
  --mat-form-field-subscript-text-line-height: 20px;
  --mat-form-field-subscript-text-size: 12px;
  --mat-form-field-subscript-text-tracking: 0.0333333333em;
  --mat-form-field-subscript-text-weight: 400;
  --mat-form-field-filled-label-text-font: toyota-book;
  --mat-form-field-filled-label-text-size: 16px;
  --mat-form-field-filled-label-text-tracking: 0.03125em;
  --mat-form-field-filled-label-text-weight: 400;
  --mat-form-field-outlined-label-text-font: toyota-book;
  --mat-form-field-outlined-label-text-size: 16px;
  --mat-form-field-outlined-label-text-tracking: 0.03125em;
  --mat-form-field-outlined-label-text-weight: 400;
}

html {
  --mat-select-trigger-text-font: toyota-book;
  --mat-select-trigger-text-line-height: 24px;
  --mat-select-trigger-text-size: 16px;
  --mat-select-trigger-text-tracking: 0.03125em;
  --mat-select-trigger-text-weight: 400;
}

html {
  --mat-dialog-subhead-font: toyota-book;
  --mat-dialog-subhead-line-height: 32px;
  --mat-dialog-subhead-size: 20px;
  --mat-dialog-subhead-weight: 500;
  --mat-dialog-subhead-tracking: 0.0125em;
  --mat-dialog-supporting-text-font: toyota-book;
  --mat-dialog-supporting-text-line-height: 24px;
  --mat-dialog-supporting-text-size: 16px;
  --mat-dialog-supporting-text-weight: 400;
  --mat-dialog-supporting-text-tracking: 0.03125em;
}

.mat-mdc-standard-chip {
  --mat-chip-label-text-font: toyota-book;
  --mat-chip-label-text-line-height: 20px;
  --mat-chip-label-text-size: 14px;
  --mat-chip-label-text-tracking: 0.0178571429em;
  --mat-chip-label-text-weight: 400;
}

html {
  --mat-slide-toggle-label-text-font: toyota-book;
  --mat-slide-toggle-label-text-line-height: 20px;
  --mat-slide-toggle-label-text-size: 14px;
  --mat-slide-toggle-label-text-tracking: 0.0178571429em;
  --mat-slide-toggle-label-text-weight: 400;
}
html .mat-mdc-slide-toggle {
  --mat-slide-toggle-label-text-font: toyota-book;
  --mat-slide-toggle-label-text-line-height: 20px;
  --mat-slide-toggle-label-text-size: 14px;
  --mat-slide-toggle-label-text-tracking: 0.0178571429em;
  --mat-slide-toggle-label-text-weight: 400;
}

html {
  --mat-radio-label-text-font: toyota-book;
  --mat-radio-label-text-line-height: 20px;
  --mat-radio-label-text-size: 14px;
  --mat-radio-label-text-tracking: 0.0178571429em;
  --mat-radio-label-text-weight: 400;
}

html {
  --mat-slider-label-label-text-font: toyota-book;
  --mat-slider-label-label-text-size: 14px;
  --mat-slider-label-label-text-line-height: 22px;
  --mat-slider-label-label-text-tracking: 0.0071428571em;
  --mat-slider-label-label-text-weight: 500;
}

html {
  --mat-menu-item-label-text-font: toyota-book;
  --mat-menu-item-label-text-size: 16px;
  --mat-menu-item-label-text-tracking: 0.03125em;
  --mat-menu-item-label-text-line-height: 24px;
  --mat-menu-item-label-text-weight: 400;
}

html {
  --mat-list-list-item-label-text-font: toyota-book;
  --mat-list-list-item-label-text-line-height: 24px;
  --mat-list-list-item-label-text-size: 16px;
  --mat-list-list-item-label-text-tracking: 0.03125em;
  --mat-list-list-item-label-text-weight: 400;
  --mat-list-list-item-supporting-text-font: toyota-book;
  --mat-list-list-item-supporting-text-line-height: 20px;
  --mat-list-list-item-supporting-text-size: 14px;
  --mat-list-list-item-supporting-text-tracking: 0.0178571429em;
  --mat-list-list-item-supporting-text-weight: 400;
  --mat-list-list-item-trailing-supporting-text-font: toyota-book;
  --mat-list-list-item-trailing-supporting-text-line-height: 20px;
  --mat-list-list-item-trailing-supporting-text-size: 12px;
  --mat-list-list-item-trailing-supporting-text-tracking: 0.0333333333em;
  --mat-list-list-item-trailing-supporting-text-weight: 400;
}

.mdc-list-group__subheader {
  font: 400 16px / 28px toyota-book;
  letter-spacing: 0.009375em;
}

html {
  --mat-paginator-container-text-font: toyota-book;
  --mat-paginator-container-text-line-height: 20px;
  --mat-paginator-container-text-size: 12px;
  --mat-paginator-container-text-tracking: 0.0333333333em;
  --mat-paginator-container-text-weight: 400;
  --mat-paginator-select-trigger-text-size: 12px;
}

.mat-mdc-tab-header {
  --mat-tab-label-text-font: toyota-book;
  --mat-tab-label-text-size: 14px;
  --mat-tab-label-text-tracking: 0.0892857143em;
  --mat-tab-label-text-line-height: 36px;
  --mat-tab-label-text-weight: 500;
}

html {
  --mat-checkbox-label-text-font: toyota-book;
  --mat-checkbox-label-text-line-height: 20px;
  --mat-checkbox-label-text-size: 14px;
  --mat-checkbox-label-text-tracking: 0.0178571429em;
  --mat-checkbox-label-text-weight: 400;
}

html {
  --mat-button-filled-label-text-font: toyota-book;
  --mat-button-filled-label-text-size: 14px;
  --mat-button-filled-label-text-tracking: 0.0892857143em;
  --mat-button-filled-label-text-transform: none;
  --mat-button-filled-label-text-weight: 500;
  --mat-button-outlined-label-text-font: toyota-book;
  --mat-button-outlined-label-text-size: 14px;
  --mat-button-outlined-label-text-tracking: 0.0892857143em;
  --mat-button-outlined-label-text-transform: none;
  --mat-button-outlined-label-text-weight: 500;
  --mat-button-protected-label-text-font: toyota-book;
  --mat-button-protected-label-text-size: 14px;
  --mat-button-protected-label-text-tracking: 0.0892857143em;
  --mat-button-protected-label-text-transform: none;
  --mat-button-protected-label-text-weight: 500;
  --mat-button-text-label-text-font: toyota-book;
  --mat-button-text-label-text-size: 14px;
  --mat-button-text-label-text-tracking: 0.0892857143em;
  --mat-button-text-label-text-transform: none;
  --mat-button-text-label-text-weight: 500;
  --mat-button-tonal-label-text-font: toyota-book;
  --mat-button-tonal-label-text-size: 14px;
  --mat-button-tonal-label-text-tracking: 0.0892857143em;
  --mat-button-tonal-label-text-transform: none;
  --mat-button-tonal-label-text-weight: 500;
}

html {
  --mat-fab-extended-label-text-font: toyota-book;
  --mat-fab-extended-label-text-size: 14px;
  --mat-fab-extended-label-text-tracking: 0.0892857143em;
  --mat-fab-extended-label-text-weight: 500;
}

html {
  --mat-snack-bar-supporting-text-font: toyota-book;
  --mat-snack-bar-supporting-text-line-height: 20px;
  --mat-snack-bar-supporting-text-size: 14px;
  --mat-snack-bar-supporting-text-weight: 400;
}

html {
  --mat-table-header-headline-font: toyota-book;
  --mat-table-header-headline-line-height: 22px;
  --mat-table-header-headline-size: 14px;
  --mat-table-header-headline-weight: 500;
  --mat-table-header-headline-tracking: 0.0071428571em;
  --mat-table-row-item-label-text-font: toyota-book;
  --mat-table-row-item-label-text-line-height: 20px;
  --mat-table-row-item-label-text-size: 14px;
  --mat-table-row-item-label-text-weight: 400;
  --mat-table-row-item-label-text-tracking: 0.0178571429em;
  --mat-table-footer-supporting-text-font: toyota-book;
  --mat-table-footer-supporting-text-line-height: 20px;
  --mat-table-footer-supporting-text-size: 14px;
  --mat-table-footer-supporting-text-weight: 400;
  --mat-table-footer-supporting-text-tracking: 0.0178571429em;
}

.mat-elevation-z0, .mat-mdc-elevation-specific.mat-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0, 0px 0px 0px 0px --mat-sys-shadow, 0px 0px 0px 0px --mat-sys-shadow, 0px 0px 0px 0px --mat-sys-shadow);
}

.mat-elevation-z1, .mat-mdc-elevation-specific.mat-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1, 0px 2px 1px -1px --mat-sys-shadow, 0px 1px 1px 0px --mat-sys-shadow, 0px 1px 3px 0px --mat-sys-shadow);
}

.mat-elevation-z2, .mat-mdc-elevation-specific.mat-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2, 0px 3px 1px -2px --mat-sys-shadow, 0px 2px 2px 0px --mat-sys-shadow, 0px 1px 5px 0px --mat-sys-shadow);
}

.mat-elevation-z3, .mat-mdc-elevation-specific.mat-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3, 0px 3px 3px -2px --mat-sys-shadow, 0px 3px 4px 0px --mat-sys-shadow, 0px 1px 8px 0px --mat-sys-shadow);
}

.mat-elevation-z4, .mat-mdc-elevation-specific.mat-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4, 0px 2px 4px -1px --mat-sys-shadow, 0px 4px 5px 0px --mat-sys-shadow, 0px 1px 10px 0px --mat-sys-shadow);
}

.mat-elevation-z5, .mat-mdc-elevation-specific.mat-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5, 0px 3px 5px -1px --mat-sys-shadow, 0px 5px 8px 0px --mat-sys-shadow, 0px 1px 14px 0px --mat-sys-shadow);
}

.mat-elevation-z6, .mat-mdc-elevation-specific.mat-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6, 0px 3px 5px -1px --mat-sys-shadow, 0px 6px 10px 0px --mat-sys-shadow, 0px 1px 18px 0px --mat-sys-shadow);
}

.mat-elevation-z7, .mat-mdc-elevation-specific.mat-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7, 0px 4px 5px -2px --mat-sys-shadow, 0px 7px 10px 1px --mat-sys-shadow, 0px 2px 16px 1px --mat-sys-shadow);
}

.mat-elevation-z8, .mat-mdc-elevation-specific.mat-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8, 0px 5px 5px -3px --mat-sys-shadow, 0px 8px 10px 1px --mat-sys-shadow, 0px 3px 14px 2px --mat-sys-shadow);
}

.mat-elevation-z9, .mat-mdc-elevation-specific.mat-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9, 0px 5px 6px -3px --mat-sys-shadow, 0px 9px 12px 1px --mat-sys-shadow, 0px 3px 16px 2px --mat-sys-shadow);
}

.mat-elevation-z10, .mat-mdc-elevation-specific.mat-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10, 0px 6px 6px -3px --mat-sys-shadow, 0px 10px 14px 1px --mat-sys-shadow, 0px 4px 18px 3px --mat-sys-shadow);
}

.mat-elevation-z11, .mat-mdc-elevation-specific.mat-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11, 0px 6px 7px -4px --mat-sys-shadow, 0px 11px 15px 1px --mat-sys-shadow, 0px 4px 20px 3px --mat-sys-shadow);
}

.mat-elevation-z12, .mat-mdc-elevation-specific.mat-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12, 0px 7px 8px -4px --mat-sys-shadow, 0px 12px 17px 2px --mat-sys-shadow, 0px 5px 22px 4px --mat-sys-shadow);
}

.mat-elevation-z13, .mat-mdc-elevation-specific.mat-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13, 0px 7px 8px -4px --mat-sys-shadow, 0px 13px 19px 2px --mat-sys-shadow, 0px 5px 24px 4px --mat-sys-shadow);
}

.mat-elevation-z14, .mat-mdc-elevation-specific.mat-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14, 0px 7px 9px -4px --mat-sys-shadow, 0px 14px 21px 2px --mat-sys-shadow, 0px 5px 26px 4px --mat-sys-shadow);
}

.mat-elevation-z15, .mat-mdc-elevation-specific.mat-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15, 0px 8px 9px -5px --mat-sys-shadow, 0px 15px 22px 2px --mat-sys-shadow, 0px 6px 28px 5px --mat-sys-shadow);
}

.mat-elevation-z16, .mat-mdc-elevation-specific.mat-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16, 0px 8px 10px -5px --mat-sys-shadow, 0px 16px 24px 2px --mat-sys-shadow, 0px 6px 30px 5px --mat-sys-shadow);
}

.mat-elevation-z17, .mat-mdc-elevation-specific.mat-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17, 0px 8px 11px -5px --mat-sys-shadow, 0px 17px 26px 2px --mat-sys-shadow, 0px 6px 32px 5px --mat-sys-shadow);
}

.mat-elevation-z18, .mat-mdc-elevation-specific.mat-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18, 0px 9px 11px -5px --mat-sys-shadow, 0px 18px 28px 2px --mat-sys-shadow, 0px 7px 34px 6px --mat-sys-shadow);
}

.mat-elevation-z19, .mat-mdc-elevation-specific.mat-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19, 0px 9px 12px -6px --mat-sys-shadow, 0px 19px 29px 2px --mat-sys-shadow, 0px 7px 36px 6px --mat-sys-shadow);
}

.mat-elevation-z20, .mat-mdc-elevation-specific.mat-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20, 0px 10px 13px -6px --mat-sys-shadow, 0px 20px 31px 3px --mat-sys-shadow, 0px 8px 38px 7px --mat-sys-shadow);
}

.mat-elevation-z21, .mat-mdc-elevation-specific.mat-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21, 0px 10px 13px -6px --mat-sys-shadow, 0px 21px 33px 3px --mat-sys-shadow, 0px 8px 40px 7px --mat-sys-shadow);
}

.mat-elevation-z22, .mat-mdc-elevation-specific.mat-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22, 0px 10px 14px -6px --mat-sys-shadow, 0px 22px 35px 3px --mat-sys-shadow, 0px 8px 42px 7px --mat-sys-shadow);
}

.mat-elevation-z23, .mat-mdc-elevation-specific.mat-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23, 0px 11px 14px -7px --mat-sys-shadow, 0px 23px 36px 3px --mat-sys-shadow, 0px 9px 44px 8px --mat-sys-shadow);
}

.mat-elevation-z24, .mat-mdc-elevation-specific.mat-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24, 0px 11px 15px -7px --mat-sys-shadow, 0px 24px 38px 3px --mat-sys-shadow, 0px 9px 46px 8px --mat-sys-shadow);
}

html {
  --mat-sys-on-surface: initial;
}

.mat-app-background {
  background-color: var(--mat-app-background-color, var(--mat-sys-background, transparent));
  color: var(--mat-app-text-color, var(--mat-sys-on-background, inherit));
}

html {
  --mat-app-background-color: #fafafa;
  --mat-app-text-color: rgba(0, 0, 0, 0.87);
  --mat-app-elevation-shadow-level-0: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-1: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-2: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-3: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-4: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-5: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-6: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-7: 0px 4px 5px -2px rgba(0, 0, 0, 0.2), 0px 7px 10px 1px rgba(0, 0, 0, 0.14), 0px 2px 16px 1px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-8: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-9: 0px 5px 6px -3px rgba(0, 0, 0, 0.2), 0px 9px 12px 1px rgba(0, 0, 0, 0.14), 0px 3px 16px 2px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-10: 0px 6px 6px -3px rgba(0, 0, 0, 0.2), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-11: 0px 6px 7px -4px rgba(0, 0, 0, 0.2), 0px 11px 15px 1px rgba(0, 0, 0, 0.14), 0px 4px 20px 3px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-12: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-13: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 13px 19px 2px rgba(0, 0, 0, 0.14), 0px 5px 24px 4px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-14: 0px 7px 9px -4px rgba(0, 0, 0, 0.2), 0px 14px 21px 2px rgba(0, 0, 0, 0.14), 0px 5px 26px 4px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-15: 0px 8px 9px -5px rgba(0, 0, 0, 0.2), 0px 15px 22px 2px rgba(0, 0, 0, 0.14), 0px 6px 28px 5px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-16: 0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-17: 0px 8px 11px -5px rgba(0, 0, 0, 0.2), 0px 17px 26px 2px rgba(0, 0, 0, 0.14), 0px 6px 32px 5px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-18: 0px 9px 11px -5px rgba(0, 0, 0, 0.2), 0px 18px 28px 2px rgba(0, 0, 0, 0.14), 0px 7px 34px 6px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-19: 0px 9px 12px -6px rgba(0, 0, 0, 0.2), 0px 19px 29px 2px rgba(0, 0, 0, 0.14), 0px 7px 36px 6px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-20: 0px 10px 13px -6px rgba(0, 0, 0, 0.2), 0px 20px 31px 3px rgba(0, 0, 0, 0.14), 0px 8px 38px 7px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-21: 0px 10px 13px -6px rgba(0, 0, 0, 0.2), 0px 21px 33px 3px rgba(0, 0, 0, 0.14), 0px 8px 40px 7px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-22: 0px 10px 14px -6px rgba(0, 0, 0, 0.2), 0px 22px 35px 3px rgba(0, 0, 0, 0.14), 0px 8px 42px 7px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-23: 0px 11px 14px -7px rgba(0, 0, 0, 0.2), 0px 23px 36px 3px rgba(0, 0, 0, 0.14), 0px 9px 44px 8px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-24: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
}

html {
  --mat-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
}

html {
  --mat-option-selected-state-label-text-color: #03a9f4;
  --mat-option-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-option-hover-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 4%, transparent);
  --mat-option-focus-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-option-selected-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
}

.mat-accent {
  --mat-option-selected-state-label-text-color: #4caf50;
  --mat-option-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-option-hover-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 4%, transparent);
  --mat-option-focus-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-option-selected-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
}

.mat-warn {
  --mat-option-selected-state-label-text-color: #f44336;
  --mat-option-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-option-hover-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 4%, transparent);
  --mat-option-focus-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-option-selected-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
}

html {
  --mat-optgroup-label-text-color: rgba(0, 0, 0, 0.87);
}

html {
  --mat-pseudo-checkbox-full-selected-icon-color: #4caf50;
  --mat-pseudo-checkbox-full-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-pseudo-checkbox-full-disabled-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-full-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-minimal-selected-checkmark-color: #4caf50;
  --mat-pseudo-checkbox-minimal-disabled-selected-checkmark-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
}

.mat-primary {
  --mat-pseudo-checkbox-full-selected-icon-color: #03a9f4;
  --mat-pseudo-checkbox-full-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-pseudo-checkbox-full-disabled-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-full-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-minimal-selected-checkmark-color: #03a9f4;
  --mat-pseudo-checkbox-minimal-disabled-selected-checkmark-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
}

.mat-accent {
  --mat-pseudo-checkbox-full-selected-icon-color: #4caf50;
  --mat-pseudo-checkbox-full-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-pseudo-checkbox-full-disabled-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-full-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-minimal-selected-checkmark-color: #4caf50;
  --mat-pseudo-checkbox-minimal-disabled-selected-checkmark-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
}

.mat-warn {
  --mat-pseudo-checkbox-full-selected-icon-color: #f44336;
  --mat-pseudo-checkbox-full-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-pseudo-checkbox-full-disabled-selected-checkmark-color: #fafafa;
  --mat-pseudo-checkbox-full-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-full-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-pseudo-checkbox-minimal-selected-checkmark-color: #f44336;
  --mat-pseudo-checkbox-minimal-disabled-selected-checkmark-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
}

html {
  --mat-option-label-text-font: toyota-book;
  --mat-option-label-text-line-height: 24px;
  --mat-option-label-text-size: 16px;
  --mat-option-label-text-tracking: 0.03125em;
  --mat-option-label-text-weight: 400;
}

html {
  --mat-optgroup-label-text-font: toyota-book;
  --mat-optgroup-label-text-line-height: 24px;
  --mat-optgroup-label-text-size: 16px;
  --mat-optgroup-label-text-tracking: 0.03125em;
  --mat-optgroup-label-text-weight: 400;
}

html {
  --mat-card-elevated-container-shape: 4px;
  --mat-card-outlined-container-shape: 4px;
  --mat-card-filled-container-shape: 4px;
  --mat-card-outlined-outline-width: 1px;
}

html {
  --mat-card-elevated-container-color: white;
  --mat-card-elevated-container-elevation: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mat-card-outlined-container-color: white;
  --mat-card-outlined-container-elevation: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-card-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-card-subtitle-text-color: rgba(0, 0, 0, 0.54);
  --mat-card-filled-container-color: white;
  --mat-card-filled-container-elevation: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
}

html {
  --mat-card-title-text-font: toyota-book;
  --mat-card-title-text-line-height: 32px;
  --mat-card-title-text-size: 20px;
  --mat-card-title-text-tracking: 0.0125em;
  --mat-card-title-text-weight: 500;
  --mat-card-subtitle-text-font: toyota-book;
  --mat-card-subtitle-text-line-height: 22px;
  --mat-card-subtitle-text-size: 14px;
  --mat-card-subtitle-text-tracking: 0.0071428571em;
  --mat-card-subtitle-text-weight: 500;
}

html {
  --mat-progress-bar-active-indicator-height: 4px;
  --mat-progress-bar-track-height: 4px;
  --mat-progress-bar-track-shape: 0;
}

.mat-mdc-progress-bar {
  --mat-progress-bar-active-indicator-color: #03a9f4;
  --mat-progress-bar-track-color: rgba(3, 169, 244, 0.25);
}
.mat-mdc-progress-bar.mat-accent {
  --mat-progress-bar-active-indicator-color: #4caf50;
  --mat-progress-bar-track-color: rgba(76, 175, 80, 0.25);
}
.mat-mdc-progress-bar.mat-warn {
  --mat-progress-bar-active-indicator-color: #f44336;
  --mat-progress-bar-track-color: rgba(244, 67, 54, 0.25);
}

html {
  --mat-tooltip-container-shape: 4px;
  --mat-tooltip-supporting-text-line-height: 16px;
}

html {
  --mat-tooltip-container-color: #424242;
  --mat-tooltip-supporting-text-color: white;
}

html {
  --mat-tooltip-supporting-text-font: toyota-book;
  --mat-tooltip-supporting-text-size: 12px;
  --mat-tooltip-supporting-text-weight: 400;
  --mat-tooltip-supporting-text-tracking: 0.0333333333em;
}

html {
  --mat-form-field-filled-active-indicator-height: 1px;
  --mat-form-field-filled-focus-active-indicator-height: 2px;
  --mat-form-field-filled-container-shape: 4px;
  --mat-form-field-outlined-outline-width: 1px;
  --mat-form-field-outlined-focus-outline-width: 2px;
  --mat-form-field-outlined-container-shape: 4px;
}

html {
  --mat-form-field-focus-select-arrow-color: color-mix(in srgb, #03a9f4 87%, transparent);
  --mat-form-field-filled-caret-color: #03a9f4;
  --mat-form-field-filled-focus-active-indicator-color: #03a9f4;
  --mat-form-field-filled-focus-label-text-color: color-mix(in srgb, #03a9f4 87%, transparent);
  --mat-form-field-outlined-caret-color: #03a9f4;
  --mat-form-field-outlined-focus-outline-color: #03a9f4;
  --mat-form-field-outlined-focus-label-text-color: color-mix(in srgb, #03a9f4 87%, transparent);
  --mat-form-field-disabled-input-text-placeholder-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-form-field-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-form-field-error-text-color: #f44336;
  --mat-form-field-select-option-text-color: inherit;
  --mat-form-field-select-disabled-option-text-color: GrayText;
  --mat-form-field-leading-icon-color: unset;
  --mat-form-field-disabled-leading-icon-color: unset;
  --mat-form-field-trailing-icon-color: unset;
  --mat-form-field-disabled-trailing-icon-color: unset;
  --mat-form-field-error-focus-trailing-icon-color: unset;
  --mat-form-field-error-hover-trailing-icon-color: unset;
  --mat-form-field-error-trailing-icon-color: unset;
  --mat-form-field-enabled-select-arrow-color: rgba(0, 0, 0, 0.54);
  --mat-form-field-disabled-select-arrow-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-form-field-hover-state-layer-opacity: 0.04;
  --mat-form-field-focus-state-layer-opacity: 0.12;
  --mat-form-field-filled-container-color: #f6f6f6;
  --mat-form-field-filled-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 4%, transparent);
  --mat-form-field-filled-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-form-field-filled-hover-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-form-field-filled-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-form-field-filled-input-text-color: rgba(0, 0, 0, 0.87);
  --mat-form-field-filled-disabled-input-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-form-field-filled-input-text-placeholder-color: rgba(0, 0, 0, 0.54);
  --mat-form-field-filled-error-hover-label-text-color: #f44336;
  --mat-form-field-filled-error-focus-label-text-color: #f44336;
  --mat-form-field-filled-error-label-text-color: #f44336;
  --mat-form-field-filled-error-caret-color: #f44336;
  --mat-form-field-filled-active-indicator-color: rgba(0, 0, 0, 0.54);
  --mat-form-field-filled-disabled-active-indicator-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-form-field-filled-hover-active-indicator-color: rgba(0, 0, 0, 0.87);
  --mat-form-field-filled-error-active-indicator-color: #f44336;
  --mat-form-field-filled-error-focus-active-indicator-color: #f44336;
  --mat-form-field-filled-error-hover-active-indicator-color: #f44336;
  --mat-form-field-outlined-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-form-field-outlined-hover-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-form-field-outlined-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-form-field-outlined-input-text-color: rgba(0, 0, 0, 0.87);
  --mat-form-field-outlined-disabled-input-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-form-field-outlined-input-text-placeholder-color: rgba(0, 0, 0, 0.54);
  --mat-form-field-outlined-error-caret-color: #f44336;
  --mat-form-field-outlined-error-focus-label-text-color: #f44336;
  --mat-form-field-outlined-error-label-text-color: #f44336;
  --mat-form-field-outlined-error-hover-label-text-color: #f44336;
  --mat-form-field-outlined-outline-color: rgba(0, 0, 0, 0.38);
  --mat-form-field-outlined-disabled-outline-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-form-field-outlined-hover-outline-color: rgba(0, 0, 0, 0.87);
  --mat-form-field-outlined-error-focus-outline-color: #f44336;
  --mat-form-field-outlined-error-hover-outline-color: #f44336;
  --mat-form-field-outlined-error-outline-color: #f44336;
}

.mat-mdc-form-field.mat-accent {
  --mat-form-field-focus-select-arrow-color: color-mix(in srgb, #4caf50 87%, transparent);
  --mat-form-field-filled-caret-color: #4caf50;
  --mat-form-field-filled-focus-active-indicator-color: #4caf50;
  --mat-form-field-filled-focus-label-text-color: color-mix(in srgb, #4caf50 87%, transparent);
  --mat-form-field-outlined-caret-color: #4caf50;
  --mat-form-field-outlined-focus-outline-color: #4caf50;
  --mat-form-field-outlined-focus-label-text-color: color-mix(in srgb, #4caf50 87%, transparent);
}

.mat-mdc-form-field.mat-warn {
  --mat-form-field-focus-select-arrow-color: color-mix(in srgb, #f44336 87%, transparent);
  --mat-form-field-filled-caret-color: #f44336;
  --mat-form-field-filled-focus-active-indicator-color: #f44336;
  --mat-form-field-filled-focus-label-text-color: color-mix(in srgb, #f44336 87%, transparent);
  --mat-form-field-outlined-caret-color: #f44336;
  --mat-form-field-outlined-focus-outline-color: #f44336;
  --mat-form-field-outlined-focus-label-text-color: color-mix(in srgb, #f44336 87%, transparent);
}

html {
  --mat-form-field-container-height: 56px;
  --mat-form-field-filled-label-display: block;
  --mat-form-field-container-vertical-padding: 16px;
  --mat-form-field-filled-with-label-container-padding-top: 24px;
  --mat-form-field-filled-with-label-container-padding-bottom: 8px;
}

html {
  --mat-form-field-container-text-font: toyota-book;
  --mat-form-field-container-text-line-height: 24px;
  --mat-form-field-container-text-size: 16px;
  --mat-form-field-container-text-tracking: 0.03125em;
  --mat-form-field-container-text-weight: 400;
  --mat-form-field-outlined-label-text-populated-size: 16px;
  --mat-form-field-subscript-text-font: toyota-book;
  --mat-form-field-subscript-text-line-height: 20px;
  --mat-form-field-subscript-text-size: 12px;
  --mat-form-field-subscript-text-tracking: 0.0333333333em;
  --mat-form-field-subscript-text-weight: 400;
  --mat-form-field-filled-label-text-font: toyota-book;
  --mat-form-field-filled-label-text-size: 16px;
  --mat-form-field-filled-label-text-tracking: 0.03125em;
  --mat-form-field-filled-label-text-weight: 400;
  --mat-form-field-outlined-label-text-font: toyota-book;
  --mat-form-field-outlined-label-text-size: 16px;
  --mat-form-field-outlined-label-text-tracking: 0.03125em;
  --mat-form-field-outlined-label-text-weight: 400;
}

html {
  --mat-select-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

html {
  --mat-select-panel-background-color: white;
  --mat-select-enabled-trigger-text-color: rgba(0, 0, 0, 0.87);
  --mat-select-disabled-trigger-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-select-placeholder-text-color: rgba(0, 0, 0, 0.54);
  --mat-select-enabled-arrow-color: rgba(0, 0, 0, 0.54);
  --mat-select-disabled-arrow-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-select-focused-arrow-color: #03a9f4;
  --mat-select-invalid-arrow-color: #f44336;
}

.mat-mdc-form-field.mat-accent {
  --mat-select-panel-background-color: white;
  --mat-select-enabled-trigger-text-color: rgba(0, 0, 0, 0.87);
  --mat-select-disabled-trigger-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-select-placeholder-text-color: rgba(0, 0, 0, 0.54);
  --mat-select-enabled-arrow-color: rgba(0, 0, 0, 0.54);
  --mat-select-disabled-arrow-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-select-focused-arrow-color: #4caf50;
  --mat-select-invalid-arrow-color: #f44336;
}

.mat-mdc-form-field.mat-warn {
  --mat-select-panel-background-color: white;
  --mat-select-enabled-trigger-text-color: rgba(0, 0, 0, 0.87);
  --mat-select-disabled-trigger-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-select-placeholder-text-color: rgba(0, 0, 0, 0.54);
  --mat-select-enabled-arrow-color: rgba(0, 0, 0, 0.54);
  --mat-select-disabled-arrow-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-select-focused-arrow-color: #f44336;
  --mat-select-invalid-arrow-color: #f44336;
}

html {
  --mat-select-arrow-transform: translateY(-8px);
}

html {
  --mat-select-trigger-text-font: toyota-book;
  --mat-select-trigger-text-line-height: 24px;
  --mat-select-trigger-text-size: 16px;
  --mat-select-trigger-text-tracking: 0.03125em;
  --mat-select-trigger-text-weight: 400;
}

html {
  --mat-autocomplete-container-shape: 4px;
  --mat-autocomplete-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

html {
  --mat-autocomplete-background-color: white;
}

html {
  --mat-dialog-container-shape: 4px;
  --mat-dialog-container-elevation-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
  --mat-dialog-container-max-width: 80vw;
  --mat-dialog-container-small-max-width: 80vw;
  --mat-dialog-container-min-width: 0;
  --mat-dialog-actions-alignment: start;
  --mat-dialog-actions-padding: 8px;
  --mat-dialog-content-padding: 20px 24px;
  --mat-dialog-with-actions-content-padding: 20px 24px;
  --mat-dialog-headline-padding: 0 24px 9px;
}

html {
  --mat-dialog-container-color: white;
  --mat-dialog-subhead-color: rgba(0, 0, 0, 0.87);
  --mat-dialog-supporting-text-color: rgba(0, 0, 0, 0.54);
}

html {
  --mat-dialog-subhead-font: toyota-book;
  --mat-dialog-subhead-line-height: 32px;
  --mat-dialog-subhead-size: 20px;
  --mat-dialog-subhead-weight: 500;
  --mat-dialog-subhead-tracking: 0.0125em;
  --mat-dialog-supporting-text-font: toyota-book;
  --mat-dialog-supporting-text-line-height: 24px;
  --mat-dialog-supporting-text-size: 16px;
  --mat-dialog-supporting-text-weight: 400;
  --mat-dialog-supporting-text-tracking: 0.03125em;
}

.mat-mdc-standard-chip {
  --mat-chip-container-shape-radius: 16px;
  --mat-chip-disabled-container-opacity: 0.4;
  --mat-chip-disabled-outline-color: transparent;
  --mat-chip-flat-selected-outline-width: 0;
  --mat-chip-focus-outline-color: transparent;
  --mat-chip-hover-state-layer-opacity: 0.04;
  --mat-chip-outline-color: transparent;
  --mat-chip-outline-width: 0;
  --mat-chip-selected-hover-state-layer-opacity: 0.04;
  --mat-chip-selected-trailing-action-state-layer-color: transparent;
  --mat-chip-trailing-action-focus-opacity: 1;
  --mat-chip-trailing-action-focus-state-layer-opacity: 0;
  --mat-chip-trailing-action-hover-state-layer-opacity: 0;
  --mat-chip-trailing-action-opacity: 0.54;
  --mat-chip-trailing-action-state-layer-color: transparent;
  --mat-chip-with-avatar-avatar-shape-radius: 14px;
  --mat-chip-with-avatar-avatar-size: 28px;
  --mat-chip-with-avatar-disabled-avatar-opacity: 1;
  --mat-chip-with-icon-disabled-icon-opacity: 1;
  --mat-chip-with-icon-icon-size: 18px;
  --mat-chip-with-trailing-icon-disabled-trailing-icon-opacity: 1;
}

.mat-mdc-standard-chip {
  --mat-chip-disabled-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-chip-elevated-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-chip-elevated-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-chip-elevated-selected-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-chip-flat-disabled-selected-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-chip-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-focus-state-layer-opacity: 0.12;
  --mat-chip-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-chip-selected-disabled-trailing-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-selected-focus-state-layer-color: 0.12;
  --mat-chip-selected-focus-state-layer-opacity: 0.12;
  --mat-chip-selected-hover-state-layer-color: 0.04;
  --mat-chip-selected-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-chip-selected-trailing-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-icon-disabled-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-icon-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-icon-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-trailing-icon-disabled-trailing-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-trailing-icon-trailing-icon-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-standard-chip.mat-mdc-chip-selected.mat-primary, .mat-mdc-standard-chip.mat-mdc-chip-highlighted.mat-primary {
  --mat-chip-disabled-label-text-color: white;
  --mat-chip-elevated-container-color: #03a9f4;
  --mat-chip-elevated-disabled-container-color: #03a9f4;
  --mat-chip-elevated-selected-container-color: #03a9f4;
  --mat-chip-flat-disabled-selected-container-color: #03a9f4;
  --mat-chip-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-focus-state-layer-opacity: 0.12;
  --mat-chip-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-label-text-color: white;
  --mat-chip-selected-disabled-trailing-icon-color: white;
  --mat-chip-selected-focus-state-layer-color: 0.12;
  --mat-chip-selected-focus-state-layer-opacity: 0.12;
  --mat-chip-selected-hover-state-layer-color: 0.04;
  --mat-chip-selected-label-text-color: white;
  --mat-chip-selected-trailing-icon-color: white;
  --mat-chip-with-icon-disabled-icon-color: white;
  --mat-chip-with-icon-icon-color: white;
  --mat-chip-with-icon-selected-icon-color: white;
  --mat-chip-with-trailing-icon-disabled-trailing-icon-color: white;
  --mat-chip-with-trailing-icon-trailing-icon-color: white;
}
.mat-mdc-standard-chip.mat-mdc-chip-selected.mat-accent, .mat-mdc-standard-chip.mat-mdc-chip-highlighted.mat-accent {
  --mat-chip-disabled-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-chip-elevated-container-color: #4caf50;
  --mat-chip-elevated-disabled-container-color: #4caf50;
  --mat-chip-elevated-selected-container-color: #4caf50;
  --mat-chip-flat-disabled-selected-container-color: #4caf50;
  --mat-chip-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-focus-state-layer-opacity: 0.12;
  --mat-chip-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-chip-selected-disabled-trailing-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-selected-focus-state-layer-color: 0.12;
  --mat-chip-selected-focus-state-layer-opacity: 0.12;
  --mat-chip-selected-hover-state-layer-color: 0.04;
  --mat-chip-selected-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-chip-selected-trailing-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-icon-disabled-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-icon-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-icon-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-trailing-icon-disabled-trailing-icon-color: rgba(0, 0, 0, 0.87);
  --mat-chip-with-trailing-icon-trailing-icon-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-standard-chip.mat-mdc-chip-selected.mat-warn, .mat-mdc-standard-chip.mat-mdc-chip-highlighted.mat-warn {
  --mat-chip-disabled-label-text-color: white;
  --mat-chip-elevated-container-color: #f44336;
  --mat-chip-elevated-disabled-container-color: #f44336;
  --mat-chip-elevated-selected-container-color: #f44336;
  --mat-chip-flat-disabled-selected-container-color: #f44336;
  --mat-chip-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-focus-state-layer-opacity: 0.12;
  --mat-chip-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-chip-label-text-color: white;
  --mat-chip-selected-disabled-trailing-icon-color: white;
  --mat-chip-selected-focus-state-layer-color: 0.12;
  --mat-chip-selected-focus-state-layer-opacity: 0.12;
  --mat-chip-selected-hover-state-layer-color: 0.04;
  --mat-chip-selected-label-text-color: white;
  --mat-chip-selected-trailing-icon-color: white;
  --mat-chip-with-icon-disabled-icon-color: white;
  --mat-chip-with-icon-icon-color: white;
  --mat-chip-with-icon-selected-icon-color: white;
  --mat-chip-with-trailing-icon-disabled-trailing-icon-color: white;
  --mat-chip-with-trailing-icon-trailing-icon-color: white;
}

.mat-mdc-chip.mat-mdc-standard-chip {
  --mat-chip-container-height: 32px;
}

.mat-mdc-standard-chip {
  --mat-chip-label-text-font: toyota-book;
  --mat-chip-label-text-line-height: 20px;
  --mat-chip-label-text-size: 14px;
  --mat-chip-label-text-tracking: 0.0178571429em;
  --mat-chip-label-text-weight: 400;
}

html {
  --mat-slide-toggle-disabled-handle-opacity: 0.38;
  --mat-slide-toggle-disabled-selected-handle-opacity: 0.38;
  --mat-slide-toggle-disabled-selected-icon-opacity: 0.38;
  --mat-slide-toggle-disabled-track-opacity: 0.12;
  --mat-slide-toggle-disabled-unselected-handle-opacity: 0.38;
  --mat-slide-toggle-disabled-unselected-icon-opacity: 0.38;
  --mat-slide-toggle-disabled-unselected-track-outline-color: transparent;
  --mat-slide-toggle-disabled-unselected-track-outline-width: 1px;
  --mat-slide-toggle-handle-height: 20px;
  --mat-slide-toggle-handle-shape: 10px;
  --mat-slide-toggle-handle-width: 20px;
  --mat-slide-toggle-hidden-track-opacity: 1;
  --mat-slide-toggle-hidden-track-transition: transform 75ms 0ms cubic-bezier(0.4, 0, 0.6, 1);
  --mat-slide-toggle-pressed-handle-size: 20px;
  --mat-slide-toggle-selected-focus-state-layer-opacity: 0.12;
  --mat-slide-toggle-selected-handle-horizontal-margin: 0;
  --mat-slide-toggle-selected-handle-size: 20px;
  --mat-slide-toggle-selected-hover-state-layer-opacity: 0.04;
  --mat-slide-toggle-selected-icon-size: 18px;
  --mat-slide-toggle-selected-pressed-handle-horizontal-margin: 0;
  --mat-slide-toggle-selected-pressed-state-layer-opacity: 0.12;
  --mat-slide-toggle-selected-track-outline-color: transparent;
  --mat-slide-toggle-selected-track-outline-width: 1px;
  --mat-slide-toggle-selected-with-icon-handle-horizontal-margin: 0;
  --mat-slide-toggle-track-height: 14px;
  --mat-slide-toggle-track-outline-color: transparent;
  --mat-slide-toggle-track-outline-width: 1px;
  --mat-slide-toggle-track-shape: 7px;
  --mat-slide-toggle-track-width: 36px;
  --mat-slide-toggle-unselected-focus-state-layer-opacity: 0.12;
  --mat-slide-toggle-unselected-handle-horizontal-margin: 0;
  --mat-slide-toggle-unselected-handle-size: 20px;
  --mat-slide-toggle-unselected-hover-state-layer-opacity: 0.12;
  --mat-slide-toggle-unselected-icon-size: 18px;
  --mat-slide-toggle-unselected-pressed-handle-horizontal-margin: 0;
  --mat-slide-toggle-unselected-pressed-state-layer-opacity: 0.1;
  --mat-slide-toggle-unselected-with-icon-handle-horizontal-margin: 0;
  --mat-slide-toggle-visible-track-opacity: 1;
  --mat-slide-toggle-visible-track-transition: transform 75ms 0ms cubic-bezier(0, 0, 0.2, 1);
  --mat-slide-toggle-with-icon-handle-size: 20px;
  --mat-slide-toggle-touch-target-size: 48px;
}

html {
  --mat-slide-toggle-selected-icon-color: white;
  --mat-slide-toggle-disabled-selected-icon-color: white;
  --mat-slide-toggle-selected-focus-state-layer-color: #03a9f4;
  --mat-slide-toggle-selected-handle-color: #03a9f4;
  --mat-slide-toggle-selected-hover-state-layer-color: #03a9f4;
  --mat-slide-toggle-selected-pressed-state-layer-color: #03a9f4;
  --mat-slide-toggle-selected-focus-handle-color: #03a9f4;
  --mat-slide-toggle-selected-hover-handle-color: #03a9f4;
  --mat-slide-toggle-selected-pressed-handle-color: #03a9f4;
  --mat-slide-toggle-selected-focus-track-color: #4fc3f7;
  --mat-slide-toggle-selected-hover-track-color: #4fc3f7;
  --mat-slide-toggle-selected-pressed-track-color: #4fc3f7;
  --mat-slide-toggle-selected-track-color: #4fc3f7;
  --mat-slide-toggle-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-slide-toggle-disabled-handle-elevation-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-slide-toggle-disabled-selected-handle-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-disabled-selected-track-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-disabled-unselected-handle-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-disabled-unselected-icon-color: #f6f6f6;
  --mat-slide-toggle-disabled-unselected-track-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-handle-elevation-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mat-slide-toggle-handle-surface-color: white;
  --mat-slide-toggle-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-unselected-hover-handle-color: #424242;
  --mat-slide-toggle-unselected-focus-handle-color: #424242;
  --mat-slide-toggle-unselected-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-unselected-focus-track-color: rgba(0, 0, 0, 0.12);
  --mat-slide-toggle-unselected-icon-color: #f6f6f6;
  --mat-slide-toggle-unselected-handle-color: rgba(0, 0, 0, 0.54);
  --mat-slide-toggle-unselected-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-unselected-hover-track-color: rgba(0, 0, 0, 0.12);
  --mat-slide-toggle-unselected-pressed-handle-color: #424242;
  --mat-slide-toggle-unselected-pressed-track-color: rgba(0, 0, 0, 0.12);
  --mat-slide-toggle-unselected-pressed-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-unselected-track-color: rgba(0, 0, 0, 0.12);
}

.mat-mdc-slide-toggle.mat-accent {
  --mat-slide-toggle-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-disabled-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-slide-toggle-selected-focus-state-layer-color: #4caf50;
  --mat-slide-toggle-selected-handle-color: #4caf50;
  --mat-slide-toggle-selected-hover-state-layer-color: #4caf50;
  --mat-slide-toggle-selected-pressed-state-layer-color: #4caf50;
  --mat-slide-toggle-selected-focus-handle-color: #4caf50;
  --mat-slide-toggle-selected-hover-handle-color: #4caf50;
  --mat-slide-toggle-selected-pressed-handle-color: #4caf50;
  --mat-slide-toggle-selected-focus-track-color: #81c784;
  --mat-slide-toggle-selected-hover-track-color: #81c784;
  --mat-slide-toggle-selected-pressed-track-color: #81c784;
  --mat-slide-toggle-selected-track-color: #81c784;
}
.mat-mdc-slide-toggle.mat-warn {
  --mat-slide-toggle-selected-icon-color: white;
  --mat-slide-toggle-disabled-selected-icon-color: white;
  --mat-slide-toggle-selected-focus-state-layer-color: #f44336;
  --mat-slide-toggle-selected-handle-color: #f44336;
  --mat-slide-toggle-selected-hover-state-layer-color: #f44336;
  --mat-slide-toggle-selected-pressed-state-layer-color: #f44336;
  --mat-slide-toggle-selected-focus-handle-color: #f44336;
  --mat-slide-toggle-selected-hover-handle-color: #f44336;
  --mat-slide-toggle-selected-pressed-handle-color: #f44336;
  --mat-slide-toggle-selected-focus-track-color: #e57373;
  --mat-slide-toggle-selected-hover-track-color: #e57373;
  --mat-slide-toggle-selected-pressed-track-color: #e57373;
  --mat-slide-toggle-selected-track-color: #e57373;
}

html {
  --mat-slide-toggle-state-layer-size: 40px;
  --mat-slide-toggle-touch-target-display: block;
}

html {
  --mat-slide-toggle-label-text-font: toyota-book;
  --mat-slide-toggle-label-text-line-height: 20px;
  --mat-slide-toggle-label-text-size: 14px;
  --mat-slide-toggle-label-text-tracking: 0.0178571429em;
  --mat-slide-toggle-label-text-weight: 400;
}
html .mat-mdc-slide-toggle {
  --mat-slide-toggle-label-text-font: toyota-book;
  --mat-slide-toggle-label-text-line-height: 20px;
  --mat-slide-toggle-label-text-size: 14px;
  --mat-slide-toggle-label-text-tracking: 0.0178571429em;
  --mat-slide-toggle-label-text-weight: 400;
}

html {
  --mat-radio-disabled-selected-icon-opacity: 0.38;
  --mat-radio-disabled-unselected-icon-opacity: 0.38;
  --mat-radio-state-layer-size: 40px;
  --mat-radio-touch-target-size: 48px;
}

.mat-mdc-radio-button.mat-primary {
  --mat-radio-checked-ripple-color: #03a9f4;
  --mat-radio-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-radio-disabled-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-disabled-unselected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-radio-ripple-color: rgba(0, 0, 0, 0.87);
  --mat-radio-selected-focus-icon-color: #03a9f4;
  --mat-radio-selected-hover-icon-color: #03a9f4;
  --mat-radio-selected-icon-color: #03a9f4;
  --mat-radio-selected-pressed-icon-color: #03a9f4;
  --mat-radio-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-radio-unselected-pressed-icon-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-radio-button.mat-accent {
  --mat-radio-checked-ripple-color: #4caf50;
  --mat-radio-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-radio-disabled-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-disabled-unselected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-radio-ripple-color: rgba(0, 0, 0, 0.87);
  --mat-radio-selected-focus-icon-color: #4caf50;
  --mat-radio-selected-hover-icon-color: #4caf50;
  --mat-radio-selected-icon-color: #4caf50;
  --mat-radio-selected-pressed-icon-color: #4caf50;
  --mat-radio-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-radio-unselected-pressed-icon-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-radio-button.mat-warn {
  --mat-radio-checked-ripple-color: #f44336;
  --mat-radio-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-radio-disabled-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-disabled-unselected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-radio-ripple-color: rgba(0, 0, 0, 0.87);
  --mat-radio-selected-focus-icon-color: #f44336;
  --mat-radio-selected-hover-icon-color: #f44336;
  --mat-radio-selected-icon-color: #f44336;
  --mat-radio-selected-pressed-icon-color: #f44336;
  --mat-radio-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-radio-unselected-pressed-icon-color: rgba(0, 0, 0, 0.87);
}

html {
  --mat-radio-state-layer-size: 40px;
  --mat-radio-touch-target-display: block;
}

html {
  --mat-radio-label-text-font: toyota-book;
  --mat-radio-label-text-line-height: 20px;
  --mat-radio-label-text-size: 14px;
  --mat-radio-label-text-tracking: 0.0178571429em;
  --mat-radio-label-text-weight: 400;
}

html {
  --mat-slider-active-track-height: 6px;
  --mat-slider-active-track-shape: 9999px;
  --mat-slider-handle-elevation: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mat-slider-handle-height: 20px;
  --mat-slider-handle-shape: 50%;
  --mat-slider-handle-width: 20px;
  --mat-slider-inactive-track-height: 4px;
  --mat-slider-inactive-track-shape: 9999px;
  --mat-slider-value-indicator-border-radius: 4px;
  --mat-slider-value-indicator-caret-display: block;
  --mat-slider-value-indicator-container-transform: translateX(-50%);
  --mat-slider-value-indicator-height: 32px;
  --mat-slider-value-indicator-padding: 0 12px;
  --mat-slider-value-indicator-text-transform: none;
  --mat-slider-value-indicator-width: auto;
  --mat-slider-with-overlap-handle-outline-width: 1px;
  --mat-slider-with-tick-marks-active-container-opacity: 0.6;
  --mat-slider-with-tick-marks-container-shape: 50%;
  --mat-slider-with-tick-marks-container-size: 2px;
  --mat-slider-with-tick-marks-inactive-container-opacity: 0.6;
  --mat-slider-value-indicator-transform-origin: bottom;
}

html {
  --mat-slider-active-track-color: #03a9f4;
  --mat-slider-focus-handle-color: #03a9f4;
  --mat-slider-handle-color: #03a9f4;
  --mat-slider-hover-handle-color: #03a9f4;
  --mat-slider-focus-state-layer-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-slider-hover-state-layer-color: color-mix(in srgb, #03a9f4 4%, transparent);
  --mat-slider-inactive-track-color: #03a9f4;
  --mat-slider-ripple-color: #03a9f4;
  --mat-slider-with-tick-marks-active-container-color: white;
  --mat-slider-with-tick-marks-inactive-container-color: #03a9f4;
  --mat-slider-disabled-active-track-color: rgba(0, 0, 0, 0.87);
  --mat-slider-disabled-handle-color: rgba(0, 0, 0, 0.87);
  --mat-slider-disabled-inactive-track-color: rgba(0, 0, 0, 0.87);
  --mat-slider-label-container-color: #424242;
  --mat-slider-label-label-text-color: white;
  --mat-slider-value-indicator-opacity: 1;
  --mat-slider-with-overlap-handle-outline-color: rgba(0, 0, 0, 0.87);
  --mat-slider-with-tick-marks-disabled-container-color: rgba(0, 0, 0, 0.87);
}

.mat-accent {
  --mat-slider-active-track-color: #4caf50;
  --mat-slider-focus-handle-color: #4caf50;
  --mat-slider-handle-color: #4caf50;
  --mat-slider-hover-handle-color: #4caf50;
  --mat-slider-focus-state-layer-color: color-mix(in srgb, #4caf50 12%, transparent);
  --mat-slider-hover-state-layer-color: color-mix(in srgb, #4caf50 4%, transparent);
  --mat-slider-inactive-track-color: #4caf50;
  --mat-slider-ripple-color: #4caf50;
  --mat-slider-with-tick-marks-active-container-color: rgba(0, 0, 0, 0.87);
  --mat-slider-with-tick-marks-inactive-container-color: #4caf50;
}

.mat-warn {
  --mat-slider-active-track-color: #f44336;
  --mat-slider-focus-handle-color: #f44336;
  --mat-slider-handle-color: #f44336;
  --mat-slider-hover-handle-color: #f44336;
  --mat-slider-focus-state-layer-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-slider-hover-state-layer-color: color-mix(in srgb, #f44336 4%, transparent);
  --mat-slider-inactive-track-color: #f44336;
  --mat-slider-ripple-color: #f44336;
  --mat-slider-with-tick-marks-active-container-color: white;
  --mat-slider-with-tick-marks-inactive-container-color: #f44336;
}

html {
  --mat-slider-label-label-text-font: toyota-book;
  --mat-slider-label-label-text-size: 14px;
  --mat-slider-label-label-text-line-height: 22px;
  --mat-slider-label-label-text-tracking: 0.0071428571em;
  --mat-slider-label-label-text-weight: 500;
}

html {
  --mat-menu-container-shape: 4px;
  --mat-menu-divider-bottom-spacing: 0;
  --mat-menu-divider-top-spacing: 0;
  --mat-menu-item-spacing: 16px;
  --mat-menu-item-icon-size: 24px;
  --mat-menu-item-leading-spacing: 16px;
  --mat-menu-item-trailing-spacing: 16px;
  --mat-menu-item-with-icon-leading-spacing: 16px;
  --mat-menu-item-with-icon-trailing-spacing: 16px;
  --mat-menu-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

html {
  --mat-menu-item-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-menu-item-icon-color: rgba(0, 0, 0, 0.87);
  --mat-menu-item-hover-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 4%, transparent);
  --mat-menu-item-focus-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-menu-container-color: white;
  --mat-menu-divider-color: rgba(0, 0, 0, 0.12);
}

html {
  --mat-menu-item-label-text-font: toyota-book;
  --mat-menu-item-label-text-size: 16px;
  --mat-menu-item-label-text-tracking: 0.03125em;
  --mat-menu-item-label-text-line-height: 24px;
  --mat-menu-item-label-text-weight: 400;
}

html {
  --mat-list-active-indicator-color: transparent;
  --mat-list-active-indicator-shape: 4px;
  --mat-list-list-item-container-shape: 0;
  --mat-list-list-item-leading-avatar-shape: 50%;
  --mat-list-list-item-container-color: transparent;
  --mat-list-list-item-selected-container-color: transparent;
  --mat-list-list-item-leading-avatar-color: transparent;
  --mat-list-list-item-leading-icon-size: 24px;
  --mat-list-list-item-leading-avatar-size: 40px;
  --mat-list-list-item-trailing-icon-size: 24px;
  --mat-list-list-item-disabled-state-layer-color: transparent;
  --mat-list-list-item-disabled-state-layer-opacity: 0;
  --mat-list-list-item-disabled-label-text-opacity: 0.38;
  --mat-list-list-item-disabled-leading-icon-opacity: 0.38;
  --mat-list-list-item-disabled-trailing-icon-opacity: 0.38;
}

html {
  --mat-list-list-item-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-supporting-text-color: rgba(0, 0, 0, 0.54);
  --mat-list-list-item-leading-icon-color: rgba(0, 0, 0, 0.54);
  --mat-list-list-item-trailing-supporting-text-color: rgba(0, 0, 0, 0.54);
  --mat-list-list-item-trailing-icon-color: rgba(0, 0, 0, 0.54);
  --mat-list-list-item-selected-trailing-icon-color: rgba(0, 0, 0, 0.54);
  --mat-list-list-item-disabled-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-disabled-leading-icon-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-disabled-trailing-icon-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-hover-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-hover-leading-icon-color: rgba(0, 0, 0, 0.54);
  --mat-list-list-item-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-hover-state-layer-opacity: 0.04;
  --mat-list-list-item-hover-trailing-icon-color: rgba(0, 0, 0, 0.54);
  --mat-list-list-item-focus-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-list-list-item-focus-state-layer-opacity: 0.12;
}

.mdc-list-item__start,
.mdc-list-item__end {
  --mat-radio-checked-ripple-color: #03a9f4;
  --mat-radio-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-radio-disabled-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-disabled-unselected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-radio-ripple-color: rgba(0, 0, 0, 0.87);
  --mat-radio-selected-focus-icon-color: #03a9f4;
  --mat-radio-selected-hover-icon-color: #03a9f4;
  --mat-radio-selected-icon-color: #03a9f4;
  --mat-radio-selected-pressed-icon-color: #03a9f4;
  --mat-radio-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-radio-unselected-pressed-icon-color: rgba(0, 0, 0, 0.87);
}

.mat-accent .mdc-list-item__start,
.mat-accent .mdc-list-item__end {
  --mat-radio-checked-ripple-color: #4caf50;
  --mat-radio-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-radio-disabled-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-disabled-unselected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-radio-ripple-color: rgba(0, 0, 0, 0.87);
  --mat-radio-selected-focus-icon-color: #4caf50;
  --mat-radio-selected-hover-icon-color: #4caf50;
  --mat-radio-selected-icon-color: #4caf50;
  --mat-radio-selected-pressed-icon-color: #4caf50;
  --mat-radio-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-radio-unselected-pressed-icon-color: rgba(0, 0, 0, 0.87);
}

.mat-warn .mdc-list-item__start,
.mat-warn .mdc-list-item__end {
  --mat-radio-checked-ripple-color: #f44336;
  --mat-radio-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-radio-disabled-selected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-disabled-unselected-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-radio-ripple-color: rgba(0, 0, 0, 0.87);
  --mat-radio-selected-focus-icon-color: #f44336;
  --mat-radio-selected-hover-icon-color: #f44336;
  --mat-radio-selected-icon-color: #f44336;
  --mat-radio-selected-pressed-icon-color: #f44336;
  --mat-radio-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-radio-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-radio-unselected-pressed-icon-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-list-option {
  --mat-checkbox-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-selected-checkmark-color: white;
  --mat-checkbox-selected-focus-icon-color: #03a9f4;
  --mat-checkbox-selected-hover-icon-color: #03a9f4;
  --mat-checkbox-selected-icon-color: #03a9f4;
  --mat-checkbox-selected-pressed-icon-color: #03a9f4;
  --mat-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-checkbox-selected-focus-state-layer-color: #03a9f4;
  --mat-checkbox-selected-hover-state-layer-color: #03a9f4;
  --mat-checkbox-selected-pressed-state-layer-color: #03a9f4;
  --mat-checkbox-unselected-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-pressed-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-list-option.mat-accent {
  --mat-checkbox-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-selected-checkmark-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-selected-focus-icon-color: #4caf50;
  --mat-checkbox-selected-hover-icon-color: #4caf50;
  --mat-checkbox-selected-icon-color: #4caf50;
  --mat-checkbox-selected-pressed-icon-color: #4caf50;
  --mat-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-checkbox-selected-focus-state-layer-color: #4caf50;
  --mat-checkbox-selected-hover-state-layer-color: #4caf50;
  --mat-checkbox-selected-pressed-state-layer-color: #4caf50;
  --mat-checkbox-unselected-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-pressed-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-list-option.mat-warn {
  --mat-checkbox-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-selected-checkmark-color: white;
  --mat-checkbox-selected-focus-icon-color: #f44336;
  --mat-checkbox-selected-hover-icon-color: #f44336;
  --mat-checkbox-selected-icon-color: #f44336;
  --mat-checkbox-selected-pressed-icon-color: #f44336;
  --mat-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-checkbox-selected-focus-state-layer-color: #f44336;
  --mat-checkbox-selected-hover-state-layer-color: #f44336;
  --mat-checkbox-selected-pressed-state-layer-color: #f44336;
  --mat-checkbox-unselected-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-pressed-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-list-base.mat-mdc-list-base .mdc-list-item--selected .mdc-list-item__primary-text,
.mat-mdc-list-base.mat-mdc-list-base .mdc-list-item--selected .mdc-list-item__start,
.mat-mdc-list-base.mat-mdc-list-base .mdc-list-item--activated .mdc-list-item__primary-text,
.mat-mdc-list-base.mat-mdc-list-base .mdc-list-item--activated .mdc-list-item__start {
  color: #03a9f4;
}

.mat-mdc-list-base .mdc-list-item--disabled .mdc-list-item__start,
.mat-mdc-list-base .mdc-list-item--disabled .mdc-list-item__content,
.mat-mdc-list-base .mdc-list-item--disabled .mdc-list-item__end {
  opacity: 1;
}

html {
  --mat-list-list-item-leading-icon-start-space: 16px;
  --mat-list-list-item-leading-icon-end-space: 32px;
  --mat-list-list-item-one-line-container-height: 48px;
  --mat-list-list-item-two-line-container-height: 64px;
  --mat-list-list-item-three-line-container-height: 88px;
}

.mdc-list-item__start,
.mdc-list-item__end {
  --mat-radio-state-layer-size: 40px;
  --mat-radio-touch-target-display: block;
}

.mat-mdc-list-item.mdc-list-item--with-leading-avatar.mdc-list-item--with-one-line, .mat-mdc-list-item.mdc-list-item--with-leading-checkbox.mdc-list-item--with-one-line, .mat-mdc-list-item.mdc-list-item--with-leading-icon.mdc-list-item--with-one-line {
  height: 56px;
}
.mat-mdc-list-item.mdc-list-item--with-leading-avatar.mdc-list-item--with-two-lines, .mat-mdc-list-item.mdc-list-item--with-leading-checkbox.mdc-list-item--with-two-lines, .mat-mdc-list-item.mdc-list-item--with-leading-icon.mdc-list-item--with-two-lines {
  height: 72px;
}

html {
  --mat-list-list-item-label-text-font: toyota-book;
  --mat-list-list-item-label-text-line-height: 24px;
  --mat-list-list-item-label-text-size: 16px;
  --mat-list-list-item-label-text-tracking: 0.03125em;
  --mat-list-list-item-label-text-weight: 400;
  --mat-list-list-item-supporting-text-font: toyota-book;
  --mat-list-list-item-supporting-text-line-height: 20px;
  --mat-list-list-item-supporting-text-size: 14px;
  --mat-list-list-item-supporting-text-tracking: 0.0178571429em;
  --mat-list-list-item-supporting-text-weight: 400;
  --mat-list-list-item-trailing-supporting-text-font: toyota-book;
  --mat-list-list-item-trailing-supporting-text-line-height: 20px;
  --mat-list-list-item-trailing-supporting-text-size: 12px;
  --mat-list-list-item-trailing-supporting-text-tracking: 0.0333333333em;
  --mat-list-list-item-trailing-supporting-text-weight: 400;
}

.mdc-list-group__subheader {
  font: 400 16px / 28px toyota-book;
  letter-spacing: 0.009375em;
}

html {
  --mat-paginator-page-size-select-width: 84px;
  --mat-paginator-page-size-select-touch-target-height: 48px;
}

html {
  --mat-paginator-container-text-color: rgba(0, 0, 0, 0.87);
  --mat-paginator-container-background-color: white;
  --mat-paginator-enabled-icon-color: rgba(0, 0, 0, 0.54);
  --mat-paginator-disabled-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
}

html {
  --mat-paginator-container-size: 56px;
  --mat-paginator-form-field-container-height: 40px;
  --mat-paginator-form-field-container-vertical-padding: 8px;
  --mat-paginator-touch-target-display: block;
}

html {
  --mat-paginator-container-text-font: toyota-book;
  --mat-paginator-container-text-line-height: 20px;
  --mat-paginator-container-text-size: 12px;
  --mat-paginator-container-text-tracking: 0.0333333333em;
  --mat-paginator-container-text-weight: 400;
  --mat-paginator-select-trigger-text-size: 12px;
}

html {
  --mat-tab-container-height: 48px;
  --mat-tab-divider-color: transparent;
  --mat-tab-divider-height: 0;
  --mat-tab-active-indicator-height: 2px;
  --mat-tab-active-indicator-shape: 0;
}

.mat-mdc-tab-group,
.mat-mdc-tab-nav-bar {
  --mat-tab-disabled-ripple-color: rgba(0, 0, 0, 0.54);
  --mat-tab-pagination-icon-color: rgba(0, 0, 0, 0.87);
  --mat-tab-inactive-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-active-label-text-color: #03a9f4;
  --mat-tab-active-ripple-color: #03a9f4;
  --mat-tab-inactive-ripple-color: #03a9f4;
  --mat-tab-inactive-focus-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-inactive-hover-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-active-focus-label-text-color: #03a9f4;
  --mat-tab-active-hover-label-text-color: #03a9f4;
  --mat-tab-active-focus-indicator-color: #03a9f4;
  --mat-tab-active-hover-indicator-color: #03a9f4;
  --mat-tab-active-indicator-color: #03a9f4;
}
.mat-mdc-tab-group.mat-accent,
.mat-mdc-tab-nav-bar.mat-accent {
  --mat-tab-disabled-ripple-color: rgba(0, 0, 0, 0.54);
  --mat-tab-pagination-icon-color: rgba(0, 0, 0, 0.87);
  --mat-tab-inactive-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-active-label-text-color: #4caf50;
  --mat-tab-active-ripple-color: #4caf50;
  --mat-tab-inactive-ripple-color: #4caf50;
  --mat-tab-inactive-focus-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-inactive-hover-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-active-focus-label-text-color: #4caf50;
  --mat-tab-active-hover-label-text-color: #4caf50;
  --mat-tab-active-focus-indicator-color: #4caf50;
  --mat-tab-active-hover-indicator-color: #4caf50;
  --mat-tab-active-indicator-color: #4caf50;
}
.mat-mdc-tab-group.mat-warn,
.mat-mdc-tab-nav-bar.mat-warn {
  --mat-tab-disabled-ripple-color: rgba(0, 0, 0, 0.54);
  --mat-tab-pagination-icon-color: rgba(0, 0, 0, 0.87);
  --mat-tab-inactive-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-active-label-text-color: #f44336;
  --mat-tab-active-ripple-color: #f44336;
  --mat-tab-inactive-ripple-color: #f44336;
  --mat-tab-inactive-focus-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-inactive-hover-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-tab-active-focus-label-text-color: #f44336;
  --mat-tab-active-hover-label-text-color: #f44336;
  --mat-tab-active-focus-indicator-color: #f44336;
  --mat-tab-active-hover-indicator-color: #f44336;
  --mat-tab-active-indicator-color: #f44336;
}
.mat-mdc-tab-group.mat-background-primary,
.mat-mdc-tab-nav-bar.mat-background-primary {
  --mat-tab-background-color: #03a9f4;
  --mat-tab-foreground-color: white;
}
.mat-mdc-tab-group.mat-background-accent,
.mat-mdc-tab-nav-bar.mat-background-accent {
  --mat-tab-background-color: #4caf50;
  --mat-tab-foreground-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-tab-group.mat-background-warn,
.mat-mdc-tab-nav-bar.mat-background-warn {
  --mat-tab-background-color: #f44336;
  --mat-tab-foreground-color: white;
}

.mat-mdc-tab-header {
  --mat-tab-container-height: 48px;
}

.mat-mdc-tab-header {
  --mat-tab-label-text-font: toyota-book;
  --mat-tab-label-text-size: 14px;
  --mat-tab-label-text-tracking: 0.0892857143em;
  --mat-tab-label-text-line-height: 36px;
  --mat-tab-label-text-weight: 500;
}

html {
  --mat-checkbox-disabled-selected-checkmark-color: white;
  --mat-checkbox-selected-focus-state-layer-opacity: 0.12;
  --mat-checkbox-selected-hover-state-layer-opacity: 0.04;
  --mat-checkbox-selected-pressed-state-layer-opacity: 0.12;
  --mat-checkbox-unselected-focus-state-layer-opacity: 0.12;
  --mat-checkbox-unselected-hover-state-layer-opacity: 0.04;
  --mat-checkbox-unselected-pressed-state-layer-opacity: 0.12;
  --mat-checkbox-touch-target-size: 48px;
}

html {
  --mat-checkbox-disabled-label-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-selected-checkmark-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-selected-focus-icon-color: #4caf50;
  --mat-checkbox-selected-hover-icon-color: #4caf50;
  --mat-checkbox-selected-icon-color: #4caf50;
  --mat-checkbox-selected-pressed-icon-color: #4caf50;
  --mat-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-checkbox-selected-focus-state-layer-color: #4caf50;
  --mat-checkbox-selected-hover-state-layer-color: #4caf50;
  --mat-checkbox-selected-pressed-state-layer-color: #4caf50;
  --mat-checkbox-unselected-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-pressed-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-checkbox.mat-primary {
  --mat-checkbox-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-selected-checkmark-color: white;
  --mat-checkbox-selected-focus-icon-color: #03a9f4;
  --mat-checkbox-selected-hover-icon-color: #03a9f4;
  --mat-checkbox-selected-icon-color: #03a9f4;
  --mat-checkbox-selected-pressed-icon-color: #03a9f4;
  --mat-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-checkbox-selected-focus-state-layer-color: #03a9f4;
  --mat-checkbox-selected-hover-state-layer-color: #03a9f4;
  --mat-checkbox-selected-pressed-state-layer-color: #03a9f4;
  --mat-checkbox-unselected-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-pressed-state-layer-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-checkbox.mat-warn {
  --mat-checkbox-disabled-selected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-disabled-unselected-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-checkbox-selected-checkmark-color: white;
  --mat-checkbox-selected-focus-icon-color: #f44336;
  --mat-checkbox-selected-hover-icon-color: #f44336;
  --mat-checkbox-selected-icon-color: #f44336;
  --mat-checkbox-selected-pressed-icon-color: #f44336;
  --mat-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-icon-color: rgba(0, 0, 0, 0.54);
  --mat-checkbox-selected-focus-state-layer-color: #f44336;
  --mat-checkbox-selected-hover-state-layer-color: #f44336;
  --mat-checkbox-selected-pressed-state-layer-color: #f44336;
  --mat-checkbox-unselected-focus-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-hover-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-checkbox-unselected-pressed-state-layer-color: rgba(0, 0, 0, 0.87);
}

html {
  --mat-checkbox-touch-target-display: block;
  --mat-checkbox-state-layer-size: 40px;
}

html {
  --mat-checkbox-label-text-font: toyota-book;
  --mat-checkbox-label-text-line-height: 20px;
  --mat-checkbox-label-text-size: 14px;
  --mat-checkbox-label-text-tracking: 0.0178571429em;
  --mat-checkbox-label-text-weight: 400;
}

html {
  --mat-button-filled-container-shape: 4px;
  --mat-button-filled-horizontal-padding: 16px;
  --mat-button-filled-icon-offset: -4px;
  --mat-button-filled-icon-spacing: 8px;
  --mat-button-filled-touch-target-size: 48px;
  --mat-button-outlined-container-shape: 4px;
  --mat-button-outlined-horizontal-padding: 15px;
  --mat-button-outlined-icon-offset: -4px;
  --mat-button-outlined-icon-spacing: 8px;
  --mat-button-outlined-keep-touch-target: false;
  --mat-button-outlined-outline-width: 1px;
  --mat-button-outlined-touch-target-size: 48px;
  --mat-button-protected-container-elevation-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-container-shape: 4px;
  --mat-button-protected-disabled-container-elevation-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-focus-container-elevation-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-horizontal-padding: 16px;
  --mat-button-protected-hover-container-elevation-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-icon-offset: -4px;
  --mat-button-protected-icon-spacing: 8px;
  --mat-button-protected-pressed-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-button-protected-touch-target-size: 48px;
  --mat-button-text-container-shape: 4px;
  --mat-button-text-horizontal-padding: 8px;
  --mat-button-text-icon-offset: 0;
  --mat-button-text-icon-spacing: 8px;
  --mat-button-text-with-icon-horizontal-padding: 8px;
  --mat-button-text-touch-target-size: 48px;
  --mat-button-tonal-container-shape: 4px;
  --mat-button-tonal-horizontal-padding: 16px;
  --mat-button-tonal-icon-offset: -4px;
  --mat-button-tonal-icon-spacing: 8px;
  --mat-button-tonal-touch-target-size: 48px;
}

html {
  --mat-button-filled-container-color: white;
  --mat-button-filled-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-filled-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-filled-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-filled-focus-state-layer-opacity: 0.12;
  --mat-button-filled-hover-state-layer-opacity: 0.04;
  --mat-button-filled-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-filled-pressed-state-layer-opacity: 0.12;
  --mat-button-filled-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-filled-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-outlined-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-outlined-disabled-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-outlined-focus-state-layer-opacity: 0.12;
  --mat-button-outlined-hover-state-layer-opacity: 0.04;
  --mat-button-outlined-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-pressed-state-layer-opacity: 0.12;
  --mat-button-outlined-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-outlined-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-protected-container-color: white;
  --mat-button-protected-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-protected-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-protected-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-protected-focus-state-layer-opacity: 0.12;
  --mat-button-protected-hover-state-layer-opacity: 0.04;
  --mat-button-protected-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-protected-pressed-state-layer-opacity: 0.12;
  --mat-button-protected-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-protected-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-text-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-text-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-text-focus-state-layer-opacity: 0.12;
  --mat-button-text-hover-state-layer-opacity: 0.04;
  --mat-button-text-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-text-pressed-state-layer-opacity: 0.12;
  --mat-button-text-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-text-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-tonal-container-color: white;
  --mat-button-tonal-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-tonal-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-tonal-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-tonal-focus-state-layer-opacity: 0.12;
  --mat-button-tonal-hover-state-layer-opacity: 0.04;
  --mat-button-tonal-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-tonal-pressed-state-layer-opacity: 0.12;
  --mat-button-tonal-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-tonal-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-button.mat-primary,
.mat-mdc-unelevated-button.mat-primary,
.mat-mdc-raised-button.mat-primary,
.mat-mdc-outlined-button.mat-primary,
.mat-tonal-button.mat-primary {
  --mat-button-filled-container-color: #03a9f4;
  --mat-button-filled-label-text-color: white;
  --mat-button-filled-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-filled-state-layer-color: white;
  --mat-button-outlined-label-text-color: #03a9f4;
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-button-outlined-state-layer-color: #03a9f4;
  --mat-button-protected-container-color: #03a9f4;
  --mat-button-protected-label-text-color: white;
  --mat-button-protected-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-protected-state-layer-color: white;
  --mat-button-text-label-text-color: #03a9f4;
  --mat-button-text-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-button-text-state-layer-color: #03a9f4;
  --mat-button-tonal-container-color: #03a9f4;
  --mat-button-tonal-label-text-color: white;
  --mat-button-tonal-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-tonal-state-layer-color: white;
}
.mat-mdc-button.mat-accent,
.mat-mdc-unelevated-button.mat-accent,
.mat-mdc-raised-button.mat-accent,
.mat-mdc-outlined-button.mat-accent,
.mat-tonal-button.mat-accent {
  --mat-button-filled-container-color: #4caf50;
  --mat-button-filled-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-filled-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-filled-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-outlined-label-text-color: #4caf50;
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-ripple-color: color-mix(in srgb, #4caf50 12%, transparent);
  --mat-button-outlined-state-layer-color: #4caf50;
  --mat-button-protected-container-color: #4caf50;
  --mat-button-protected-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-protected-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-protected-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-text-label-text-color: #4caf50;
  --mat-button-text-ripple-color: color-mix(in srgb, #4caf50 12%, transparent);
  --mat-button-text-state-layer-color: #4caf50;
  --mat-button-tonal-container-color: #4caf50;
  --mat-button-tonal-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-tonal-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-tonal-state-layer-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-button.mat-warn,
.mat-mdc-unelevated-button.mat-warn,
.mat-mdc-raised-button.mat-warn,
.mat-mdc-outlined-button.mat-warn,
.mat-tonal-button.mat-warn {
  --mat-button-filled-container-color: #f44336;
  --mat-button-filled-label-text-color: white;
  --mat-button-filled-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-filled-state-layer-color: white;
  --mat-button-outlined-label-text-color: #f44336;
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-button-outlined-state-layer-color: #f44336;
  --mat-button-protected-container-color: #f44336;
  --mat-button-protected-label-text-color: white;
  --mat-button-protected-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-protected-state-layer-color: white;
  --mat-button-text-label-text-color: #f44336;
  --mat-button-text-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-button-text-state-layer-color: #f44336;
  --mat-button-tonal-container-color: #f44336;
  --mat-button-tonal-label-text-color: white;
  --mat-button-tonal-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-tonal-state-layer-color: white;
}

html {
  --mat-button-filled-container-height: 36px;
  --mat-button-filled-touch-target-display: block;
  --mat-button-outlined-container-height: 36px;
  --mat-button-outlined-touch-target-display: block;
  --mat-button-protected-container-height: 36px;
  --mat-button-protected-touch-target-display: block;
  --mat-button-text-container-height: 36px;
  --mat-button-text-touch-target-display: block;
  --mat-button-tonal-container-height: 36px;
  --mat-button-tonal-touch-target-display: block;
}

html {
  --mat-button-filled-label-text-font: toyota-book;
  --mat-button-filled-label-text-size: 14px;
  --mat-button-filled-label-text-tracking: 0.0892857143em;
  --mat-button-filled-label-text-transform: none;
  --mat-button-filled-label-text-weight: 500;
  --mat-button-outlined-label-text-font: toyota-book;
  --mat-button-outlined-label-text-size: 14px;
  --mat-button-outlined-label-text-tracking: 0.0892857143em;
  --mat-button-outlined-label-text-transform: none;
  --mat-button-outlined-label-text-weight: 500;
  --mat-button-protected-label-text-font: toyota-book;
  --mat-button-protected-label-text-size: 14px;
  --mat-button-protected-label-text-tracking: 0.0892857143em;
  --mat-button-protected-label-text-transform: none;
  --mat-button-protected-label-text-weight: 500;
  --mat-button-text-label-text-font: toyota-book;
  --mat-button-text-label-text-size: 14px;
  --mat-button-text-label-text-tracking: 0.0892857143em;
  --mat-button-text-label-text-transform: none;
  --mat-button-text-label-text-weight: 500;
  --mat-button-tonal-label-text-font: toyota-book;
  --mat-button-tonal-label-text-size: 14px;
  --mat-button-tonal-label-text-tracking: 0.0892857143em;
  --mat-button-tonal-label-text-transform: none;
  --mat-button-tonal-label-text-weight: 500;
}

html {
  --mat-icon-button-icon-size: 24px;
  --mat-icon-button-container-shape: 50%;
  --mat-icon-button-touch-target-size: 48px;
}

html {
  --mat-icon-button-disabled-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-icon-button-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-icon-button-focus-state-layer-opacity: 0.12;
  --mat-icon-button-hover-state-layer-opacity: 0.04;
  --mat-icon-button-icon-color: inherit;
  --mat-icon-button-pressed-state-layer-opacity: 0.12;
  --mat-icon-button-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-icon-button-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-icon-button.mat-primary {
  --mat-icon-button-icon-color: #03a9f4;
  --mat-icon-button-state-layer-color: #03a9f4;
  --mat-icon-button-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
}
.mat-mdc-icon-button.mat-accent {
  --mat-icon-button-icon-color: #4caf50;
  --mat-icon-button-state-layer-color: #4caf50;
  --mat-icon-button-ripple-color: color-mix(in srgb, #4caf50 12%, transparent);
}
.mat-mdc-icon-button.mat-warn {
  --mat-icon-button-icon-color: #f44336;
  --mat-icon-button-state-layer-color: #f44336;
  --mat-icon-button-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
}

html {
  --mat-icon-button-touch-target-display: block;
}

.mat-mdc-icon-button.mat-mdc-button-base {
  --mdc-icon-button-state-layer-size: 48px;
  --mat-icon-button-state-layer-size: 48px;
  width: var(--mat-icon-button-state-layer-size);
  height: var(--mat-icon-button-state-layer-size);
  padding: 12px;
}

html {
  --mat-fab-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-container-shape: 50%;
  --mat-fab-touch-target-size: 48px;
  --mat-fab-extended-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-extended-container-height: 48px;
  --mat-fab-extended-container-shape: 24px;
  --mat-fab-extended-focus-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-extended-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-extended-pressed-container-elevation-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  --mat-fab-focus-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-pressed-container-elevation-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  --mat-fab-small-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-small-container-shape: 50%;
  --mat-fab-small-touch-target-size: 48px;
  --mat-fab-small-focus-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-small-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-small-pressed-container-elevation-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
}

html {
  --mat-fab-container-color: white;
  --mat-fab-disabled-state-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-disabled-state-foreground-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-fab-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-fab-focus-state-layer-opacity: 0.12;
  --mat-fab-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-fab-hover-state-layer-opacity: 0.04;
  --mat-fab-pressed-state-layer-opacity: 0.12;
  --mat-fab-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-small-container-color: white;
  --mat-fab-small-disabled-state-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-small-disabled-state-foreground-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-fab-small-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-fab-small-focus-state-layer-opacity: 0.12;
  --mat-fab-small-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-fab-small-hover-state-layer-opacity: 0.04;
  --mat-fab-small-pressed-state-layer-opacity: 0.12;
  --mat-fab-small-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-small-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-fab-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-fab.mat-primary, .mat-mdc-mini-fab.mat-primary {
  --mat-fab-container-color: #03a9f4;
  --mat-fab-foreground-color: white;
  --mat-fab-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-fab-small-container-color: #03a9f4;
  --mat-fab-small-foreground-color: white;
  --mat-fab-small-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-fab-small-state-layer-color: white;
  --mat-fab-state-layer-color: white;
}
.mat-mdc-fab.mat-accent, .mat-mdc-mini-fab.mat-accent {
  --mat-fab-container-color: #4caf50;
  --mat-fab-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-fab-ripple-color: color-mix(in srgb, #4caf50 12%, transparent);
  --mat-fab-small-container-color: #4caf50;
  --mat-fab-small-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-fab-small-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-small-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-fab-state-layer-color: rgba(0, 0, 0, 0.87);
}
.mat-mdc-fab.mat-warn, .mat-mdc-mini-fab.mat-warn {
  --mat-fab-container-color: #f44336;
  --mat-fab-foreground-color: white;
  --mat-fab-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-fab-small-container-color: #f44336;
  --mat-fab-small-foreground-color: white;
  --mat-fab-small-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-fab-small-state-layer-color: white;
  --mat-fab-state-layer-color: white;
}

html {
  --mat-fab-small-touch-target-display: block;
  --mat-fab-touch-target-display: block;
}

html {
  --mat-fab-extended-label-text-font: toyota-book;
  --mat-fab-extended-label-text-size: 14px;
  --mat-fab-extended-label-text-tracking: 0.0892857143em;
  --mat-fab-extended-label-text-weight: 500;
}

html {
  --mat-snack-bar-container-shape: 4px;
}

html {
  --mat-snack-bar-container-color: #424242;
  --mat-snack-bar-supporting-text-color: white;
  --mat-snack-bar-button-color: #4fc3f7;
}

html {
  --mat-snack-bar-supporting-text-font: toyota-book;
  --mat-snack-bar-supporting-text-line-height: 20px;
  --mat-snack-bar-supporting-text-size: 14px;
  --mat-snack-bar-supporting-text-weight: 400;
}

html {
  --mat-table-row-item-outline-width: 1px;
}

html {
  --mat-table-background-color: white;
  --mat-table-header-headline-color: rgba(0, 0, 0, 0.87);
  --mat-table-row-item-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-table-row-item-outline-color: rgba(0, 0, 0, 0.12);
}

html {
  --mat-table-header-container-height: 56px;
  --mat-table-footer-container-height: 52px;
  --mat-table-row-item-container-height: 52px;
}

html {
  --mat-table-header-headline-font: toyota-book;
  --mat-table-header-headline-line-height: 22px;
  --mat-table-header-headline-size: 14px;
  --mat-table-header-headline-weight: 500;
  --mat-table-header-headline-tracking: 0.0071428571em;
  --mat-table-row-item-label-text-font: toyota-book;
  --mat-table-row-item-label-text-line-height: 20px;
  --mat-table-row-item-label-text-size: 14px;
  --mat-table-row-item-label-text-weight: 400;
  --mat-table-row-item-label-text-tracking: 0.0178571429em;
  --mat-table-footer-supporting-text-font: toyota-book;
  --mat-table-footer-supporting-text-line-height: 20px;
  --mat-table-footer-supporting-text-size: 14px;
  --mat-table-footer-supporting-text-weight: 400;
  --mat-table-footer-supporting-text-tracking: 0.0178571429em;
}

html {
  --mat-progress-spinner-active-indicator-width: 4px;
  --mat-progress-spinner-size: 48px;
}

html {
  --mat-progress-spinner-active-indicator-color: #03a9f4;
}

.mat-accent {
  --mat-progress-spinner-active-indicator-color: #4caf50;
}

.mat-warn {
  --mat-progress-spinner-active-indicator-color: #f44336;
}

html {
  --mat-badge-container-shape: 50%;
  --mat-badge-container-size: unset;
  --mat-badge-small-size-container-size: unset;
  --mat-badge-large-size-container-size: unset;
  --mat-badge-legacy-container-size: 22px;
  --mat-badge-legacy-small-size-container-size: 16px;
  --mat-badge-legacy-large-size-container-size: 28px;
  --mat-badge-container-offset: -11px 0;
  --mat-badge-small-size-container-offset: -8px 0;
  --mat-badge-large-size-container-offset: -14px 0;
  --mat-badge-container-overlap-offset: -11px;
  --mat-badge-small-size-container-overlap-offset: -8px;
  --mat-badge-large-size-container-overlap-offset: -14px;
  --mat-badge-container-padding: 0;
  --mat-badge-small-size-container-padding: 0;
  --mat-badge-large-size-container-padding: 0;
}

html {
  --mat-badge-background-color: #03a9f4;
  --mat-badge-text-color: white;
  --mat-badge-disabled-state-background-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-badge-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
}

.mat-badge-accent {
  --mat-badge-background-color: #4caf50;
  --mat-badge-text-color: rgba(0, 0, 0, 0.87);
}

.mat-badge-warn {
  --mat-badge-background-color: #f44336;
  --mat-badge-text-color: white;
}

html {
  --mat-badge-text-font: toyota-book;
  --mat-badge-line-height: 22px;
  --mat-badge-text-size: 12px;
  --mat-badge-text-weight: 600;
  --mat-badge-small-size-text-size: 9px;
  --mat-badge-small-size-line-height: 16px;
  --mat-badge-large-size-text-size: 24px;
  --mat-badge-large-size-line-height: 28px;
}

html {
  --mat-bottom-sheet-container-shape: 4px;
}

html {
  --mat-bottom-sheet-container-text-color: rgba(0, 0, 0, 0.87);
  --mat-bottom-sheet-container-background-color: white;
}

html {
  --mat-bottom-sheet-container-text-font: toyota-book;
  --mat-bottom-sheet-container-text-line-height: 20px;
  --mat-bottom-sheet-container-text-size: 14px;
  --mat-bottom-sheet-container-text-tracking: 0.0178571429em;
  --mat-bottom-sheet-container-text-weight: 400;
}

html {
  --mat-button-toggle-focus-state-layer-opacity: 0.12;
  --mat-button-toggle-hover-state-layer-opacity: 0.04;
  --mat-button-toggle-legacy-focus-state-layer-opacity: 1;
  --mat-button-toggle-legacy-height: 36px;
  --mat-button-toggle-legacy-shape: 2px;
  --mat-button-toggle-shape: 4px;
}

html {
  --mat-button-toggle-background-color: white;
  --mat-button-toggle-disabled-selected-state-background-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-toggle-disabled-selected-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-toggle-disabled-state-background-color: white;
  --mat-button-toggle-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-toggle-divider-color: rgba(0, 0, 0, 0.12);
  --mat-button-toggle-legacy-disabled-selected-state-background-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-toggle-legacy-disabled-state-background-color: white;
  --mat-button-toggle-legacy-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-toggle-legacy-selected-state-background-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-toggle-legacy-selected-state-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-toggle-legacy-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-toggle-legacy-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-toggle-selected-state-background-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-toggle-selected-state-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-toggle-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-toggle-text-color: rgba(0, 0, 0, 0.87);
}

html {
  --mat-button-toggle-height: 48px;
}

html {
  --mat-button-toggle-label-text-font: toyota-book;
  --mat-button-toggle-label-text-line-height: 24px;
  --mat-button-toggle-label-text-size: 16px;
  --mat-button-toggle-label-text-tracking: 0.03125em;
  --mat-button-toggle-label-text-weight: 400;
  --mat-button-toggle-legacy-label-text-font: toyota-book;
  --mat-button-toggle-legacy-label-text-line-height: 24px;
  --mat-button-toggle-legacy-label-text-size: 16px;
  --mat-button-toggle-legacy-label-text-tracking: 0.03125em;
  --mat-button-toggle-legacy-label-text-weight: 400;
}

html {
  --mat-datepicker-calendar-container-shape: 4px;
  --mat-datepicker-calendar-container-touch-shape: 4px;
  --mat-datepicker-calendar-container-elevation-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  --mat-datepicker-calendar-container-touch-elevation-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
}

html {
  --mat-datepicker-calendar-date-in-range-state-background-color: color-mix(in srgb, #03a9f4 20%, transparent);
  --mat-datepicker-calendar-date-in-comparison-range-state-background-color: color-mix(in srgb, #4caf50 20%, transparent);
  --mat-datepicker-calendar-date-in-overlap-range-state-background-color: #a8dab5;
  --mat-datepicker-calendar-date-in-overlap-range-selected-state-background-color: rgb(69.5241935484, 163.4758064516, 93.9516129032);
  --mat-datepicker-calendar-date-selected-state-text-color: white;
  --mat-datepicker-calendar-date-selected-state-background-color: #03a9f4;
  --mat-datepicker-calendar-date-selected-disabled-state-background-color: color-mix(in srgb, #03a9f4 38%, transparent);
  --mat-datepicker-calendar-date-today-selected-state-outline-color: white;
  --mat-datepicker-calendar-date-focus-state-background-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-datepicker-calendar-date-hover-state-background-color: color-mix(in srgb, #03a9f4 4%, transparent);
  --mat-datepicker-toggle-active-state-icon-color: #03a9f4;
  --mat-datepicker-toggle-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-body-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-period-button-text-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-period-button-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-navigation-button-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-header-divider-color: rgba(0, 0, 0, 0.12);
  --mat-datepicker-calendar-header-text-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-date-today-outline-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-date-today-disabled-state-outline-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-date-text-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-date-outline-color: transparent;
  --mat-datepicker-calendar-date-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-date-preview-state-outline-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-range-input-separator-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-range-input-disabled-state-separator-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-range-input-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-container-background-color: white;
  --mat-datepicker-calendar-container-text-color: rgba(0, 0, 0, 0.87);
}

.mat-datepicker-content.mat-accent, .mat-datepicker-toggle-active.mat-accent {
  --mat-datepicker-calendar-date-in-range-state-background-color: color-mix(in srgb, #4caf50 20%, transparent);
  --mat-datepicker-calendar-date-in-comparison-range-state-background-color: color-mix(in srgb, #4caf50 20%, transparent);
  --mat-datepicker-calendar-date-in-overlap-range-state-background-color: #a8dab5;
  --mat-datepicker-calendar-date-in-overlap-range-selected-state-background-color: rgb(69.5241935484, 163.4758064516, 93.9516129032);
  --mat-datepicker-calendar-date-selected-state-text-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-date-selected-state-background-color: #4caf50;
  --mat-datepicker-calendar-date-selected-disabled-state-background-color: color-mix(in srgb, #4caf50 38%, transparent);
  --mat-datepicker-calendar-date-today-selected-state-outline-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-date-focus-state-background-color: color-mix(in srgb, #4caf50 12%, transparent);
  --mat-datepicker-calendar-date-hover-state-background-color: color-mix(in srgb, #4caf50 4%, transparent);
  --mat-datepicker-toggle-active-state-icon-color: #4caf50;
  --mat-datepicker-toggle-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-body-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-period-button-text-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-period-button-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-navigation-button-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-header-divider-color: rgba(0, 0, 0, 0.12);
  --mat-datepicker-calendar-header-text-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-date-today-outline-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-date-today-disabled-state-outline-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-date-text-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-date-outline-color: transparent;
  --mat-datepicker-calendar-date-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-date-preview-state-outline-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-range-input-separator-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-range-input-disabled-state-separator-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-range-input-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-container-background-color: white;
  --mat-datepicker-calendar-container-text-color: rgba(0, 0, 0, 0.87);
}
.mat-datepicker-content.mat-warn, .mat-datepicker-toggle-active.mat-warn {
  --mat-datepicker-calendar-date-in-range-state-background-color: color-mix(in srgb, #f44336 20%, transparent);
  --mat-datepicker-calendar-date-in-comparison-range-state-background-color: color-mix(in srgb, #4caf50 20%, transparent);
  --mat-datepicker-calendar-date-in-overlap-range-state-background-color: #a8dab5;
  --mat-datepicker-calendar-date-in-overlap-range-selected-state-background-color: rgb(69.5241935484, 163.4758064516, 93.9516129032);
  --mat-datepicker-calendar-date-selected-state-text-color: white;
  --mat-datepicker-calendar-date-selected-state-background-color: #f44336;
  --mat-datepicker-calendar-date-selected-disabled-state-background-color: color-mix(in srgb, #f44336 38%, transparent);
  --mat-datepicker-calendar-date-today-selected-state-outline-color: white;
  --mat-datepicker-calendar-date-focus-state-background-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-datepicker-calendar-date-hover-state-background-color: color-mix(in srgb, #f44336 4%, transparent);
  --mat-datepicker-toggle-active-state-icon-color: #f44336;
  --mat-datepicker-toggle-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-body-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-period-button-text-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-period-button-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-navigation-button-icon-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-header-divider-color: rgba(0, 0, 0, 0.12);
  --mat-datepicker-calendar-header-text-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-date-today-outline-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-calendar-date-today-disabled-state-outline-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-date-text-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-calendar-date-outline-color: transparent;
  --mat-datepicker-calendar-date-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-date-preview-state-outline-color: rgba(0, 0, 0, 0.54);
  --mat-datepicker-range-input-separator-color: rgba(0, 0, 0, 0.87);
  --mat-datepicker-range-input-disabled-state-separator-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-range-input-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-datepicker-calendar-container-background-color: white;
  --mat-datepicker-calendar-container-text-color: rgba(0, 0, 0, 0.87);
}

.mat-calendar-controls {
  --mat-icon-button-touch-target-display: none;
}
.mat-calendar-controls .mat-mdc-icon-button.mat-mdc-button-base {
  --mdc-icon-button-state-layer-size: 40px;
  --mat-icon-button-state-layer-size: 40px;
  width: var(--mat-icon-button-state-layer-size);
  height: var(--mat-icon-button-state-layer-size);
  padding: 8px;
}

html {
  --mat-datepicker-calendar-text-font: toyota-book;
  --mat-datepicker-calendar-text-size: 13px;
  --mat-datepicker-calendar-body-label-text-size: 14px;
  --mat-datepicker-calendar-body-label-text-weight: 500;
  --mat-datepicker-calendar-period-button-text-size: 14px;
  --mat-datepicker-calendar-period-button-text-weight: 500;
  --mat-datepicker-calendar-header-text-size: 11px;
  --mat-datepicker-calendar-header-text-weight: 400;
}

html {
  --mat-divider-width: 1px;
}

html {
  --mat-divider-color: rgba(0, 0, 0, 0.12);
}

html {
  --mat-expansion-container-shape: 4px;
  --mat-expansion-container-elevation-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  --mat-expansion-legacy-header-indicator-display: inline-block;
  --mat-expansion-header-indicator-display: none;
}

html {
  --mat-expansion-container-background-color: white;
  --mat-expansion-container-text-color: rgba(0, 0, 0, 0.87);
  --mat-expansion-actions-divider-color: rgba(0, 0, 0, 0.12);
  --mat-expansion-header-hover-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 4%, transparent);
  --mat-expansion-header-focus-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-expansion-header-disabled-state-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-expansion-header-text-color: rgba(0, 0, 0, 0.87);
  --mat-expansion-header-description-color: rgba(0, 0, 0, 0.54);
  --mat-expansion-header-indicator-color: rgba(0, 0, 0, 0.54);
}

html {
  --mat-expansion-header-collapsed-state-height: 48px;
  --mat-expansion-header-expanded-state-height: 64px;
}

html {
  --mat-expansion-header-text-font: toyota-book;
  --mat-expansion-header-text-size: 14px;
  --mat-expansion-header-text-weight: 500;
  --mat-expansion-header-text-line-height: inherit;
  --mat-expansion-header-text-tracking: inherit;
  --mat-expansion-container-text-font: toyota-book;
  --mat-expansion-container-text-line-height: 20px;
  --mat-expansion-container-text-size: 14px;
  --mat-expansion-container-text-tracking: 0.0178571429em;
  --mat-expansion-container-text-weight: 400;
}

html {
  --mat-grid-list-tile-header-primary-text-size: 14px;
  --mat-grid-list-tile-header-secondary-text-size: 12px;
  --mat-grid-list-tile-footer-primary-text-size: 14px;
  --mat-grid-list-tile-footer-secondary-text-size: 12px;
}

html {
  --mat-icon-color: inherit;
}

.mat-icon.mat-primary {
  --mat-icon-color: #03a9f4;
}
.mat-icon.mat-accent {
  --mat-icon-color: #4caf50;
}
.mat-icon.mat-warn {
  --mat-icon-color: #f44336;
}

html {
  --mat-sidenav-container-shape: 0;
  --mat-sidenav-container-elevation-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);
  --mat-sidenav-container-width: auto;
}

html {
  --mat-sidenav-container-divider-color: rgba(0, 0, 0, 0.12);
  --mat-sidenav-container-background-color: white;
  --mat-sidenav-container-text-color: rgba(0, 0, 0, 0.87);
  --mat-sidenav-content-background-color: #fafafa;
  --mat-sidenav-content-text-color: rgba(0, 0, 0, 0.87);
  --mat-sidenav-scrim-color: rgba(0, 0, 0, 0.6);
}

html {
  --mat-stepper-header-focus-state-layer-shape: 0;
  --mat-stepper-header-hover-state-layer-shape: 0;
}

html {
  --mat-stepper-header-icon-foreground-color: white;
  --mat-stepper-header-selected-state-icon-background-color: #03a9f4;
  --mat-stepper-header-selected-state-icon-foreground-color: white;
  --mat-stepper-header-done-state-icon-background-color: #03a9f4;
  --mat-stepper-header-done-state-icon-foreground-color: white;
  --mat-stepper-header-edit-state-icon-background-color: #03a9f4;
  --mat-stepper-header-edit-state-icon-foreground-color: white;
  --mat-stepper-container-color: white;
  --mat-stepper-line-color: rgba(0, 0, 0, 0.12);
  --mat-stepper-header-hover-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 4%, transparent);
  --mat-stepper-header-focus-state-layer-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-stepper-header-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-stepper-header-optional-label-text-color: rgba(0, 0, 0, 0.54);
  --mat-stepper-header-selected-state-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-stepper-header-error-state-label-text-color: #f44336;
  --mat-stepper-header-icon-background-color: rgba(0, 0, 0, 0.54);
  --mat-stepper-header-error-state-icon-foreground-color: #f44336;
  --mat-stepper-header-error-state-icon-background-color: transparent;
}

.mat-step-header.mat-accent {
  --mat-stepper-header-icon-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-stepper-header-selected-state-icon-background-color: #4caf50;
  --mat-stepper-header-selected-state-icon-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-stepper-header-done-state-icon-background-color: #4caf50;
  --mat-stepper-header-done-state-icon-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-stepper-header-edit-state-icon-background-color: #4caf50;
  --mat-stepper-header-edit-state-icon-foreground-color: rgba(0, 0, 0, 0.87);
}

.mat-step-header.mat-warn {
  --mat-stepper-header-icon-foreground-color: white;
  --mat-stepper-header-selected-state-icon-background-color: #f44336;
  --mat-stepper-header-selected-state-icon-foreground-color: white;
  --mat-stepper-header-done-state-icon-background-color: #f44336;
  --mat-stepper-header-done-state-icon-foreground-color: white;
  --mat-stepper-header-edit-state-icon-background-color: #f44336;
  --mat-stepper-header-edit-state-icon-foreground-color: white;
}

html {
  --mat-stepper-header-height: 72px;
}

html {
  --mat-stepper-container-text-font: toyota-book;
  --mat-stepper-header-label-text-font: toyota-book;
  --mat-stepper-header-label-text-size: 14px;
  --mat-stepper-header-label-text-weight: 400;
  --mat-stepper-header-error-state-label-text-size: 16px;
  --mat-stepper-header-selected-state-label-text-size: 16px;
  --mat-stepper-header-selected-state-label-text-weight: 400;
}

html {
  --mat-sort-arrow-color: rgba(0, 0, 0, 0.87);
}

html {
  --mat-toolbar-container-background-color: white;
  --mat-toolbar-container-text-color: rgba(0, 0, 0, 0.87);
}

.mat-toolbar.mat-primary {
  --mat-toolbar-container-background-color: #03a9f4;
  --mat-toolbar-container-text-color: white;
}
.mat-toolbar.mat-accent {
  --mat-toolbar-container-background-color: #4caf50;
  --mat-toolbar-container-text-color: rgba(0, 0, 0, 0.87);
}
.mat-toolbar.mat-warn {
  --mat-toolbar-container-background-color: #f44336;
  --mat-toolbar-container-text-color: white;
}

html {
  --mat-toolbar-standard-height: 64px;
  --mat-toolbar-mobile-height: 56px;
}

html {
  --mat-toolbar-title-text-font: toyota-book;
  --mat-toolbar-title-text-line-height: 32px;
  --mat-toolbar-title-text-size: 20px;
  --mat-toolbar-title-text-tracking: 0.0125em;
  --mat-toolbar-title-text-weight: 500;
}

html {
  --mat-tree-container-background-color: white;
  --mat-tree-node-text-color: rgba(0, 0, 0, 0.87);
}

html {
  --mat-tree-node-min-height: 48px;
}

html {
  --mat-tree-node-text-font: toyota-book;
  --mat-tree-node-text-size: 14px;
  --mat-tree-node-text-weight: 400;
}

html {
  --mat-timepicker-container-shape: 4px;
  --mat-timepicker-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

html {
  --mat-timepicker-container-background-color: white;
}

html {
  --mat-button-filled-container-shape: 4px;
  --mat-button-filled-horizontal-padding: 16px;
  --mat-button-filled-icon-offset: -4px;
  --mat-button-filled-icon-spacing: 8px;
  --mat-button-filled-touch-target-size: 48px;
  --mat-button-outlined-container-shape: 4px;
  --mat-button-outlined-horizontal-padding: 15px;
  --mat-button-outlined-icon-offset: -4px;
  --mat-button-outlined-icon-spacing: 8px;
  --mat-button-outlined-keep-touch-target: false;
  --mat-button-outlined-outline-width: 1px;
  --mat-button-outlined-touch-target-size: 48px;
  --mat-button-protected-container-elevation-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-container-shape: 4px;
  --mat-button-protected-disabled-container-elevation-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-focus-container-elevation-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-horizontal-padding: 16px;
  --mat-button-protected-hover-container-elevation-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-icon-offset: -4px;
  --mat-button-protected-icon-spacing: 8px;
  --mat-button-protected-pressed-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-button-protected-touch-target-size: 48px;
  --mat-button-text-container-shape: 4px;
  --mat-button-text-horizontal-padding: 8px;
  --mat-button-text-icon-offset: 0;
  --mat-button-text-icon-spacing: 8px;
  --mat-button-text-with-icon-horizontal-padding: 8px;
  --mat-button-text-touch-target-size: 48px;
  --mat-button-tonal-container-shape: 4px;
  --mat-button-tonal-horizontal-padding: 16px;
  --mat-button-tonal-icon-offset: -4px;
  --mat-button-tonal-icon-spacing: 8px;
  --mat-button-tonal-touch-target-size: 48px;
}

html {
  --mat-button-filled-container-color: white;
  --mat-button-filled-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-filled-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-filled-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-filled-focus-state-layer-opacity: 0.12;
  --mat-button-filled-hover-state-layer-opacity: 0.04;
  --mat-button-filled-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-filled-pressed-state-layer-opacity: 0.12;
  --mat-button-filled-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-filled-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-outlined-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-outlined-disabled-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-outlined-focus-state-layer-opacity: 0.12;
  --mat-button-outlined-hover-state-layer-opacity: 0.04;
  --mat-button-outlined-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-pressed-state-layer-opacity: 0.12;
  --mat-button-outlined-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-outlined-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-protected-container-color: white;
  --mat-button-protected-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-protected-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-protected-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-protected-focus-state-layer-opacity: 0.12;
  --mat-button-protected-hover-state-layer-opacity: 0.04;
  --mat-button-protected-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-protected-pressed-state-layer-opacity: 0.12;
  --mat-button-protected-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-protected-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-text-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-text-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-text-focus-state-layer-opacity: 0.12;
  --mat-button-text-hover-state-layer-opacity: 0.04;
  --mat-button-text-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-text-pressed-state-layer-opacity: 0.12;
  --mat-button-text-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-text-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-button-tonal-container-color: white;
  --mat-button-tonal-disabled-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-tonal-disabled-label-text-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-button-tonal-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-button-tonal-focus-state-layer-opacity: 0.12;
  --mat-button-tonal-hover-state-layer-opacity: 0.04;
  --mat-button-tonal-label-text-color: rgba(0, 0, 0, 0.87);
  --mat-button-tonal-pressed-state-layer-opacity: 0.12;
  --mat-button-tonal-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-button-tonal-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-button.mat-primary,
.mat-mdc-unelevated-button.mat-primary,
.mat-mdc-raised-button.mat-primary,
.mat-mdc-outlined-button.mat-primary,
.mat-tonal-button.mat-primary {
  --mat-button-filled-container-color: #03a9f4;
  --mat-button-filled-label-text-color: white;
  --mat-button-filled-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-filled-state-layer-color: white;
  --mat-button-outlined-label-text-color: #03a9f4;
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-button-outlined-state-layer-color: #03a9f4;
  --mat-button-protected-container-color: #03a9f4;
  --mat-button-protected-label-text-color: white;
  --mat-button-protected-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-protected-state-layer-color: white;
  --mat-button-text-label-text-color: #03a9f4;
  --mat-button-text-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-button-text-state-layer-color: #03a9f4;
  --mat-button-tonal-container-color: #03a9f4;
  --mat-button-tonal-label-text-color: white;
  --mat-button-tonal-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-tonal-state-layer-color: white;
}
.mat-mdc-button.mat-accent,
.mat-mdc-unelevated-button.mat-accent,
.mat-mdc-raised-button.mat-accent,
.mat-mdc-outlined-button.mat-accent,
.mat-tonal-button.mat-accent {
  --mat-button-filled-container-color: #d50000;
  --mat-button-filled-label-text-color: white;
  --mat-button-filled-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-filled-state-layer-color: white;
  --mat-button-outlined-label-text-color: #d50000;
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-ripple-color: color-mix(in srgb, #d50000 12%, transparent);
  --mat-button-outlined-state-layer-color: #d50000;
  --mat-button-protected-container-color: #d50000;
  --mat-button-protected-label-text-color: white;
  --mat-button-protected-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-protected-state-layer-color: white;
  --mat-button-text-label-text-color: #d50000;
  --mat-button-text-ripple-color: color-mix(in srgb, #d50000 12%, transparent);
  --mat-button-text-state-layer-color: #d50000;
  --mat-button-tonal-container-color: #d50000;
  --mat-button-tonal-label-text-color: white;
  --mat-button-tonal-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-tonal-state-layer-color: white;
}
.mat-mdc-button.mat-warn,
.mat-mdc-unelevated-button.mat-warn,
.mat-mdc-raised-button.mat-warn,
.mat-mdc-outlined-button.mat-warn,
.mat-tonal-button.mat-warn {
  --mat-button-filled-container-color: #f44336;
  --mat-button-filled-label-text-color: white;
  --mat-button-filled-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-filled-state-layer-color: white;
  --mat-button-outlined-label-text-color: #f44336;
  --mat-button-outlined-outline-color: rgba(0, 0, 0, 0.12);
  --mat-button-outlined-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-button-outlined-state-layer-color: #f44336;
  --mat-button-protected-container-color: #f44336;
  --mat-button-protected-label-text-color: white;
  --mat-button-protected-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-protected-state-layer-color: white;
  --mat-button-text-label-text-color: #f44336;
  --mat-button-text-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-button-text-state-layer-color: #f44336;
  --mat-button-tonal-container-color: #f44336;
  --mat-button-tonal-label-text-color: white;
  --mat-button-tonal-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-button-tonal-state-layer-color: white;
}

html {
  --mat-button-filled-container-height: 36px;
  --mat-button-filled-touch-target-display: block;
  --mat-button-outlined-container-height: 36px;
  --mat-button-outlined-touch-target-display: block;
  --mat-button-protected-container-height: 36px;
  --mat-button-protected-touch-target-display: block;
  --mat-button-text-container-height: 36px;
  --mat-button-text-touch-target-display: block;
  --mat-button-tonal-container-height: 36px;
  --mat-button-tonal-touch-target-display: block;
}

html {
  --mat-fab-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-container-shape: 50%;
  --mat-fab-touch-target-size: 48px;
  --mat-fab-extended-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-extended-container-height: 48px;
  --mat-fab-extended-container-shape: 24px;
  --mat-fab-extended-focus-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-extended-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-extended-pressed-container-elevation-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  --mat-fab-focus-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-pressed-container-elevation-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  --mat-fab-small-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-small-container-shape: 50%;
  --mat-fab-small-touch-target-size: 48px;
  --mat-fab-small-focus-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-small-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-small-pressed-container-elevation-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
}

html {
  --mat-fab-container-color: white;
  --mat-fab-disabled-state-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-disabled-state-foreground-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-fab-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-fab-focus-state-layer-opacity: 0.12;
  --mat-fab-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-fab-hover-state-layer-opacity: 0.04;
  --mat-fab-pressed-state-layer-opacity: 0.12;
  --mat-fab-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-small-container-color: white;
  --mat-fab-small-disabled-state-container-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-small-disabled-state-foreground-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-fab-small-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-fab-small-focus-state-layer-opacity: 0.12;
  --mat-fab-small-foreground-color: rgba(0, 0, 0, 0.87);
  --mat-fab-small-hover-state-layer-opacity: 0.04;
  --mat-fab-small-pressed-state-layer-opacity: 0.12;
  --mat-fab-small-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-fab-small-state-layer-color: rgba(0, 0, 0, 0.87);
  --mat-fab-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-fab.mat-primary, .mat-mdc-mini-fab.mat-primary {
  --mat-fab-container-color: #03a9f4;
  --mat-fab-foreground-color: white;
  --mat-fab-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
  --mat-fab-small-container-color: #03a9f4;
  --mat-fab-small-foreground-color: white;
  --mat-fab-small-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-fab-small-state-layer-color: white;
  --mat-fab-state-layer-color: white;
}
.mat-mdc-fab.mat-accent, .mat-mdc-mini-fab.mat-accent {
  --mat-fab-container-color: #d50000;
  --mat-fab-foreground-color: white;
  --mat-fab-ripple-color: color-mix(in srgb, #d50000 12%, transparent);
  --mat-fab-small-container-color: #d50000;
  --mat-fab-small-foreground-color: white;
  --mat-fab-small-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-fab-small-state-layer-color: white;
  --mat-fab-state-layer-color: white;
}
.mat-mdc-fab.mat-warn, .mat-mdc-mini-fab.mat-warn {
  --mat-fab-container-color: #f44336;
  --mat-fab-foreground-color: white;
  --mat-fab-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
  --mat-fab-small-container-color: #f44336;
  --mat-fab-small-foreground-color: white;
  --mat-fab-small-ripple-color: color-mix(in srgb, white 12%, transparent);
  --mat-fab-small-state-layer-color: white;
  --mat-fab-state-layer-color: white;
}

html {
  --mat-fab-small-touch-target-display: block;
  --mat-fab-touch-target-display: block;
}

html {
  --mat-icon-button-icon-size: 24px;
  --mat-icon-button-container-shape: 50%;
  --mat-icon-button-touch-target-size: 48px;
}

html {
  --mat-icon-button-disabled-icon-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 38%, transparent);
  --mat-icon-button-disabled-state-layer-color: rgba(0, 0, 0, 0.54);
  --mat-icon-button-focus-state-layer-opacity: 0.12;
  --mat-icon-button-hover-state-layer-opacity: 0.04;
  --mat-icon-button-icon-color: inherit;
  --mat-icon-button-pressed-state-layer-opacity: 0.12;
  --mat-icon-button-ripple-color: color-mix(in srgb, rgba(0, 0, 0, 0.87) 12%, transparent);
  --mat-icon-button-state-layer-color: rgba(0, 0, 0, 0.87);
}

.mat-mdc-icon-button.mat-primary {
  --mat-icon-button-icon-color: #03a9f4;
  --mat-icon-button-state-layer-color: #03a9f4;
  --mat-icon-button-ripple-color: color-mix(in srgb, #03a9f4 12%, transparent);
}
.mat-mdc-icon-button.mat-accent {
  --mat-icon-button-icon-color: #d50000;
  --mat-icon-button-state-layer-color: #d50000;
  --mat-icon-button-ripple-color: color-mix(in srgb, #d50000 12%, transparent);
}
.mat-mdc-icon-button.mat-warn {
  --mat-icon-button-icon-color: #f44336;
  --mat-icon-button-state-layer-color: #f44336;
  --mat-icon-button-ripple-color: color-mix(in srgb, #f44336 12%, transparent);
}

html {
  --mat-icon-button-touch-target-display: block;
}

.mat-mdc-icon-button.mat-mdc-button-base {
  --mdc-icon-button-state-layer-size: 48px;
  --mat-icon-button-state-layer-size: 48px;
  width: var(--mat-icon-button-state-layer-size);
  height: var(--mat-icon-button-state-layer-size);
  padding: 12px;
}

html {
  --mat-toolbar-container-background-color: white;
  --mat-toolbar-container-text-color: rgba(0, 0, 0, 0.87);
}

.mat-toolbar.mat-primary {
  --mat-toolbar-container-background-color: #263238;
  --mat-toolbar-container-text-color: white;
}
.mat-toolbar.mat-accent {
  --mat-toolbar-container-background-color: #4caf50;
  --mat-toolbar-container-text-color: rgba(0, 0, 0, 0.87);
}
.mat-toolbar.mat-warn {
  --mat-toolbar-container-background-color: #f44336;
  --mat-toolbar-container-text-color: white;
}

html {
  --mat-toolbar-standard-height: 64px;
  --mat-toolbar-mobile-height: 56px;
}

html {
  --mat-progress-spinner-active-indicator-width: 4px;
  --mat-progress-spinner-size: 48px;
}

html {
  --mat-progress-spinner-active-indicator-color: #f44336;
}

.mat-accent {
  --mat-progress-spinner-active-indicator-color: #4caf50;
}

.mat-warn {
  --mat-progress-spinner-active-indicator-color: #f44336;
}

.custom-active-button {
  font-family: "toyota-bold";
  font-size: 1em;
  font-weight: bold;
  margin: 1em 0em;
  padding: 0em 0em 0.3em;
  border-radius: 0.2em;
  width: 100%;
  background-color: rgb(180, 57, 53) !important;
  color: rgb(255, 255, 255) !important;
  --mat-button-text-label-text-color: rgb(255, 255, 255);
  --mat-button-outlined-label-text-color: rgb(255, 255, 255);
  --mat-button-filled-label-text-color: rgb(255, 255, 255);
  --mat-button-text-label-text-font: toyota-bold;
  --mat-button-outlined-label-text-font: toyota-bold;
  --mat-button-filled-label-text-font: toyota-bold;
}

.custom-disabled-button {
  font-family: "toyota-bold";
  font-size: 1em;
  font-weight: bold;
  color: rgb(255, 255, 255) !important;
  opacity: 0.6;
}

.custom-error-aligment {
  float: right;
}

.rental_ev_modal_conatainer {
  font-family: "toyota-regular";
}
.rental_ev_modal_conatainer .title_container {
  text-align: center;
}
.rental_ev_modal_conatainer .title_container .title {
  font-family: "toyota-bold";
  font-size: 1.5em;
}
.rental_ev_modal_conatainer .title_container .description {
  font-size: 1em;
}
.rental_ev_modal_conatainer .dropdown_container {
  text-align: center;
  width: 5.25em;
  margin-top: 2em;
  margin-bottom: 3.5em;
  margin-left: auto;
  margin-right: auto;
  caret-color: transparent;
}
.rental_ev_modal_conatainer .dropdown_container .selected_value {
  font-family: "toyota-bold";
  font-size: 1.5em;
  width: 1.5em;
}
.rental_ev_modal_conatainer .dropdown_container .arrow_drop_down_icon {
  position: relative;
  right: -0.8em;
}
.rental_ev_modal_conatainer .dropdown_container .selected_Value_container {
  border-bottom: 0.0625em solid rgb(216, 216, 216);
  cursor: pointer;
}
.rental_ev_modal_conatainer .dropdown_container .options_container {
  max-height: 9.6875em;
  overflow-y: scroll;
  border: 0.0625em solid rgb(216, 216, 216);
}
.rental_ev_modal_conatainer .dropdown_container .options_container ::ng-deep .mat-mdc-option {
  padding-left: 1.5em;
}
.rental_ev_modal_conatainer .actions_container {
  display: flex;
  justify-content: center;
  /* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version. */
}
.rental_ev_modal_conatainer .actions_container button {
  margin-right: 1.5em;
  border-radius: 0.25em;
  outline: none;
}
.rental_ev_modal_conatainer .actions_container .cancel-btn, .rental_ev_modal_conatainer .actions_container .cancel-btn:hover {
  border: 0.0625em solid rgb(204, 0, 0);
  color: rgb(204, 0, 0);
  background-color: rgb(255, 255, 255);
  font-weight: 600;
}
.rental_ev_modal_conatainer .actions_container ::ng-deep .mat-button-focus-overlay {
  display: none;
}
.rental_ev_modal_conatainer .actions_container .confirm-btn {
  background-color: rgb(204, 0, 0);
  color: rgb(255, 255, 255);
}
.rental_ev_modal_conatainer .actions_container .disabled-confirm-btn {
  background-color: rgb(216, 216, 216);
  color: rgb(138, 138, 138);
}

::-webkit-scrollbar {
  height: 0.75em;
  width: 0.5em;
  background: rgb(242, 242, 242);
}

::-webkit-scrollbar-thumb {
  background: rgb(217, 217, 217);
  -webkit-border-radius: 1ex;
}`, "",{"version":3,"sources":["webpack://./src/app/styles/app/theme.scss","webpack://./src/app/styles/fonts/toyota-fonts.scss","webpack://./src/app/admin/dailag_components/rental-ev-credits-popup/rental-ev-credits-popup.component.scss","webpack://./src/app/styles/app/utilities.scss","webpack://./src/app/styles/app/admin.scss","webpack://./src/app/styles/colors/palette.scss","webpack://./node_modules/@angular/material/core/style/_sass-utils.scss","webpack://./node_modules/@angular/material/core/tokens/_token-utils.scss","webpack://./node_modules/@angular/material/core/typography/_typography.scss","webpack://./node_modules/@angular/material/core/typography/_typography-utils.scss","webpack://./node_modules/@angular/material/chips/_chips-theme.scss","webpack://./node_modules/@angular/material/slide-toggle/_slide-toggle-theme.scss","webpack://./node_modules/@angular/material/list/_list-theme.scss","webpack://./node_modules/@angular/material/tabs/_tabs-theme.scss","webpack://./node_modules/@angular/material/core/_core.scss","webpack://./node_modules/@angular/material/core/option/_option-theme.scss","webpack://./node_modules/@angular/material/core/selection/pseudo-checkbox/_pseudo-checkbox-theme.scss","webpack://./node_modules/@angular/material/progress-bar/_progress-bar-theme.scss","webpack://./node_modules/@angular/material/form-field/_form-field-theme.scss","webpack://./node_modules/@angular/material/select/_select-theme.scss","webpack://./node_modules/@angular/material/radio/_radio-theme.scss","webpack://./node_modules/@angular/material/slider/_slider-theme.scss","webpack://./node_modules/@angular/material/checkbox/_checkbox-theme.scss","webpack://./node_modules/@angular/material/button/_button-theme.scss","webpack://./node_modules/@angular/material/button/_icon-button-theme.scss","webpack://./node_modules/@angular/material/button/_fab-theme.scss","webpack://./node_modules/@angular/material/progress-spinner/_progress-spinner-theme.scss","webpack://./node_modules/@angular/material/badge/_badge-theme.scss","webpack://./node_modules/@angular/material/datepicker/_datepicker-theme.scss","webpack://./node_modules/@angular/material/icon/_icon-theme.scss","webpack://./node_modules/@angular/material/stepper/_stepper-theme.scss","webpack://./node_modules/@angular/material/toolbar/_toolbar-theme.scss","webpack://./src/app/admin/styles/simple-components.scss","webpack://./src/app/admin/styles/layout.scss"],"names":[],"mappings":"AAAA,0BAAA;ACAA;EACE,0BAAA;EACA,yDAAA;ACEF;ADAA;EACE,0BAAA;EACA,yDAAA;ACEF;ADAA;EACE,6BAAA;EACA,4DAAA;ACEF;AC4BA;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AD1BF;;AC8BA;EACE;IACE,SAAA;IACA,UAAA;IACA,cAAA;ED3BF;EC6BA,4HAAA;EACA;IACE,aAAA;ED3BF;EC8BA;;IAEE,aAAA;ED5BF;EC+BA;IACE,aAAA;ED7BF;ECgCA;IACE,aAAA;ED9BF;ECiCA;IACE,aAAA;ED/BF;ECkCA;IACE,gBAAA;EDhCF;AACF;ACmCA;EACE,qBAAA;ADjCF;;ACoCA;EACE,sBAAA;ADjCF;;ACoCA;EACI,cAAA;ADjCJ;;ACoCA;EACE,0BF9EK;AC6CP;;ADhEA;EACE,0BAAA;EACA,yDAAA;ACmEF;ADjEA;EACE,0BAAA;EACA,yDAAA;ACmEF;ADjEA;EACE,6BAAA;EACA,4DAAA;ACmEF;AEvEA;EACI,YAAA;AFyEJ;AEvEI;EACI,qBC0BF;EDzBE,oDAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,6BAAA;AFyER;AEtEI;EACI,gBAAA;AFwER;;AEnEI;EACI,iCAAA;AFsER;;AElEA;EACI,cAAA;EACA,gBAAA;AFqEJ;AEnEI;EACI,iBAAA;AFqER;;AEjEA;EACI,uBAAA;AFoEJ;;AEjEA;EACE,sBAAA;EACA,6CAAA;EACA,oCAAA;AFoEF;;AEjEA;EACE,oCAAA;EACA,YAAA;AFoEF;;AIjGI;ECsDI,kCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,qCAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,wCAAA;ALsDR;;AMWE;;;;;EAKE,iCAAA;EACA,sBAAA;EACA,gBAAA;ANRJ;;AMWE;;;;;EAKE,iCAAA;EACA,wBAAA;EACA,gBAAA;ANRJ;;AMWE;;;;;EAKE,iCAAA;EACA,0BAAA;EACA,gBAAA;ANRJ;;AMWE;;;;;EAKE,iCAAA;EACA,yBAAA;EACA,gBAAA;ANRJ;;AMcE;;;EC5JE,8CAAA;EDuKA,gBAAA;ANlBJ;;AMqBE;;;EC1KE,8CAAA;EDqLA,gBAAA;ANzBJ;;AM4BE;;;;EAIE,iCAAA;EACA,8BAAA;ANzBJ;;AM4BE;;;;;EAKE,iCAAA;EACA,8BAAA;ANzBJ;AM2BI;;;;;EACE,gBAAA;ANrBN;;AMyBE;;;;EAIE,iCAAA;EACA,8BAAA;ANtBJ;;AMyBE;;EAEE,iCAAA;EACA,2BAAA;EACA,gBAAA;ANtBJ;;AMyBE;;EAEE,iCAAA;EACA,+BAAA;EACA,gBAAA;ANtBJ;;AMyBE;;EAEE,iCAAA;EACA,sBAAA;EACA,gBAAA;ANtBJ;;AMyBE;;EAEE,iCAAA;EACA,8BAAA;EACA,gBAAA;ANtBJ;;AI9NI;ECsDI,mDAAA;EAAA,mDAAA;EAAA,4CAAA;EAAA,0DAAA;EAAA,6CAAA;ALgLR;;AItOI;ECsDI,gDAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,kDAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,yDAAA;EAAA,iDAAA;AL6LR;;AInPI;ECsDI,gDAAA;EAAA,yCAAA;EAAA,oDAAA;EAAA,qDAAA;EAAA,uDAAA;EAAA,wDAAA;EAAA,gDAAA;EAAA,iDAAA;ALwMR;;AI9PI;ECsDI,6CAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA,0CAAA;ALqNR;;AI3QI;ECsDI,mDAAA;EAAA,qDAAA;EAAA,mDAAA;EAAA,qDAAA;AL4NR;;AIlRI;ECsDI,8CAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,2CAAA;EAAA,sDAAA;EAAA,yDAAA;EAAA,0DAAA;ALsOR;;AI5RI;ECsDI,0CAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,2CAAA;EAAA,oCAAA;AL8OR;;AIpSI;ECsDI,sCAAA;EAAA,+BAAA;EAAA,gCAAA;ALoPR;;AI1SI;ECsDI,yCAAA;EAAA,yCAAA;EAAA,kCAAA;EAAA,2CAAA;EAAA,mCAAA;AL4PR;;AIlTI;ECsDI,2CAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,6CAAA;EAAA,qCAAA;ALoQR;;AI1TI;ECsDI,uCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,wCAAA;EAAA,iCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,iDAAA;EAAA,oCAAA;ALiRR;;AIvUI;ECsDI,+CAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,sDAAA;ALwRR;;AI9UI;ECsDI,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,mDAAA;EAAA,2CAAA;EAAA,yDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,wDAAA;EAAA,2CAAA;EAAA,oDAAA;EAAA,6CAAA;EAAA,sDAAA;EAAA,8CAAA;EAAA,sDAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gDAAA;AL8SR;;AIpWI;ECsDI,2CAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,6CAAA;EAAA,qCAAA;ALsTR;;AI5WI;ECsDI,sCAAA;EAAA,sCAAA;EAAA,+BAAA;EAAA,gCAAA;EAAA,uCAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,gDAAA;ALmUR;;AQpVI;EHiBI,uCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,8CAAA;EAAA,iCAAA;AL2UR;;AIjYI;ECsDI,+CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,yCAAA;ALmVR;ASjWM;EJcE,+CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,yCAAA;AL0VR;;AIhZI;ECsDI,wCAAA;EAAA,wCAAA;EAAA,iCAAA;EAAA,+CAAA;EAAA,kCAAA;ALkWR;;AIxZI;ECsDI,+CAAA;EAAA,wCAAA;EAAA,+CAAA;EAAA,sDAAA;EAAA,yCAAA;AL0WR;;AIhaI;ECsDI,4CAAA;EAAA,qCAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,sCAAA;ALkXR;;AIxaI;ECsDI,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,mDAAA;EAAA,2CAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,+CAAA;EAAA,6DAAA;EAAA,gDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,wDAAA;EAAA,sEAAA;EAAA,yDAAA;ALoYR;;AUhTI;EAEE,iCAAA;EACA,0BAAA;AVkTN;;AI/bI;ECsDI,gDAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA,0CAAA;EAAA,8CAAA;ALkZR;;AWnZI;ENCI,sCAAA;EAAA,+BAAA;EAAA,6CAAA;EAAA,sCAAA;EAAA,gCAAA;AL0ZR;;AIhdI;ECsDI,2CAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,kDAAA;EAAA,qCAAA;ALkaR;;AIxdI;ECsDI,gDAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA,8CAAA;EAAA,0CAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,yDAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,mDAAA;EAAA,4CAAA;EAAA,0DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,qDAAA;EAAA,4CAAA;EAAA,wCAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,6CAAA;EAAA,yCAAA;AL8bR;;AIpfI;ECsDI,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,yCAAA;ALqcR;;AI3fI;ECsDI,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,2CAAA;AL4cR;;AIlgBI;ECsDI,6CAAA;EAAA,6CAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,oDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,2CAAA;EAAA,wDAAA;EAAA,oDAAA;EAAA,oDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,2DAAA;AL8dR;;AY9fM;EACE,yJAAA;AZigBR;;AYlgBM;EACE,0JAAA;AZqgBR;;AYtgBM;EACE,0JAAA;AZygBR;;AY1gBM;EACE,0JAAA;AZ6gBR;;AY9gBM;EACE,2JAAA;AZihBR;;AYlhBM;EACE,2JAAA;AZqhBR;;AYthBM;EACE,4JAAA;AZyhBR;;AY1hBM;EACE,4JAAA;AZ6hBR;;AY9hBM;EACE,4JAAA;AZiiBR;;AYliBM;EACE,4JAAA;AZqiBR;;AYtiBM;EACE,8JAAA;AZyiBR;;AY1iBM;EACE,8JAAA;AZ6iBR;;AY9iBM;EACE,8JAAA;AZijBR;;AYljBM;EACE,8JAAA;AZqjBR;;AYtjBM;EACE,8JAAA;AZyjBR;;AY1jBM;EACE,8JAAA;AZ6jBR;;AY9jBM;EACE,+JAAA;AZikBR;;AYlkBM;EACE,+JAAA;AZqkBR;;AYtkBM;EACE,+JAAA;AZykBR;;AY1kBM;EACE,+JAAA;AZ6kBR;;AY9kBM;EACE,gKAAA;AZilBR;;AYllBM;EACE,gKAAA;AZqlBR;;AYtlBM;EACE,gKAAA;AZylBR;;AY1lBM;EACE,gKAAA;AZ6lBR;;AY9lBM;EACE,gKAAA;AZimBR;;AY9nBE;EACE,6BAAA;AZioBJ;;AY1nBI;EACE,yFAAA;EACA,uEAAA;AZ6nBN;;AIjoBI;ECsDI,mCAAA;EAAA,yCAAA;EAAA,gJAAA;EAAA,iJAAA;EAAA,iJAAA;EAAA,iJAAA;EAAA,kJAAA;EAAA,kJAAA;EAAA,mJAAA;EAAA,mJAAA;EAAA,mJAAA;EAAA,mJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,sJAAA;EAAA,sJAAA;EAAA,sJAAA;EAAA,sJAAA;EAAA,uJAAA;EAAA,uJAAA;EAAA,uJAAA;EAAA,uJAAA;EAAA,uJAAA;ALymBR;;AI/pBI;ECsDI,4EAAA;AL6mBR;;AInqBI;ECsDI,qDAAA;EAAA,kDAAA;EAAA,6FAAA;EAAA,8FAAA;EAAA,iGAAA;ALqnBR;;AalqBI;ER6CI,qDAAA;EAAA,kDAAA;EAAA,6FAAA;EAAA,8FAAA;EAAA,iGAAA;AL6nBR;;AarqBI;ERwCI,qDAAA;EAAA,kDAAA;EAAA,6FAAA;EAAA,8FAAA;EAAA,iGAAA;ALqoBR;;AI3rBI;ECsDI,oDAAA;ALyoBR;;AI/rBI;ECsDI,uDAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA,qEAAA;EAAA,mHAAA;EAAA,iHAAA;EAAA,+DAAA;EAAA,yHAAA;ALopBR;;AcrrBI;ETiCI,uDAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA,qEAAA;EAAA,mHAAA;EAAA,iHAAA;EAAA,+DAAA;EAAA,yHAAA;AL+pBR;;Ac3rBI;ET4BI,uDAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA,qEAAA;EAAA,mHAAA;EAAA,iHAAA;EAAA,+DAAA;EAAA,yHAAA;AL0qBR;;AcjsBI;ETuBI,uDAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA,qEAAA;EAAA,mHAAA;EAAA,iHAAA;EAAA,+DAAA;EAAA,yHAAA;ALqrBR;;AI3uBI;ECsDI,yCAAA;EAAA,yCAAA;EAAA,kCAAA;EAAA,2CAAA;EAAA,mCAAA;AL6rBR;;AInvBI;ECsDI,2CAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,6CAAA;EAAA,qCAAA;ALqsBR;;AI3vBI;ECsDI,wCAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,sCAAA;AL4sBR;;AIlwBI;ECsDI,0CAAA;EAAA,sJAAA;EAAA,0CAAA;EAAA,qJAAA;EAAA,sDAAA;EAAA,mDAAA;EAAA,wCAAA;EAAA,mJAAA;ALutBR;;AI7wBI;ECsDI,uCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,wCAAA;EAAA,iCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,iDAAA;EAAA,oCAAA;ALouBR;;AI1xBI;ECsDI,+CAAA;EAAA,oCAAA;EAAA,iCAAA;AL0uBR;;AelyBI;EVwDI,kDAAA;EAAA,uDAAA;AL+uBR;AenyBM;EVoDE,kDAAA;EAAA,uDAAA;ALmvBR;AelyBM;EV+CE,kDAAA;EAAA,uDAAA;ALuvBR;;AI7yBI;ECsDI,kCAAA;EAAA,+CAAA;AL4vBR;;AIlzBI;ECsDI,sCAAA;EAAA,0CAAA;ALiwBR;;AIvzBI;ECsDI,+CAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,sDAAA;ALwwBR;;AI9zBI;ECsDI,oDAAA;EAAA,0DAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,kDAAA;EAAA,8CAAA;ALixBR;;AIv0BI;ECsDI,uFAAA;EAAA,4CAAA;EAAA,6DAAA;EAAA,4FAAA;EAAA,8CAAA;EAAA,sDAAA;EAAA,8FAAA;EAAA,gHAAA;EAAA,uDAAA;EAAA,0CAAA;EAAA,kDAAA;EAAA,4DAAA;EAAA,0CAAA;EAAA,mDAAA;EAAA,2CAAA;EAAA,oDAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,iDAAA;EAAA,gEAAA;EAAA,sGAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,yGAAA;EAAA,6DAAA;EAAA,mEAAA;EAAA,2GAAA;EAAA,6DAAA;EAAA,2GAAA;EAAA,yEAAA;EAAA,6DAAA;EAAA,6DAAA;EAAA,uDAAA;EAAA,kDAAA;EAAA,mEAAA;EAAA,iHAAA;EAAA,yEAAA;EAAA,6DAAA;EAAA,mEAAA;EAAA,mEAAA;EAAA,+DAAA;EAAA,qEAAA;EAAA,6GAAA;EAAA,+DAAA;EAAA,6GAAA;EAAA,2EAAA;EAAA,oDAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,+DAAA;EAAA,4DAAA;EAAA,0GAAA;EAAA,kEAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;AL60BR;;AgB73BI;EXgDI,uFAAA;EAAA,4CAAA;EAAA,6DAAA;EAAA,4FAAA;EAAA,8CAAA;EAAA,sDAAA;EAAA,8FAAA;ALu1BR;;AgBl4BI;EX2CI,uFAAA;EAAA,4CAAA;EAAA,6DAAA;EAAA,4FAAA;EAAA,8CAAA;EAAA,sDAAA;EAAA,8FAAA;ALi2BR;;AIv5BI;ECsDI,uCAAA;EAAA,4CAAA;EAAA,iDAAA;EAAA,8DAAA;EAAA,gEAAA;ALy2BR;;AI/5BI;ECsDI,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,mDAAA;EAAA,2CAAA;EAAA,yDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,wDAAA;EAAA,2CAAA;EAAA,oDAAA;EAAA,6CAAA;EAAA,sDAAA;EAAA,8CAAA;EAAA,sDAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gDAAA;AL+3BR;;AIr7BI;ECsDI,wJAAA;ALm4BR;;AIz7BI;ECsDI,0CAAA;EAAA,4DAAA;EAAA,kGAAA;EAAA,wDAAA;EAAA,qDAAA;EAAA,2FAAA;EAAA,yCAAA;EAAA,yCAAA;AL84BR;;AiB37BI;EZ6CI,0CAAA;EAAA,4DAAA;EAAA,kGAAA;EAAA,wDAAA;EAAA,qDAAA;EAAA,2FAAA;EAAA,yCAAA;EAAA,yCAAA;ALy5BR;;AiBj8BI;EZwCI,0CAAA;EAAA,4DAAA;EAAA,kGAAA;EAAA,wDAAA;EAAA,qDAAA;EAAA,2FAAA;EAAA,yCAAA;EAAA,yCAAA;ALo6BR;;AI19BI;ECsDI,8CAAA;ALw6BR;;AI99BI;ECsDI,2CAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,6CAAA;EAAA,qCAAA;ALg7BR;;AIt+BI;ECsDI,uCAAA;EAAA,8JAAA;ALq7BR;;AI3+BI;ECsDI,0CAAA;ALy7BR;;AI/+BI;ECsDI,iCAAA;EAAA,2JAAA;EAAA,sCAAA;EAAA,4CAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,iCAAA;EAAA,uCAAA;EAAA,oDAAA;EAAA,yCAAA;ALs8BR;;AI5/BI;ECsDI,mCAAA;EAAA,+CAAA;EAAA,uDAAA;AL48BR;;AIlgCI;ECsDI,sCAAA;EAAA,sCAAA;EAAA,+BAAA;EAAA,gCAAA;EAAA,uCAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,gDAAA;ALy9BR;;AQthCI;EH6DI,uCAAA;EAAA,0CAAA;EAAA,8CAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,qCAAA;EAAA,2BAAA;EAAA,mDAAA;EAAA,kEAAA;EAAA,2CAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,wCAAA;EAAA,yDAAA;EAAA,gDAAA;EAAA,wCAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,oCAAA;EAAA,+DAAA;ALi/BR;;AQhiCI;EH+CI,yDAAA;EAAA,6FAAA;EAAA,sGAAA;EAAA,sGAAA;EAAA,2GAAA;EAAA,uDAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,qEAAA;EAAA,iDAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,yDAAA;EAAA,4DAAA;EAAA,6DAAA;EAAA,oDAAA;EAAA,6DAAA;EAAA,+EAAA;EAAA,sEAAA;ALwgCR;AQljCQ;EH0CA,2CAAA;EAAA,4CAAA;EAAA,qDAAA;EAAA,qDAAA;EAAA,0DAAA;EAAA,uDAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA,kCAAA;EAAA,uDAAA;EAAA,iDAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,+CAAA;EAAA,sCAAA;EAAA,+CAAA;EAAA,iEAAA;EAAA,wDAAA;AL8hCR;AQnkCQ;EHqCA,yDAAA;EAAA,4CAAA;EAAA,qDAAA;EAAA,qDAAA;EAAA,0DAAA;EAAA,uDAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,qEAAA;EAAA,iDAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,yDAAA;EAAA,4DAAA;EAAA,6DAAA;EAAA,oDAAA;EAAA,6DAAA;EAAA,+EAAA;EAAA,sEAAA;ALojCR;AQplCQ;EHgCA,2CAAA;EAAA,4CAAA;EAAA,qDAAA;EAAA,qDAAA;EAAA,0DAAA;EAAA,uDAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA,kCAAA;EAAA,uDAAA;EAAA,iDAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,+CAAA;EAAA,sCAAA;EAAA,+CAAA;EAAA,iEAAA;EAAA,wDAAA;AL0kCR;;AQ/kCI;EHKI,iCAAA;AL8kCR;;AQ/lCI;EHiBI,uCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,8CAAA;EAAA,iCAAA;ALslCR;;AI5oCI;ECsDI,gDAAA;EAAA,yDAAA;EAAA,uDAAA;EAAA,+CAAA;EAAA,2DAAA;EAAA,yDAAA;EAAA,uEAAA;EAAA,+DAAA;EAAA,sCAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,0CAAA;EAAA,2FAAA;EAAA,4CAAA;EAAA,2DAAA;EAAA,uDAAA;EAAA,6CAAA;EAAA,2DAAA;EAAA,2CAAA;EAAA,+DAAA;EAAA,6DAAA;EAAA,4DAAA;EAAA,oDAAA;EAAA,iEAAA;EAAA,qCAAA;EAAA,mDAAA;EAAA,2CAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,6DAAA;EAAA,yDAAA;EAAA,+CAAA;EAAA,6DAAA;EAAA,6CAAA;EAAA,iEAAA;EAAA,8DAAA;EAAA,mEAAA;EAAA,2CAAA;EAAA,0FAAA;EAAA,8CAAA;EAAA,0CAAA;ALkoCR;;AIxrCI;ECsDI,6CAAA;EAAA,sDAAA;EAAA,4DAAA;EAAA,iDAAA;EAAA,4DAAA;EAAA,8DAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,yDAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,wDAAA;EAAA,gDAAA;EAAA,sGAAA;EAAA,iKAAA;EAAA,sEAAA;EAAA,qEAAA;EAAA,wEAAA;EAAA,0DAAA;EAAA,uEAAA;EAAA,yJAAA;EAAA,8CAAA;EAAA,wDAAA;EAAA,yDAAA;EAAA,yDAAA;EAAA,0EAAA;EAAA,oEAAA;EAAA,iDAAA;EAAA,+DAAA;EAAA,0EAAA;EAAA,oEAAA;EAAA,2DAAA;EAAA,sEAAA;EAAA,4EAAA;EAAA,8DAAA;ALwqCR;;AS9sCM;EJsCE,2DAAA;EAAA,oEAAA;EAAA,4DAAA;EAAA,iDAAA;EAAA,4DAAA;EAAA,8DAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,yDAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,wDAAA;EAAA,gDAAA;ALwrCR;ASztCM;EJiCE,6CAAA;EAAA,sDAAA;EAAA,4DAAA;EAAA,iDAAA;EAAA,4DAAA;EAAA,8DAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,yDAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,wDAAA;EAAA,gDAAA;ALusCR;;AI7vCI;ECsDI,yCAAA;EAAA,8CAAA;AL4sCR;;AIlwCI;ECsDI,+CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,yCAAA;ALotCR;ASluCM;EJcE,+CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,yCAAA;AL2tCR;;AIjxCI;ECsDI,gDAAA;EAAA,kDAAA;EAAA,kCAAA;EAAA,mCAAA;ALkuCR;;AkBlxCM;EbgDE,yCAAA;EAAA,0FAAA;EAAA,6DAAA;EAAA,+DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,8DAAA;ALmvCR;AkB9xCM;Eb2CE,yCAAA;EAAA,0FAAA;EAAA,6DAAA;EAAA,+DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,8DAAA;ALmwCR;AkBzyCM;EbsCE,yCAAA;EAAA,0FAAA;EAAA,6DAAA;EAAA,+DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,8DAAA;ALmxCR;;AIz0CI;ECsDI,kCAAA;EAAA,uCAAA;ALwxCR;;AI90CI;ECsDI,wCAAA;EAAA,wCAAA;EAAA,iCAAA;EAAA,+CAAA;EAAA,kCAAA;ALgyCR;;AIt1CI;ECsDI,qCAAA;EAAA,uCAAA;EAAA,4IAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,+CAAA;EAAA,iDAAA;EAAA,kEAAA;EAAA,yCAAA;EAAA,4CAAA;EAAA,iDAAA;EAAA,wCAAA;EAAA,mDAAA;EAAA,0DAAA;EAAA,iDAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,qDAAA;ALwzCR;;AI92CI;ECsDI,wCAAA;EAAA,wCAAA;EAAA,kCAAA;EAAA,wCAAA;EAAA,kFAAA;EAAA,iFAAA;EAAA,0CAAA;EAAA,kCAAA;EAAA,0DAAA;EAAA,8DAAA;EAAA,6DAAA;EAAA,uDAAA;EAAA,+DAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,mEAAA;EAAA,0EAAA;AL60CR;;AmB13CI;Ed6CI,wCAAA;EAAA,wCAAA;EAAA,kCAAA;EAAA,wCAAA;EAAA,kFAAA;EAAA,iFAAA;EAAA,0CAAA;EAAA,kCAAA;EAAA,wEAAA;EAAA,8DAAA;AL01CR;;AmBl4CI;EdwCI,wCAAA;EAAA,wCAAA;EAAA,kCAAA;EAAA,wCAAA;EAAA,kFAAA;EAAA,iFAAA;EAAA,0CAAA;EAAA,kCAAA;EAAA,0DAAA;EAAA,8DAAA;ALu2CR;;AI75CI;ECsDI,+CAAA;EAAA,wCAAA;EAAA,+CAAA;EAAA,sDAAA;EAAA,yCAAA;AL+2CR;;AIr6CI;ECsDI,+BAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,+CAAA;EAAA,gDAAA;EAAA,sJAAA;AL43CR;;AIl7CI;ECsDI,qDAAA;EAAA,+CAAA;EAAA,gGAAA;EAAA,iGAAA;EAAA,iCAAA;EAAA,6CAAA;ALq4CR;;AI37CI;ECsDI,4CAAA;EAAA,qCAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,sCAAA;AL64CR;;AIn8CI;ECsDI,8CAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,8CAAA;EAAA,iDAAA;EAAA,0DAAA;EAAA,sDAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,4DAAA;EAAA,oDAAA;EAAA,sDAAA;EAAA,wDAAA;EAAA,yDAAA;AL+5CR;;AIr9CI;ECsDI,0DAAA;EAAA,+DAAA;EAAA,4DAAA;EAAA,wEAAA;EAAA,6DAAA;EAAA,sEAAA;EAAA,mEAAA;EAAA,qEAAA;EAAA,sEAAA;EAAA,gEAAA;EAAA,kEAAA;EAAA,iEAAA;EAAA,oDAAA;EAAA,mEAAA;EAAA,gEAAA;EAAA,iEAAA;EAAA,oDAAA;ALm7CR;;AUj+CI;;EL8CI,yCAAA;EAAA,0FAAA;EAAA,6DAAA;EAAA,+DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,8DAAA;ALq8CR;;AU5+CM;;ELuCE,yCAAA;EAAA,0FAAA;EAAA,6DAAA;EAAA,+DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,8DAAA;ALu9CR;;AUt/CM;;EL+BE,yCAAA;EAAA,0FAAA;EAAA,6DAAA;EAAA,+DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,8DAAA;ALy+CR;;AUjgDI;ELwBI,6FAAA;EAAA,oDAAA;EAAA,qGAAA;EAAA,uGAAA;EAAA,8CAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,wDAAA;EAAA,0DAAA;EAAA,sEAAA;EAAA,sEAAA;EAAA,wEAAA;AL8/CR;;AUjhDI;ELmBI,6FAAA;EAAA,oDAAA;EAAA,qGAAA;EAAA,uGAAA;EAAA,4DAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,wDAAA;EAAA,0DAAA;EAAA,sEAAA;EAAA,sEAAA;EAAA,wEAAA;ALmhDR;;AUjiDI;ELcI,6FAAA;EAAA,oDAAA;EAAA,qGAAA;EAAA,uGAAA;EAAA,8CAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,wDAAA;EAAA,0DAAA;EAAA,sEAAA;EAAA,sEAAA;EAAA,wEAAA;ALwiDR;;AU5iDQ;;;;EAEE,cAAA;AVijDV;;AUxiDM;;;EAGE,UAAA;AV2iDR;;AI3mDI;ECsDI,mDAAA;EAAA,iDAAA;EAAA,oDAAA;EAAA,oDAAA;EAAA,sDAAA;AL6jDR;;AUjiDI;;EL5BI,kCAAA;EAAA,uCAAA;ALmkDR;;AU1hDQ;EACE,YAAA;AV6hDV;AUhhDQ;EACE,YAAA;AVkhDV;;AIhoDI;ECsDI,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,mDAAA;EAAA,2CAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,+CAAA;EAAA,6DAAA;EAAA,gDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,wDAAA;EAAA,sEAAA;EAAA,yDAAA;AL4lDR;;AUxgDI;EAEE,iCAAA;EACA,0BAAA;AV0gDN;;AIvpDI;ECsDI,4CAAA;EAAA,0DAAA;ALsmDR;;AI5pDI;ECsDI,yDAAA;EAAA,iDAAA;EAAA,uDAAA;EAAA,6FAAA;AL6mDR;;AInqDI;ECsDI,oCAAA;EAAA,iDAAA;EAAA,0DAAA;EAAA,2CAAA;ALonDR;;AI1qDI;ECsDI,gDAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA,0CAAA;EAAA,8CAAA;AL6nDR;;AInrDI;ECsDI,gCAAA;EAAA,oCAAA;EAAA,2BAAA;EAAA,sCAAA;EAAA,mCAAA;ALqoDR;;AWzrDI;;ENoDI,oDAAA;EAAA,oDAAA;EAAA,wDAAA;EAAA,0CAAA;EAAA,sCAAA;EAAA,wCAAA;EAAA,8DAAA;EAAA,8DAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,+CAAA;EAAA,yCAAA;ALspDR;AWpsDM;;EN8CE,oDAAA;EAAA,oDAAA;EAAA,wDAAA;EAAA,0CAAA;EAAA,sCAAA;EAAA,wCAAA;EAAA,8DAAA;EAAA,8DAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,+CAAA;EAAA,yCAAA;ALsqDR;AW9sDM;;ENwCE,oDAAA;EAAA,oDAAA;EAAA,wDAAA;EAAA,0CAAA;EAAA,sCAAA;EAAA,wCAAA;EAAA,8DAAA;EAAA,8DAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,+CAAA;EAAA,yCAAA;ALsrDR;AWxtDM;;ENkCE,mCAAA;EAAA,iCAAA;AL2rDR;AWrtDM;;EN0BE,mCAAA;EAAA,+CAAA;ALgsDR;AWltDM;;ENkBE,mCAAA;EAAA,iCAAA;ALqsDR;;AW1rDI;ENXI,gCAAA;ALysDR;;AW1sDI;ENCI,sCAAA;EAAA,+BAAA;EAAA,6CAAA;EAAA,sCAAA;EAAA,gCAAA;ALitDR;;AIvwDI;ECsDI,uDAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,yDAAA;EAAA,yDAAA;EAAA,yDAAA;EAAA,2DAAA;EAAA,sCAAA;AL4tDR;;AIlxDI;ECsDI,6FAAA;EAAA,oDAAA;EAAA,qGAAA;EAAA,uGAAA;EAAA,4DAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,wDAAA;EAAA,0DAAA;EAAA,sEAAA;EAAA,sEAAA;EAAA,wEAAA;ALivDR;;AoB7xDM;Ef4CE,qGAAA;EAAA,uGAAA;EAAA,8CAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,wDAAA;EAAA,0DAAA;EAAA,sEAAA;EAAA,sEAAA;EAAA,wEAAA;ALowDR;AoBzyDM;EfqCE,qGAAA;EAAA,uGAAA;EAAA,8CAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,wDAAA;EAAA,0DAAA;EAAA,sEAAA;EAAA,sEAAA;EAAA,wEAAA;ALsxDR;;AI50DI;ECsDI,0CAAA;EAAA,qCAAA;AL2xDR;;AIj1DI;ECsDI,2CAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,kDAAA;EAAA,qCAAA;ALmyDR;;AIz1DI;ECsDI,wCAAA;EAAA,4CAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,uCAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,6CAAA;EAAA,gKAAA;EAAA,2CAAA;EAAA,wKAAA;EAAA,uKAAA;EAAA,+CAAA;EAAA,uKAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0KAAA;EAAA,8CAAA;EAAA,sCAAA;EAAA,yCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,mDAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,0CAAA;ALu0DR;;AI73DI;ECsDI,0CAAA;EAAA,sGAAA;EAAA,uGAAA;EAAA,mEAAA;EAAA,mDAAA;EAAA,mDAAA;EAAA,yDAAA;EAAA,qDAAA;EAAA,0FAAA;EAAA,0DAAA;EAAA,yGAAA;EAAA,iEAAA;EAAA,qEAAA;EAAA,qDAAA;EAAA,qDAAA;EAAA,2DAAA;EAAA,wDAAA;EAAA,uDAAA;EAAA,4FAAA;EAAA,4DAAA;EAAA,6CAAA;EAAA,yGAAA;EAAA,0GAAA;EAAA,sEAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,4DAAA;EAAA,wDAAA;EAAA,6FAAA;EAAA,6DAAA;EAAA,qGAAA;EAAA,iEAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,uDAAA;EAAA,mDAAA;EAAA,wFAAA;EAAA,wDAAA;EAAA,yCAAA;EAAA,qGAAA;EAAA,sGAAA;EAAA,kEAAA;EAAA,kDAAA;EAAA,kDAAA;EAAA,wDAAA;EAAA,oDAAA;EAAA,yFAAA;EAAA,yDAAA;AL03DR;;AqBh6DM;;;;;EhBsCE,4CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gFAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,+EAAA;EAAA,+CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,2EAAA;EAAA,2CAAA;ALo5DR;AqBr7DM;;;;;EhBiCE,4CAAA;EAAA,yDAAA;EAAA,0FAAA;EAAA,0DAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gFAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,4DAAA;EAAA,6FAAA;EAAA,6DAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,wDAAA;EAAA,yFAAA;EAAA,yDAAA;AL66DR;AqBz8DM;;;;;EhB4BE,4CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gFAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,+EAAA;EAAA,+CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,2EAAA;EAAA,2CAAA;ALs8DR;;AI5/DI;ECsDI,0CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,kDAAA;EAAA,wCAAA;EAAA,6CAAA;EAAA,yCAAA;EAAA,8CAAA;ALm9DR;;AIzgEI;ECsDI,gDAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA,8CAAA;EAAA,0CAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,yDAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,mDAAA;EAAA,4CAAA;EAAA,0DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,qDAAA;EAAA,4CAAA;EAAA,wCAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,6CAAA;EAAA,yCAAA;AL++DR;;AIriEI;ECsDI,iCAAA;EAAA,sCAAA;EAAA,yCAAA;ALq/DR;;AI3iEI;ECsDI,+FAAA;EAAA,iEAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,qCAAA;EAAA,mDAAA;EAAA,wFAAA;EAAA,wDAAA;ALggER;;AsB5iEM;EjB4CE,qCAAA;EAAA,4CAAA;EAAA,4EAAA;ALsgER;AsB7iEM;EjBuCE,qCAAA;EAAA,4CAAA;EAAA,4EAAA;AL2gER;AsB7iEM;EjBkCE,qCAAA;EAAA,4CAAA;EAAA,4EAAA;ALghER;;AItkEI;ECsDI,6CAAA;ALohER;;AsB/gEI;EAGE,wCAAA;EACA,wCAAA;EAOA,8CAAA;EACA,+CAAA;EACA,aAAA;AtB0gEN;;AIllEI;ECsDI,qJAAA;EAAA,8BAAA;EAAA,iCAAA;EAAA,8JAAA;EAAA,yCAAA;EAAA,wCAAA;EAAA,oKAAA;EAAA,oKAAA;EAAA,uKAAA;EAAA,2JAAA;EAAA,2JAAA;EAAA,8JAAA;EAAA,2JAAA;EAAA,oCAAA;EAAA,uCAAA;EAAA,iKAAA;EAAA,iKAAA;EAAA,oKAAA;ALijER;;AIvmEI;ECsDI,gCAAA;EAAA,kGAAA;EAAA,mGAAA;EAAA,yDAAA;EAAA,yCAAA;EAAA,+CAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,gFAAA;EAAA,sCAAA;EAAA,wGAAA;EAAA,yGAAA;EAAA,+DAAA;EAAA,+CAAA;EAAA,qDAAA;EAAA,+CAAA;EAAA,iDAAA;EAAA,sFAAA;EAAA,sDAAA;EAAA,gDAAA;ALwkER;;AuBnnEM;ElB2CE,kCAAA;EAAA,iCAAA;EAAA,oEAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,wEAAA;EAAA,wCAAA;EAAA,kCAAA;ALmlER;AuBznEM;ElBsCE,kCAAA;EAAA,+CAAA;EAAA,oEAAA;EAAA,wCAAA;EAAA,qDAAA;EAAA,sFAAA;EAAA,sDAAA;EAAA,gDAAA;AL6lER;AuB9nEM;ElBiCE,kCAAA;EAAA,iCAAA;EAAA,oEAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,wEAAA;EAAA,wCAAA;EAAA,kCAAA;ALumER;;AI7pEI;ECsDI,2CAAA;EAAA,qCAAA;AL4mER;;AIlqEI;ECsDI,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,yCAAA;ALmnER;;AIzqEI;ECsDI,oCAAA;ALunER;;AI7qEI;ECsDI,wCAAA;EAAA,4CAAA;EAAA,qCAAA;AL6nER;;AInrEI;ECsDI,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,2CAAA;ALooER;;AI1rEI;ECsDI,uCAAA;ALwoER;;AI9rEI;ECsDI,mCAAA;EAAA,sDAAA;EAAA,0DAAA;EAAA,uDAAA;AL+oER;;AIrsEI;ECsDI,yCAAA;EAAA,yCAAA;EAAA,2CAAA;ALqpER;;AI3sEI;ECsDI,6CAAA;EAAA,6CAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,oDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,2CAAA;EAAA,wDAAA;EAAA,oDAAA;EAAA,oDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,2DAAA;ALuqER;;AI7tEI;ECsDI,kDAAA;EAAA,iCAAA;AL4qER;;AIluEI;ECsDI,sDAAA;ALgrER;;AwBjuEI;EnBiDI,sDAAA;ALorER;;AwBhuEI;EnB4CI,sDAAA;ALwrER;;AI9uEI;ECsDI,gCAAA;EAAA,iCAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,uCAAA;EAAA,kDAAA;EAAA,kDAAA;EAAA,qCAAA;EAAA,+CAAA;EAAA,gDAAA;EAAA,2CAAA;EAAA,qDAAA;EAAA,sDAAA;EAAA,gCAAA;EAAA,2CAAA;EAAA,2CAAA;AL2sER;;AIjwEI;ECsDI,qCAAA;EAAA,6BAAA;EAAA,qGAAA;EAAA,+FAAA;ALktER;;AyB5vEI;EpB0CI,qCAAA;EAAA,2CAAA;ALutER;;AyB5vEI;EpBqCI,qCAAA;EAAA,6BAAA;AL4tER;;AIlxEI;ECsDI,kCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,qCAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,wCAAA;ALuuER;;AI7xEI;ECsDI,uCAAA;AL2uER;;AIjyEI;ECsDI,4DAAA;EAAA,oDAAA;ALgvER;;AItyEI;ECsDI,mDAAA;EAAA,mDAAA;EAAA,4CAAA;EAAA,0DAAA;EAAA,6CAAA;ALwvER;;AI9yEI;ECsDI,mDAAA;EAAA,mDAAA;EAAA,uDAAA;EAAA,uCAAA;EAAA,qCAAA;EAAA,8BAAA;ALiwER;;AIvzEI;ECsDI,2CAAA;EAAA,sHAAA;EAAA,gHAAA;EAAA,0DAAA;EAAA,uGAAA;EAAA,sDAAA;EAAA,6HAAA;EAAA,iEAAA;EAAA,8GAAA;EAAA,oHAAA;EAAA,yEAAA;EAAA,sGAAA;EAAA,0DAAA;EAAA,6GAAA;EAAA,kEAAA;EAAA,0DAAA;EAAA,mDAAA;ALqxER;;AI30EI;ECsDI,gCAAA;ALyxER;;AI/0EI;ECsDI,gDAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,kDAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,yDAAA;EAAA,iDAAA;ALsyER;;AI51EI;ECsDI,8CAAA;EAAA,oDAAA;EAAA,oKAAA;EAAA,8KAAA;AL6yER;;AIn2EI;ECsDI,4GAAA;EAAA,uHAAA;EAAA,+EAAA;EAAA,kIAAA;EAAA,+DAAA;EAAA,uEAAA;EAAA,qHAAA;EAAA,wEAAA;EAAA,yGAAA;EAAA,wGAAA;EAAA,wDAAA;EAAA,uDAAA;EAAA,oEAAA;EAAA,uEAAA;EAAA,uEAAA;EAAA,2EAAA;EAAA,mEAAA;EAAA,gEAAA;EAAA,uEAAA;EAAA,2HAAA;EAAA,8DAAA;EAAA,yDAAA;EAAA,kHAAA;EAAA,+EAAA;EAAA,iEAAA;EAAA,qHAAA;EAAA,gHAAA;EAAA,2DAAA;EAAA,mEAAA;AL60ER;;A0Bv3EM;ErB0CE,4GAAA;EAAA,uHAAA;EAAA,+EAAA;EAAA,kIAAA;EAAA,6EAAA;EAAA,uEAAA;EAAA,qHAAA;EAAA,sFAAA;EAAA,yGAAA;EAAA,wGAAA;EAAA,wDAAA;EAAA,uDAAA;EAAA,oEAAA;EAAA,uEAAA;EAAA,uEAAA;EAAA,2EAAA;EAAA,mEAAA;EAAA,gEAAA;EAAA,uEAAA;EAAA,2HAAA;EAAA,8DAAA;EAAA,yDAAA;EAAA,kHAAA;EAAA,+EAAA;EAAA,iEAAA;EAAA,qHAAA;EAAA,gHAAA;EAAA,2DAAA;EAAA,mEAAA;AL62ER;A0Bl5EM;ErBqCE,4GAAA;EAAA,uHAAA;EAAA,+EAAA;EAAA,kIAAA;EAAA,+DAAA;EAAA,uEAAA;EAAA,qHAAA;EAAA,wEAAA;EAAA,yGAAA;EAAA,wGAAA;EAAA,wDAAA;EAAA,uDAAA;EAAA,oEAAA;EAAA,uEAAA;EAAA,uEAAA;EAAA,2EAAA;EAAA,mEAAA;EAAA,gEAAA;EAAA,uEAAA;EAAA,2HAAA;EAAA,8DAAA;EAAA,yDAAA;EAAA,kHAAA;EAAA,+EAAA;EAAA,iEAAA;EAAA,qHAAA;EAAA,gHAAA;EAAA,2DAAA;EAAA,mEAAA;AL44ER;;A0Bh4EI;ErBZI,4CAAA;ALg5ER;AsB34EI;EAGE,wCAAA;EACA,wCAAA;EAOA,8CAAA;EACA,+CAAA;EACA,YAAA;AtBq4EN;;AI78EI;ECsDI,gDAAA;EAAA,yCAAA;EAAA,oDAAA;EAAA,qDAAA;EAAA,uDAAA;EAAA,wDAAA;EAAA,gDAAA;EAAA,iDAAA;ALk6ER;;AIx9EI;ECsDI,wBAAA;ALs6ER;;AI59EI;ECsDI,wCAAA;AL06ER;;AIh+EI;ECsDI,oCAAA;EAAA,yJAAA;EAAA,6DAAA;EAAA,8CAAA;ALi7ER;;AIv+EI;ECsDI,iDAAA;EAAA,yDAAA;EAAA,0DAAA;EAAA,uGAAA;EAAA,wGAAA;EAAA,0GAAA;EAAA,sDAAA;EAAA,6DAAA;EAAA,2DAAA;AL67ER;;AIn/EI;ECsDI,mDAAA;EAAA,kDAAA;ALk8ER;;AIx/EI;ECsDI,6CAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA,0CAAA;AL+8ER;;AIrgFI;ECsDI,mDAAA;EAAA,qDAAA;EAAA,mDAAA;EAAA,qDAAA;ALs9ER;;AI5gFI;ECsDI,yBAAA;AL09ER;;A2B1gFM;EtBgDE,yBAAA;AL89ER;A2BxgFM;EtB0CE,yBAAA;ALi+ER;A2BrgFM;EtBoCE,yBAAA;ALo+ER;;AI1hFI;ECsDI,gCAAA;EAAA,2JAAA;EAAA,mCAAA;AL0+ER;;AIhiFI;ECsDI,0DAAA;EAAA,+CAAA;EAAA,uDAAA;EAAA,+CAAA;EAAA,qDAAA;EAAA,6CAAA;ALm/ER;;AIziFI;ECsDI,+CAAA;EAAA,+CAAA;ALw/ER;;AI9iFI;ECsDI,iDAAA;EAAA,kEAAA;EAAA,gEAAA;EAAA,8DAAA;EAAA,4DAAA;EAAA,8DAAA;EAAA,4DAAA;EAAA,oCAAA;EAAA,6CAAA;EAAA,qGAAA;EAAA,sGAAA;EAAA,0DAAA;EAAA,mEAAA;EAAA,yEAAA;EAAA,0DAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,mEAAA;AL6gFR;;A4B1jFI;EvB6CI,+DAAA;EAAA,kEAAA;EAAA,8EAAA;EAAA,8DAAA;EAAA,0EAAA;EAAA,8DAAA;EAAA,0EAAA;ALuhFR;;A4B/jFI;EvBwCI,iDAAA;EAAA,kEAAA;EAAA,gEAAA;EAAA,8DAAA;EAAA,4DAAA;EAAA,8DAAA;EAAA,4DAAA;ALiiFR;;AIvlFI;ECsDI,iCAAA;ALqiFR;;AI3lFI;ECsDI,8CAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,2CAAA;EAAA,sDAAA;EAAA,yDAAA;EAAA,0DAAA;AL+iFR;;AIrmFI;ECsDI,2CAAA;ALmjFR;;AIzmFI;ECsDI,+CAAA;EAAA,uDAAA;ALwjFR;;A6BlmFM;ExB0CE,iDAAA;EAAA,yCAAA;AL6jFR;A6B/lFM;ExBkCE,iDAAA;EAAA,uDAAA;ALikFR;A6B3lFM;ExB0BE,iDAAA;EAAA,yCAAA;ALqkFR;;AI3nFI;ECsDI,mCAAA;EAAA,iCAAA;AL0kFR;;AIhoFI;ECsDI,0CAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,2CAAA;EAAA,oCAAA;ALklFR;;AIxoFI;ECsDI,4CAAA;EAAA,+CAAA;ALulFR;;AI7oFI;ECsDI,gCAAA;AL2lFR;;AIjpFI;ECsDI,sCAAA;EAAA,+BAAA;EAAA,gCAAA;ALimFR;;AIvpFI;ECsDI,qCAAA;EAAA,4JAAA;ALsmFR;;AI5pFI;ECsDI,kDAAA;AL0mFR;;AIhqFI;ECsDI,wCAAA;EAAA,4CAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,uCAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,6CAAA;EAAA,gKAAA;EAAA,2CAAA;EAAA,wKAAA;EAAA,uKAAA;EAAA,+CAAA;EAAA,uKAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0KAAA;EAAA,8CAAA;EAAA,sCAAA;EAAA,yCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,mDAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,0CAAA;AL8oFR;;AIpsFI;ECsDI,0CAAA;EAAA,sGAAA;EAAA,uGAAA;EAAA,mEAAA;EAAA,mDAAA;EAAA,mDAAA;EAAA,yDAAA;EAAA,qDAAA;EAAA,0FAAA;EAAA,0DAAA;EAAA,yGAAA;EAAA,iEAAA;EAAA,qEAAA;EAAA,qDAAA;EAAA,qDAAA;EAAA,2DAAA;EAAA,wDAAA;EAAA,uDAAA;EAAA,4FAAA;EAAA,4DAAA;EAAA,6CAAA;EAAA,yGAAA;EAAA,0GAAA;EAAA,sEAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,4DAAA;EAAA,wDAAA;EAAA,6FAAA;EAAA,6DAAA;EAAA,qGAAA;EAAA,iEAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,uDAAA;EAAA,mDAAA;EAAA,wFAAA;EAAA,wDAAA;EAAA,yCAAA;EAAA,qGAAA;EAAA,sGAAA;EAAA,kEAAA;EAAA,kDAAA;EAAA,kDAAA;EAAA,wDAAA;EAAA,oDAAA;EAAA,yFAAA;EAAA,yDAAA;ALisFR;;AqBvuFM;;;;;EhBsCE,4CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gFAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,+EAAA;EAAA,+CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,2EAAA;EAAA,2CAAA;AL2tFR;AqB5vFM;;;;;EhBiCE,4CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gFAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,+EAAA;EAAA,+CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,2EAAA;EAAA,2CAAA;ALovFR;AqBhxFM;;;;;EhB4BE,4CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gFAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,+EAAA;EAAA,+CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,2EAAA;EAAA,2CAAA;AL6wFR;;AIn0FI;ECsDI,0CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,kDAAA;EAAA,wCAAA;EAAA,6CAAA;EAAA,yCAAA;EAAA,8CAAA;AL0xFR;;AIh1FI;ECsDI,qJAAA;EAAA,8BAAA;EAAA,iCAAA;EAAA,8JAAA;EAAA,yCAAA;EAAA,wCAAA;EAAA,oKAAA;EAAA,oKAAA;EAAA,uKAAA;EAAA,2JAAA;EAAA,2JAAA;EAAA,8JAAA;EAAA,2JAAA;EAAA,oCAAA;EAAA,uCAAA;EAAA,iKAAA;EAAA,iKAAA;EAAA,oKAAA;AL+yFR;;AIr2FI;ECsDI,gCAAA;EAAA,kGAAA;EAAA,mGAAA;EAAA,yDAAA;EAAA,yCAAA;EAAA,+CAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,gFAAA;EAAA,sCAAA;EAAA,wGAAA;EAAA,yGAAA;EAAA,+DAAA;EAAA,+CAAA;EAAA,qDAAA;EAAA,+CAAA;EAAA,iDAAA;EAAA,sFAAA;EAAA,sDAAA;EAAA,gDAAA;ALs0FR;;AuBj3FM;ElB2CE,kCAAA;EAAA,iCAAA;EAAA,oEAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,wEAAA;EAAA,wCAAA;EAAA,kCAAA;ALi1FR;AuBv3FM;ElBsCE,kCAAA;EAAA,iCAAA;EAAA,oEAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,wEAAA;EAAA,wCAAA;EAAA,kCAAA;AL21FR;AuB53FM;ElBiCE,kCAAA;EAAA,iCAAA;EAAA,oEAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,wEAAA;EAAA,wCAAA;EAAA,kCAAA;ALq2FR;;AI35FI;ECsDI,2CAAA;EAAA,qCAAA;AL02FR;;AIh6FI;ECsDI,iCAAA;EAAA,sCAAA;EAAA,yCAAA;ALg3FR;;AIt6FI;ECsDI,+FAAA;EAAA,iEAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,qCAAA;EAAA,mDAAA;EAAA,wFAAA;EAAA,wDAAA;AL23FR;;AsBv6FM;EjB4CE,qCAAA;EAAA,4CAAA;EAAA,4EAAA;ALi4FR;AsBx6FM;EjBuCE,qCAAA;EAAA,4CAAA;EAAA,4EAAA;ALs4FR;AsBx6FM;EjBkCE,qCAAA;EAAA,4CAAA;EAAA,4EAAA;AL24FR;;AIj8FI;ECsDI,6CAAA;AL+4FR;;AsB14FI;EAGE,wCAAA;EACA,wCAAA;EAOA,8CAAA;EACA,+CAAA;EACA,aAAA;AtBq4FN;;AI78FI;ECsDI,+CAAA;EAAA,uDAAA;AL45FR;;A6Bt8FM;ExB0CE,iDAAA;EAAA,yCAAA;ALi6FR;A6Bn8FM;ExBkCE,iDAAA;EAAA,uDAAA;ALq6FR;A6B/7FM;ExB0BE,iDAAA;EAAA,yCAAA;ALy6FR;;AI/9FI;ECsDI,mCAAA;EAAA,iCAAA;AL86FR;;AIp+FI;ECsDI,kDAAA;EAAA,iCAAA;ALm7FR;;AIz+FI;ECsDI,sDAAA;ALu7FR;;AwBx+FI;EnBiDI,sDAAA;AL27FR;;AwBv+FI;EnB4CI,sDAAA;AL+7FR;;AF3gGA,0BAAA;ACAA;EACE,0BAAA;EACA,yDAAA;AC+gGF;AD7gGA;EACE,0BAAA;EACA,yDAAA;AC+gGF;AD7gGA;EACE,6BAAA;EACA,4DAAA;AC+gGF;ACj/FA;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;ADm/FF;;AC/+FA;EACE;IACE,SAAA;IACA,UAAA;IACA,cAAA;EDk/FF;ECh/FA,4HAAA;EACA;IACE,aAAA;EDk/FF;EC/+FA;;IAEE,aAAA;EDi/FF;EC9+FA;IACE,aAAA;EDg/FF;EC7+FA;IACE,aAAA;ED++FF;EC5+FA;IACE,aAAA;ED8+FF;EC3+FA;IACE,gBAAA;ED6+FF;AACF;AC1+FA;EACE,qBAAA;AD4+FF;;ACz+FA;EACE,sBAAA;AD4+FF;;ACz+FA;EACI,cAAA;AD4+FJ;;ACz+FA;EACE,0BF9EK;AC0jGP;;AD7kGA;EACE,0BAAA;EACA,yDAAA;ACglGF;AD9kGA;EACE,0BAAA;EACA,yDAAA;ACglGF;AD9kGA;EACE,6BAAA;EACA,4DAAA;ACglGF;AEplGA;EACI,YAAA;AFslGJ;AEplGI;EACI,qBC0BF;EDzBE,oDAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,6BAAA;AFslGR;AEnlGI;EACI,gBAAA;AFqlGR;;AEhlGI;EACI,iCAAA;AFmlGR;;AE/kGA;EACI,cAAA;EACA,gBAAA;AFklGJ;AEhlGI;EACI,iBAAA;AFklGR;;AE9kGA;EACI,uBAAA;AFilGJ;;AE9kGA;EACE,sBAAA;EACA,6CAAA;EACA,oCAAA;AFilGF;;AE9kGA;EACE,oCAAA;EACA,YAAA;AFilGF;;AI9mGI;ECsDI,kCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,qCAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,wCAAA;ALmkGR;;AMlgGE;;;;;EAKE,iCAAA;EACA,sBAAA;EACA,gBAAA;ANqgGJ;;AMlgGE;;;;;EAKE,iCAAA;EACA,wBAAA;EACA,gBAAA;ANqgGJ;;AMlgGE;;;;;EAKE,iCAAA;EACA,0BAAA;EACA,gBAAA;ANqgGJ;;AMlgGE;;;;;EAKE,iCAAA;EACA,yBAAA;EACA,gBAAA;ANqgGJ;;AM//FE;;;EC5JE,8CAAA;EDuKA,gBAAA;AN2/FJ;;AMx/FE;;;EC1KE,8CAAA;EDqLA,gBAAA;ANo/FJ;;AMj/FE;;;;EAIE,iCAAA;EACA,8BAAA;ANo/FJ;;AMj/FE;;;;;EAKE,iCAAA;EACA,8BAAA;ANo/FJ;AMl/FI;;;;;EACE,gBAAA;ANw/FN;;AMp/FE;;;;EAIE,iCAAA;EACA,8BAAA;ANu/FJ;;AMp/FE;;EAEE,iCAAA;EACA,2BAAA;EACA,gBAAA;ANu/FJ;;AMp/FE;;EAEE,iCAAA;EACA,+BAAA;EACA,gBAAA;ANu/FJ;;AMp/FE;;EAEE,iCAAA;EACA,sBAAA;EACA,gBAAA;ANu/FJ;;AMp/FE;;EAEE,iCAAA;EACA,8BAAA;EACA,gBAAA;ANu/FJ;;AI3uGI;ECsDI,mDAAA;EAAA,mDAAA;EAAA,4CAAA;EAAA,0DAAA;EAAA,6CAAA;AL6rGR;;AInvGI;ECsDI,gDAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,kDAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,yDAAA;EAAA,iDAAA;AL0sGR;;AIhwGI;ECsDI,gDAAA;EAAA,yCAAA;EAAA,oDAAA;EAAA,qDAAA;EAAA,uDAAA;EAAA,wDAAA;EAAA,gDAAA;EAAA,iDAAA;ALqtGR;;AI3wGI;ECsDI,6CAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA,0CAAA;ALkuGR;;AIxxGI;ECsDI,mDAAA;EAAA,qDAAA;EAAA,mDAAA;EAAA,qDAAA;ALyuGR;;AI/xGI;ECsDI,8CAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,2CAAA;EAAA,sDAAA;EAAA,yDAAA;EAAA,0DAAA;ALmvGR;;AIzyGI;ECsDI,0CAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,2CAAA;EAAA,oCAAA;AL2vGR;;AIjzGI;ECsDI,sCAAA;EAAA,+BAAA;EAAA,gCAAA;ALiwGR;;AIvzGI;ECsDI,yCAAA;EAAA,yCAAA;EAAA,kCAAA;EAAA,2CAAA;EAAA,mCAAA;ALywGR;;AI/zGI;ECsDI,2CAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,6CAAA;EAAA,qCAAA;ALixGR;;AIv0GI;ECsDI,uCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,wCAAA;EAAA,iCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,iDAAA;EAAA,oCAAA;AL8xGR;;AIp1GI;ECsDI,+CAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,sDAAA;ALqyGR;;AI31GI;ECsDI,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,mDAAA;EAAA,2CAAA;EAAA,yDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,wDAAA;EAAA,2CAAA;EAAA,oDAAA;EAAA,6CAAA;EAAA,sDAAA;EAAA,8CAAA;EAAA,sDAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gDAAA;AL2zGR;;AIj3GI;ECsDI,2CAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,6CAAA;EAAA,qCAAA;ALm0GR;;AIz3GI;ECsDI,sCAAA;EAAA,sCAAA;EAAA,+BAAA;EAAA,gCAAA;EAAA,uCAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,gDAAA;ALg1GR;;AQj2GI;EHiBI,uCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,8CAAA;EAAA,iCAAA;ALw1GR;;AI94GI;ECsDI,+CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,yCAAA;ALg2GR;AS92GM;EJcE,+CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,yCAAA;ALu2GR;;AI75GI;ECsDI,wCAAA;EAAA,wCAAA;EAAA,iCAAA;EAAA,+CAAA;EAAA,kCAAA;AL+2GR;;AIr6GI;ECsDI,+CAAA;EAAA,wCAAA;EAAA,+CAAA;EAAA,sDAAA;EAAA,yCAAA;ALu3GR;;AI76GI;ECsDI,4CAAA;EAAA,qCAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,sCAAA;AL+3GR;;AIr7GI;ECsDI,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,mDAAA;EAAA,2CAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,+CAAA;EAAA,6DAAA;EAAA,gDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,wDAAA;EAAA,sEAAA;EAAA,yDAAA;ALi5GR;;AU7zGI;EAEE,iCAAA;EACA,0BAAA;AV+zGN;;AI58GI;ECsDI,gDAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA,0CAAA;EAAA,8CAAA;AL+5GR;;AWh6GI;ENCI,sCAAA;EAAA,+BAAA;EAAA,6CAAA;EAAA,sCAAA;EAAA,gCAAA;ALu6GR;;AI79GI;ECsDI,2CAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,kDAAA;EAAA,qCAAA;AL+6GR;;AIr+GI;ECsDI,gDAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA,8CAAA;EAAA,0CAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,yDAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,mDAAA;EAAA,4CAAA;EAAA,0DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,qDAAA;EAAA,4CAAA;EAAA,wCAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,6CAAA;EAAA,yCAAA;AL28GR;;AIjgHI;ECsDI,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,yCAAA;ALk9GR;;AIxgHI;ECsDI,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,2CAAA;ALy9GR;;AI/gHI;ECsDI,6CAAA;EAAA,6CAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,oDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,2CAAA;EAAA,wDAAA;EAAA,oDAAA;EAAA,oDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,2DAAA;AL2+GR;;AY3gHM;EACE,yJAAA;AZ8gHR;;AY/gHM;EACE,0JAAA;AZkhHR;;AYnhHM;EACE,0JAAA;AZshHR;;AYvhHM;EACE,0JAAA;AZ0hHR;;AY3hHM;EACE,2JAAA;AZ8hHR;;AY/hHM;EACE,2JAAA;AZkiHR;;AYniHM;EACE,4JAAA;AZsiHR;;AYviHM;EACE,4JAAA;AZ0iHR;;AY3iHM;EACE,4JAAA;AZ8iHR;;AY/iHM;EACE,4JAAA;AZkjHR;;AYnjHM;EACE,8JAAA;AZsjHR;;AYvjHM;EACE,8JAAA;AZ0jHR;;AY3jHM;EACE,8JAAA;AZ8jHR;;AY/jHM;EACE,8JAAA;AZkkHR;;AYnkHM;EACE,8JAAA;AZskHR;;AYvkHM;EACE,8JAAA;AZ0kHR;;AY3kHM;EACE,+JAAA;AZ8kHR;;AY/kHM;EACE,+JAAA;AZklHR;;AYnlHM;EACE,+JAAA;AZslHR;;AYvlHM;EACE,+JAAA;AZ0lHR;;AY3lHM;EACE,gKAAA;AZ8lHR;;AY/lHM;EACE,gKAAA;AZkmHR;;AYnmHM;EACE,gKAAA;AZsmHR;;AYvmHM;EACE,gKAAA;AZ0mHR;;AY3mHM;EACE,gKAAA;AZ8mHR;;AY3oHE;EACE,6BAAA;AZ8oHJ;;AYvoHI;EACE,yFAAA;EACA,uEAAA;AZ0oHN;;AI9oHI;ECsDI,mCAAA;EAAA,yCAAA;EAAA,gJAAA;EAAA,iJAAA;EAAA,iJAAA;EAAA,iJAAA;EAAA,kJAAA;EAAA,kJAAA;EAAA,mJAAA;EAAA,mJAAA;EAAA,mJAAA;EAAA,mJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,sJAAA;EAAA,sJAAA;EAAA,sJAAA;EAAA,sJAAA;EAAA,uJAAA;EAAA,uJAAA;EAAA,uJAAA;EAAA,uJAAA;EAAA,uJAAA;ALsnHR;;AI5qHI;ECsDI,4EAAA;AL0nHR;;AIhrHI;ECsDI,qDAAA;EAAA,kDAAA;EAAA,6FAAA;EAAA,8FAAA;EAAA,iGAAA;ALkoHR;;Aa/qHI;ER6CI,qDAAA;EAAA,kDAAA;EAAA,6FAAA;EAAA,8FAAA;EAAA,iGAAA;AL0oHR;;AalrHI;ERwCI,qDAAA;EAAA,kDAAA;EAAA,6FAAA;EAAA,8FAAA;EAAA,iGAAA;ALkpHR;;AIxsHI;ECsDI,oDAAA;ALspHR;;AI5sHI;ECsDI,uDAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA,qEAAA;EAAA,mHAAA;EAAA,iHAAA;EAAA,+DAAA;EAAA,yHAAA;ALiqHR;;AclsHI;ETiCI,uDAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA,qEAAA;EAAA,mHAAA;EAAA,iHAAA;EAAA,+DAAA;EAAA,yHAAA;AL4qHR;;AcxsHI;ET4BI,uDAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA,qEAAA;EAAA,mHAAA;EAAA,iHAAA;EAAA,+DAAA;EAAA,yHAAA;ALurHR;;Ac9sHI;ETuBI,uDAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA,qEAAA;EAAA,mHAAA;EAAA,iHAAA;EAAA,+DAAA;EAAA,yHAAA;ALksHR;;AIxvHI;ECsDI,yCAAA;EAAA,yCAAA;EAAA,kCAAA;EAAA,2CAAA;EAAA,mCAAA;AL0sHR;;AIhwHI;ECsDI,2CAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,6CAAA;EAAA,qCAAA;ALktHR;;AIxwHI;ECsDI,wCAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,sCAAA;ALytHR;;AI/wHI;ECsDI,0CAAA;EAAA,sJAAA;EAAA,0CAAA;EAAA,qJAAA;EAAA,sDAAA;EAAA,mDAAA;EAAA,wCAAA;EAAA,mJAAA;ALouHR;;AI1xHI;ECsDI,uCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,wCAAA;EAAA,iCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,iDAAA;EAAA,oCAAA;ALivHR;;AIvyHI;ECsDI,+CAAA;EAAA,oCAAA;EAAA,iCAAA;ALuvHR;;Ae/yHI;EVwDI,kDAAA;EAAA,uDAAA;AL4vHR;AehzHM;EVoDE,kDAAA;EAAA,uDAAA;ALgwHR;Ae/yHM;EV+CE,kDAAA;EAAA,uDAAA;ALowHR;;AI1zHI;ECsDI,kCAAA;EAAA,+CAAA;ALywHR;;AI/zHI;ECsDI,sCAAA;EAAA,0CAAA;AL8wHR;;AIp0HI;ECsDI,+CAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,sDAAA;ALqxHR;;AI30HI;ECsDI,oDAAA;EAAA,0DAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,kDAAA;EAAA,8CAAA;AL8xHR;;AIp1HI;ECsDI,uFAAA;EAAA,4CAAA;EAAA,6DAAA;EAAA,4FAAA;EAAA,8CAAA;EAAA,sDAAA;EAAA,8FAAA;EAAA,gHAAA;EAAA,uDAAA;EAAA,0CAAA;EAAA,kDAAA;EAAA,4DAAA;EAAA,0CAAA;EAAA,mDAAA;EAAA,2CAAA;EAAA,oDAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,iDAAA;EAAA,gEAAA;EAAA,sGAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,yGAAA;EAAA,6DAAA;EAAA,mEAAA;EAAA,2GAAA;EAAA,6DAAA;EAAA,2GAAA;EAAA,yEAAA;EAAA,6DAAA;EAAA,6DAAA;EAAA,uDAAA;EAAA,kDAAA;EAAA,mEAAA;EAAA,iHAAA;EAAA,yEAAA;EAAA,6DAAA;EAAA,mEAAA;EAAA,mEAAA;EAAA,+DAAA;EAAA,qEAAA;EAAA,6GAAA;EAAA,+DAAA;EAAA,6GAAA;EAAA,2EAAA;EAAA,oDAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,+DAAA;EAAA,4DAAA;EAAA,0GAAA;EAAA,kEAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;AL01HR;;AgB14HI;EXgDI,uFAAA;EAAA,4CAAA;EAAA,6DAAA;EAAA,4FAAA;EAAA,8CAAA;EAAA,sDAAA;EAAA,8FAAA;ALo2HR;;AgB/4HI;EX2CI,uFAAA;EAAA,4CAAA;EAAA,6DAAA;EAAA,4FAAA;EAAA,8CAAA;EAAA,sDAAA;EAAA,8FAAA;AL82HR;;AIp6HI;ECsDI,uCAAA;EAAA,4CAAA;EAAA,iDAAA;EAAA,8DAAA;EAAA,gEAAA;ALs3HR;;AI56HI;ECsDI,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,mDAAA;EAAA,2CAAA;EAAA,yDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,wDAAA;EAAA,2CAAA;EAAA,oDAAA;EAAA,6CAAA;EAAA,sDAAA;EAAA,8CAAA;EAAA,sDAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gDAAA;AL44HR;;AIl8HI;ECsDI,wJAAA;ALg5HR;;AIt8HI;ECsDI,0CAAA;EAAA,4DAAA;EAAA,kGAAA;EAAA,wDAAA;EAAA,qDAAA;EAAA,2FAAA;EAAA,yCAAA;EAAA,yCAAA;AL25HR;;AiBx8HI;EZ6CI,0CAAA;EAAA,4DAAA;EAAA,kGAAA;EAAA,wDAAA;EAAA,qDAAA;EAAA,2FAAA;EAAA,yCAAA;EAAA,yCAAA;ALs6HR;;AiB98HI;EZwCI,0CAAA;EAAA,4DAAA;EAAA,kGAAA;EAAA,wDAAA;EAAA,qDAAA;EAAA,2FAAA;EAAA,yCAAA;EAAA,yCAAA;ALi7HR;;AIv+HI;ECsDI,8CAAA;ALq7HR;;AI3+HI;ECsDI,2CAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,6CAAA;EAAA,qCAAA;AL67HR;;AIn/HI;ECsDI,uCAAA;EAAA,8JAAA;ALk8HR;;AIx/HI;ECsDI,0CAAA;ALs8HR;;AI5/HI;ECsDI,iCAAA;EAAA,2JAAA;EAAA,sCAAA;EAAA,4CAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,iCAAA;EAAA,uCAAA;EAAA,oDAAA;EAAA,yCAAA;ALm9HR;;AIzgII;ECsDI,mCAAA;EAAA,+CAAA;EAAA,uDAAA;ALy9HR;;AI/gII;ECsDI,sCAAA;EAAA,sCAAA;EAAA,+BAAA;EAAA,gCAAA;EAAA,uCAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,gDAAA;ALs+HR;;AQniII;EH6DI,uCAAA;EAAA,0CAAA;EAAA,8CAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,qCAAA;EAAA,2BAAA;EAAA,mDAAA;EAAA,kEAAA;EAAA,2CAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,wCAAA;EAAA,yDAAA;EAAA,gDAAA;EAAA,wCAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,oCAAA;EAAA,+DAAA;AL8/HR;;AQ7iII;EH+CI,yDAAA;EAAA,6FAAA;EAAA,sGAAA;EAAA,sGAAA;EAAA,2GAAA;EAAA,uDAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,qEAAA;EAAA,iDAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,yDAAA;EAAA,4DAAA;EAAA,6DAAA;EAAA,oDAAA;EAAA,6DAAA;EAAA,+EAAA;EAAA,sEAAA;ALqhIR;AQ/jIQ;EH0CA,2CAAA;EAAA,4CAAA;EAAA,qDAAA;EAAA,qDAAA;EAAA,0DAAA;EAAA,uDAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA,kCAAA;EAAA,uDAAA;EAAA,iDAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,+CAAA;EAAA,sCAAA;EAAA,+CAAA;EAAA,iEAAA;EAAA,wDAAA;AL2iIR;AQhlIQ;EHqCA,yDAAA;EAAA,4CAAA;EAAA,qDAAA;EAAA,qDAAA;EAAA,0DAAA;EAAA,uDAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,qEAAA;EAAA,iDAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,yDAAA;EAAA,4DAAA;EAAA,6DAAA;EAAA,oDAAA;EAAA,6DAAA;EAAA,+EAAA;EAAA,sEAAA;ALikIR;AQjmIQ;EHgCA,2CAAA;EAAA,4CAAA;EAAA,qDAAA;EAAA,qDAAA;EAAA,0DAAA;EAAA,uDAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA,kCAAA;EAAA,uDAAA;EAAA,iDAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,+CAAA;EAAA,sCAAA;EAAA,+CAAA;EAAA,iEAAA;EAAA,wDAAA;ALulIR;;AQ5lII;EHKI,iCAAA;AL2lIR;;AQ5mII;EHiBI,uCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,8CAAA;EAAA,iCAAA;ALmmIR;;AIzpII;ECsDI,gDAAA;EAAA,yDAAA;EAAA,uDAAA;EAAA,+CAAA;EAAA,2DAAA;EAAA,yDAAA;EAAA,uEAAA;EAAA,+DAAA;EAAA,sCAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,0CAAA;EAAA,2FAAA;EAAA,4CAAA;EAAA,2DAAA;EAAA,uDAAA;EAAA,6CAAA;EAAA,2DAAA;EAAA,2CAAA;EAAA,+DAAA;EAAA,6DAAA;EAAA,4DAAA;EAAA,oDAAA;EAAA,iEAAA;EAAA,qCAAA;EAAA,mDAAA;EAAA,2CAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,6DAAA;EAAA,yDAAA;EAAA,+CAAA;EAAA,6DAAA;EAAA,6CAAA;EAAA,iEAAA;EAAA,8DAAA;EAAA,mEAAA;EAAA,2CAAA;EAAA,0FAAA;EAAA,8CAAA;EAAA,0CAAA;AL+oIR;;AIrsII;ECsDI,6CAAA;EAAA,sDAAA;EAAA,4DAAA;EAAA,iDAAA;EAAA,4DAAA;EAAA,8DAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,yDAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,wDAAA;EAAA,gDAAA;EAAA,sGAAA;EAAA,iKAAA;EAAA,sEAAA;EAAA,qEAAA;EAAA,wEAAA;EAAA,0DAAA;EAAA,uEAAA;EAAA,yJAAA;EAAA,8CAAA;EAAA,wDAAA;EAAA,yDAAA;EAAA,yDAAA;EAAA,0EAAA;EAAA,oEAAA;EAAA,iDAAA;EAAA,+DAAA;EAAA,0EAAA;EAAA,oEAAA;EAAA,2DAAA;EAAA,sEAAA;EAAA,4EAAA;EAAA,8DAAA;ALqrIR;;AS3tIM;EJsCE,2DAAA;EAAA,oEAAA;EAAA,4DAAA;EAAA,iDAAA;EAAA,4DAAA;EAAA,8DAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,yDAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,wDAAA;EAAA,gDAAA;ALqsIR;AStuIM;EJiCE,6CAAA;EAAA,sDAAA;EAAA,4DAAA;EAAA,iDAAA;EAAA,4DAAA;EAAA,8DAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,yDAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,wDAAA;EAAA,gDAAA;ALotIR;;AI1wII;ECsDI,yCAAA;EAAA,8CAAA;ALytIR;;AI/wII;ECsDI,+CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,yCAAA;ALiuIR;AS/uIM;EJcE,+CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,yCAAA;ALwuIR;;AI9xII;ECsDI,gDAAA;EAAA,kDAAA;EAAA,kCAAA;EAAA,mCAAA;AL+uIR;;AkB/xIM;EbgDE,yCAAA;EAAA,0FAAA;EAAA,6DAAA;EAAA,+DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,8DAAA;ALgwIR;AkB3yIM;Eb2CE,yCAAA;EAAA,0FAAA;EAAA,6DAAA;EAAA,+DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,8DAAA;ALgxIR;AkBtzIM;EbsCE,yCAAA;EAAA,0FAAA;EAAA,6DAAA;EAAA,+DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,8DAAA;ALgyIR;;AIt1II;ECsDI,kCAAA;EAAA,uCAAA;ALqyIR;;AI31II;ECsDI,wCAAA;EAAA,wCAAA;EAAA,iCAAA;EAAA,+CAAA;EAAA,kCAAA;AL6yIR;;AIn2II;ECsDI,qCAAA;EAAA,uCAAA;EAAA,4IAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,+CAAA;EAAA,iDAAA;EAAA,kEAAA;EAAA,yCAAA;EAAA,4CAAA;EAAA,iDAAA;EAAA,wCAAA;EAAA,mDAAA;EAAA,0DAAA;EAAA,iDAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,qDAAA;ALq0IR;;AI33II;ECsDI,wCAAA;EAAA,wCAAA;EAAA,kCAAA;EAAA,wCAAA;EAAA,kFAAA;EAAA,iFAAA;EAAA,0CAAA;EAAA,kCAAA;EAAA,0DAAA;EAAA,8DAAA;EAAA,6DAAA;EAAA,uDAAA;EAAA,+DAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,mEAAA;EAAA,0EAAA;AL01IR;;AmBv4II;Ed6CI,wCAAA;EAAA,wCAAA;EAAA,kCAAA;EAAA,wCAAA;EAAA,kFAAA;EAAA,iFAAA;EAAA,0CAAA;EAAA,kCAAA;EAAA,wEAAA;EAAA,8DAAA;ALu2IR;;AmB/4II;EdwCI,wCAAA;EAAA,wCAAA;EAAA,kCAAA;EAAA,wCAAA;EAAA,kFAAA;EAAA,iFAAA;EAAA,0CAAA;EAAA,kCAAA;EAAA,0DAAA;EAAA,8DAAA;ALo3IR;;AI16II;ECsDI,+CAAA;EAAA,wCAAA;EAAA,+CAAA;EAAA,sDAAA;EAAA,yCAAA;AL43IR;;AIl7II;ECsDI,+BAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,+CAAA;EAAA,gDAAA;EAAA,sJAAA;ALy4IR;;AI/7II;ECsDI,qDAAA;EAAA,+CAAA;EAAA,gGAAA;EAAA,iGAAA;EAAA,iCAAA;EAAA,6CAAA;ALk5IR;;AIx8II;ECsDI,4CAAA;EAAA,qCAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,sCAAA;AL05IR;;AIh9II;ECsDI,8CAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,8CAAA;EAAA,iDAAA;EAAA,0DAAA;EAAA,sDAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,4DAAA;EAAA,oDAAA;EAAA,sDAAA;EAAA,wDAAA;EAAA,yDAAA;AL46IR;;AIl+II;ECsDI,0DAAA;EAAA,+DAAA;EAAA,4DAAA;EAAA,wEAAA;EAAA,6DAAA;EAAA,sEAAA;EAAA,mEAAA;EAAA,qEAAA;EAAA,sEAAA;EAAA,gEAAA;EAAA,kEAAA;EAAA,iEAAA;EAAA,oDAAA;EAAA,mEAAA;EAAA,gEAAA;EAAA,iEAAA;EAAA,oDAAA;ALg8IR;;AU9+II;;EL8CI,yCAAA;EAAA,0FAAA;EAAA,6DAAA;EAAA,+DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,8DAAA;ALk9IR;;AUz/IM;;ELuCE,yCAAA;EAAA,0FAAA;EAAA,6DAAA;EAAA,+DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,8DAAA;ALo+IR;;AUngJM;;EL+BE,yCAAA;EAAA,0FAAA;EAAA,6DAAA;EAAA,+DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,8DAAA;ALs/IR;;AU9gJI;ELwBI,6FAAA;EAAA,oDAAA;EAAA,qGAAA;EAAA,uGAAA;EAAA,8CAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,wDAAA;EAAA,0DAAA;EAAA,sEAAA;EAAA,sEAAA;EAAA,wEAAA;AL2gJR;;AU9hJI;ELmBI,6FAAA;EAAA,oDAAA;EAAA,qGAAA;EAAA,uGAAA;EAAA,4DAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,wDAAA;EAAA,0DAAA;EAAA,sEAAA;EAAA,sEAAA;EAAA,wEAAA;ALgiJR;;AU9iJI;ELcI,6FAAA;EAAA,oDAAA;EAAA,qGAAA;EAAA,uGAAA;EAAA,8CAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,wDAAA;EAAA,0DAAA;EAAA,sEAAA;EAAA,sEAAA;EAAA,wEAAA;ALqjJR;;AUzjJQ;;;;EAEE,cAAA;AV8jJV;;AUrjJM;;;EAGE,UAAA;AVwjJR;;AIxnJI;ECsDI,mDAAA;EAAA,iDAAA;EAAA,oDAAA;EAAA,oDAAA;EAAA,sDAAA;AL0kJR;;AU9iJI;;EL5BI,kCAAA;EAAA,uCAAA;ALglJR;;AUviJQ;EACE,YAAA;AV0iJV;AU7hJQ;EACE,YAAA;AV+hJV;;AI7oJI;ECsDI,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,mDAAA;EAAA,2CAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,+CAAA;EAAA,6DAAA;EAAA,gDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,wDAAA;EAAA,sEAAA;EAAA,yDAAA;ALymJR;;AUrhJI;EAEE,iCAAA;EACA,0BAAA;AVuhJN;;AIpqJI;ECsDI,4CAAA;EAAA,0DAAA;ALmnJR;;AIzqJI;ECsDI,yDAAA;EAAA,iDAAA;EAAA,uDAAA;EAAA,6FAAA;AL0nJR;;AIhrJI;ECsDI,oCAAA;EAAA,iDAAA;EAAA,0DAAA;EAAA,2CAAA;ALioJR;;AIvrJI;ECsDI,gDAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA,0CAAA;EAAA,8CAAA;AL0oJR;;AIhsJI;ECsDI,gCAAA;EAAA,oCAAA;EAAA,2BAAA;EAAA,sCAAA;EAAA,mCAAA;ALkpJR;;AWtsJI;;ENoDI,oDAAA;EAAA,oDAAA;EAAA,wDAAA;EAAA,0CAAA;EAAA,sCAAA;EAAA,wCAAA;EAAA,8DAAA;EAAA,8DAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,+CAAA;EAAA,yCAAA;ALmqJR;AWjtJM;;EN8CE,oDAAA;EAAA,oDAAA;EAAA,wDAAA;EAAA,0CAAA;EAAA,sCAAA;EAAA,wCAAA;EAAA,8DAAA;EAAA,8DAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,+CAAA;EAAA,yCAAA;ALmrJR;AW3tJM;;ENwCE,oDAAA;EAAA,oDAAA;EAAA,wDAAA;EAAA,0CAAA;EAAA,sCAAA;EAAA,wCAAA;EAAA,8DAAA;EAAA,8DAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,+CAAA;EAAA,yCAAA;ALmsJR;AWruJM;;ENkCE,mCAAA;EAAA,iCAAA;ALwsJR;AWluJM;;EN0BE,mCAAA;EAAA,+CAAA;AL6sJR;AW/tJM;;ENkBE,mCAAA;EAAA,iCAAA;ALktJR;;AWvsJI;ENXI,gCAAA;ALstJR;;AWvtJI;ENCI,sCAAA;EAAA,+BAAA;EAAA,6CAAA;EAAA,sCAAA;EAAA,gCAAA;AL8tJR;;AIpxJI;ECsDI,uDAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,yDAAA;EAAA,yDAAA;EAAA,yDAAA;EAAA,2DAAA;EAAA,sCAAA;ALyuJR;;AI/xJI;ECsDI,6FAAA;EAAA,oDAAA;EAAA,qGAAA;EAAA,uGAAA;EAAA,4DAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,wDAAA;EAAA,0DAAA;EAAA,sEAAA;EAAA,sEAAA;EAAA,wEAAA;AL8vJR;;AoB1yJM;Ef4CE,qGAAA;EAAA,uGAAA;EAAA,8CAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,wDAAA;EAAA,0DAAA;EAAA,sEAAA;EAAA,sEAAA;EAAA,wEAAA;ALixJR;AoBtzJM;EfqCE,qGAAA;EAAA,uGAAA;EAAA,8CAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,wDAAA;EAAA,0DAAA;EAAA,sEAAA;EAAA,sEAAA;EAAA,wEAAA;ALmyJR;;AIz1JI;ECsDI,0CAAA;EAAA,qCAAA;ALwyJR;;AI91JI;ECsDI,2CAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,kDAAA;EAAA,qCAAA;ALgzJR;;AIt2JI;ECsDI,wCAAA;EAAA,4CAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,uCAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,6CAAA;EAAA,gKAAA;EAAA,2CAAA;EAAA,wKAAA;EAAA,uKAAA;EAAA,+CAAA;EAAA,uKAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0KAAA;EAAA,8CAAA;EAAA,sCAAA;EAAA,yCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,mDAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,0CAAA;ALo1JR;;AI14JI;ECsDI,0CAAA;EAAA,sGAAA;EAAA,uGAAA;EAAA,mEAAA;EAAA,mDAAA;EAAA,mDAAA;EAAA,yDAAA;EAAA,qDAAA;EAAA,0FAAA;EAAA,0DAAA;EAAA,yGAAA;EAAA,iEAAA;EAAA,qEAAA;EAAA,qDAAA;EAAA,qDAAA;EAAA,2DAAA;EAAA,wDAAA;EAAA,uDAAA;EAAA,4FAAA;EAAA,4DAAA;EAAA,6CAAA;EAAA,yGAAA;EAAA,0GAAA;EAAA,sEAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,4DAAA;EAAA,wDAAA;EAAA,6FAAA;EAAA,6DAAA;EAAA,qGAAA;EAAA,iEAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,uDAAA;EAAA,mDAAA;EAAA,wFAAA;EAAA,wDAAA;EAAA,yCAAA;EAAA,qGAAA;EAAA,sGAAA;EAAA,kEAAA;EAAA,kDAAA;EAAA,kDAAA;EAAA,wDAAA;EAAA,oDAAA;EAAA,yFAAA;EAAA,yDAAA;ALu4JR;;AqB76JM;;;;;EhBsCE,4CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gFAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,+EAAA;EAAA,+CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,2EAAA;EAAA,2CAAA;ALi6JR;AqBl8JM;;;;;EhBiCE,4CAAA;EAAA,yDAAA;EAAA,0FAAA;EAAA,0DAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gFAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,4DAAA;EAAA,6FAAA;EAAA,6DAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,wDAAA;EAAA,yFAAA;EAAA,yDAAA;AL07JR;AqBt9JM;;;;;EhB4BE,4CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gFAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,+EAAA;EAAA,+CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,2EAAA;EAAA,2CAAA;ALm9JR;;AIzgKI;ECsDI,0CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,kDAAA;EAAA,wCAAA;EAAA,6CAAA;EAAA,yCAAA;EAAA,8CAAA;ALg+JR;;AIthKI;ECsDI,gDAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA,8CAAA;EAAA,0CAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,yDAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,mDAAA;EAAA,4CAAA;EAAA,0DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,qDAAA;EAAA,4CAAA;EAAA,wCAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,6CAAA;EAAA,yCAAA;AL4/JR;;AIljKI;ECsDI,iCAAA;EAAA,sCAAA;EAAA,yCAAA;ALkgKR;;AIxjKI;ECsDI,+FAAA;EAAA,iEAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,qCAAA;EAAA,mDAAA;EAAA,wFAAA;EAAA,wDAAA;AL6gKR;;AsBzjKM;EjB4CE,qCAAA;EAAA,4CAAA;EAAA,4EAAA;ALmhKR;AsB1jKM;EjBuCE,qCAAA;EAAA,4CAAA;EAAA,4EAAA;ALwhKR;AsB1jKM;EjBkCE,qCAAA;EAAA,4CAAA;EAAA,4EAAA;AL6hKR;;AInlKI;ECsDI,6CAAA;ALiiKR;;AsB5hKI;EAGE,wCAAA;EACA,wCAAA;EAOA,8CAAA;EACA,+CAAA;EACA,aAAA;AtBuhKN;;AI/lKI;ECsDI,qJAAA;EAAA,8BAAA;EAAA,iCAAA;EAAA,8JAAA;EAAA,yCAAA;EAAA,wCAAA;EAAA,oKAAA;EAAA,oKAAA;EAAA,uKAAA;EAAA,2JAAA;EAAA,2JAAA;EAAA,8JAAA;EAAA,2JAAA;EAAA,oCAAA;EAAA,uCAAA;EAAA,iKAAA;EAAA,iKAAA;EAAA,oKAAA;AL8jKR;;AIpnKI;ECsDI,gCAAA;EAAA,kGAAA;EAAA,mGAAA;EAAA,yDAAA;EAAA,yCAAA;EAAA,+CAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,gFAAA;EAAA,sCAAA;EAAA,wGAAA;EAAA,yGAAA;EAAA,+DAAA;EAAA,+CAAA;EAAA,qDAAA;EAAA,+CAAA;EAAA,iDAAA;EAAA,sFAAA;EAAA,sDAAA;EAAA,gDAAA;ALqlKR;;AuBhoKM;ElB2CE,kCAAA;EAAA,iCAAA;EAAA,oEAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,wEAAA;EAAA,wCAAA;EAAA,kCAAA;ALgmKR;AuBtoKM;ElBsCE,kCAAA;EAAA,+CAAA;EAAA,oEAAA;EAAA,wCAAA;EAAA,qDAAA;EAAA,sFAAA;EAAA,sDAAA;EAAA,gDAAA;AL0mKR;AuB3oKM;ElBiCE,kCAAA;EAAA,iCAAA;EAAA,oEAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,wEAAA;EAAA,wCAAA;EAAA,kCAAA;ALonKR;;AI1qKI;ECsDI,2CAAA;EAAA,qCAAA;ALynKR;;AI/qKI;ECsDI,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,yCAAA;ALgoKR;;AItrKI;ECsDI,oCAAA;ALooKR;;AI1rKI;ECsDI,wCAAA;EAAA,4CAAA;EAAA,qCAAA;AL0oKR;;AIhsKI;ECsDI,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,2CAAA;ALipKR;;AIvsKI;ECsDI,uCAAA;ALqpKR;;AI3sKI;ECsDI,mCAAA;EAAA,sDAAA;EAAA,0DAAA;EAAA,uDAAA;AL4pKR;;AIltKI;ECsDI,yCAAA;EAAA,yCAAA;EAAA,2CAAA;ALkqKR;;AIxtKI;ECsDI,6CAAA;EAAA,6CAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,oDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,2CAAA;EAAA,wDAAA;EAAA,oDAAA;EAAA,oDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,2DAAA;ALorKR;;AI1uKI;ECsDI,kDAAA;EAAA,iCAAA;ALyrKR;;AI/uKI;ECsDI,sDAAA;AL6rKR;;AwB9uKI;EnBiDI,sDAAA;ALisKR;;AwB7uKI;EnB4CI,sDAAA;ALqsKR;;AI3vKI;ECsDI,gCAAA;EAAA,iCAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,uCAAA;EAAA,kDAAA;EAAA,kDAAA;EAAA,qCAAA;EAAA,+CAAA;EAAA,gDAAA;EAAA,2CAAA;EAAA,qDAAA;EAAA,sDAAA;EAAA,gCAAA;EAAA,2CAAA;EAAA,2CAAA;ALwtKR;;AI9wKI;ECsDI,qCAAA;EAAA,6BAAA;EAAA,qGAAA;EAAA,+FAAA;AL+tKR;;AyBzwKI;EpB0CI,qCAAA;EAAA,2CAAA;ALouKR;;AyBzwKI;EpBqCI,qCAAA;EAAA,6BAAA;ALyuKR;;AI/xKI;ECsDI,kCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,qCAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,wCAAA;ALovKR;;AI1yKI;ECsDI,uCAAA;ALwvKR;;AI9yKI;ECsDI,4DAAA;EAAA,oDAAA;AL6vKR;;AInzKI;ECsDI,mDAAA;EAAA,mDAAA;EAAA,4CAAA;EAAA,0DAAA;EAAA,6CAAA;ALqwKR;;AI3zKI;ECsDI,mDAAA;EAAA,mDAAA;EAAA,uDAAA;EAAA,uCAAA;EAAA,qCAAA;EAAA,8BAAA;AL8wKR;;AIp0KI;ECsDI,2CAAA;EAAA,sHAAA;EAAA,gHAAA;EAAA,0DAAA;EAAA,uGAAA;EAAA,sDAAA;EAAA,6HAAA;EAAA,iEAAA;EAAA,8GAAA;EAAA,oHAAA;EAAA,yEAAA;EAAA,sGAAA;EAAA,0DAAA;EAAA,6GAAA;EAAA,kEAAA;EAAA,0DAAA;EAAA,mDAAA;ALkyKR;;AIx1KI;ECsDI,gCAAA;ALsyKR;;AI51KI;ECsDI,gDAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,kDAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,yDAAA;EAAA,iDAAA;ALmzKR;;AIz2KI;ECsDI,8CAAA;EAAA,oDAAA;EAAA,oKAAA;EAAA,8KAAA;AL0zKR;;AIh3KI;ECsDI,4GAAA;EAAA,uHAAA;EAAA,+EAAA;EAAA,kIAAA;EAAA,+DAAA;EAAA,uEAAA;EAAA,qHAAA;EAAA,wEAAA;EAAA,yGAAA;EAAA,wGAAA;EAAA,wDAAA;EAAA,uDAAA;EAAA,oEAAA;EAAA,uEAAA;EAAA,uEAAA;EAAA,2EAAA;EAAA,mEAAA;EAAA,gEAAA;EAAA,uEAAA;EAAA,2HAAA;EAAA,8DAAA;EAAA,yDAAA;EAAA,kHAAA;EAAA,+EAAA;EAAA,iEAAA;EAAA,qHAAA;EAAA,gHAAA;EAAA,2DAAA;EAAA,mEAAA;AL01KR;;A0Bp4KM;ErB0CE,4GAAA;EAAA,uHAAA;EAAA,+EAAA;EAAA,kIAAA;EAAA,6EAAA;EAAA,uEAAA;EAAA,qHAAA;EAAA,sFAAA;EAAA,yGAAA;EAAA,wGAAA;EAAA,wDAAA;EAAA,uDAAA;EAAA,oEAAA;EAAA,uEAAA;EAAA,uEAAA;EAAA,2EAAA;EAAA,mEAAA;EAAA,gEAAA;EAAA,uEAAA;EAAA,2HAAA;EAAA,8DAAA;EAAA,yDAAA;EAAA,kHAAA;EAAA,+EAAA;EAAA,iEAAA;EAAA,qHAAA;EAAA,gHAAA;EAAA,2DAAA;EAAA,mEAAA;AL03KR;A0B/5KM;ErBqCE,4GAAA;EAAA,uHAAA;EAAA,+EAAA;EAAA,kIAAA;EAAA,+DAAA;EAAA,uEAAA;EAAA,qHAAA;EAAA,wEAAA;EAAA,yGAAA;EAAA,wGAAA;EAAA,wDAAA;EAAA,uDAAA;EAAA,oEAAA;EAAA,uEAAA;EAAA,uEAAA;EAAA,2EAAA;EAAA,mEAAA;EAAA,gEAAA;EAAA,uEAAA;EAAA,2HAAA;EAAA,8DAAA;EAAA,yDAAA;EAAA,kHAAA;EAAA,+EAAA;EAAA,iEAAA;EAAA,qHAAA;EAAA,gHAAA;EAAA,2DAAA;EAAA,mEAAA;ALy5KR;;A0B74KI;ErBZI,4CAAA;AL65KR;AsBx5KI;EAGE,wCAAA;EACA,wCAAA;EAOA,8CAAA;EACA,+CAAA;EACA,YAAA;AtBk5KN;;AI19KI;ECsDI,gDAAA;EAAA,yCAAA;EAAA,oDAAA;EAAA,qDAAA;EAAA,uDAAA;EAAA,wDAAA;EAAA,gDAAA;EAAA,iDAAA;AL+6KR;;AIr+KI;ECsDI,wBAAA;ALm7KR;;AIz+KI;ECsDI,wCAAA;ALu7KR;;AI7+KI;ECsDI,oCAAA;EAAA,yJAAA;EAAA,6DAAA;EAAA,8CAAA;AL87KR;;AIp/KI;ECsDI,iDAAA;EAAA,yDAAA;EAAA,0DAAA;EAAA,uGAAA;EAAA,wGAAA;EAAA,0GAAA;EAAA,sDAAA;EAAA,6DAAA;EAAA,2DAAA;AL08KR;;AIhgLI;ECsDI,mDAAA;EAAA,kDAAA;AL+8KR;;AIrgLI;ECsDI,6CAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA,0CAAA;AL49KR;;AIlhLI;ECsDI,mDAAA;EAAA,qDAAA;EAAA,mDAAA;EAAA,qDAAA;ALm+KR;;AIzhLI;ECsDI,yBAAA;ALu+KR;;A2BvhLM;EtBgDE,yBAAA;AL2+KR;A2BrhLM;EtB0CE,yBAAA;AL8+KR;A2BlhLM;EtBoCE,yBAAA;ALi/KR;;AIviLI;ECsDI,gCAAA;EAAA,2JAAA;EAAA,mCAAA;ALu/KR;;AI7iLI;ECsDI,0DAAA;EAAA,+CAAA;EAAA,uDAAA;EAAA,+CAAA;EAAA,qDAAA;EAAA,6CAAA;ALggLR;;AItjLI;ECsDI,+CAAA;EAAA,+CAAA;ALqgLR;;AI3jLI;ECsDI,iDAAA;EAAA,kEAAA;EAAA,gEAAA;EAAA,8DAAA;EAAA,4DAAA;EAAA,8DAAA;EAAA,4DAAA;EAAA,oCAAA;EAAA,6CAAA;EAAA,qGAAA;EAAA,sGAAA;EAAA,0DAAA;EAAA,mEAAA;EAAA,yEAAA;EAAA,0DAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,mEAAA;AL0hLR;;A4BvkLI;EvB6CI,+DAAA;EAAA,kEAAA;EAAA,8EAAA;EAAA,8DAAA;EAAA,0EAAA;EAAA,8DAAA;EAAA,0EAAA;ALoiLR;;A4B5kLI;EvBwCI,iDAAA;EAAA,kEAAA;EAAA,gEAAA;EAAA,8DAAA;EAAA,4DAAA;EAAA,8DAAA;EAAA,4DAAA;AL8iLR;;AIpmLI;ECsDI,iCAAA;ALkjLR;;AIxmLI;ECsDI,8CAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,2CAAA;EAAA,sDAAA;EAAA,yDAAA;EAAA,0DAAA;AL4jLR;;AIlnLI;ECsDI,2CAAA;ALgkLR;;AItnLI;ECsDI,+CAAA;EAAA,uDAAA;ALqkLR;;A6B/mLM;ExB0CE,iDAAA;EAAA,yCAAA;AL0kLR;A6B5mLM;ExBkCE,iDAAA;EAAA,uDAAA;AL8kLR;A6BxmLM;ExB0BE,iDAAA;EAAA,yCAAA;ALklLR;;AIxoLI;ECsDI,mCAAA;EAAA,iCAAA;ALulLR;;AI7oLI;ECsDI,0CAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,2CAAA;EAAA,oCAAA;AL+lLR;;AIrpLI;ECsDI,4CAAA;EAAA,+CAAA;ALomLR;;AI1pLI;ECsDI,gCAAA;ALwmLR;;AI9pLI;ECsDI,sCAAA;EAAA,+BAAA;EAAA,gCAAA;AL8mLR;;AIpqLI;ECsDI,qCAAA;EAAA,4JAAA;ALmnLR;;AIzqLI;ECsDI,kDAAA;ALunLR;;AI7qLI;ECsDI,wCAAA;EAAA,4CAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,uCAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,6CAAA;EAAA,gKAAA;EAAA,2CAAA;EAAA,wKAAA;EAAA,uKAAA;EAAA,+CAAA;EAAA,uKAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0KAAA;EAAA,8CAAA;EAAA,sCAAA;EAAA,yCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,mDAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,0CAAA;AL2pLR;;AIjtLI;ECsDI,0CAAA;EAAA,sGAAA;EAAA,uGAAA;EAAA,mEAAA;EAAA,mDAAA;EAAA,mDAAA;EAAA,yDAAA;EAAA,qDAAA;EAAA,0FAAA;EAAA,0DAAA;EAAA,yGAAA;EAAA,iEAAA;EAAA,qEAAA;EAAA,qDAAA;EAAA,qDAAA;EAAA,2DAAA;EAAA,wDAAA;EAAA,uDAAA;EAAA,4FAAA;EAAA,4DAAA;EAAA,6CAAA;EAAA,yGAAA;EAAA,0GAAA;EAAA,sEAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,4DAAA;EAAA,wDAAA;EAAA,6FAAA;EAAA,6DAAA;EAAA,qGAAA;EAAA,iEAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,uDAAA;EAAA,mDAAA;EAAA,wFAAA;EAAA,wDAAA;EAAA,yCAAA;EAAA,qGAAA;EAAA,sGAAA;EAAA,kEAAA;EAAA,kDAAA;EAAA,kDAAA;EAAA,wDAAA;EAAA,oDAAA;EAAA,yFAAA;EAAA,yDAAA;AL8sLR;;AqBpvLM;;;;;EhBsCE,4CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gFAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,+EAAA;EAAA,+CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,2EAAA;EAAA,2CAAA;ALwuLR;AqBzwLM;;;;;EhBiCE,4CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gFAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,+EAAA;EAAA,+CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,2EAAA;EAAA,2CAAA;ALiwLR;AqB7xLM;;;;;EhB4BE,4CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gFAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,+EAAA;EAAA,+CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,2EAAA;EAAA,2CAAA;AL0xLR;;AIh1LI;ECsDI,0CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,kDAAA;EAAA,wCAAA;EAAA,6CAAA;EAAA,yCAAA;EAAA,8CAAA;ALuyLR;;AI71LI;ECsDI,qJAAA;EAAA,8BAAA;EAAA,iCAAA;EAAA,8JAAA;EAAA,yCAAA;EAAA,wCAAA;EAAA,oKAAA;EAAA,oKAAA;EAAA,uKAAA;EAAA,2JAAA;EAAA,2JAAA;EAAA,8JAAA;EAAA,2JAAA;EAAA,oCAAA;EAAA,uCAAA;EAAA,iKAAA;EAAA,iKAAA;EAAA,oKAAA;AL4zLR;;AIl3LI;ECsDI,gCAAA;EAAA,kGAAA;EAAA,mGAAA;EAAA,yDAAA;EAAA,yCAAA;EAAA,+CAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,gFAAA;EAAA,sCAAA;EAAA,wGAAA;EAAA,yGAAA;EAAA,+DAAA;EAAA,+CAAA;EAAA,qDAAA;EAAA,+CAAA;EAAA,iDAAA;EAAA,sFAAA;EAAA,sDAAA;EAAA,gDAAA;ALm1LR;;AuB93LM;ElB2CE,kCAAA;EAAA,iCAAA;EAAA,oEAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,wEAAA;EAAA,wCAAA;EAAA,kCAAA;AL81LR;AuBp4LM;ElBsCE,kCAAA;EAAA,iCAAA;EAAA,oEAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,wEAAA;EAAA,wCAAA;EAAA,kCAAA;ALw2LR;AuBz4LM;ElBiCE,kCAAA;EAAA,iCAAA;EAAA,oEAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,wEAAA;EAAA,wCAAA;EAAA,kCAAA;ALk3LR;;AIx6LI;ECsDI,2CAAA;EAAA,qCAAA;ALu3LR;;AI76LI;ECsDI,iCAAA;EAAA,sCAAA;EAAA,yCAAA;AL63LR;;AIn7LI;ECsDI,+FAAA;EAAA,iEAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,qCAAA;EAAA,mDAAA;EAAA,wFAAA;EAAA,wDAAA;ALw4LR;;AsBp7LM;EjB4CE,qCAAA;EAAA,4CAAA;EAAA,4EAAA;AL84LR;AsBr7LM;EjBuCE,qCAAA;EAAA,4CAAA;EAAA,4EAAA;ALm5LR;AsBr7LM;EjBkCE,qCAAA;EAAA,4CAAA;EAAA,4EAAA;ALw5LR;;AI98LI;ECsDI,6CAAA;AL45LR;;AsBv5LI;EAGE,wCAAA;EACA,wCAAA;EAOA,8CAAA;EACA,+CAAA;EACA,aAAA;AtBk5LN;;AI19LI;ECsDI,+CAAA;EAAA,uDAAA;ALy6LR;;A6Bn9LM;ExB0CE,iDAAA;EAAA,yCAAA;AL86LR;A6Bh9LM;ExBkCE,iDAAA;EAAA,uDAAA;ALk7LR;A6B58LM;ExB0BE,iDAAA;EAAA,yCAAA;ALs7LR;;AI5+LI;ECsDI,mCAAA;EAAA,iCAAA;AL27LR;;AIj/LI;ECsDI,kDAAA;EAAA,iCAAA;ALg8LR;;AIt/LI;ECsDI,sDAAA;ALo8LR;;AwBr/LI;EnBiDI,sDAAA;ALw8LR;;AwBp/LI;EnB4CI,sDAAA;AL48LR;;AFxhMA,0BAAA;ACAA;EACE,0BAAA;EACA,yDAAA;AC4hMF;AD1hMA;EACE,0BAAA;EACA,yDAAA;AC4hMF;AD1hMA;EACE,6BAAA;EACA,4DAAA;AC4hMF;AC9/LA;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;ADggMF;;AC5/LA;EACE;IACE,SAAA;IACA,UAAA;IACA,cAAA;ED+/LF;EC7/LA,4HAAA;EACA;IACE,aAAA;ED+/LF;EC5/LA;;IAEE,aAAA;ED8/LF;EC3/LA;IACE,aAAA;ED6/LF;EC1/LA;IACE,aAAA;ED4/LF;ECz/LA;IACE,aAAA;ED2/LF;ECx/LA;IACE,gBAAA;ED0/LF;AACF;ACv/LA;EACE,qBAAA;ADy/LF;;ACt/LA;EACE,sBAAA;ADy/LF;;ACt/LA;EACI,cAAA;ADy/LJ;;ACt/LA;EACE,0BF9EK;ACukMP;;AD1lMA;EACE,0BAAA;EACA,yDAAA;AC6lMF;AD3lMA;EACE,0BAAA;EACA,yDAAA;AC6lMF;AD3lMA;EACE,6BAAA;EACA,4DAAA;AC6lMF;AEjmMA;EACI,YAAA;AFmmMJ;AEjmMI;EACI,qBC0BF;EDzBE,oDAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,6BAAA;AFmmMR;AEhmMI;EACI,gBAAA;AFkmMR;;AE7lMI;EACI,iCAAA;AFgmMR;;AE5lMA;EACI,cAAA;EACA,gBAAA;AF+lMJ;AE7lMI;EACI,iBAAA;AF+lMR;;AE3lMA;EACI,uBAAA;AF8lMJ;;AE3lMA;EACE,sBAAA;EACA,6CAAA;EACA,oCAAA;AF8lMF;;AE3lMA;EACE,oCAAA;EACA,YAAA;AF8lMF;;AI3nMI;ECsDI,kCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,qCAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,wCAAA;ALglMR;;AM/gME;;;;;EAKE,iCAAA;EACA,sBAAA;EACA,gBAAA;ANkhMJ;;AM/gME;;;;;EAKE,iCAAA;EACA,wBAAA;EACA,gBAAA;ANkhMJ;;AM/gME;;;;;EAKE,iCAAA;EACA,0BAAA;EACA,gBAAA;ANkhMJ;;AM/gME;;;;;EAKE,iCAAA;EACA,yBAAA;EACA,gBAAA;ANkhMJ;;AM5gME;;;EC5JE,8CAAA;EDuKA,gBAAA;ANwgMJ;;AMrgME;;;EC1KE,8CAAA;EDqLA,gBAAA;ANigMJ;;AM9/LE;;;;EAIE,iCAAA;EACA,8BAAA;ANigMJ;;AM9/LE;;;;;EAKE,iCAAA;EACA,8BAAA;ANigMJ;AM//LI;;;;;EACE,gBAAA;ANqgMN;;AMjgME;;;;EAIE,iCAAA;EACA,8BAAA;ANogMJ;;AMjgME;;EAEE,iCAAA;EACA,2BAAA;EACA,gBAAA;ANogMJ;;AMjgME;;EAEE,iCAAA;EACA,+BAAA;EACA,gBAAA;ANogMJ;;AMjgME;;EAEE,iCAAA;EACA,sBAAA;EACA,gBAAA;ANogMJ;;AMjgME;;EAEE,iCAAA;EACA,8BAAA;EACA,gBAAA;ANogMJ;;AIxvMI;ECsDI,mDAAA;EAAA,mDAAA;EAAA,4CAAA;EAAA,0DAAA;EAAA,6CAAA;AL0sMR;;AIhwMI;ECsDI,gDAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,kDAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,yDAAA;EAAA,iDAAA;ALutMR;;AI7wMI;ECsDI,gDAAA;EAAA,yCAAA;EAAA,oDAAA;EAAA,qDAAA;EAAA,uDAAA;EAAA,wDAAA;EAAA,gDAAA;EAAA,iDAAA;ALkuMR;;AIxxMI;ECsDI,6CAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA,0CAAA;AL+uMR;;AIryMI;ECsDI,mDAAA;EAAA,qDAAA;EAAA,mDAAA;EAAA,qDAAA;ALsvMR;;AI5yMI;ECsDI,8CAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,2CAAA;EAAA,sDAAA;EAAA,yDAAA;EAAA,0DAAA;ALgwMR;;AItzMI;ECsDI,0CAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,2CAAA;EAAA,oCAAA;ALwwMR;;AI9zMI;ECsDI,sCAAA;EAAA,+BAAA;EAAA,gCAAA;AL8wMR;;AIp0MI;ECsDI,yCAAA;EAAA,yCAAA;EAAA,kCAAA;EAAA,2CAAA;EAAA,mCAAA;ALsxMR;;AI50MI;ECsDI,2CAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,6CAAA;EAAA,qCAAA;AL8xMR;;AIp1MI;ECsDI,uCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,wCAAA;EAAA,iCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,iDAAA;EAAA,oCAAA;AL2yMR;;AIj2MI;ECsDI,+CAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,sDAAA;ALkzMR;;AIx2MI;ECsDI,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,mDAAA;EAAA,2CAAA;EAAA,yDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,wDAAA;EAAA,2CAAA;EAAA,oDAAA;EAAA,6CAAA;EAAA,sDAAA;EAAA,8CAAA;EAAA,sDAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gDAAA;ALw0MR;;AI93MI;ECsDI,2CAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,6CAAA;EAAA,qCAAA;ALg1MR;;AIt4MI;ECsDI,sCAAA;EAAA,sCAAA;EAAA,+BAAA;EAAA,gCAAA;EAAA,uCAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,gDAAA;AL61MR;;AQ92MI;EHiBI,uCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,8CAAA;EAAA,iCAAA;ALq2MR;;AI35MI;ECsDI,+CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,yCAAA;AL62MR;AS33MM;EJcE,+CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,yCAAA;ALo3MR;;AI16MI;ECsDI,wCAAA;EAAA,wCAAA;EAAA,iCAAA;EAAA,+CAAA;EAAA,kCAAA;AL43MR;;AIl7MI;ECsDI,+CAAA;EAAA,wCAAA;EAAA,+CAAA;EAAA,sDAAA;EAAA,yCAAA;ALo4MR;;AI17MI;ECsDI,4CAAA;EAAA,qCAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,sCAAA;AL44MR;;AIl8MI;ECsDI,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,mDAAA;EAAA,2CAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,+CAAA;EAAA,6DAAA;EAAA,gDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,wDAAA;EAAA,sEAAA;EAAA,yDAAA;AL85MR;;AU10MI;EAEE,iCAAA;EACA,0BAAA;AV40MN;;AIz9MI;ECsDI,gDAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA,0CAAA;EAAA,8CAAA;AL46MR;;AW76MI;ENCI,sCAAA;EAAA,+BAAA;EAAA,6CAAA;EAAA,sCAAA;EAAA,gCAAA;ALo7MR;;AI1+MI;ECsDI,2CAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,kDAAA;EAAA,qCAAA;AL47MR;;AIl/MI;ECsDI,gDAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA,8CAAA;EAAA,0CAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,yDAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,mDAAA;EAAA,4CAAA;EAAA,0DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,qDAAA;EAAA,4CAAA;EAAA,wCAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,6CAAA;EAAA,yCAAA;ALw9MR;;AI9gNI;ECsDI,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,yCAAA;AL+9MR;;AIrhNI;ECsDI,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,2CAAA;ALs+MR;;AI5hNI;ECsDI,6CAAA;EAAA,6CAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,oDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,2CAAA;EAAA,wDAAA;EAAA,oDAAA;EAAA,oDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,2DAAA;ALw/MR;;AYxhNM;EACE,yJAAA;AZ2hNR;;AY5hNM;EACE,0JAAA;AZ+hNR;;AYhiNM;EACE,0JAAA;AZmiNR;;AYpiNM;EACE,0JAAA;AZuiNR;;AYxiNM;EACE,2JAAA;AZ2iNR;;AY5iNM;EACE,2JAAA;AZ+iNR;;AYhjNM;EACE,4JAAA;AZmjNR;;AYpjNM;EACE,4JAAA;AZujNR;;AYxjNM;EACE,4JAAA;AZ2jNR;;AY5jNM;EACE,4JAAA;AZ+jNR;;AYhkNM;EACE,8JAAA;AZmkNR;;AYpkNM;EACE,8JAAA;AZukNR;;AYxkNM;EACE,8JAAA;AZ2kNR;;AY5kNM;EACE,8JAAA;AZ+kNR;;AYhlNM;EACE,8JAAA;AZmlNR;;AYplNM;EACE,8JAAA;AZulNR;;AYxlNM;EACE,+JAAA;AZ2lNR;;AY5lNM;EACE,+JAAA;AZ+lNR;;AYhmNM;EACE,+JAAA;AZmmNR;;AYpmNM;EACE,+JAAA;AZumNR;;AYxmNM;EACE,gKAAA;AZ2mNR;;AY5mNM;EACE,gKAAA;AZ+mNR;;AYhnNM;EACE,gKAAA;AZmnNR;;AYpnNM;EACE,gKAAA;AZunNR;;AYxnNM;EACE,gKAAA;AZ2nNR;;AYxpNE;EACE,6BAAA;AZ2pNJ;;AYppNI;EACE,yFAAA;EACA,uEAAA;AZupNN;;AI3pNI;ECsDI,mCAAA;EAAA,yCAAA;EAAA,gJAAA;EAAA,iJAAA;EAAA,iJAAA;EAAA,iJAAA;EAAA,kJAAA;EAAA,kJAAA;EAAA,mJAAA;EAAA,mJAAA;EAAA,mJAAA;EAAA,mJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,sJAAA;EAAA,sJAAA;EAAA,sJAAA;EAAA,sJAAA;EAAA,uJAAA;EAAA,uJAAA;EAAA,uJAAA;EAAA,uJAAA;EAAA,uJAAA;ALmoNR;;AIzrNI;ECsDI,4EAAA;ALuoNR;;AI7rNI;ECsDI,qDAAA;EAAA,kDAAA;EAAA,6FAAA;EAAA,8FAAA;EAAA,iGAAA;AL+oNR;;Aa5rNI;ER6CI,qDAAA;EAAA,kDAAA;EAAA,6FAAA;EAAA,8FAAA;EAAA,iGAAA;ALupNR;;Aa/rNI;ERwCI,qDAAA;EAAA,kDAAA;EAAA,6FAAA;EAAA,8FAAA;EAAA,iGAAA;AL+pNR;;AIrtNI;ECsDI,oDAAA;ALmqNR;;AIztNI;ECsDI,uDAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA,qEAAA;EAAA,mHAAA;EAAA,iHAAA;EAAA,+DAAA;EAAA,yHAAA;AL8qNR;;Ac/sNI;ETiCI,uDAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA,qEAAA;EAAA,mHAAA;EAAA,iHAAA;EAAA,+DAAA;EAAA,yHAAA;ALyrNR;;AcrtNI;ET4BI,uDAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA,qEAAA;EAAA,mHAAA;EAAA,iHAAA;EAAA,+DAAA;EAAA,yHAAA;ALosNR;;Ac3tNI;ETuBI,uDAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA,qEAAA;EAAA,mHAAA;EAAA,iHAAA;EAAA,+DAAA;EAAA,yHAAA;AL+sNR;;AIrwNI;ECsDI,yCAAA;EAAA,yCAAA;EAAA,kCAAA;EAAA,2CAAA;EAAA,mCAAA;ALutNR;;AI7wNI;ECsDI,2CAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,6CAAA;EAAA,qCAAA;AL+tNR;;AIrxNI;ECsDI,wCAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,sCAAA;ALsuNR;;AI5xNI;ECsDI,0CAAA;EAAA,sJAAA;EAAA,0CAAA;EAAA,qJAAA;EAAA,sDAAA;EAAA,mDAAA;EAAA,wCAAA;EAAA,mJAAA;ALivNR;;AIvyNI;ECsDI,uCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,wCAAA;EAAA,iCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,iDAAA;EAAA,oCAAA;AL8vNR;;AIpzNI;ECsDI,+CAAA;EAAA,oCAAA;EAAA,iCAAA;ALowNR;;Ae5zNI;EVwDI,kDAAA;EAAA,uDAAA;ALywNR;Ae7zNM;EVoDE,kDAAA;EAAA,uDAAA;AL6wNR;Ae5zNM;EV+CE,kDAAA;EAAA,uDAAA;ALixNR;;AIv0NI;ECsDI,kCAAA;EAAA,+CAAA;ALsxNR;;AI50NI;ECsDI,sCAAA;EAAA,0CAAA;AL2xNR;;AIj1NI;ECsDI,+CAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,sDAAA;ALkyNR;;AIx1NI;ECsDI,oDAAA;EAAA,0DAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,kDAAA;EAAA,8CAAA;AL2yNR;;AIj2NI;ECsDI,uFAAA;EAAA,4CAAA;EAAA,6DAAA;EAAA,4FAAA;EAAA,8CAAA;EAAA,sDAAA;EAAA,8FAAA;EAAA,gHAAA;EAAA,uDAAA;EAAA,0CAAA;EAAA,kDAAA;EAAA,4DAAA;EAAA,0CAAA;EAAA,mDAAA;EAAA,2CAAA;EAAA,oDAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,iDAAA;EAAA,gEAAA;EAAA,sGAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,yGAAA;EAAA,6DAAA;EAAA,mEAAA;EAAA,2GAAA;EAAA,6DAAA;EAAA,2GAAA;EAAA,yEAAA;EAAA,6DAAA;EAAA,6DAAA;EAAA,uDAAA;EAAA,kDAAA;EAAA,mEAAA;EAAA,iHAAA;EAAA,yEAAA;EAAA,6DAAA;EAAA,mEAAA;EAAA,mEAAA;EAAA,+DAAA;EAAA,qEAAA;EAAA,6GAAA;EAAA,+DAAA;EAAA,6GAAA;EAAA,2EAAA;EAAA,oDAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,+DAAA;EAAA,4DAAA;EAAA,0GAAA;EAAA,kEAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;ALu2NR;;AgBv5NI;EXgDI,uFAAA;EAAA,4CAAA;EAAA,6DAAA;EAAA,4FAAA;EAAA,8CAAA;EAAA,sDAAA;EAAA,8FAAA;ALi3NR;;AgB55NI;EX2CI,uFAAA;EAAA,4CAAA;EAAA,6DAAA;EAAA,4FAAA;EAAA,8CAAA;EAAA,sDAAA;EAAA,8FAAA;AL23NR;;AIj7NI;ECsDI,uCAAA;EAAA,4CAAA;EAAA,iDAAA;EAAA,8DAAA;EAAA,gEAAA;ALm4NR;;AIz7NI;ECsDI,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,mDAAA;EAAA,2CAAA;EAAA,yDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,wDAAA;EAAA,2CAAA;EAAA,oDAAA;EAAA,6CAAA;EAAA,sDAAA;EAAA,8CAAA;EAAA,sDAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gDAAA;ALy5NR;;AI/8NI;ECsDI,wJAAA;AL65NR;;AIn9NI;ECsDI,0CAAA;EAAA,4DAAA;EAAA,kGAAA;EAAA,wDAAA;EAAA,qDAAA;EAAA,2FAAA;EAAA,yCAAA;EAAA,yCAAA;ALw6NR;;AiBr9NI;EZ6CI,0CAAA;EAAA,4DAAA;EAAA,kGAAA;EAAA,wDAAA;EAAA,qDAAA;EAAA,2FAAA;EAAA,yCAAA;EAAA,yCAAA;ALm7NR;;AiB39NI;EZwCI,0CAAA;EAAA,4DAAA;EAAA,kGAAA;EAAA,wDAAA;EAAA,qDAAA;EAAA,2FAAA;EAAA,yCAAA;EAAA,yCAAA;AL87NR;;AIp/NI;ECsDI,8CAAA;ALk8NR;;AIx/NI;ECsDI,2CAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,6CAAA;EAAA,qCAAA;AL08NR;;AIhgOI;ECsDI,uCAAA;EAAA,8JAAA;AL+8NR;;AIrgOI;ECsDI,0CAAA;ALm9NR;;AIzgOI;ECsDI,iCAAA;EAAA,2JAAA;EAAA,sCAAA;EAAA,4CAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,iCAAA;EAAA,uCAAA;EAAA,oDAAA;EAAA,yCAAA;ALg+NR;;AIthOI;ECsDI,mCAAA;EAAA,+CAAA;EAAA,uDAAA;ALs+NR;;AI5hOI;ECsDI,sCAAA;EAAA,sCAAA;EAAA,+BAAA;EAAA,gCAAA;EAAA,uCAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,gDAAA;ALm/NR;;AQhjOI;EH6DI,uCAAA;EAAA,0CAAA;EAAA,8CAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,qCAAA;EAAA,2BAAA;EAAA,mDAAA;EAAA,kEAAA;EAAA,2CAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,wCAAA;EAAA,yDAAA;EAAA,gDAAA;EAAA,wCAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,oCAAA;EAAA,+DAAA;AL2gOR;;AQ1jOI;EH+CI,yDAAA;EAAA,6FAAA;EAAA,sGAAA;EAAA,sGAAA;EAAA,2GAAA;EAAA,uDAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,qEAAA;EAAA,iDAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,yDAAA;EAAA,4DAAA;EAAA,6DAAA;EAAA,oDAAA;EAAA,6DAAA;EAAA,+EAAA;EAAA,sEAAA;ALkiOR;AQ5kOQ;EH0CA,2CAAA;EAAA,4CAAA;EAAA,qDAAA;EAAA,qDAAA;EAAA,0DAAA;EAAA,uDAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA,kCAAA;EAAA,uDAAA;EAAA,iDAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,+CAAA;EAAA,sCAAA;EAAA,+CAAA;EAAA,iEAAA;EAAA,wDAAA;ALwjOR;AQ7lOQ;EHqCA,yDAAA;EAAA,4CAAA;EAAA,qDAAA;EAAA,qDAAA;EAAA,0DAAA;EAAA,uDAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,qEAAA;EAAA,iDAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,yDAAA;EAAA,4DAAA;EAAA,6DAAA;EAAA,oDAAA;EAAA,6DAAA;EAAA,+EAAA;EAAA,sEAAA;AL8kOR;AQ9mOQ;EHgCA,2CAAA;EAAA,4CAAA;EAAA,qDAAA;EAAA,qDAAA;EAAA,0DAAA;EAAA,uDAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA,kCAAA;EAAA,uDAAA;EAAA,iDAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,+CAAA;EAAA,sCAAA;EAAA,+CAAA;EAAA,iEAAA;EAAA,wDAAA;ALomOR;;AQzmOI;EHKI,iCAAA;ALwmOR;;AQznOI;EHiBI,uCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,8CAAA;EAAA,iCAAA;ALgnOR;;AItqOI;ECsDI,gDAAA;EAAA,yDAAA;EAAA,uDAAA;EAAA,+CAAA;EAAA,2DAAA;EAAA,yDAAA;EAAA,uEAAA;EAAA,+DAAA;EAAA,sCAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,0CAAA;EAAA,2FAAA;EAAA,4CAAA;EAAA,2DAAA;EAAA,uDAAA;EAAA,6CAAA;EAAA,2DAAA;EAAA,2CAAA;EAAA,+DAAA;EAAA,6DAAA;EAAA,4DAAA;EAAA,oDAAA;EAAA,iEAAA;EAAA,qCAAA;EAAA,mDAAA;EAAA,2CAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,6DAAA;EAAA,yDAAA;EAAA,+CAAA;EAAA,6DAAA;EAAA,6CAAA;EAAA,iEAAA;EAAA,8DAAA;EAAA,mEAAA;EAAA,2CAAA;EAAA,0FAAA;EAAA,8CAAA;EAAA,0CAAA;AL4pOR;;AIltOI;ECsDI,6CAAA;EAAA,sDAAA;EAAA,4DAAA;EAAA,iDAAA;EAAA,4DAAA;EAAA,8DAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,yDAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,wDAAA;EAAA,gDAAA;EAAA,sGAAA;EAAA,iKAAA;EAAA,sEAAA;EAAA,qEAAA;EAAA,wEAAA;EAAA,0DAAA;EAAA,uEAAA;EAAA,yJAAA;EAAA,8CAAA;EAAA,wDAAA;EAAA,yDAAA;EAAA,yDAAA;EAAA,0EAAA;EAAA,oEAAA;EAAA,iDAAA;EAAA,+DAAA;EAAA,0EAAA;EAAA,oEAAA;EAAA,2DAAA;EAAA,sEAAA;EAAA,4EAAA;EAAA,8DAAA;ALksOR;;ASxuOM;EJsCE,2DAAA;EAAA,oEAAA;EAAA,4DAAA;EAAA,iDAAA;EAAA,4DAAA;EAAA,8DAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,yDAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,wDAAA;EAAA,gDAAA;ALktOR;ASnvOM;EJiCE,6CAAA;EAAA,sDAAA;EAAA,4DAAA;EAAA,iDAAA;EAAA,4DAAA;EAAA,8DAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,yDAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,wDAAA;EAAA,gDAAA;ALiuOR;;AIvxOI;ECsDI,yCAAA;EAAA,8CAAA;ALsuOR;;AI5xOI;ECsDI,+CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,yCAAA;AL8uOR;AS5vOM;EJcE,+CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,yCAAA;ALqvOR;;AI3yOI;ECsDI,gDAAA;EAAA,kDAAA;EAAA,kCAAA;EAAA,mCAAA;AL4vOR;;AkB5yOM;EbgDE,yCAAA;EAAA,0FAAA;EAAA,6DAAA;EAAA,+DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,8DAAA;AL6wOR;AkBxzOM;Eb2CE,yCAAA;EAAA,0FAAA;EAAA,6DAAA;EAAA,+DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,8DAAA;AL6xOR;AkBn0OM;EbsCE,yCAAA;EAAA,0FAAA;EAAA,6DAAA;EAAA,+DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,8DAAA;AL6yOR;;AIn2OI;ECsDI,kCAAA;EAAA,uCAAA;ALkzOR;;AIx2OI;ECsDI,wCAAA;EAAA,wCAAA;EAAA,iCAAA;EAAA,+CAAA;EAAA,kCAAA;AL0zOR;;AIh3OI;ECsDI,qCAAA;EAAA,uCAAA;EAAA,4IAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,+CAAA;EAAA,iDAAA;EAAA,kEAAA;EAAA,yCAAA;EAAA,4CAAA;EAAA,iDAAA;EAAA,wCAAA;EAAA,mDAAA;EAAA,0DAAA;EAAA,iDAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,qDAAA;ALk1OR;;AIx4OI;ECsDI,wCAAA;EAAA,wCAAA;EAAA,kCAAA;EAAA,wCAAA;EAAA,kFAAA;EAAA,iFAAA;EAAA,0CAAA;EAAA,kCAAA;EAAA,0DAAA;EAAA,8DAAA;EAAA,6DAAA;EAAA,uDAAA;EAAA,+DAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,mEAAA;EAAA,0EAAA;ALu2OR;;AmBp5OI;Ed6CI,wCAAA;EAAA,wCAAA;EAAA,kCAAA;EAAA,wCAAA;EAAA,kFAAA;EAAA,iFAAA;EAAA,0CAAA;EAAA,kCAAA;EAAA,wEAAA;EAAA,8DAAA;ALo3OR;;AmB55OI;EdwCI,wCAAA;EAAA,wCAAA;EAAA,kCAAA;EAAA,wCAAA;EAAA,kFAAA;EAAA,iFAAA;EAAA,0CAAA;EAAA,kCAAA;EAAA,0DAAA;EAAA,8DAAA;ALi4OR;;AIv7OI;ECsDI,+CAAA;EAAA,wCAAA;EAAA,+CAAA;EAAA,sDAAA;EAAA,yCAAA;ALy4OR;;AI/7OI;ECsDI,+BAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,+CAAA;EAAA,gDAAA;EAAA,sJAAA;ALs5OR;;AI58OI;ECsDI,qDAAA;EAAA,+CAAA;EAAA,gGAAA;EAAA,iGAAA;EAAA,iCAAA;EAAA,6CAAA;AL+5OR;;AIr9OI;ECsDI,4CAAA;EAAA,qCAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,sCAAA;ALu6OR;;AI79OI;ECsDI,8CAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,8CAAA;EAAA,iDAAA;EAAA,0DAAA;EAAA,sDAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,4DAAA;EAAA,oDAAA;EAAA,sDAAA;EAAA,wDAAA;EAAA,yDAAA;ALy7OR;;AI/+OI;ECsDI,0DAAA;EAAA,+DAAA;EAAA,4DAAA;EAAA,wEAAA;EAAA,6DAAA;EAAA,sEAAA;EAAA,mEAAA;EAAA,qEAAA;EAAA,sEAAA;EAAA,gEAAA;EAAA,kEAAA;EAAA,iEAAA;EAAA,oDAAA;EAAA,mEAAA;EAAA,gEAAA;EAAA,iEAAA;EAAA,oDAAA;AL68OR;;AU3/OI;;EL8CI,yCAAA;EAAA,0FAAA;EAAA,6DAAA;EAAA,+DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,8DAAA;AL+9OR;;AUtgPM;;ELuCE,yCAAA;EAAA,0FAAA;EAAA,6DAAA;EAAA,+DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,8DAAA;ALi/OR;;AUhhPM;;EL+BE,yCAAA;EAAA,0FAAA;EAAA,6DAAA;EAAA,+DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,8DAAA;ALmgPR;;AU3hPI;ELwBI,6FAAA;EAAA,oDAAA;EAAA,qGAAA;EAAA,uGAAA;EAAA,8CAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,wDAAA;EAAA,0DAAA;EAAA,sEAAA;EAAA,sEAAA;EAAA,wEAAA;ALwhPR;;AU3iPI;ELmBI,6FAAA;EAAA,oDAAA;EAAA,qGAAA;EAAA,uGAAA;EAAA,4DAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,wDAAA;EAAA,0DAAA;EAAA,sEAAA;EAAA,sEAAA;EAAA,wEAAA;AL6iPR;;AU3jPI;ELcI,6FAAA;EAAA,oDAAA;EAAA,qGAAA;EAAA,uGAAA;EAAA,8CAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,wDAAA;EAAA,0DAAA;EAAA,sEAAA;EAAA,sEAAA;EAAA,wEAAA;ALkkPR;;AUtkPQ;;;;EAEE,cAAA;AV2kPV;;AUlkPM;;;EAGE,UAAA;AVqkPR;;AIroPI;ECsDI,mDAAA;EAAA,iDAAA;EAAA,oDAAA;EAAA,oDAAA;EAAA,sDAAA;ALulPR;;AU3jPI;;EL5BI,kCAAA;EAAA,uCAAA;AL6lPR;;AUpjPQ;EACE,YAAA;AVujPV;AU1iPQ;EACE,YAAA;AV4iPV;;AI1pPI;ECsDI,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,mDAAA;EAAA,2CAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,+CAAA;EAAA,6DAAA;EAAA,gDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,wDAAA;EAAA,sEAAA;EAAA,yDAAA;ALsnPR;;AUliPI;EAEE,iCAAA;EACA,0BAAA;AVoiPN;;AIjrPI;ECsDI,4CAAA;EAAA,0DAAA;ALgoPR;;AItrPI;ECsDI,yDAAA;EAAA,iDAAA;EAAA,uDAAA;EAAA,6FAAA;ALuoPR;;AI7rPI;ECsDI,oCAAA;EAAA,iDAAA;EAAA,0DAAA;EAAA,2CAAA;AL8oPR;;AIpsPI;ECsDI,gDAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA,0CAAA;EAAA,8CAAA;ALupPR;;AI7sPI;ECsDI,gCAAA;EAAA,oCAAA;EAAA,2BAAA;EAAA,sCAAA;EAAA,mCAAA;AL+pPR;;AWntPI;;ENoDI,oDAAA;EAAA,oDAAA;EAAA,wDAAA;EAAA,0CAAA;EAAA,sCAAA;EAAA,wCAAA;EAAA,8DAAA;EAAA,8DAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,+CAAA;EAAA,yCAAA;ALgrPR;AW9tPM;;EN8CE,oDAAA;EAAA,oDAAA;EAAA,wDAAA;EAAA,0CAAA;EAAA,sCAAA;EAAA,wCAAA;EAAA,8DAAA;EAAA,8DAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,+CAAA;EAAA,yCAAA;ALgsPR;AWxuPM;;ENwCE,oDAAA;EAAA,oDAAA;EAAA,wDAAA;EAAA,0CAAA;EAAA,sCAAA;EAAA,wCAAA;EAAA,8DAAA;EAAA,8DAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,+CAAA;EAAA,yCAAA;ALgtPR;AWlvPM;;ENkCE,mCAAA;EAAA,iCAAA;ALqtPR;AW/uPM;;EN0BE,mCAAA;EAAA,+CAAA;AL0tPR;AW5uPM;;ENkBE,mCAAA;EAAA,iCAAA;AL+tPR;;AWptPI;ENXI,gCAAA;ALmuPR;;AWpuPI;ENCI,sCAAA;EAAA,+BAAA;EAAA,6CAAA;EAAA,sCAAA;EAAA,gCAAA;AL2uPR;;AIjyPI;ECsDI,uDAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,yDAAA;EAAA,yDAAA;EAAA,yDAAA;EAAA,2DAAA;EAAA,sCAAA;ALsvPR;;AI5yPI;ECsDI,6FAAA;EAAA,oDAAA;EAAA,qGAAA;EAAA,uGAAA;EAAA,4DAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,wDAAA;EAAA,0DAAA;EAAA,sEAAA;EAAA,sEAAA;EAAA,wEAAA;AL2wPR;;AoBvzPM;Ef4CE,qGAAA;EAAA,uGAAA;EAAA,8CAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,wDAAA;EAAA,0DAAA;EAAA,sEAAA;EAAA,sEAAA;EAAA,wEAAA;AL8xPR;AoBn0PM;EfqCE,qGAAA;EAAA,uGAAA;EAAA,8CAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,wDAAA;EAAA,0DAAA;EAAA,sEAAA;EAAA,sEAAA;EAAA,wEAAA;ALgzPR;;AIt2PI;ECsDI,0CAAA;EAAA,qCAAA;ALqzPR;;AI32PI;ECsDI,2CAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,kDAAA;EAAA,qCAAA;AL6zPR;;AIn3PI;ECsDI,wCAAA;EAAA,4CAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,uCAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,6CAAA;EAAA,gKAAA;EAAA,2CAAA;EAAA,wKAAA;EAAA,uKAAA;EAAA,+CAAA;EAAA,uKAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0KAAA;EAAA,8CAAA;EAAA,sCAAA;EAAA,yCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,mDAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,0CAAA;ALi2PR;;AIv5PI;ECsDI,0CAAA;EAAA,sGAAA;EAAA,uGAAA;EAAA,mEAAA;EAAA,mDAAA;EAAA,mDAAA;EAAA,yDAAA;EAAA,qDAAA;EAAA,0FAAA;EAAA,0DAAA;EAAA,yGAAA;EAAA,iEAAA;EAAA,qEAAA;EAAA,qDAAA;EAAA,qDAAA;EAAA,2DAAA;EAAA,wDAAA;EAAA,uDAAA;EAAA,4FAAA;EAAA,4DAAA;EAAA,6CAAA;EAAA,yGAAA;EAAA,0GAAA;EAAA,sEAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,4DAAA;EAAA,wDAAA;EAAA,6FAAA;EAAA,6DAAA;EAAA,qGAAA;EAAA,iEAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,uDAAA;EAAA,mDAAA;EAAA,wFAAA;EAAA,wDAAA;EAAA,yCAAA;EAAA,qGAAA;EAAA,sGAAA;EAAA,kEAAA;EAAA,kDAAA;EAAA,kDAAA;EAAA,wDAAA;EAAA,oDAAA;EAAA,yFAAA;EAAA,yDAAA;ALo5PR;;AqB17PM;;;;;EhBsCE,4CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gFAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,+EAAA;EAAA,+CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,2EAAA;EAAA,2CAAA;AL86PR;AqB/8PM;;;;;EhBiCE,4CAAA;EAAA,yDAAA;EAAA,0FAAA;EAAA,0DAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gFAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,4DAAA;EAAA,6FAAA;EAAA,6DAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,wDAAA;EAAA,yFAAA;EAAA,yDAAA;ALu8PR;AqBn+PM;;;;;EhB4BE,4CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gFAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,+EAAA;EAAA,+CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,2EAAA;EAAA,2CAAA;ALg+PR;;AIthQI;ECsDI,0CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,kDAAA;EAAA,wCAAA;EAAA,6CAAA;EAAA,yCAAA;EAAA,8CAAA;AL6+PR;;AIniQI;ECsDI,gDAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA,8CAAA;EAAA,0CAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,yDAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,mDAAA;EAAA,4CAAA;EAAA,0DAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,qDAAA;EAAA,4CAAA;EAAA,wCAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,6CAAA;EAAA,yCAAA;ALygQR;;AI/jQI;ECsDI,iCAAA;EAAA,sCAAA;EAAA,yCAAA;AL+gQR;;AIrkQI;ECsDI,+FAAA;EAAA,iEAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,qCAAA;EAAA,mDAAA;EAAA,wFAAA;EAAA,wDAAA;AL0hQR;;AsBtkQM;EjB4CE,qCAAA;EAAA,4CAAA;EAAA,4EAAA;ALgiQR;AsBvkQM;EjBuCE,qCAAA;EAAA,4CAAA;EAAA,4EAAA;ALqiQR;AsBvkQM;EjBkCE,qCAAA;EAAA,4CAAA;EAAA,4EAAA;AL0iQR;;AIhmQI;ECsDI,6CAAA;AL8iQR;;AsBziQI;EAGE,wCAAA;EACA,wCAAA;EAOA,8CAAA;EACA,+CAAA;EACA,aAAA;AtBoiQN;;AI5mQI;ECsDI,qJAAA;EAAA,8BAAA;EAAA,iCAAA;EAAA,8JAAA;EAAA,yCAAA;EAAA,wCAAA;EAAA,oKAAA;EAAA,oKAAA;EAAA,uKAAA;EAAA,2JAAA;EAAA,2JAAA;EAAA,8JAAA;EAAA,2JAAA;EAAA,oCAAA;EAAA,uCAAA;EAAA,iKAAA;EAAA,iKAAA;EAAA,oKAAA;AL2kQR;;AIjoQI;ECsDI,gCAAA;EAAA,kGAAA;EAAA,mGAAA;EAAA,yDAAA;EAAA,yCAAA;EAAA,+CAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,gFAAA;EAAA,sCAAA;EAAA,wGAAA;EAAA,yGAAA;EAAA,+DAAA;EAAA,+CAAA;EAAA,qDAAA;EAAA,+CAAA;EAAA,iDAAA;EAAA,sFAAA;EAAA,sDAAA;EAAA,gDAAA;ALkmQR;;AuB7oQM;ElB2CE,kCAAA;EAAA,iCAAA;EAAA,oEAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,wEAAA;EAAA,wCAAA;EAAA,kCAAA;AL6mQR;AuBnpQM;ElBsCE,kCAAA;EAAA,+CAAA;EAAA,oEAAA;EAAA,wCAAA;EAAA,qDAAA;EAAA,sFAAA;EAAA,sDAAA;EAAA,gDAAA;ALunQR;AuBxpQM;ElBiCE,kCAAA;EAAA,iCAAA;EAAA,oEAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,wEAAA;EAAA,wCAAA;EAAA,kCAAA;ALioQR;;AIvrQI;ECsDI,2CAAA;EAAA,qCAAA;ALsoQR;;AI5rQI;ECsDI,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,yCAAA;AL6oQR;;AInsQI;ECsDI,oCAAA;ALipQR;;AIvsQI;ECsDI,wCAAA;EAAA,4CAAA;EAAA,qCAAA;ALupQR;;AI7sQI;ECsDI,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,2CAAA;AL8pQR;;AIptQI;ECsDI,uCAAA;ALkqQR;;AIxtQI;ECsDI,mCAAA;EAAA,sDAAA;EAAA,0DAAA;EAAA,uDAAA;ALyqQR;;AI/tQI;ECsDI,yCAAA;EAAA,yCAAA;EAAA,2CAAA;AL+qQR;;AIruQI;ECsDI,6CAAA;EAAA,6CAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,oDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,2CAAA;EAAA,wDAAA;EAAA,oDAAA;EAAA,oDAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,2DAAA;ALisQR;;AIvvQI;ECsDI,kDAAA;EAAA,iCAAA;ALssQR;;AI5vQI;ECsDI,sDAAA;AL0sQR;;AwB3vQI;EnBiDI,sDAAA;AL8sQR;;AwB1vQI;EnB4CI,sDAAA;ALktQR;;AIxwQI;ECsDI,gCAAA;EAAA,iCAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,uCAAA;EAAA,kDAAA;EAAA,kDAAA;EAAA,qCAAA;EAAA,+CAAA;EAAA,gDAAA;EAAA,2CAAA;EAAA,qDAAA;EAAA,sDAAA;EAAA,gCAAA;EAAA,2CAAA;EAAA,2CAAA;ALquQR;;AI3xQI;ECsDI,qCAAA;EAAA,6BAAA;EAAA,qGAAA;EAAA,+FAAA;AL4uQR;;AyBtxQI;EpB0CI,qCAAA;EAAA,2CAAA;ALivQR;;AyBtxQI;EpBqCI,qCAAA;EAAA,6BAAA;ALsvQR;;AI5yQI;ECsDI,kCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,qCAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,wCAAA;ALiwQR;;AIvzQI;ECsDI,uCAAA;ALqwQR;;AI3zQI;ECsDI,4DAAA;EAAA,oDAAA;AL0wQR;;AIh0QI;ECsDI,mDAAA;EAAA,mDAAA;EAAA,4CAAA;EAAA,0DAAA;EAAA,6CAAA;ALkxQR;;AIx0QI;ECsDI,mDAAA;EAAA,mDAAA;EAAA,uDAAA;EAAA,uCAAA;EAAA,qCAAA;EAAA,8BAAA;AL2xQR;;AIj1QI;ECsDI,2CAAA;EAAA,sHAAA;EAAA,gHAAA;EAAA,0DAAA;EAAA,uGAAA;EAAA,sDAAA;EAAA,6HAAA;EAAA,iEAAA;EAAA,8GAAA;EAAA,oHAAA;EAAA,yEAAA;EAAA,sGAAA;EAAA,0DAAA;EAAA,6GAAA;EAAA,kEAAA;EAAA,0DAAA;EAAA,mDAAA;AL+yQR;;AIr2QI;ECsDI,gCAAA;ALmzQR;;AIz2QI;ECsDI,gDAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,kDAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,yDAAA;EAAA,iDAAA;ALg0QR;;AIt3QI;ECsDI,8CAAA;EAAA,oDAAA;EAAA,oKAAA;EAAA,8KAAA;ALu0QR;;AI73QI;ECsDI,4GAAA;EAAA,uHAAA;EAAA,+EAAA;EAAA,kIAAA;EAAA,+DAAA;EAAA,uEAAA;EAAA,qHAAA;EAAA,wEAAA;EAAA,yGAAA;EAAA,wGAAA;EAAA,wDAAA;EAAA,uDAAA;EAAA,oEAAA;EAAA,uEAAA;EAAA,uEAAA;EAAA,2EAAA;EAAA,mEAAA;EAAA,gEAAA;EAAA,uEAAA;EAAA,2HAAA;EAAA,8DAAA;EAAA,yDAAA;EAAA,kHAAA;EAAA,+EAAA;EAAA,iEAAA;EAAA,qHAAA;EAAA,gHAAA;EAAA,2DAAA;EAAA,mEAAA;ALu2QR;;A0Bj5QM;ErB0CE,4GAAA;EAAA,uHAAA;EAAA,+EAAA;EAAA,kIAAA;EAAA,6EAAA;EAAA,uEAAA;EAAA,qHAAA;EAAA,sFAAA;EAAA,yGAAA;EAAA,wGAAA;EAAA,wDAAA;EAAA,uDAAA;EAAA,oEAAA;EAAA,uEAAA;EAAA,uEAAA;EAAA,2EAAA;EAAA,mEAAA;EAAA,gEAAA;EAAA,uEAAA;EAAA,2HAAA;EAAA,8DAAA;EAAA,yDAAA;EAAA,kHAAA;EAAA,+EAAA;EAAA,iEAAA;EAAA,qHAAA;EAAA,gHAAA;EAAA,2DAAA;EAAA,mEAAA;ALu4QR;A0B56QM;ErBqCE,4GAAA;EAAA,uHAAA;EAAA,+EAAA;EAAA,kIAAA;EAAA,+DAAA;EAAA,uEAAA;EAAA,qHAAA;EAAA,wEAAA;EAAA,yGAAA;EAAA,wGAAA;EAAA,wDAAA;EAAA,uDAAA;EAAA,oEAAA;EAAA,uEAAA;EAAA,uEAAA;EAAA,2EAAA;EAAA,mEAAA;EAAA,gEAAA;EAAA,uEAAA;EAAA,2HAAA;EAAA,8DAAA;EAAA,yDAAA;EAAA,kHAAA;EAAA,+EAAA;EAAA,iEAAA;EAAA,qHAAA;EAAA,gHAAA;EAAA,2DAAA;EAAA,mEAAA;ALs6QR;;A0B15QI;ErBZI,4CAAA;AL06QR;AsBr6QI;EAGE,wCAAA;EACA,wCAAA;EAOA,8CAAA;EACA,+CAAA;EACA,YAAA;AtB+5QN;;AIv+QI;ECsDI,gDAAA;EAAA,yCAAA;EAAA,oDAAA;EAAA,qDAAA;EAAA,uDAAA;EAAA,wDAAA;EAAA,gDAAA;EAAA,iDAAA;AL47QR;;AIl/QI;ECsDI,wBAAA;ALg8QR;;AIt/QI;ECsDI,wCAAA;ALo8QR;;AI1/QI;ECsDI,oCAAA;EAAA,yJAAA;EAAA,6DAAA;EAAA,8CAAA;AL28QR;;AIjgRI;ECsDI,iDAAA;EAAA,yDAAA;EAAA,0DAAA;EAAA,uGAAA;EAAA,wGAAA;EAAA,0GAAA;EAAA,sDAAA;EAAA,6DAAA;EAAA,2DAAA;ALu9QR;;AI7gRI;ECsDI,mDAAA;EAAA,kDAAA;AL49QR;;AIlhRI;ECsDI,6CAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA,0CAAA;ALy+QR;;AI/hRI;ECsDI,mDAAA;EAAA,qDAAA;EAAA,mDAAA;EAAA,qDAAA;ALg/QR;;AItiRI;ECsDI,yBAAA;ALo/QR;;A2BpiRM;EtBgDE,yBAAA;ALw/QR;A2BliRM;EtB0CE,yBAAA;AL2/QR;A2B/hRM;EtBoCE,yBAAA;AL8/QR;;AIpjRI;ECsDI,gCAAA;EAAA,2JAAA;EAAA,mCAAA;ALogRR;;AI1jRI;ECsDI,0DAAA;EAAA,+CAAA;EAAA,uDAAA;EAAA,+CAAA;EAAA,qDAAA;EAAA,6CAAA;AL6gRR;;AInkRI;ECsDI,+CAAA;EAAA,+CAAA;ALkhRR;;AIxkRI;ECsDI,iDAAA;EAAA,kEAAA;EAAA,gEAAA;EAAA,8DAAA;EAAA,4DAAA;EAAA,8DAAA;EAAA,4DAAA;EAAA,oCAAA;EAAA,6CAAA;EAAA,qGAAA;EAAA,sGAAA;EAAA,0DAAA;EAAA,mEAAA;EAAA,yEAAA;EAAA,0DAAA;EAAA,+DAAA;EAAA,+DAAA;EAAA,mEAAA;ALuiRR;;A4BplRI;EvB6CI,+DAAA;EAAA,kEAAA;EAAA,8EAAA;EAAA,8DAAA;EAAA,0EAAA;EAAA,8DAAA;EAAA,0EAAA;ALijRR;;A4BzlRI;EvBwCI,iDAAA;EAAA,kEAAA;EAAA,gEAAA;EAAA,8DAAA;EAAA,4DAAA;EAAA,8DAAA;EAAA,4DAAA;AL2jRR;;AIjnRI;ECsDI,iCAAA;AL+jRR;;AIrnRI;ECsDI,8CAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,2CAAA;EAAA,sDAAA;EAAA,yDAAA;EAAA,0DAAA;ALykRR;;AI/nRI;ECsDI,2CAAA;AL6kRR;;AInoRI;ECsDI,+CAAA;EAAA,uDAAA;ALklRR;;A6B5nRM;ExB0CE,iDAAA;EAAA,yCAAA;ALulRR;A6BznRM;ExBkCE,iDAAA;EAAA,uDAAA;AL2lRR;A6BrnRM;ExB0BE,iDAAA;EAAA,yCAAA;AL+lRR;;AIrpRI;ECsDI,mCAAA;EAAA,iCAAA;ALomRR;;AI1pRI;ECsDI,0CAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,2CAAA;EAAA,oCAAA;AL4mRR;;AIlqRI;ECsDI,4CAAA;EAAA,+CAAA;ALinRR;;AIvqRI;ECsDI,gCAAA;ALqnRR;;AI3qRI;ECsDI,sCAAA;EAAA,+BAAA;EAAA,gCAAA;AL2nRR;;AIjrRI;ECsDI,qCAAA;EAAA,4JAAA;ALgoRR;;AItrRI;ECsDI,kDAAA;ALooRR;;AI1rRI;ECsDI,wCAAA;EAAA,4CAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,uCAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,6CAAA;EAAA,gKAAA;EAAA,2CAAA;EAAA,wKAAA;EAAA,uKAAA;EAAA,+CAAA;EAAA,uKAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0KAAA;EAAA,8CAAA;EAAA,sCAAA;EAAA,yCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,mDAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,0CAAA;ALwqRR;;AI9tRI;ECsDI,0CAAA;EAAA,sGAAA;EAAA,uGAAA;EAAA,mEAAA;EAAA,mDAAA;EAAA,mDAAA;EAAA,yDAAA;EAAA,qDAAA;EAAA,0FAAA;EAAA,0DAAA;EAAA,yGAAA;EAAA,iEAAA;EAAA,qEAAA;EAAA,qDAAA;EAAA,qDAAA;EAAA,2DAAA;EAAA,wDAAA;EAAA,uDAAA;EAAA,4FAAA;EAAA,4DAAA;EAAA,6CAAA;EAAA,yGAAA;EAAA,0GAAA;EAAA,sEAAA;EAAA,sDAAA;EAAA,sDAAA;EAAA,4DAAA;EAAA,wDAAA;EAAA,6FAAA;EAAA,6DAAA;EAAA,qGAAA;EAAA,iEAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,uDAAA;EAAA,mDAAA;EAAA,wFAAA;EAAA,wDAAA;EAAA,yCAAA;EAAA,qGAAA;EAAA,sGAAA;EAAA,kEAAA;EAAA,kDAAA;EAAA,kDAAA;EAAA,wDAAA;EAAA,oDAAA;EAAA,yFAAA;EAAA,yDAAA;AL2tRR;;AqBjwRM;;;;;EhBsCE,4CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gFAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,+EAAA;EAAA,+CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,2EAAA;EAAA,2CAAA;ALqvRR;AqBtxRM;;;;;EhBiCE,4CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gFAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,+EAAA;EAAA,+CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,2EAAA;EAAA,2CAAA;AL8wRR;AqB1yRM;;;;;EhB4BE,4CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,gFAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,+EAAA;EAAA,+CAAA;EAAA,2CAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,2EAAA;EAAA,2CAAA;ALuyRR;;AI71RI;ECsDI,0CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,kDAAA;EAAA,wCAAA;EAAA,6CAAA;EAAA,yCAAA;EAAA,8CAAA;ALozRR;;AI12RI;ECsDI,qJAAA;EAAA,8BAAA;EAAA,iCAAA;EAAA,8JAAA;EAAA,yCAAA;EAAA,wCAAA;EAAA,oKAAA;EAAA,oKAAA;EAAA,uKAAA;EAAA,2JAAA;EAAA,2JAAA;EAAA,8JAAA;EAAA,2JAAA;EAAA,oCAAA;EAAA,uCAAA;EAAA,iKAAA;EAAA,iKAAA;EAAA,oKAAA;ALy0RR;;AI/3RI;ECsDI,gCAAA;EAAA,kGAAA;EAAA,mGAAA;EAAA,yDAAA;EAAA,yCAAA;EAAA,+CAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,gFAAA;EAAA,sCAAA;EAAA,wGAAA;EAAA,yGAAA;EAAA,+DAAA;EAAA,+CAAA;EAAA,qDAAA;EAAA,+CAAA;EAAA,iDAAA;EAAA,sFAAA;EAAA,sDAAA;EAAA,gDAAA;ALg2RR;;AuB34RM;ElB2CE,kCAAA;EAAA,iCAAA;EAAA,oEAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,wEAAA;EAAA,wCAAA;EAAA,kCAAA;AL22RR;AuBj5RM;ElBsCE,kCAAA;EAAA,iCAAA;EAAA,oEAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,wEAAA;EAAA,wCAAA;EAAA,kCAAA;ALq3RR;AuBt5RM;ElBiCE,kCAAA;EAAA,iCAAA;EAAA,oEAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,wEAAA;EAAA,wCAAA;EAAA,kCAAA;AL+3RR;;AIr7RI;ECsDI,2CAAA;EAAA,qCAAA;ALo4RR;;AI17RI;ECsDI,iCAAA;EAAA,sCAAA;EAAA,yCAAA;AL04RR;;AIh8RI;ECsDI,+FAAA;EAAA,iEAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,qCAAA;EAAA,mDAAA;EAAA,wFAAA;EAAA,wDAAA;ALq5RR;;AsBj8RM;EjB4CE,qCAAA;EAAA,4CAAA;EAAA,4EAAA;AL25RR;AsBl8RM;EjBuCE,qCAAA;EAAA,4CAAA;EAAA,4EAAA;ALg6RR;AsBl8RM;EjBkCE,qCAAA;EAAA,4CAAA;EAAA,4EAAA;ALq6RR;;AI39RI;ECsDI,6CAAA;ALy6RR;;AsBp6RI;EAGE,wCAAA;EACA,wCAAA;EAOA,8CAAA;EACA,+CAAA;EACA,aAAA;AtB+5RN;;AIv+RI;ECsDI,+CAAA;EAAA,uDAAA;ALs7RR;;A6Bh+RM;ExB0CE,iDAAA;EAAA,yCAAA;AL27RR;A6B79RM;ExBkCE,iDAAA;EAAA,uDAAA;AL+7RR;A6Bz9RM;ExB0BE,iDAAA;EAAA,yCAAA;ALm8RR;;AIz/RI;ECsDI,mCAAA;EAAA,iCAAA;ALw8RR;;AI9/RI;ECsDI,kDAAA;EAAA,iCAAA;AL68RR;;AIngSI;ECsDI,sDAAA;ALi9RR;;AwBlgSI;EnBiDI,sDAAA;ALq9RR;;AwBjgSI;EnB4CI,sDAAA;ALy9RR;;A8BniSA;EC4BE,0BhCXK;EgCYL,cAAA;EACA,iBAAA;ED5BA,eAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,6CAAA;EACA,oCAAA;EACA,sDAAA;EACA,0DAAA;EACA,wDAAA;EACA,8CAAA;EACA,kDAAA;EACA,gDAAA;A9BwiSF;;A8BriSA;ECYE,0BhCXK;EgCYL,cAAA;EACA,iBAAA;EDZA,oCAAA;EACA,YAAA;A9B0iSF;;A8BtiSA;EACE,YAAA;A9ByiSF;;AAhkSA;EACE,6BDYQ;ACujSV;AAjkSE;EACE,kBAAA;AAmkSJ;AAjkSI;EACE,0BDSC;ECRD,gBAAA;AAmkSN;AAhkSI;EACE,cAAA;AAkkSN;AA/jSE;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;AAikSJ;AA/jSI;EACE,0BDTC;ECUD,gBAAA;EACA,YAAA;AAikSN;AA9jSI;EACE,kBAAA;EACA,aAAA;AAgkSN;AA7jSI;EACE,gDAAA;EACA,eAAA;AA+jSN;AA5jSI;EACE,oBAAA;EACA,kBAAA;EAEA,yCAAA;AA6jSN;AA5jSM;EACE,mBAAA;AA8jSR;AAzjSE;EACE,aAAA;EACA,uBAAA;EAcA,6HAAA;AA8iSJ;AA1jSI;EACE,mBAAA;EACA,qBAAA;EACA,aAAA;AA4jSN;AAzjSI;EACE,qCAAA;EACA,qBGvBO;EHwBP,oCGlEE;EHmEF,gBAAA;AA2jSN;AAxjSI;EACE,aAAA;AA0jSN;AAvjSI;EACE,gCGjCO;EHkCP,yBG5EE;AHqoSR;AAtjSI;EACE,oCGxDQ;EHyDR,yBGhEK;AHwnSX;;AAnjSA;EACE,cAAA;EACA,YAAA;EACA,8BG1Da;AHgnSf;;AAnjSA;EACE,8BG7Da;EH8Db,0BAAA;AAsjSF","sourcesContent":["/* Toyota costumers theme*/\n@use '@angular/material' as mat;\n\n//Importing custom colors and angular theming core\n@import \"../fonts/toyota-fonts\";\n@import \"../colors/font_color_variables\";\n@import \"../colors/admin_font_color_variables.scss\";\n@import \"utilities\";\n@import \"admin\";\n\n$toyota-typography: mat.m2-define-typography-config($font-family: \"toyota-book\"\n);\n\n//Importing Angular mixin for themes\n// TODO(v15): As of v15 mat.legacy-core no longer includes default typography styles.\n//  The following line adds:\n//    1. Default typography styles for all components\n//    2. Styles for typography hierarchy classes (e.g. .mat-headline-1)\n//  If you specify typography styles for the components you use elsewhere, you should delete this line.\n//  If you don't need the default component typographies but still want the hierarchy styles,\n//  you can delete this line and instead use:\n//    `@include mat.legacy-typography-hierarchy($toyota-typography);`\n@include mat.all-component-typographies($toyota-typography);\n@include mat.elevation-classes();\n@include mat.app-background();\n\n//General palettes light for Toyota\n$toyota-app-primary: mat.m2-define-palette(mat.$m2-light-blue-palette);\n$toyota-app-accent: mat.m2-define-palette(mat.$m2-green-palette);\n$toyota-app-warn: mat.m2-define-palette(mat.$m2-red-palette);\n\n//General palettes dark for Toyota\n$toyota-app-primary-dark: mat.m2-define-palette(mat.$m2-grey-palette);\n$toyota-app-accent-dark: mat.m2-define-palette(mat.$m2-teal-palette);\n$toyota-app-warn-dark: mat.m2-define-palette(mat.$m2-orange-palette);\n\n//General colors\n$vehicle-heading-color: $dark_grey_2;\n\n//Custom elements for Toyota\n$toyota-buttons-primary: mat.m2-define-palette(mat.$m2-light-blue-palette);\n$toyota-buttons-accent: mat.m2-define-palette(mat.$m2-red-palette, A700, A200, A100);\n\n$toyota-toolbar-primary: mat.m2-define-palette(mat.$m2-blue-grey-palette, 900);\n$toyota-toolbar-accent: mat.m2-define-palette(mat.$m2-green-palette);\n\n$toyota-spinner-primary: mat.m2-define-palette(mat.$m2-red-palette);\n$toyota-spinner-accent: mat.m2-define-palette(mat.$m2-green-palette);\n\n//General theme for Toyota\n$app-theme: mat.m2-define-light-theme((\n  color: (\n    primary: $toyota-app-primary,\n    accent: $toyota-app-accent,\n    warn: $toyota-app-warn,\n  ),\n  typography: $toyota-typography,\n  density: 0,\n));\n$app-dark: mat.m2-define-dark-theme((\n  color: (\n    primary: $toyota-app-primary-dark,\n    accent: $toyota-app-accent-dark,\n    warn: $toyota-app-warn-dark,\n  ),\n  typography: $toyota-typography,\n  density: 0,\n));\n$toyota-buttons: mat.m2-define-light-theme((\n  color: (\n    primary: $toyota-buttons-primary,\n    accent: $toyota-buttons-accent,\n  ),\n));\n$toyota-toolbar: mat.m2-define-light-theme((\n  color: (\n    primary: $toyota-toolbar-primary,\n    accent: $toyota-toolbar-accent,\n  ),\n));\n$toyota-spinner: mat.m2-define-light-theme((\n  color: (\n    primary: $toyota-spinner-primary,\n    accent: $toyota-spinner-accent,\n  ),\n));\n\n//Declaration of the themes\n@include mat.all-component-themes($app-theme);\n@include mat.button-theme($toyota-buttons);\n@include mat.fab-theme($toyota-buttons);\n@include mat.icon-button-theme($toyota-buttons);\n@include mat.toolbar-theme($toyota-toolbar);\n@include mat.progress-spinner-theme($toyota-spinner);\n","@font-face {\n  font-family: 'toyota-bold';\n  src: url('/fonts/ToyotaType-Bold.ttf') format('truetype')\n}\n@font-face {\n  font-family: 'toyota-book';\n  src: url('/fonts/ToyotaType-Book.ttf') format('truetype')\n}\n@font-face {\n  font-family: 'toyota-regular';\n  src: url('/fonts/ToyotaType-Regular.ttf') format('truetype')\n}\n// Book families\n$book: 'toyota-book';\n\n// Regular families\n$regular: 'toyota-regular';\n\n// Bold families\n$bold: 'toyota-bold';\n","@import \"theme\";\n@import \"../../styles/common.scss\";\n\n.rental_ev_modal_conatainer {\n  font-family: $regular;\n\n  .title_container {\n    text-align: center;\n\n    .title {\n      font-family: $bold;\n      font-size: 1.5em;\n    }\n\n    .description {\n      font-size: 1em;\n    }\n  }\n  .dropdown_container {\n    text-align: center;\n    width: 5.25em;\n    margin-top: 2em;\n    margin-bottom: 3.5em;\n    margin-left: auto;\n    margin-right: auto;\n    caret-color: transparent;\n\n    .selected_value {\n      font-family: $bold;\n      font-size: 1.5em;\n      width: 1.5em;\n    }\n\n    .arrow_drop_down_icon {\n      position: relative;\n      right: -0.8em;\n    }\n\n    .selected_Value_container {\n      border-bottom: 0.0625em solid $light_grey11;\n      cursor: pointer;\n    }\n\n    .options_container {\n      max-height: 9.6875em;\n      overflow-y: scroll;\n\n      border: 0.0625em solid $light_grey11;\n      ::ng-deep .mat-mdc-option{\n        padding-left: 1.5em;\n      }\n    }\n  }\n\n  .actions_container {\n    display: flex;\n    justify-content: center;\n\n    button {\n      margin-right: 1.5em;\n      border-radius: 0.25em;\n      outline: none;\n    }\n\n    .cancel-btn , .cancel-btn:hover {\n      border: 0.0625em solid $status_red;\n      color: $status_red;\n      background-color: $white;\n      font-weight: 600;\n    }\n    /* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version. */\n    ::ng-deep .mat-button-focus-overlay {\n      display: none;\n    }\n\n    .confirm-btn {\n      background-color: $status_red;\n      color: $white;\n    }\n\n    .disabled-confirm-btn {\n      background-color: $light_grey11;\n      color: $text_grey;\n    }\n  }\n}\n\n::-webkit-scrollbar {\n  height: 0.75em;\n  width: 0.50em;\n  background: $light_grey12;\n}\n\n::-webkit-scrollbar-thumb {\n  background: $light_grey13;\n  -webkit-border-radius: 1ex;\n}\n\n","// Utilities for the portal\n\n$left-gutter-responsive: 8%;\n$left-gutter-desktop: 8%;\n$right-gutter-responsive: 8%;\n$right-gutter-desktop: 8%;\n\n// Breakpoint for small devices\n@mixin responsive-screen {\n  @media only screen and (max-width: 767px) {\n    @content;\n  }\n}\n\n// Breakpoint for desktop\n@mixin desktop-screen {\n  @media only screen and (min-width: 768px) {\n    @content;\n  }\n}\n\n// Left gutter for the portal\n@mixin left-gutter() {\n  padding-left: $left-gutter-responsive;\n\n  @include desktop-screen {\n    padding-left: $left-gutter-desktop;\n  }\n}\n\n// Right gutter for the portal\n@mixin right-gutter() {\n  padding-right: $right-gutter-responsive;\n\n  @include desktop-screen {\n    padding-right: $right-gutter-desktop;\n  }\n}\n\n//common class for tooltips\n::ng-deep .link__tooltip {\n  padding: 1em;\n  width: auto;\n  height: auto;\n  border-radius: 0.2em;\n  font-size: 1em;\n  line-height: 1.5;\n  text-align: center;\n}\n\n// css for print agreement page\n@media only print {\n  * {\n    margin: 0;\n    padding: 0;\n    font-size: 1em;\n  }\n  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/\n  ::ng-deep .mat-select-value-text {\n    display: none;\n  }\n\n  ::ng-deep .message__title,\n  .message__description {\n    display: none;\n  }\n\n  ::ng-deep .search-section {\n    display: none;\n  }\n\n  ::ng-deep .print__confirmation {\n    display: none;\n  }\n\n  ::ng-deep .button__confirmation {\n    display: none;\n  }\n\n  .mat-mdc-card {\n    box-shadow: none;\n  }\n}\n\n.half-width {\n  width: 50% !important;\n}\n\n.full-width {\n  width: 100% !important;\n}\n\n.spacer {\n    flex: 1 1 auto;\n}\n\n.bold {\n  font-weight: $bold;\n}","// Admin portal global styles\n\n@import \"../../styles/colors/admin_font_color_variables.scss\";\n@import \"../colors/palette.scss\";\n@import \"../fonts/toyota-fonts.scss\";\n\n.admin-card {\n    height: 100%;\n\n    .card-title {\n        color: $red;\n        border-bottom: 0.01em solid $light_grey1;\n        padding: 1em 1.3em 0.5em;\n        font-size: 1.2em;\n        font-weight: bold;\n        display: flex;\n        font-family: $regular;\n    }\n\n    .card-body {\n        padding: 1em 1em;\n    }\n}\n\n.address-row {\n    mat-form-field {\n        width: calc(100% / 3 - 2em);\n    }\n}\n\n.card-footer {\n    padding: 0 1em;\n    font-size: 0.7em;\n    \n    .card-footer-title {\n        font-weight: bold;\n    }\n}\n\n.customer-state * {\n    color: black !important;\n}\n\n.save-button {\n  padding: 0em 0em .3em;\n  background-color: $admin-default!important;\n  color: $white!important;\n}\n\n.disabled-save-button {\n  color: $white !important;\n  opacity: 0.6;\n}\n","//white\n$white: rgb(255, 255, 255);\n$dull_white: rgb(250, 250, 250);\n$white_2:rgb(242, 242, 242);\n\n// Grey Colors\n$grey: rgb(118, 118, 118);\n$dark_grey:rgb(33, 33, 33);\n$charcoal_gray: rgb(49, 56, 58);\n$content_grey: rgb(41, 45, 48);\n$dark_grey_2: rgb(34, 34, 34);\n$light_grey1: rgba(248, 248, 248, 0.8);\n$light_grey: rgba(0, 0, 0, 0.1);\n$light_grey2: rgba(0, 0, 0, 0.2);\n$light_grey3: rgb(176, 173, 171);\n$light_grey4: rgb(238, 238, 238);\n$charcoal_gray_transparency: rgba(49, 56, 58, 0.1);\n$black_grey:rgb(33, 13, 13);\n$text_grey:rgb(138, 138, 138);\n$warm_grey:rgb(155, 155, 155);\n$light_grey5: rgb(222, 222, 222);\n$light_grey6: rgb(181, 181, 181);\n$light_grey7: rgb(197, 192, 192);\n$light_grey8:rgb(226, 222, 222);\n$light_grey9:rgb(205, 189, 189);\n$light_grey11:rgb(216, 216, 216);\n$light_grey12:rgb(240, 240, 240);\n$light_grey13:rgb(182,182,182);\n$bg_grey:rgb(245, 245, 246);\n$light_shade_grey:rgb(170,170,170);\n$light_grey_3: rgb(207,207,207);\n$light_grey10: rgb(165, 165, 165);\n$light_grey12: rgb(242, 242, 242);\n$light_grey13: rgb(217, 217, 217);\n// Red Colors\n$toyota_red: rgb(180, 57, 53);\n$red: rgb(255, 5, 0);\n$toyota_red_light: rgba(180, 57, 53, 0.4);\n$red_transparency: rgba(255, 0, 0, 0.1);\n$red_transparency2: rgba(255, 0, 0, 0.2);\n$dark_red:rgb(217, 37, 42);\n$customer_invalid_red: rgb(255, 5, 0);\n$session_timeout_red: rgb(235, 10, 30);\n$status_red: rgb(204, 0, 0);\n$banner_red:rgb(200,0,0);\n// orange\n$orange: rgb(249, 130, 5);\n// black\n$black: rgb(0, 0, 0);\n$black_grey:rgb(74, 74, 74); \t\n$black_grey2:rgb(41, 45, 48);\n// Green\n$dark_green:rgb(48, 120, 58);\n$green: rgb(26, 151, 105);\n$medium_green:rgb(57, 181, 74);\n$green_transparency2: rgba(26, 151, 105, 0.3);\n$light_green: rgba(39, 170, 122, 0.2);\n// Yellow\n$non-telematics-yellow: rgba(255, 212, 0, 1);\n$yellow: rgb(255,255,0);\n//pink\n$pink:rgb(253, 230, 232);\n// Opacities and compositions\n$black-transparency: rgba($black, 0.87);\n$grey_transparency: rgba(0, 0, 0, 0.5);\n$transparent: rgba(0, 0, 0, 0);\n$edit_icon_color: rgb(11, 100, 255);\n$cornflower_blue: rgb(100, 149, 237);\n$blue: rgba(0, 126, 255, 1);\n\n","@use 'sass:string';\n@use 'sass:map';\n@use 'sass:meta';\n\n/// Whether our theming API is using --sys- variables for color tokens.\n$use-system-color-variables: false;\n\n/// Whether our theming API is using --sys- variables for typography tokens.\n$use-system-typography-variables: false;\n\n/// Include content under the current selector (&) or the document root if there is no current\n/// selector.\n/// @param {String} $root [html] The default root selector to use when there is no current selector.\n/// @output The given content under the current selector, or root selector if there is no current\n///     selector.\n/// @content Content to output under the current selector, or root selector if there is no current\n///     selector.\n@mixin current-selector-or-root($root: html) {\n  @if & {\n    @content;\n  }\n  @else {\n    #{$root} {\n      @content;\n    }\n  }\n}\n\n/// A version of the standard `map.merge` function that takes a variable number of arguments.\n/// Each argument is merged into the final result from left to right.\n/// @param {List} $maps The maps to combine with map.merge\n/// @return {Map} The combined result of successively calling map.merge with each parameter.\n@function merge-all($maps...) {\n  $result: ();\n  @each $map in $maps {\n    $result: map.merge($result, $map);\n  }\n  @return $result;\n}\n\n/// A version of the standard `map.deep-merge` function that takes a variable number of arguments.\n/// Each argument is deep-merged into the final result from left to right.\n/// @param {List} $maps The maps to combine with map.deep-merge\n/// @return {Map} The combined result of successively calling map.deep-merge with each parameter.\n@function deep-merge-all($maps...) {\n  $result: ();\n  @each $map in $maps {\n    $result: map.deep-merge($result, $map);\n  }\n  @return $result;\n}\n\n// Returns whether the $value is a CSS variable name based on whether it's a string prefixed\n// by \"--\".\n@function is-css-var-name($value) {\n  @return meta.type-of($value) == string and string.index($value, '--') == 1;\n}\n","@use '../style/sass-utils';\n@use 'sass:list';\n@use 'sass:map';\n@use 'sass:string';\n\n// Creates a CSS variable, including the fallback if provided.\n@function _create-var($name, $fallback: null) {\n  @if ($fallback) {\n    @return var($name, $fallback);\n  } @else {\n    @return var($name);\n  }\n}\n\n// Returns a list of overrides for the given M3 get-tokens mixin and prefix. Each token has its\n// prefix removed since the overrides API expects its absence. The returned map includes \"all\" for\n// all override tokens, and also the subsets with keys base, color, typography, and density.\n@function get-overrides($tokens, $prefix) {\n  $base: remove-token-prefixes(map.get($tokens, base), $prefix);\n  $color: remove-token-prefixes(map.get($tokens, color), $prefix);\n  $typography: remove-token-prefixes(map.get($tokens, typography), $prefix);\n  $density: remove-token-prefixes(map.get($tokens, density), $prefix);\n  $all: ();\n  @each $map in ($base, $color, $typography, $density) {\n    $all: map.merge($all, $map);\n  }\n\n  @return (\n    all: $all,\n    base: $base,\n    color: $color,\n    typography: $typography,\n    density: $density,\n  );\n}\n\n// Removes a prefix from each component token in the provided map of prefixed tokens.\n@function remove-token-prefixes($prefixed-tokens: (), $prefix) {\n  $tokens: ();\n  @each $prefixed-token, $value in $prefixed-tokens {\n    $token: string.slice($prefixed-token, string.length($prefix) + 2);\n    $tokens: map.set($tokens, $token, $value);\n  }\n  @return $tokens;\n}\n\n// Returns the token slot value.\n// Accepts an optional fallback parameter to include in the CSS variable.\n// If $fallback is `true`, then use the tokens map to get the fallback.\n@function slot($token, $fallbacks, $fallback: null) {\n  // Fallbacks are a map of base, color, typography, and density tokens. To simplify\n  // lookup, flatten these token groups into a single map.\n  $fallbacks-flattened: ();\n  @each $tokens in map.values($fallbacks) {\n    @each $token, $value in $tokens {\n      $fallbacks-flattened: map.set($fallbacks-flattened, $token, $value);\n    }\n  }\n  @if not map.has-key($fallbacks-flattened, $token) {\n    @error 'Token #{$token} does not exist. Configured tokens are:' +\n        #{map.keys($fallbacks-flattened)};\n  }\n\n  $sys-fallback: map.get($fallbacks-flattened, $token);\n  @if (sass-utils.is-css-var-name($sys-fallback)) {\n    $sys-fallback: _create-var($sys-fallback, $fallback);\n  }\n\n  @return _create-var(--mat-#{$token}, $sys-fallback);\n}\n\n// Outputs a map of token values as CSS variable definitions.\n@mixin values($tokens) {\n  @include sass-utils.current-selector-or-root() {\n    @each $key, $value in $tokens {\n      @if $value != null {\n        --mat-#{$key}: #{$value};\n      }\n    }\n  }\n}\n\n/// Emits new token values for the given token overrides.\n/// Verifies that the overrides passed in are valid tokens.\n/// New token values are emitted under the current selector or root.\n@mixin batch-create-token-values($overrides: (), $namespace-configs) {\n  @include sass-utils.current-selector-or-root() {\n    $prefixed-name-data: ();\n    $all-names: ();\n\n    @each $config in $namespace-configs {\n      $namespace: map.get($config, namespace);\n      $prefix: if(map.has-key($config, prefix), map.get($config, prefix), '');\n      $tokens: map.get(map.get($config, tokens), all);\n      @each $name, $value in $tokens {\n        $prefixed-name: $prefix + $name;\n        $all-names: list.append($all-names, $prefixed-name, $separator: comma);\n        $prefixed-name-data: map.set($prefixed-name-data, $prefixed-name, ($namespace, $name));\n      }\n    }\n\n    @each $name, $value in $overrides {\n      @if map.has-key($prefixed-name-data, $name) {\n        $data: map.get($prefixed-name-data, $name);\n        $namespace: list.nth($data, 1);\n        $name: list.nth($data, 2);\n        $prefixed-name: $namespace + '-' + $name;\n        @include values(($prefixed-name: $value));\n      } @else {\n        @error #{'Invalid token name `'}#{$name}#{'`. '}#{'Valid tokens are: '}#{$all-names};\n      }\n    }\n  }\n}\n","@use 'sass:list';\n@use 'sass:map';\n@use 'sass:string';\n@use 'typography-utils';\n@use '../theming/inspection';\n\n// Definition and versioning functions live in their own files to avoid circular dependencies, but\n// we re-export them here so that historical imports from this file continue to work without needing\n// to be updated.\n@forward './versioning';\n\n@mixin typography-hierarchy($theme, $selector: '.mat-typography', $back-compat: false) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include _m3-typography-hierarchy($theme, $selector, $back-compat);\n  }\n  @else {\n    @include _m2-typography-hierarchy($theme, $selector);\n  }\n}\n\n@function _get-selector($selectors, $prefix) {\n  $result: ();\n  @each $selector in $selectors {\n    // Don't add \"naked\" tag selectors, and don't nest prefix selector.\n    @if string.index($selector, '.') == 1 {\n      $result: list.append($result, $selector, $separator: comma);\n    }\n    // Don't nest the prefix selector in itself.\n    @if $selector != $prefix {\n      $result: list.append($result, '#{$prefix} #{$selector}', $separator: comma);\n    }\n  }\n  @return $result;\n}\n\n@mixin _m3-typography-level($theme, $selector-prefix, $level, $selectors, $margin: null) {\n  #{_get-selector($selectors, $selector-prefix)} {\n    // TODO(mmalerba): When we expose system tokens as CSS vars, we should change this to emit token\n    //  slots.\n    font: inspection.get-theme-typography($theme, $level, font);\n    letter-spacing: inspection.get-theme-typography($theme, $level, letter-spacing);\n    @if $margin != null {\n      margin: 0 0 $margin;\n    }\n  }\n}\n\n@mixin _m3-typography-hierarchy($theme, $selector-prefix, $add-m2-selectors) {\n $levels: (\n   display-large: (\n     selectors: ('.mat-display-large', 'h1'),\n     m2-selectors: ('.mat-h1', '.mat-headline-1'),\n     margin: 0.5em\n   ),\n   display-medium: (\n     selectors: ('.mat-display-medium', 'h2'),\n     m2-selectors: ('.mat-h2', '.mat-headline-2'),\n     margin: 0.5em\n   ),\n   display-small: (\n     selectors: ('.mat-display-small', 'h3'),\n     m2-selectors: ('.mat-h3', '.mat-headline-3'),\n     margin: 0.5em\n   ),\n   headline-large: (\n     selectors: ('.mat-headline-large', 'h4'),\n     m2-selectors: ('.mat-h4', '.mat-headline-4'),\n     margin: 0.5em\n   ),\n   headline-medium: (\n     selectors: ('.mat-headline-medium', 'h5'),\n     m2-selectors: ('.mat-h5', '.mat-headline-5'),\n     margin: 0.5em\n   ),\n   headline-small: (\n     selectors: ('.mat-headline-small', 'h6'),\n     m2-selectors: ('.mat-h6', '.mat-headline-6'),\n     margin: 0.5em\n   ),\n   title-large: (\n     selectors: ('.mat-title-large'),\n     m2-selectors: ('.mat-subtitle-1'),\n   ),\n   title-medium: (\n     selectors: ('.mat-title-medium'),\n     m2-selectors: ('.mat-subtitle-2'),\n   ),\n   title-small: (\n     selectors: ('.mat-title-small')\n   ),\n   body-large: (\n     selectors: ('.mat-body-large', $selector-prefix),\n     m2-selectors: ('.mat-body', '.mat-body-strong', '.mat-body-2'),\n   ),\n   body-medium: (\n     selectors: ('.mat-body-medium')\n   ),\n   body-small: (\n     selectors: ('.mat-body-small')\n   ),\n   label-large: (\n     selectors: ('.mat-label-large')\n   ),\n   label-medium: (\n     selectors: ('.mat-label-medium')\n   ),\n   label-small: (\n     selectors: ('.mat-label-small'),\n     m2-selectors: ('.mat-small', '.mat-caption')\n   ),\n );\n\n  @each $level, $options in $levels {\n    @if $add-m2-selectors {\n      $options: map.set($options, selectors,\n          list.join(map.get($options, selectors), map.get($options, m2-selectors) or ()));\n    }\n    $options: map.remove($options, m2-selectors);\n\n    // Apply styles for the level.\n    @include _m3-typography-level($theme, $selector-prefix, $level, $options...);\n\n    // Also style <p> inside body-large.\n    @if $level == body-large {\n      #{_get-selector(map.get($options, selectors), $selector-prefix)} {\n        p {\n          margin: 0 0 0.75em;\n        }\n      }\n    }\n  }\n}\n\n/// Emits baseline typographic styles based on a given config.\n/// @param {Map} $config-or-theme A typography config for an entire theme.\n/// @param {String} $selector Ancestor selector under which native elements, such as h1, will\n///     be styled.\n@mixin _m2-typography-hierarchy($theme, $selector) {\n  // Note that it seems redundant to prefix the class rules with the `$selector`, however it's\n  // necessary if we want to allow people to overwrite the tag selectors. This is due to\n  // selectors like `#{$selector} h1` being more specific than ones like `.mat-title`.\n  .mat-h1,\n  .mat-headline-5,\n  #{$selector} .mat-h1,\n  #{$selector} .mat-headline-5,\n  #{$selector} h1 {\n    font: inspection.get-theme-typography($theme, headline-5, font);\n    letter-spacing: inspection.get-theme-typography($theme, headline-5, letter-spacing);\n    margin: 0 0 16px;\n  }\n\n  .mat-h2,\n  .mat-headline-6,\n  #{$selector} .mat-h2,\n  #{$selector} .mat-headline-6,\n  #{$selector} h2 {\n    font: inspection.get-theme-typography($theme, headline-6, font);\n    letter-spacing: inspection.get-theme-typography($theme, headline-6, letter-spacing);\n    margin: 0 0 16px;\n  }\n\n  .mat-h3,\n  .mat-subtitle-1,\n  #{$selector} .mat-h3,\n  #{$selector} .mat-subtitle-1,\n  #{$selector} h3 {\n    font: inspection.get-theme-typography($theme, subtitle-1, font);\n    letter-spacing: inspection.get-theme-typography($theme, subtitle-1, letter-spacing);\n    margin: 0 0 16px;\n  }\n\n  .mat-h4,\n  .mat-body-1,\n  #{$selector} .mat-h4,\n  #{$selector} .mat-body-1,\n  #{$selector} h4 {\n    font: inspection.get-theme-typography($theme, body-1, font);\n    letter-spacing: inspection.get-theme-typography($theme, body-1, letter-spacing);\n    margin: 0 0 16px;\n  }\n\n  // Note: the spec doesn't have anything that would correspond to h5 and h6, but we add these for\n  // consistency. The font sizes come from the Chrome user agent styles which have h5 at 0.83em\n  // and h6 at 0.67em.\n  .mat-h5,\n  #{$selector} .mat-h5,\n  #{$selector} h5 {\n    @include typography-utils.font-shorthand(\n       // calc is used here to support css variables\n      calc(#{inspection.get-theme-typography($theme, body-2, font-size)} * 0.83),\n      inspection.get-theme-typography($theme, body-2, font-weight),\n      inspection.get-theme-typography($theme, body-2, line-height),\n      inspection.get-theme-typography($theme, body-2, font-family)\n    );\n\n    margin: 0 0 12px;\n  }\n\n  .mat-h6,\n  #{$selector} .mat-h6,\n  #{$selector} h6 {\n    @include typography-utils.font-shorthand(\n       // calc is used here to support css variables\n      calc(#{inspection.get-theme-typography($theme, body-2, font-size)} * 0.67),\n      inspection.get-theme-typography($theme, body-2, font-weight),\n      inspection.get-theme-typography($theme, body-2, line-height),\n      inspection.get-theme-typography($theme, body-2, font-family)\n    );\n\n    margin: 0 0 12px;\n  }\n\n  .mat-body-strong,\n  .mat-subtitle-2,\n  #{$selector} .mat-body-strong,\n  #{$selector} .mat-subtitle-2 {\n    font: inspection.get-theme-typography($theme, subtitle-2, font);\n    letter-spacing: inspection.get-theme-typography($theme, subtitle-2, letter-spacing);\n  }\n\n  .mat-body,\n  .mat-body-2,\n  #{$selector} .mat-body,\n  #{$selector} .mat-body-2,\n  #{$selector} {\n    font: inspection.get-theme-typography($theme, body-2, font);\n    letter-spacing: inspection.get-theme-typography($theme, body-2, letter-spacing);\n\n    p {\n      margin: 0 0 12px;\n    }\n  }\n\n  .mat-small,\n  .mat-caption,\n  #{$selector} .mat-small,\n  #{$selector} .mat-caption {\n    font: inspection.get-theme-typography($theme, caption, font);\n    letter-spacing: inspection.get-theme-typography($theme, caption, letter-spacing);\n  }\n\n  .mat-headline-1,\n  #{$selector} .mat-headline-1 {\n    font: inspection.get-theme-typography($theme, headline-1, font);\n    letter-spacing: inspection.get-theme-typography($theme, headline-1, letter-spacing);\n    margin: 0 0 56px;\n  }\n\n  .mat-headline-2,\n  #{$selector} .mat-headline-2 {\n    font: inspection.get-theme-typography($theme, headline-2, font);\n    letter-spacing: inspection.get-theme-typography($theme, headline-2, letter-spacing);\n    margin: 0 0 64px;\n  }\n\n  .mat-headline-3,\n  #{$selector} .mat-headline-3 {\n    font: inspection.get-theme-typography($theme, headline-3, font);\n    letter-spacing: inspection.get-theme-typography($theme, headline-3, letter-spacing);\n    margin: 0 0 64px;\n  }\n\n  .mat-headline-4,\n  #{$selector} .mat-headline-4 {\n    font: inspection.get-theme-typography($theme, headline-4, font);\n    letter-spacing: inspection.get-theme-typography($theme, headline-4, letter-spacing);\n    margin: 0 0 64px;\n  }\n}\n","@use 'sass:list';\n\n/// Outputs the shorthand `font` CSS property, based on a set of typography values. Falls back to\n/// the individual properties if a value that isn't allowed in the shorthand is passed in.\n/// @param {String} $font-size The font-size value.\n/// @param {String | Number} $font-weight The font-weight value.\n/// @param {String | Number} $line-height The line-height value.\n/// @param {String} $font-family The font-family value.\n/// @returns {String} The `font` shorthand value combining the given parts.\n@mixin font-shorthand($font-size, $font-weight, $line-height, $font-family) {\n  // If any of the values are set to `inherit`, we can't use the shorthand\n  // so we fall back to passing in the individual properties.\n  @if ($font-size == inherit or\n       $font-weight == inherit or\n       $line-height == inherit or\n       $font-family == inherit or\n       $font-size == null or\n       $font-weight == null or\n       $line-height == null or\n       $font-family == null) {\n\n    font-size: $font-size;\n    font-weight: $font-weight;\n    line-height: $line-height;\n    font-family: $font-family;\n  }\n  @else {\n    // Otherwise use the shorthand `font`, because it's the least amount of bytes.\n    font: $font-weight list.slash($font-size, $line-height) $font-family;\n  }\n}\n","@use 'sass:color';\n@use './m2-chip';\n@use './m3-chip';\n@use '../core/tokens/token-utils';\n@use '../core/theming/inspection';\n@use '../core/typography/typography';\n@use 'sass:map';\n\n/// Outputs base theme styles (styles not dependent on the color, typography, or density settings)\n/// for the mat-chips.\n/// @param {Map} $theme The theme to generate base styles for.\n@mixin base($theme) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include token-utils.values(map.get(m3-chip.get-tokens($theme), base));\n  } @else {\n    .mat-mdc-standard-chip {\n      @include token-utils.values(map.get(m2-chip.get-tokens($theme), base));\n    }\n  }\n}\n\n/// Outputs color theme styles for the mat-chips.\n/// @param {Map} $theme The theme to generate color styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin color($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include token-utils.values(\n        map.get(m3-chip.get-tokens($theme, $color-variant), color));\n  } @else {\n    .mat-mdc-standard-chip {\n      @include token-utils.values(map.get(m2-chip.get-tokens($theme), color));\n\n      &.mat-mdc-chip-selected,\n      &.mat-mdc-chip-highlighted {\n        &.mat-primary {\n          @include token-utils.values(\n              m2-chip.private-get-color-palette-color-tokens($theme, primary));\n        }\n\n        &.mat-accent {\n          @include token-utils.values(\n              m2-chip.private-get-color-palette-color-tokens($theme, secondary));\n        }\n\n        &.mat-warn {\n          @include token-utils.values(\n              m2-chip.private-get-color-palette-color-tokens($theme, error));\n        }\n      }\n    }\n  }\n}\n\n/// Outputs typography theme styles for the mat-chips.\n/// @param {Map} $theme The theme to generate typography styles for.\n@mixin typography($theme) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include token-utils.values(map.get(m3-chip.get-tokens($theme), typography));\n  } @else {\n    .mat-mdc-standard-chip {\n      @include token-utils.values(map.get(m2-chip.get-tokens($theme), typography));\n    }\n  }\n}\n\n/// Outputs density theme styles for the mat-chips.\n/// @param {Map} $theme The theme to generate density styles for.\n@mixin density($theme) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include token-utils.values(map.get(m3-chip.get-tokens($theme), density));\n  } @else {\n    .mat-mdc-chip.mat-mdc-standard-chip {\n      @include token-utils.values(map.get(m2-chip.get-tokens($theme), density));\n    }\n  }\n}\n\n/// Defines the tokens that will be available in the `overrides` mixin and for docs extraction.\n@function _define-overrides() {\n  @return (\n    (\n      namespace: chip,\n      tokens: token-utils.get-overrides(m3-chip.get-tokens(), chip)\n    ),\n  );\n}\n\n/// Outputs the CSS variable values for the given tokens.\n/// @param {Map} $tokens The token values to emit.\n@mixin overrides($tokens: ()) {\n    @include token-utils.batch-create-token-values($tokens, _define-overrides());\n}\n\n/// Outputs all (base, color, typography, and density) theme styles for the mat-chips.\n/// @param {Map} $theme The theme to generate styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin theme($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include base($theme);\n    @include color($theme, $color-variant);\n    @include density($theme);\n    @include typography($theme);\n  } @else {\n    @include base($theme);\n    @if inspection.theme-has($theme, color) {\n      @include color($theme);\n    }\n    @if inspection.theme-has($theme, density) {\n      @include density($theme);\n    }\n    @if inspection.theme-has($theme, typography) {\n      @include typography($theme);\n    }\n  }\n}\n","@use 'sass:map';\n@use '../core/style/sass-utils';\n@use '../core/theming/inspection';\n@use '../core/tokens/token-utils';\n@use '../core/typography/typography';\n@use './m2-slide-toggle';\n@use './m3-slide-toggle';\n@use '../core/tokens/m2-utils';\n\n/// Outputs base theme styles (styles not dependent on the color, typography, or density settings)\n/// for the mat-slide-toggle.\n/// @param {Map} $theme The theme to generate base styles for.\n@mixin base($theme) {\n  $tokens: map.get(m2-slide-toggle.get-tokens($theme), base);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-slide-toggle.get-tokens($theme), base);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs color theme styles for the mat-slide-toggle.\n/// @param {Map} $theme The theme to generate color styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin color($theme, $color-variant: null) {\n  $tokens: map.get(m2-slide-toggle.get-tokens($theme), color);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-slide-toggle.get-tokens($theme, $color-variant), color);\n  }\n\n  @include token-utils.values($tokens);\n\n  @if inspection.get-theme-version($theme) != 1 {\n    $mat-tokens: map.get(m2-slide-toggle.get-tokens($theme), color);\n    $system: m2-utils.get-system($theme);\n\n    .mat-mdc-slide-toggle {\n      // Change the color palette related tokens to accent or warn if applicable\n      &.mat-accent {\n        $tokens: m2-slide-toggle.private-get-color-palette-color-tokens($theme, secondary);\n        @include token-utils.values($tokens);\n      }\n\n      &.mat-warn {\n        $tokens: m2-slide-toggle.private-get-color-palette-color-tokens($theme, error);\n        @include token-utils.values($tokens);\n      }\n    }\n  }\n}\n\n/// Outputs typography theme styles for the mat-slide-toggle.\n/// @param {Map} $theme The theme to generate typography styles for.\n@mixin typography($theme) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include token-utils.values(\n        map.get(m3-slide-toggle.get-tokens($theme), typography));\n  } @else {\n    @include sass-utils.current-selector-or-root() {\n      // TODO: See if this can be removed\n      @include token-utils.values(map.get(m2-slide-toggle.get-tokens($theme), typography));\n\n      .mat-mdc-slide-toggle {\n        @include token-utils.values(\n            map.get(m2-slide-toggle.get-tokens($theme), typography));\n      }\n    }\n  }\n}\n\n/// Outputs density theme styles for the mat-slide-toggle.\n/// @param {Map} $theme The theme to generate density styles for.\n@mixin density($theme) {\n  $tokens: map.get(m2-slide-toggle.get-tokens($theme), density);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-slide-toggle.get-tokens($theme), density);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Defines the tokens that will be available in the `overrides` mixin and for docs extraction.\n@function _define-overrides() {\n  @return (\n    (\n      namespace: slide-toggle,\n      tokens: token-utils.get-overrides(m3-slide-toggle.get-tokens(), slide-toggle)\n    ),\n  );\n}\n\n/// Outputs the CSS variable values for the given tokens.\n/// @param {Map} $tokens The token values to emit.\n@mixin overrides($tokens: ()) {\n    @include token-utils.batch-create-token-values($tokens, _define-overrides());\n}\n\n/// Outputs all (base, color, typography, and density) theme styles for the mat-icon.\n/// @param {Map} $theme The theme to generate styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin theme($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include base($theme);\n    @include color($theme, $color-variant);\n    @include density($theme);\n    @include typography($theme);\n  } @else {\n    @include base($theme);\n    @if inspection.theme-has($theme, color) {\n      @include color($theme);\n    }\n    @if inspection.theme-has($theme, density) {\n      @include density($theme);\n    }\n    @if inspection.theme-has($theme, typography) {\n      @include typography($theme);\n    }\n  }\n}\n","@use 'sass:map';\n\n@use '../checkbox/m2-checkbox';\n@use '../core/theming/inspection';\n@use '../core/tokens/token-utils';\n@use '../core/typography/typography';\n@use '../radio/m2-radio';\n@use './m2-list';\n@use './m3-list';\n@use '../core/tokens/m2-utils';\n@use '../core/theming/theming';\n\n@mixin base($theme) {\n  $tokens: map.get(m2-list.get-tokens($theme), base);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-list.get-tokens($theme), base);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n@mixin color($theme) {\n  $tokens: map.get(m2-list.get-tokens($theme), color);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-list.get-tokens($theme), color);\n  }\n\n  @include token-utils.values($tokens);\n\n  @if inspection.get-theme-version($theme) != 1 {\n    .mdc-list-item__start,\n    .mdc-list-item__end {\n      $tokens: m2-radio.private-get-color-palette-color-tokens($theme, primary);\n      @include token-utils.values($tokens);\n    }\n\n    .mat-accent {\n      .mdc-list-item__start,\n      .mdc-list-item__end {\n        $tokens: m2-radio.private-get-color-palette-color-tokens($theme, secondary);\n        @include token-utils.values($tokens);\n      }\n    }\n\n    .mat-warn {\n      .mdc-list-item__start,\n      .mdc-list-item__end {\n        $tokens: m2-radio.private-get-color-palette-color-tokens($theme, error);\n        @include token-utils.values($tokens);\n      }\n    }\n\n    .mat-mdc-list-option {\n      $tokens: m2-checkbox.private-get-color-palette-color-tokens($theme, primary);\n      @include token-utils.values($tokens);\n    }\n\n    .mat-mdc-list-option.mat-accent {\n      $tokens: m2-checkbox.private-get-color-palette-color-tokens($theme, secondary);\n      @include token-utils.values($tokens);\n    }\n\n    .mat-mdc-list-option.mat-warn {\n      $tokens: m2-checkbox.private-get-color-palette-color-tokens($theme, error);\n      @include token-utils.values($tokens);\n    }\n\n    // There is no token for activated color on nav list.\n    // TODO(mmalerba): Add a token to MDC or make a custom one.\n    .mat-mdc-list-base.mat-mdc-list-base {\n      .mdc-list-item--selected,\n      .mdc-list-item--activated {\n        .mdc-list-item__primary-text,\n        .mdc-list-item__start {\n          color: inspection.get-theme-color($theme, primary);\n        }\n      }\n    }\n\n    // TODO(mmalerba): Leaking styles from the old MDC list mixins used in other components can\n    //  cause opacity issues, so we need this override for now. We can remove it when all\n    //  Angular Material components stop using the old MDC mixins.\n    .mat-mdc-list-base .mdc-list-item--disabled {\n      .mdc-list-item__start,\n      .mdc-list-item__content,\n      .mdc-list-item__end {\n        opacity: 1;\n      }\n    }\n  }\n}\n\n@mixin density($theme) {\n  $tokens: map.get(m2-list.get-tokens($theme), density);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-list.get-tokens($theme), density);\n  }\n\n  @include token-utils.values($tokens);\n\n  @if inspection.get-theme-version($theme) != 1 {\n    $system: m2-utils.get-system($theme);\n    $density-scale: theming.clamp-density(map.get($system, density-scale), -5);\n\n    .mdc-list-item__start,\n    .mdc-list-item__end {\n      $tokens: map.get(m2-radio.get-tokens($theme), density);\n      @include token-utils.values($tokens);\n    }\n\n    // TODO(mmalerba): This is added to maintain the same style MDC used prior to the token-based\n    //  API, to avoid screenshot diffs. We should remove it in favor of following MDC's current\n    //  style, or add custom tokens for it.\n    .mat-mdc-list-item {\n      &.mdc-list-item--with-leading-avatar,\n      &.mdc-list-item--with-leading-checkbox,\n      &.mdc-list-item--with-leading-icon {\n        &.mdc-list-item--with-one-line {\n          height: map.get(\n            (\n              0: 56px,\n              -1: 52px,\n              -2: 48px,\n              -3: 44px,\n              -4: 40px,\n              -5: 40px,\n            ),\n            $density-scale\n          );\n        }\n\n        &.mdc-list-item--with-two-lines {\n          height: map.get(\n            (\n              0: 72px,\n              -1: 68px,\n              -2: 64px,\n              -3: 60px,\n              -4: 56px,\n              -5: 56px,\n            ),\n            $density-scale\n          );\n        }\n      }\n    }\n  }\n}\n\n@mixin typography($theme) {\n  $tokens: map.get(m2-list.get-tokens($theme), typography);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-list.get-tokens($theme), typography);\n  }\n\n  @include token-utils.values($tokens);\n\n  @if inspection.get-theme-version($theme) != 1 {\n    // MDC does not have tokens for the subheader.\n    // TODO(mmalerba): Discuss with MDC about adding them, or create custom tokens.\n    .mdc-list-group__subheader {\n      $system: m2-utils.get-system($theme);\n      font: map.get($system, label-large);\n      letter-spacing: map.get($system, label-large-tracking);\n    }\n  }\n}\n\n/// Defines the tokens that will be available in the `overrides` mixin and for docs extraction.\n@function _define-overrides() {\n  @return (\n    (\n      namespace: list,\n      tokens: token-utils.get-overrides(m3-list.get-tokens(), list)\n    ),\n  );\n}\n\n@mixin overrides($tokens: ()) {\n    @include token-utils.batch-create-token-values($tokens, _define-overrides());\n}\n\n@mixin theme($theme) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include base($theme);\n    @include color($theme);\n    @include density($theme);\n    @include typography($theme);\n  } @else {\n    @include base($theme);\n    @if inspection.theme-has($theme, color) {\n      @include color($theme);\n    }\n    @if inspection.theme-has($theme, density) {\n      @include density($theme);\n    }\n    @if inspection.theme-has($theme, typography) {\n      @include typography($theme);\n    }\n  }\n}\n","@use './m2-tabs';\n@use './m3-tabs';\n@use '../core/theming/inspection';\n@use '../core/typography/typography';\n@use '../core/tokens/token-utils';\n@use 'sass:map';\n\n@mixin base($theme) {\n  $tokens: map.get(m2-tabs.get-tokens($theme), base);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-tabs.get-tokens($theme), base);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs color theme styles for the mat-tab.\n/// @param {Map} $theme The theme to generate color styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin color($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-tabs.get-tokens($theme, $color-variant), color);\n    @include token-utils.values($tokens);\n  } @else {\n    .mat-mdc-tab-group,\n    .mat-mdc-tab-nav-bar {\n      @include token-utils.values(\n          m2-tabs.private-get-color-palette-color-tokens($theme, primary,\n            $exclude: (tab-background-color, tab-foreground-color)));\n\n      &.mat-accent {\n        @include token-utils.values(\n          m2-tabs.private-get-color-palette-color-tokens($theme, secondary,\n            $exclude: (tab-background-color, tab-foreground-color)));\n      }\n\n      &.mat-warn {\n        @include token-utils.values(\n          m2-tabs.private-get-color-palette-color-tokens($theme, error,\n            $exclude: (tab-background-color, tab-foreground-color)));\n      }\n\n      &.mat-background-primary {\n        $tokens: m2-tabs.private-get-color-palette-color-tokens($theme, primary);\n        @include token-utils.values((\n          tab-background-color: map.get($tokens, tab-background-color),\n          tab-foreground-color: map.get($tokens, tab-foreground-color)\n        ));\n      }\n\n      &.mat-background-accent {\n        $tokens: m2-tabs.private-get-color-palette-color-tokens($theme, secondary);\n        @include token-utils.values((\n          tab-background-color: map.get($tokens, tab-background-color),\n          tab-foreground-color: map.get($tokens, tab-foreground-color),\n        ));\n      }\n\n      &.mat-background-warn {\n        $tokens: m2-tabs.private-get-color-palette-color-tokens($theme, error);\n        @include token-utils.values((\n          tab-background-color: map.get($tokens, tab-background-color),\n          tab-foreground-color: map.get($tokens, tab-foreground-color),\n        ));\n      }\n    }\n  }\n}\n\n/// Outputs typography theme styles for the mat-tab.\n/// @param {Map} $theme The theme to generate typography styles for.\n@mixin typography($theme) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include token-utils.values(map.get(m3-tabs.get-tokens($theme), typography));\n  } @else {\n    .mat-mdc-tab-header {\n      @include token-utils.values(map.get(m2-tabs.get-tokens($theme), typography));\n    }\n  }\n}\n\n/// Outputs density theme styles for the mat-tab.\n/// @param {Map} $theme The theme to generate density styles for.\n@mixin density($theme) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include token-utils.values(map.get(m3-tabs.get-tokens($theme), density));\n  } @else {\n    .mat-mdc-tab-header {\n      @include token-utils.values(map.get(m2-tabs.get-tokens($theme), density));\n    }\n  }\n}\n\n/// Defines the tokens that will be available in the `overrides` mixin and for docs extraction.\n@function _define-overrides() {\n  @return (\n    (\n      namespace: tab,\n      tokens: token-utils.get-overrides(m3-tabs.get-tokens(), tab)\n    ),\n  );\n}\n\n/// Outputs the CSS variable values for the given tokens.\n/// @param {Map} $tokens The token values to emit.\n@mixin overrides($tokens: ()) {\n    @include token-utils.batch-create-token-values($tokens, _define-overrides());\n}\n\n/// Outputs all (base, color, typography, and density) theme styles for the mat-tab.\n/// @param {Map} $theme The theme to generate styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin theme($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include base($theme);\n    @include color($theme, $color-variant);\n    @include density($theme);\n    @include typography($theme);\n  } @else {\n    @include base($theme);\n    @if inspection.theme-has($theme, color) {\n      @include color($theme);\n    }\n    @if inspection.theme-has($theme, density) {\n      @include density($theme);\n    }\n    @if inspection.theme-has($theme, typography) {\n      @include typography($theme);\n    }\n  }\n}\n","@use './m3-app';\n@use './tokens/token-utils';\n@use './style/elevation';\n\n$fallbacks: m3-app.get-tokens();\n\n/// @deprecated This mixin is a no-op and is going to be removed in v21.\n@mixin core() {}\n\n// Emits the mat-app-background CSS class. This predefined class sets the\n// background color and text color of an element.\n@mixin app-background() {\n  // TODO: Move ripple styles to be dynamically loaded instead of in core.\n  // This variable is used as a fallback for the ripple element's\n  // background color. However, if it isn't defined anywhere, then MSS\n  // complains in its verification stage.\n  html {\n    --mat-sys-on-surface: initial;\n  }\n\n  // Wrapper element that provides the theme background when the\n  // user's content isn't inside of a `mat-sidenav-container`.\n  @at-root {\n    // Note: we need to emit fallback values here to avoid errors in internal builds.\n    .mat-app-background {\n      background-color: token-utils.slot(app-background-color, $fallbacks, transparent);\n      color: token-utils.slot(app-text-color, $fallbacks, inherit);\n    }\n  }\n}\n\n// Emits CSS classes for applying elevation. These classes follow the pattern\n// mat-elevation-z#, where # is the elevation number you want, from 0 to 24.\n// These predefined classes use the CSS box-shadow settings defined by the\n// Material Design specification.\n@mixin elevation-classes() {\n  @at-root {\n    // Provides external CSS classes for each elevation value. Each CSS class is formatted as\n    // `mat-elevation-z$z-value` where `$z-value` corresponds to the z-space to which the element\n    // is elevated.\n    @for $z-value from 0 through 24 {\n      $selector: elevation.$prefix + $z-value;\n      // We need the `mat-mdc-elevation-specific`, because some MDC mixins\n      // come with elevation baked in and we don't have a way of removing it.\n      .#{$selector}, .mat-mdc-elevation-specific.#{$selector} {\n        box-shadow: token-utils.slot('app-elevation-shadow-level-#{$z-value}', $fallbacks, none);\n      }\n    }\n  }\n}\n","@use './m2-option';\n@use './m3-option';\n@use '../tokens/token-utils';\n@use '../theming/inspection';\n@use '../typography/typography';\n@use 'sass:map';\n\n/// Outputs base theme styles (styles not dependent on the color, typography, or density settings)\n/// for the mat-option.\n/// @param {Map} $theme The theme to generate base styles for.\n@mixin base($theme) {\n  $tokens: map.get(m2-option.get-tokens($theme), base);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-option.get-tokens($theme), base);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs color theme styles for the mat-option.\n/// @param {Map} $theme The theme to generate color styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin color($theme, $color-variant: null) {\n  $tokens: map.get(m2-option.get-tokens($theme), color);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-option.get-tokens($theme, $color-variant), color);\n  }\n\n  @include token-utils.values($tokens);\n\n  @if inspection.get-theme-version($theme) != 1 {\n    .mat-accent {\n      $tokens: m2-option.private-get-color-palette-color-tokens($theme, secondary);\n      @include token-utils.values($tokens);\n    }\n\n    .mat-warn {\n      $tokens: m2-option.private-get-color-palette-color-tokens($theme, error);\n      @include token-utils.values($tokens);\n    }\n  }\n}\n\n/// Outputs typography theme styles for the mat-option.\n/// @param {Map} $theme The theme to generate typography styles for.\n@mixin typography($theme) {\n  $tokens: map.get(m2-option.get-tokens($theme), typography);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-option.get-tokens($theme), typography);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs density theme styles for the mat-option.\n/// @param {Map} $theme The theme to generate density styles for.\n@mixin density($theme) {\n  $tokens: map.get(m2-option.get-tokens($theme), density);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-option.get-tokens($theme), density);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Defines the tokens that will be available in the `overrides` mixin and for docs extraction.\n@function _define-overrides() {\n  @return (\n    (\n      namespace: option,\n      tokens: token-utils.get-overrides(m3-option.get-tokens(), option)\n    ),\n  );\n}\n\n/// Outputs the CSS variable values for the given tokens.\n/// @param {Map} $tokens The token values to emit.\n@mixin overrides($tokens: ()) {\n    @include token-utils.batch-create-token-values($tokens, _define-overrides());\n}\n\n/// Outputs all (base, color, typography, and density) theme styles for the mat-option.\n/// @param {Map} $theme The theme to generate styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin theme($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include base($theme);\n    @include color($theme, $color-variant);\n    @include density($theme);\n    @include typography($theme);\n  } @else {\n    @include base($theme);\n    @if inspection.theme-has($theme, color) {\n      @include color($theme);\n    }\n    @if inspection.theme-has($theme, density) {\n      @include density($theme);\n    }\n    @if inspection.theme-has($theme, typography) {\n      @include typography($theme);\n    }\n  }\n}\n","@use '../../theming/inspection';\n@use '../../tokens/token-utils';\n@use './m2-pseudo-checkbox';\n@use './m3-pseudo-checkbox';\n@use 'sass:map';\n\n@mixin _palette-styles($theme, $palette-name) {\n  $tokens: map.get(m2-pseudo-checkbox.get-tokens($theme), color);\n  @include token-utils.values($tokens);\n}\n\n@mixin base($theme) {\n  $tokens: map.get(m2-pseudo-checkbox.get-tokens($theme), base);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-pseudo-checkbox.get-tokens($theme), base);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs the CSS variable values for the given tokens.\n/// @param {Map} $tokens The token values to emit.\n@mixin overrides($tokens: ()) {\n    @include token-utils.batch-create-token-values($tokens, _define-overrides());\n}\n\n/// Outputs color theme styles for the mat-pseudo-checkbox.\n/// @param {Map} $theme The theme to generate color styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin color($theme, $color-variant: null) {\n  $tokens: map.get(m2-pseudo-checkbox.get-tokens($theme), color);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-pseudo-checkbox.get-tokens($theme, $color-variant), color);\n  }\n\n  @include token-utils.values($tokens);\n\n  @if inspection.get-theme-version($theme) != 1 {\n    // Default to the accent color. Note that the pseudo checkboxes are meant to inherit the\n    // theme from their parent, rather than implementing their own theming, which is why we\n    // don't attach to the `mat-*` classes. Also note that this needs to be below `.mat-primary`\n    // in order to allow for the color to be overwritten if the checkbox is inside a parent that\n    // has `mat-accent` and is placed inside another parent that has `mat-primary`.\n    .mat-primary {\n      $tokens: m2-pseudo-checkbox.private-get-color-palette-color-tokens($theme, primary);\n      @include token-utils.values($tokens);\n    }\n\n    .mat-accent {\n      $tokens: m2-pseudo-checkbox.private-get-color-palette-color-tokens($theme, secondary);\n      @include token-utils.values($tokens);\n    }\n\n    .mat-warn {\n      $tokens: m2-pseudo-checkbox.private-get-color-palette-color-tokens($theme, error);\n      @include token-utils.values($tokens);\n    }\n  }\n}\n\n@mixin typography($theme) {\n  $tokens: map.get(m2-pseudo-checkbox.get-tokens($theme), typography);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-pseudo-checkbox.get-tokens($theme), typography);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n@mixin density($theme) {\n  $tokens: map.get(m2-pseudo-checkbox.get-tokens($theme), density);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-pseudo-checkbox.get-tokens($theme), density);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Defines the tokens that will be available in the `overrides` mixin and for docs extraction.\n@function _define-overrides() {\n  @return (\n    (\n      namespace: pseudo-checkbox,\n      tokens: token-utils.get-overrides(m3-pseudo-checkbox.get-tokens(), pseudo-checkbox)\n    ),\n  );\n}\n\n/// Outputs all (base, color, typography, and density) theme styles for the mat-pseudo-checkbox.\n/// @param {Map} $theme The theme to generate styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin theme($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include base($theme);\n    @include color($theme, $color-variant);\n    @include density($theme);\n    @include typography($theme);\n  } @else {\n    @include base($theme);\n    @if inspection.theme-has($theme, color) {\n      @include color($theme);\n    }\n    @if inspection.theme-has($theme, density) {\n      @include density($theme);\n    }\n    @if inspection.theme-has($theme, typography) {\n      @include typography($theme);\n    }\n  }\n}\n","@use '../core/theming/inspection';\n@use '../core/tokens/token-utils';\n@use './m2-progress-bar';\n@use './m3-progress-bar';\n@use 'sass:map';\n\n@mixin base($theme) {\n  $tokens: map.get(m2-progress-bar.get-tokens($theme), base);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-progress-bar.get-tokens($theme), base);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n@mixin color($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include token-utils.values(\n        map.get(m3-progress-bar.get-tokens($theme, $color-variant), color));\n  } @else {\n    .mat-mdc-progress-bar {\n      $tokens: m2-progress-bar.private-get-color-palette-color-tokens($theme, primary);\n      @include token-utils.values($tokens);\n\n      &.mat-accent {\n        $tokens: m2-progress-bar.private-get-color-palette-color-tokens($theme, secondary);\n        @include token-utils.values($tokens);\n      }\n\n      &.mat-warn {\n        $tokens: m2-progress-bar.private-get-color-palette-color-tokens($theme, error);\n        @include token-utils.values($tokens);\n      }\n    }\n  }\n}\n\n@mixin typography($theme) {\n  $tokens: map.get(m2-progress-bar.get-tokens($theme), typography);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-progress-bar.get-tokens($theme), typography);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n@mixin density($theme) {\n  $tokens: map.get(m2-progress-bar.get-tokens($theme), density);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-progress-bar.get-tokens($theme), density);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Defines the tokens that will be available in the `overrides` mixin and for docs extraction.\n@function _define-overrides() {\n  @return (\n    (\n      namespace: progress-bar,\n      tokens: token-utils.get-overrides(m3-progress-bar.get-tokens(), progress-bar)\n    ),\n  );\n}\n\n/// Outputs the CSS variable values for the given tokens.\n/// @param {Map} $tokens The token values to emit.\n@mixin overrides($tokens: ()) {\n    @include token-utils.batch-create-token-values($tokens, _define-overrides());\n}\n\n/// Outputs all (base, color, typography, and density) theme styles for the mat-progress-bar.\n/// @param {Map} $theme The theme to generate styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin theme($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include base($theme);\n    @include color($theme, $color-variant);\n    @include density($theme);\n    @include typography($theme);\n  } @else {\n    @include base($theme);\n    @if inspection.theme-has($theme, color) {\n      @include color($theme);\n    }\n    @if inspection.theme-has($theme, density) {\n      @include density($theme);\n    }\n    @if inspection.theme-has($theme, typography) {\n      @include typography($theme);\n    }\n  }\n}\n","@use './m2-form-field';\n@use './m3-form-field';\n@use '../core/theming/inspection';\n@use '../core/typography/typography';\n@use '../core/tokens/token-utils';\n@use 'sass:map';\n\n@mixin base($theme) {\n  $tokens: map.get(m2-form-field.get-tokens($theme), base);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-form-field.get-tokens($theme), base);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs color theme styles for the mat-form-field.\n/// @param {Map} $theme The theme to generate color styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin color($theme, $color-variant: null) {\n  $tokens: map.get(m2-form-field.get-tokens($theme), color);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-form-field.get-tokens($theme, $color-variant), color);\n  }\n\n  @include token-utils.values($tokens);\n\n  @if inspection.get-theme-version($theme) != 1 {\n    .mat-mdc-form-field.mat-accent {\n      $tokens: m2-form-field.private-get-color-palette-color-tokens($theme, secondary);\n      @include token-utils.values($tokens);\n    }\n\n    .mat-mdc-form-field.mat-warn {\n      $tokens: m2-form-field.private-get-color-palette-color-tokens($theme, error);\n      @include token-utils.values($tokens);\n    }\n  }\n}\n\n@mixin typography($theme) {\n  $tokens: map.get(m2-form-field.get-tokens($theme), typography);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-form-field.get-tokens($theme), typography);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n@mixin density($theme) {\n  $tokens: map.get(m2-form-field.get-tokens($theme), density);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-form-field.get-tokens($theme), density);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Defines the tokens that will be available in the `overrides` mixin and for docs extraction.\n@function _define-overrides() {\n  @return (\n    (\n      namespace: form-field,\n      tokens: token-utils.get-overrides(m3-form-field.get-tokens(), form-field),\n    ),\n  );\n}\n\n/// Outputs the CSS variable values for the given tokens.\n/// @param {Map} $tokens The token values to emit.\n@mixin overrides($tokens: ()) {\n    @include token-utils.batch-create-token-values($tokens, _define-overrides());\n}\n\n/// Outputs all (base, color, typography, and density) theme styles for the mat-form-field.\n/// @param {Map} $theme The theme to generate styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin theme($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include base($theme);\n    @include color($theme, $color-variant);\n    @include density($theme);\n    @include typography($theme);\n  } @else {\n    @include base($theme);\n    @if inspection.theme-has($theme, color) {\n      @include color($theme);\n    }\n    @if inspection.theme-has($theme, density) {\n      @include density($theme);\n    }\n    @if inspection.theme-has($theme, typography) {\n      @include typography($theme);\n    }\n  }\n}\n","@use '../core/theming/inspection';\n@use '../core/tokens/token-utils';\n@use '../core/typography/typography';\n@use './m2-select';\n@use './m3-select';\n@use 'sass:map';\n\n/// Outputs base theme styles (styles not dependent on the color, typography, or density settings)\n/// for the mat-select.\n/// @param {Map} $theme The theme to generate base styles for.\n@mixin base($theme) {\n  $tokens: map.get(m2-select.get-tokens($theme), base);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-select.get-tokens($theme), base);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs color theme styles for the mat-select.\n/// @param {Map} $theme The theme to generate color styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin color($theme, $color-variant: null) {\n  $tokens: map.get(m2-select.get-tokens($theme), color);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-select.get-tokens($theme, $color-variant), color);\n  }\n\n  @include token-utils.values($tokens);\n\n  @if inspection.get-theme-version($theme) != 1 {\n    .mat-mdc-form-field.mat-accent {\n      $tokens: m2-select.private-get-color-palette-color-tokens($theme, secondary);\n      @include token-utils.values($tokens);\n    }\n\n    .mat-mdc-form-field.mat-warn {\n      $tokens: m2-select.private-get-color-palette-color-tokens($theme, error);\n      @include token-utils.values($tokens);\n    }\n  }\n}\n\n@mixin typography($theme) {\n  $tokens: map.get(m2-select.get-tokens($theme), typography);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-select.get-tokens($theme), typography);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n@mixin density($theme) {\n  $tokens: map.get(m2-select.get-tokens($theme), density);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-select.get-tokens($theme), density);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Defines the tokens that will be available in the `overrides` mixin and for docs extraction.\n@function _define-overrides() {\n  @return (\n    (\n      namespace: select,\n      tokens: token-utils.get-overrides(m3-select.get-tokens(), select)\n    ),\n  );\n}\n\n/// Outputs the CSS variable values for the given tokens.\n/// @param {Map} $tokens The token values to emit.\n@mixin overrides($tokens: ()) {\n    @include token-utils.batch-create-token-values($tokens, _define-overrides());\n}\n\n/// Outputs all (base, color, typography, and density) theme styles for the mat-icon.\n/// @param {Map} $theme The theme to generate styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin theme($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include base($theme);\n    @include color($theme, $color-variant);\n    @include density($theme);\n    @include typography($theme);\n  } @else {\n    @include base($theme);\n    @if inspection.theme-has($theme, color) {\n      @include color($theme);\n    }\n    @if inspection.theme-has($theme, density) {\n      @include density($theme);\n    }\n    @if inspection.theme-has($theme, typography) {\n      @include typography($theme);\n    }\n  }\n}\n","@use '../core/theming/inspection';\n@use '../core/tokens/token-utils';\n@use '../core/typography/typography';\n@use './m2-radio';\n@use './m3-radio';\n@use 'sass:map';\n\n/// Outputs base theme styles (styles not dependent on the color, typography, or density settings)\n/// for the mat-radio.\n/// @param {Map} $theme The theme to generate base styles for.\n@mixin base($theme) {\n  $tokens: map.get(m2-radio.get-tokens($theme), base);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-radio.get-tokens($theme), base);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs color theme styles for the mat-radio.\n/// @param {Map} $theme The theme to generate color styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin color($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-radio.get-tokens($theme, $color-variant), color);\n    @include token-utils.values($tokens);\n  } @else {\n    .mat-mdc-radio-button {\n      &.mat-primary {\n        $tokens: m2-radio.private-get-color-palette-color-tokens($theme, primary);\n        @include token-utils.values($tokens);\n      }\n\n      &.mat-accent {\n        $tokens: m2-radio.private-get-color-palette-color-tokens($theme, secondary);\n        @include token-utils.values($tokens);\n      }\n\n      &.mat-warn {\n        $tokens: m2-radio.private-get-color-palette-color-tokens($theme, error);\n        @include token-utils.values($tokens);\n      }\n    }\n  }\n}\n\n@mixin typography($theme) {\n  $tokens: map.get(m2-radio.get-tokens($theme), typography);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-radio.get-tokens($theme), typography);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n@mixin density($theme) {\n  $tokens: map.get(m2-radio.get-tokens($theme), density);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-radio.get-tokens($theme), density);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Defines the tokens that will be available in the `overrides` mixin and for docs extraction.\n@function _define-overrides() {\n  @return (\n    (\n      namespace: radio,\n      tokens: token-utils.get-overrides(m3-radio.get-tokens(), radio)\n    ),\n  );\n}\n\n/// Outputs the CSS variable values for the given tokens.\n/// @param {Map} $tokens The token values to emit.\n@mixin overrides($tokens: ()) {\n    @include token-utils.batch-create-token-values($tokens, _define-overrides());\n}\n\n/// Outputs all (base, color, typography, and density) theme styles for the mat-radio.\n/// @param {Map} $theme The theme to generate styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin theme($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include base($theme);\n    @include color($theme, $color-variant);\n    @include density($theme);\n    @include typography($theme);\n  } @else {\n    @include base($theme);\n    @if inspection.theme-has($theme, color) {\n      @include color($theme);\n    }\n    @if inspection.theme-has($theme, density) {\n      @include density($theme);\n    }\n    @if inspection.theme-has($theme, typography) {\n      @include typography($theme);\n    }\n  }\n}\n","@use '../core/theming/inspection';\n@use '../core/typography/typography';\n@use '../core/tokens/token-utils';\n@use './m2-slider';\n@use './m3-slider';\n@use 'sass:map';\n\n/// Outputs base theme styles (styles not dependent on the color, typography, or density settings)\n/// for the mat-slider.\n/// @param {Map} $theme The theme to generate base styles for.\n@mixin base($theme) {\n  $tokens: map.get(m2-slider.get-tokens($theme), base);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-slider.get-tokens($theme), base);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs color theme styles for the mat-slider.\n/// @param {Map} $theme The theme to generate color styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin color($theme, $color-variant: null) {\n  $tokens: map.get(m2-slider.get-tokens($theme), color);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-slider.get-tokens($theme, $color-variant), color);\n  }\n\n  @include token-utils.values($tokens);\n\n  @if inspection.get-theme-version($theme) != 1 {\n    .mat-accent {\n      $tokens: m2-slider.private-get-color-palette-color-tokens($theme, secondary);\n      @include token-utils.values($tokens);\n    }\n\n    .mat-warn {\n      $tokens: m2-slider.private-get-color-palette-color-tokens($theme, error);\n      @include token-utils.values($tokens);\n    }\n  }\n}\n\n/// Outputs typography theme styles for the mat-slider.\n/// @param {Map} $theme The theme to generate typography styles for.\n@mixin typography($theme) {\n  $tokens: map.get(m2-slider.get-tokens($theme), typography);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-slider.get-tokens($theme), typography);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs density theme styles for the mat-slider.\n/// @param {Map} $theme The theme to generate density styles for.\n@mixin density($theme) {\n  $tokens: map.get(m2-slider.get-tokens($theme), density);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-slider.get-tokens($theme), density);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Defines the tokens that will be available in the `overrides` mixin and for docs extraction.\n@function _define-overrides() {\n  @return (\n    (\n      namespace: slider,\n      tokens: token-utils.get-overrides(m3-slider.get-tokens(), slider)\n    ),\n  );\n}\n\n/// Outputs the CSS variable values for the given tokens.\n/// @param {Map} $tokens The token values to emit.\n@mixin overrides($tokens: ()) {\n    @include token-utils.batch-create-token-values($tokens, _define-overrides());\n}\n\n/// Outputs all (base, color, typography, and density) theme styles for the mat-option.\n/// @param {Map} $theme The theme to generate styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin theme($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include base($theme);\n    @include color($theme, $color-variant);\n    @include density($theme);\n    @include typography($theme);\n  } @else {\n    @include base($theme);\n    @if inspection.theme-has($theme, color) {\n      @include color($theme);\n    }\n    @if inspection.theme-has($theme, density) {\n      @include density($theme);\n    }\n    @if inspection.theme-has($theme, typography) {\n      @include typography($theme);\n    }\n  }\n}\n","@use '../core/theming/inspection';\n@use '../core/tokens/token-utils';\n@use '../core/typography/typography';\n@use './m2-checkbox';\n@use './m3-checkbox';\n@use 'sass:map';\n\n/// Outputs base theme styles (styles not dependent on the color, typography, or density settings)\n/// for the mat-checkbox.\n/// @param {Map} $theme The theme to generate base styles for.\n@mixin base($theme) {\n  $tokens: map.get(m2-checkbox.get-tokens($theme), base);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-checkbox.get-tokens($theme), base);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs color theme styles for the mat-checkbox.\n/// @param {Map} $theme The theme to generate color styles for.\n/// @param {String} $color-variant The color variant to use for the component\n@mixin color($theme, $color-variant: null) {\n  $tokens: map.get(m2-checkbox.get-tokens($theme), color);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-checkbox.get-tokens($theme, $color-variant), color);\n  }\n\n  @include token-utils.values($tokens);\n\n  @if inspection.get-theme-version($theme) != 1 {\n    .mat-mdc-checkbox {\n      &.mat-primary {\n        @include token-utils.values(m2-checkbox.private-get-color-palette-color-tokens(\n            $theme, primary,\n            $exclude: (checkbox-disabled-label-color, checkbox-label-text-color))\n        );\n      }\n\n      &.mat-warn {\n        @include token-utils.values(m2-checkbox.private-get-color-palette-color-tokens(\n            $theme, error,\n            $exclude: (checkbox-disabled-label-color, checkbox-label-text-color))\n        );\n      }\n    }\n  }\n}\n\n@mixin typography($theme) {\n  $tokens: map.get(m2-checkbox.get-tokens($theme), typography);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-checkbox.get-tokens($theme), typography);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n@mixin density($theme) {\n  $tokens: map.get(m2-checkbox.get-tokens($theme), density);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-checkbox.get-tokens($theme), density);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Defines the tokens that will be available in the `overrides` mixin and for docs extraction.\n@function _define-overrides() {\n  @return (\n    (\n      namespace: checkbox,\n      tokens: token-utils.get-overrides(m3-checkbox.get-tokens(), checkbox),\n    ),\n  );\n}\n\n/// Outputs the CSS variable values for the given tokens.\n/// @param {Map} $tokens The token values to emit.\n@mixin overrides($tokens: ()) {\n  @include token-utils.batch-create-token-values($tokens, _define-overrides());\n}\n\n/// Outputs all (base, color, typography, and density) theme styles for the mat-checkbox.\n/// @param {Map} $theme The theme to generate styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin theme($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include base($theme);\n    @include color($theme, $color-variant);\n    @include density($theme);\n    @include typography($theme);\n  } @else {\n    @include base($theme);\n    @if inspection.theme-has($theme, color) {\n      @include color($theme);\n    }\n    @if inspection.theme-has($theme, density) {\n      @include density($theme);\n    }\n    @if inspection.theme-has($theme, typography) {\n      @include typography($theme);\n    }\n  }\n}\n","@use '../core/theming/inspection';\n@use '../core/tokens/token-utils';\n@use '../core/typography/typography';\n@use './m2-button';\n@use './m3-button';\n@use 'sass:map';\n\n/// Outputs base theme styles (styles not dependent on the color, typography, or density settings)\n/// for the mat-button.\n/// @param {Map} $theme The theme to generate base styles for.\n@mixin base($theme) {\n  $tokens: map.get(m2-button.get-tokens($theme), base);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-button.get-tokens($theme), base);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs color theme styles for the mat-button.\n/// @param {Map} $theme The theme to generate color styles for.\n/// @param {String} $color-variant The color variant to use for\n///     the badge: primary, secondary, tertiary, or error (If not specified,\n///     default primary color will be used).\n@mixin color($theme, $color-variant: null) {\n  $tokens: map.get(m2-button.get-tokens($theme), color);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-button.get-tokens($theme, $color-variant), color);\n  }\n\n  @include token-utils.values($tokens);\n\n  @if inspection.get-theme-version($theme) != 1 {\n    .mat-mdc-button,\n    .mat-mdc-unelevated-button,\n    .mat-mdc-raised-button,\n    .mat-mdc-outlined-button,\n    .mat-tonal-button {\n      &.mat-primary {\n        $tokens: m2-button.private-get-color-palette-color-tokens($theme, primary);\n        @include token-utils.values($tokens);\n      }\n\n      &.mat-accent {\n        $tokens: m2-button.private-get-color-palette-color-tokens($theme, secondary);\n        @include token-utils.values($tokens);\n      }\n\n      &.mat-warn {\n        $tokens: m2-button.private-get-color-palette-color-tokens($theme, error);\n        @include token-utils.values($tokens);\n      }\n    }\n  }\n}\n\n@mixin typography($theme) {\n  $tokens: map.get(m2-button.get-tokens($theme), typography);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-button.get-tokens($theme), typography);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n@mixin density($theme) {\n  $tokens: map.get(m2-button.get-tokens($theme), density);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-button.get-tokens($theme), density);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Defines the tokens that will be available in the `overrides` mixin and for docs extraction.\n@function _define-overrides() {\n  @return (\n    (\n      namespace: button,\n      tokens: token-utils.get-overrides(m3-button.get-tokens(), button),\n    ),\n  );\n}\n\n/// Outputs the CSS variable values for the given tokens.\n/// @param {Map} $tokens The token values to emit.\n@mixin overrides($tokens: ()) {\n    @include token-utils.batch-create-token-values($tokens, _define-overrides());\n}\n\n/// Outputs all (base, color, typography, and density) theme styles for the mat-button.\n/// @param {Map} $theme The theme to generate styles for.\n/// @param {String} $color-variant: The color variant to use for the button: primary, secondary,\n//         tertiary, or error (If not specified, default primary color will be used).\n@mixin theme($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include base($theme);\n    @include color($theme, $color-variant);\n    @include density($theme);\n    @include typography($theme);\n  } @else {\n    @include base($theme);\n    @if inspection.theme-has($theme, color) {\n      @include color($theme);\n    }\n    @if inspection.theme-has($theme, density) {\n      @include density($theme);\n    }\n    @if inspection.theme-has($theme, typography) {\n      @include typography($theme);\n    }\n  }\n}\n","@use 'sass:map';\n@use 'sass:math';\n@use './m2-icon-button';\n@use './m3-icon-button';\n@use '../core/tokens/token-utils';\n@use '../core/tokens/m2-utils';\n@use '../core/theming/inspection';\n@use '../core/theming/theming';\n\n@mixin base($theme) {\n  $tokens: map.get(m2-icon-button.get-tokens($theme), base);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-icon-button.get-tokens($theme), base);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs color theme styles for the mat-icon-button.\n/// @param {Map} $theme The theme to generate color styles for.\n/// @param {String} $color-variant: The color variant to use for the\n//         button: primary, secondary, tertiary, or error.\n@mixin color($theme, $color-variant: null) {\n  $tokens: map.get(m2-icon-button.get-tokens($theme), color);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-icon-button.get-tokens($theme, $color-variant), color);\n  }\n\n  @include token-utils.values($tokens);\n\n  @if inspection.get-theme-version($theme) != 1 {\n    .mat-mdc-icon-button {\n      &.mat-primary {\n        $tokens: m2-icon-button.private-get-color-palette-color-tokens($theme, primary);\n        @include token-utils.values($tokens);\n      }\n\n      &.mat-accent {\n        $tokens: m2-icon-button.private-get-color-palette-color-tokens($theme, secondary);\n        @include token-utils.values($tokens);\n      }\n\n      &.mat-warn {\n        $tokens: m2-icon-button.private-get-color-palette-color-tokens($theme, error);\n        @include token-utils.values($tokens);\n      }\n    }\n  }\n}\n\n@mixin typography($theme) {\n  $tokens: map.get(m2-icon-button.get-tokens($theme), typography);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-icon-button.get-tokens($theme), typography);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n@mixin density($theme) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include token-utils.values(map.get(m3-icon-button.get-tokens($theme), density));\n  } @else {\n    $icon-size: 24px;\n    $system: m2-utils.get-system($theme);\n    $density-scale: theming.clamp-density(map.get($system, density-scale), -5);\n    $size-map: (\n      0: 48px,\n      -1: 44px,\n      -2: 40px,\n      -3: 36px,\n      -4: 32px,\n      -5: 28px,\n    );\n    $calculated-size: map.get($size-map, $density-scale);\n\n    $density-tokens: map.get(m2-icon-button.get-tokens($theme), density);\n    $density-tokens: map.remove($density-tokens, icon-button-state-layer-size);\n    @include token-utils.values($density-tokens);\n\n    // Use `mat-mdc-button-base` to increase the specificity over the button's structural styles.\n    .mat-mdc-icon-button.mat-mdc-button-base {\n      // Match the styles that used to be present. This is necessary for backwards\n      // compat to match the previous implementations selector count (two classes).\n      --mdc-icon-button-state-layer-size: #{$calculated-size};\n      --mat-icon-button-state-layer-size: #{$calculated-size};\n\n      // TODO: Switch calculated-size to \"var(--mat-icon-button-state-layer-size)\"\n      // Currently fails validation because the variable is \"undefined\"\n      // in the sass stack.\n      // TODO: Switch icon-size to \"var(--mat-icon-button-icon-size)\". Currently\n      // fails validation because the variable is \"undefined\" in the sass stack.\n      width: var(--mat-icon-button-state-layer-size);\n      height: var(--mat-icon-button-state-layer-size);\n      padding: math.div($calculated-size - $icon-size, 2);\n    }\n  }\n}\n\n/// Defines the tokens that will be available in the `overrides` mixin and for docs extraction.\n@function _define-overrides() {\n  @return (\n    (\n      namespace: icon-button,\n      tokens: token-utils.get-overrides(m3-icon-button.get-tokens(), icon-button)\n    ),\n  );\n}\n\n@mixin overrides($tokens: ()) {\n    @include token-utils.batch-create-token-values($tokens, _define-overrides());\n}\n\n/// Outputs all (base, color, typography, and density) theme styles for the mat-icon-button.\n/// @param {Map} $theme The theme to generate styles for.\n/// @param {String} $color-variant: The color variant to use for the button: primary,\n//         secondary, tertiary, or error.\n@mixin theme($theme, $color-variant: null) {\n    @if inspection.get-theme-version($theme) == 1 {\n      @include base($theme);\n      @include color($theme, $color-variant);\n      @include density($theme);\n      @include typography($theme);\n    } @else {\n      @include base($theme);\n      @if inspection.theme-has($theme, color) {\n        @include color($theme);\n      }\n      @if inspection.theme-has($theme, density) {\n        @include density($theme);\n      }\n      @if inspection.theme-has($theme, typography) {\n        @include typography($theme);\n    }\n  }\n}\n","@use '../core/theming/inspection';\n@use './m2-fab';\n@use './m3-fab';\n@use '../core/tokens/token-utils';\n@use '../core/typography/typography';\n@use 'sass:map';\n\n/// Outputs base theme styles (styles not dependent on the color, typography, or density settings)\n/// for the mat-fab.\n/// @param {Map} $theme The theme to generate base styles for.\n@mixin base($theme) {\n  $tokens: map.get(m2-fab.get-tokens($theme), base);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-fab.get-tokens($theme), base);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs color theme styles for the mat-fab.\n/// @param {Map} $theme The theme to generate color styles for.\n/// @param {ArgList} $color-variant: The color variant to use for the fab: primary, secondary,\n//          or tertiary. (If not specified, default primary color will be used).\n@mixin color($theme, $color-variant: null) {\n  $tokens: map.get(m2-fab.get-tokens($theme), color);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-fab.get-tokens($theme, $color-variant), color);\n  }\n\n  @include token-utils.values($tokens);\n\n  @if inspection.get-theme-version($theme) != 1 {\n    .mat-mdc-fab, .mat-mdc-mini-fab {\n      &.mat-primary {\n        $tokens: m2-fab.private-get-color-palette-color-tokens($theme, primary);\n        @include token-utils.values($tokens);\n      }\n\n      &.mat-accent {\n        $tokens: m2-fab.private-get-color-palette-color-tokens($theme, secondary);\n        @include token-utils.values($tokens);\n      }\n\n      &.mat-warn {\n        $tokens: m2-fab.private-get-color-palette-color-tokens($theme, error);\n        @include token-utils.values($tokens);\n      }\n    }\n  }\n}\n\n/// Outputs typography theme styles for the mat-fab.\n/// @param {Map} $theme The theme to generate typography styles for.\n@mixin typography($theme) {\n  $tokens: map.get(m2-fab.get-tokens($theme), typography);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-fab.get-tokens($theme), typography);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs density theme styles for the mat-fab.\n/// @param {Map} $theme The theme to generate density styles for.\n@mixin density($theme) {\n  $tokens: map.get(m2-fab.get-tokens($theme), density);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-fab.get-tokens($theme), density);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Defines the tokens that will be available in the `overrides` mixin and for docs extraction.\n@function _define-overrides() {\n  @return (\n    (\n      namespace: fab,\n      tokens: token-utils.get-overrides(m3-fab.get-tokens(), fab)\n    ),\n  );\n}\n\n/// Outputs the CSS variable values for the given tokens.\n/// @param {Map} $tokens The token values to emit.\n@mixin overrides($tokens: ()) {\n    @include token-utils.batch-create-token-values($tokens, _define-overrides());\n}\n\n/// Outputs all (base, color, typography, and density) theme styles for the mat-checkbox.\n/// @param {Map} $theme The theme to generate styles for.\n/// @param {String} $color-variant: The color variant to use for the fab\n@mixin theme($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include base($theme);\n    @include color($theme, $color-variant);\n    @include density($theme);\n    @include typography($theme);\n  } @else {\n    @include base($theme);\n    @if inspection.theme-has($theme, color) {\n      @include color($theme);\n    }\n    @if inspection.theme-has($theme, density) {\n      @include density($theme);\n    }\n    @if inspection.theme-has($theme, typography) {\n      @include typography($theme);\n    }\n  }\n}\n","@use '../core/theming/inspection';\n@use '../core/tokens/token-utils';\n@use './m2-progress-spinner';\n@use './m3-progress-spinner';\n@use 'sass:map';\n\n@mixin base($theme) {\n  $tokens: map.get(m2-progress-spinner.get-tokens($theme), base);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-progress-spinner.get-tokens($theme), base);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs color theme styles for the mat-progress-spinner.\n/// @param {Map} $theme The theme to generate color styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin color($theme, $color-variant: null) {\n  $tokens: map.get(m2-progress-spinner.get-tokens($theme), color);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-progress-spinner.get-tokens($theme, $color-variant), color);\n  }\n\n  @include token-utils.values($tokens);\n\n  @if inspection.get-theme-version($theme) != 1 {\n    .mat-accent {\n      $tokens: m2-progress-spinner.private-get-color-palette-color-tokens($theme, secondary);\n      @include token-utils.values($tokens);\n    }\n\n    .mat-warn {\n      $tokens: m2-progress-spinner.private-get-color-palette-color-tokens($theme, error);\n      @include token-utils.values($tokens);\n    }\n  }\n}\n\n@mixin typography($theme) {\n  $tokens: map.get(m2-progress-spinner.get-tokens($theme), typography);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-progress-spinner.get-tokens($theme), typography);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n@mixin density($theme) {\n  $tokens: map.get(m2-progress-spinner.get-tokens($theme), density);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-progress-spinner.get-tokens($theme), density);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Defines the tokens that will be available in the `overrides` mixin and for docs extraction.\n@function _define-overrides() {\n  @return (\n    (\n      namespace: progress-spinner,\n      tokens: token-utils.get-overrides(m3-progress-spinner.get-tokens(), progress-spinner)\n    ),\n  );\n}\n\n/// Outputs the CSS variable values for the given tokens.\n/// @param {Map} $tokens The token values to emit.\n@mixin overrides($tokens: ()) {\n    @include token-utils.batch-create-token-values($tokens, _define-overrides());\n}\n\n/// Outputs all (base, color, typography, and density) theme styles for the mat-progress-spinner.\n/// @param {Map} $theme The theme to generate styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin theme($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include base($theme);\n    @include color($theme, $color-variant);\n    @include density($theme);\n    @include typography($theme);\n  } @else {\n    @include base($theme);\n    @if inspection.theme-has($theme, color) {\n      @include color($theme);\n    }\n    @if inspection.theme-has($theme, density) {\n      @include density($theme);\n    }\n    @if inspection.theme-has($theme, typography) {\n      @include typography($theme);\n    }\n  }\n}\n","@use '../core/theming/inspection';\n@use '../core/tokens/token-utils';\n@use '../core/typography/typography';\n@use './m2-badge';\n@use './m3-badge';\n@use 'sass:color';\n@use 'sass:map';\n\n/// Outputs base theme styles (styles not dependent on the color, typography, or density settings)\n/// for the mat-badge.\n/// @param {Map} $theme The theme to generate base styles for.\n@mixin base($theme) {\n  $tokens: map.get(m2-badge.get-tokens($theme), base);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-badge.get-tokens($theme), base);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs color theme styles for the mat-badge.\n/// @param {Map} $theme The theme to generate color styles for.\n/// @param {String} $color-variant The color variant to use for\n///     the badge: primary, secondary, tertiary, or error (If not specified,\n///     default error color will be used).\n@mixin color($theme, $color-variant: null) {\n  $tokens: map.get(m2-badge.get-tokens($theme), color);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-badge.get-tokens($theme, $color-variant), color);\n  }\n\n  @include token-utils.values($tokens);\n\n  @if inspection.get-theme-version($theme) != 1 {\n    .mat-badge-accent {\n      $tokens: m2-badge.private-get-color-palette-color-tokens($theme, secondary);\n      @include token-utils.values($tokens);\n    }\n\n    .mat-badge-warn {\n      $tokens: m2-badge.private-get-color-palette-color-tokens($theme, error);\n      @include token-utils.values($tokens);\n    }\n  }\n}\n\n/// Outputs typography theme styles for the mat-badge.\n/// @param {Map} $theme The theme to generate typography styles for.\n@mixin typography($theme) {\n  $tokens: map.get(m2-badge.get-tokens($theme), typography);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-badge.get-tokens($theme), typography);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs density theme styles for the mat-badge.\n/// @param {Map} $theme The theme to generate density styles for.\n@mixin density($theme) {\n  $tokens: map.get(m2-badge.get-tokens($theme), density);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-badge.get-tokens($theme), density);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Defines the tokens that will be available in the `overrides` mixin and for docs extraction.\n@function _define-overrides() {\n  @return (\n    (\n      namespace: badge,\n      tokens: token-utils.get-overrides(m3-badge.get-tokens(), badge),\n    ),\n  );\n}\n\n/// Outputs the CSS variable values for the given tokens.\n/// @param {Map} $tokens The token values to emit.\n@mixin overrides($tokens: ()) {\n    @include token-utils.batch-create-token-values($tokens, _define-overrides());\n}\n\n/// Outputs all (base, color, typography, and density) theme styles for the mat-badge.\n/// @param {Map} $theme The theme to generate styles for.\n/// @param {String} $color-variant The color variant to use for the component\n@mixin theme($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include base($theme);\n    @include color($theme, $color-variant);\n    @include density($theme);\n    @include typography($theme);\n  } @else {\n    @include base($theme);\n    @if inspection.theme-has($theme, color) {\n      @include color($theme);\n    }\n    @if inspection.theme-has($theme, density) {\n      @include density($theme);\n    }\n    @if inspection.theme-has($theme, typography) {\n      @include typography($theme);\n    }\n  }\n}\n","@use 'sass:color';\n@use 'sass:map';\n@use './m2-datepicker';\n@use './m3-datepicker';\n@use '../core/theming/inspection';\n@use '../core/tokens/token-utils';\n@use '../core/typography/typography';\n@use '../button/icon-button-theme';\n\n/// Outputs base theme styles (styles not dependent on the color, typography, or density settings)\n/// for the mat-datepicker.\n/// @param {Map} $theme The theme to generate base styles for.\n@mixin base($theme) {\n  $tokens: map.get(m2-datepicker.get-tokens($theme), base);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-datepicker.get-tokens($theme), base);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs color theme styles for the mat-datepicker.\n/// @param {Map} $theme The theme to generate color styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin color($theme, $color-variant: null) {\n  $tokens: map.get(m2-datepicker.get-tokens($theme), color);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-datepicker.get-tokens($theme, $color-variant), color);\n  }\n\n  @include token-utils.values($tokens);\n\n  @if inspection.get-theme-version($theme) != 1 {\n    .mat-datepicker-content, .mat-datepicker-toggle-active {\n      &.mat-accent {\n        $tokens: m2-datepicker.private-get-color-palette-color-tokens($theme, secondary);\n        @include token-utils.values($tokens);\n      }\n\n      &.mat-warn {\n        $tokens: m2-datepicker.private-get-color-palette-color-tokens($theme, error);\n        @include token-utils.values($tokens);\n      }\n    }\n  }\n}\n\n/// Outputs typography theme styles for the mat-datepicker.\n/// @param {Map} $theme The theme to generate typography styles for.\n@mixin typography($theme) {\n  $tokens: map.get(m2-datepicker.get-tokens($theme), typography);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-datepicker.get-tokens($theme), typography);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n@mixin date-range-colors(\n  $range-color,\n  $comparison-color: rgba(#f9ab00, 0.2),\n  $overlap-color: #a8dab5,\n  $overlap-selected-color: color.adjust($overlap-color, $lightness: -30%)\n) {\n  @include overrides((\n    calendar-date-in-range-state-background-color: $range-color,\n    calendar-date-in-comparison-range-state-background-color: $comparison-color,\n    calendar-date-in-overlap-range-state-background-color: $overlap-color,\n    calendar-date-in-overlap-range-selected-state-background-color: $overlap-selected-color,\n  ));\n}\n\n/// Outputs density theme styles for the mat-datepicker.\n/// @param {Map} $theme The theme to generate density styles for.\n@mixin density($theme) {\n  $tokens: map.get(m2-datepicker.get-tokens($theme), density);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-datepicker.get-tokens($theme), density);\n  }\n\n  @include token-utils.values($tokens);\n\n  @if inspection.get-theme-version($theme) != 1 {\n    // TODO(crisbeto): move this into the structural styles\n    // once the icon button density is switched to tokens.\n\n    // Regardless of the user-passed density, we want the calendar\n    // previous/next buttons to remain at density -2\n    .mat-calendar-controls {\n      @include icon-button-theme.density(-2);\n    }\n  }\n}\n\n/// Defines the tokens that will be available in the `overrides` mixin and for docs extraction.\n@function _define-overrides() {\n  @return (\n    (\n      namespace: datepicker,\n      tokens: token-utils.get-overrides(m3-datepicker.get-tokens(), datepicker)\n    ),\n  );\n}\n\n/// Outputs the CSS variable values for the given tokens.\n/// @param {Map} $tokens The token values to emit.\n@mixin overrides($tokens: ()) {\n    @include token-utils.batch-create-token-values($tokens, _define-overrides());\n}\n\n/// Outputs all (base, color, typography, and density) theme styles for the mat-datepicker.\n/// @param {Map} $theme The theme to generate styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin theme($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include base($theme);\n    @include color($theme, $color-variant);\n    @include density($theme);\n    @include typography($theme);\n  } @else {\n    @include base($theme);\n    @if inspection.theme-has($theme, color) {\n      @include color($theme);\n    }\n    @if inspection.theme-has($theme, density) {\n      @include density($theme);\n    }\n    @if inspection.theme-has($theme, typography) {\n      @include typography($theme);\n    }\n  }\n}\n","@use '../core/theming/inspection';\n@use '../core/tokens/token-utils';\n@use './m2-icon';\n@use './m3-icon';\n@use 'sass:map';\n\n@mixin base($theme) {\n  $tokens: map.get(m2-icon.get-tokens($theme), base);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-icon.get-tokens($theme), base);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs color theme styles for the mat-icon.\n/// @param {Map} $theme The theme to generate color styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin color($theme, $color-variant: null) {\n  $tokens: map.get(m2-icon.get-tokens($theme), color);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-icon.get-tokens($theme, $color-variant), color);\n  }\n\n  @include token-utils.values($tokens);\n\n  @if inspection.get-theme-version($theme) != 1 {\n    .mat-icon {\n      &.mat-primary {\n        $color: inspection.get-theme-color($theme, primary, text);\n        $tokens: m2-icon.private-get-icon-color-tokens($color);\n        @include token-utils.values($tokens);\n      }\n\n      &.mat-accent {\n        $color: inspection.get-theme-color($theme, accent, text);\n        $tokens: m2-icon.private-get-icon-color-tokens($color);\n        @include token-utils.values($tokens);\n      }\n\n      &.mat-warn {\n        $color: inspection.get-theme-color($theme, warn, text);\n        $tokens: m2-icon.private-get-icon-color-tokens($color);\n        @include token-utils.values($tokens);\n      }\n    }\n  }\n}\n\n/// Outputs typography theme styles for the mat-icon.\n/// @param {Map} $theme The theme to generate typography styles for.\n@mixin typography($theme) {\n  $tokens: map.get(m2-icon.get-tokens($theme), typography);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-icon.get-tokens($theme), typography);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs density theme styles for the mat-icon.\n/// @param {Map} $theme The theme to generate density styles for.\n@mixin density($theme) {\n  $tokens: map.get(m2-icon.get-tokens($theme), density);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-icon.get-tokens($theme), density);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Defines the tokens that will be available in the `overrides` mixin and for docs extraction.\n@function _define-overrides() {\n  @return (\n    (\n      namespace: icon,\n      tokens: token-utils.get-overrides(m3-icon.get-tokens(), icon)\n    ),\n  );\n}\n\n/// Outputs the CSS variable values for the given tokens.\n/// @param {Map} $tokens The token values to emit.\n@mixin overrides($tokens: ()) {\n    @include token-utils.batch-create-token-values($tokens, _define-overrides());\n}\n\n/// Outputs all (base, color, typography, and density) theme styles for the mat-icon.\n/// @param {Map} $theme The theme to generate styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin theme($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include base($theme);\n    @include color($theme, $color-variant);\n    @include density($theme);\n    @include typography($theme);\n  } @else {\n    @include base($theme);\n    @if inspection.theme-has($theme, color) {\n      @include color($theme);\n    }\n    @if inspection.theme-has($theme, density) {\n      @include density($theme);\n    }\n    @if inspection.theme-has($theme, typography) {\n      @include typography($theme);\n    }\n  }\n}\n","@use '../core/theming/inspection';\n@use '../core/typography/typography';\n@use '../core/tokens/token-utils';\n@use './m2-stepper';\n@use './m3-stepper';\n@use 'sass:map';\n\n/// Outputs base theme styles (styles not dependent on the color, typography, or density settings)\n/// for mat-stepper.\n/// @param {Map} $theme The theme to generate base styles for.\n@mixin base($theme) {\n  $tokens: map.get(m2-stepper.get-tokens($theme), base);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-stepper.get-tokens($theme), base);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Outputs color theme styles for mat-stepper.\n/// @param {Map} $theme The theme to generate color styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin color($theme, $color-variant: null) {\n  $tokens: map.get(m2-stepper.get-tokens($theme), color);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-stepper.get-tokens($theme, $color-variant), color);\n  }\n\n  @include token-utils.values($tokens);\n\n  @if inspection.get-theme-version($theme) != 1 {\n    .mat-step-header.mat-accent {\n      $tokens: m2-stepper.private-get-color-palette-color-tokens($theme, secondary);\n      @include token-utils.values($tokens);\n    }\n\n    .mat-step-header.mat-warn {\n      $tokens: m2-stepper.private-get-color-palette-color-tokens($theme, error);\n      @include token-utils.values($tokens);\n    }\n  }\n}\n\n@mixin typography($theme) {\n  $tokens: map.get(m2-stepper.get-tokens($theme), typography);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-stepper.get-tokens($theme), typography);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n@mixin density($theme) {\n  $tokens: map.get(m2-stepper.get-tokens($theme), density);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-stepper.get-tokens($theme), density);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n/// Defines the tokens that will be available in the `overrides` mixin and for docs extraction.\n@function _define-overrides() {\n  @return (\n    (\n      namespace: stepper,\n      tokens: token-utils.get-overrides(m3-stepper.get-tokens(), stepper)\n    ),\n  );\n}\n\n/// Outputs the CSS variable values for the given tokens.\n/// @param {Map} $tokens The token values to emit.\n@mixin overrides($tokens: ()) {\n    @include token-utils.batch-create-token-values($tokens, _define-overrides());\n}\n\n/// Outputs all (base, color, typography, and density) theme styles for mat-stepper.\n/// @param {Map} $theme The theme to generate color styles for.\n/// @param {String} $color-variant The color variant to use for the component (M3 only)\n@mixin theme($theme, $color-variant: null) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include base($theme);\n    @include color($theme, $color-variant);\n    @include density($theme);\n    @include typography($theme);\n    @if inspection.theme-has($theme, density) {\n      @include density($theme);\n    }\n  } @else {\n    @include base($theme);\n    @if inspection.theme-has($theme, color) {\n      @include color($theme);\n    }\n    @if inspection.theme-has($theme, density) {\n      @include density($theme);\n    }\n    @if inspection.theme-has($theme, typography) {\n      @include typography($theme);\n    }\n  }\n}\n","@use 'sass:map';\n@use '../core/theming/inspection';\n@use '../core/tokens/token-utils';\n@use '../core/typography/typography';\n@use './m2-toolbar';\n@use './m3-toolbar';\n\n@mixin _palette-styles($theme, $palette-name) {\n  $tokens: m2-toolbar.private-get-color-palette-color-tokens(\n    $background-color: inspection.get-theme-color($theme, $palette-name),\n    $text-color: inspection.get-theme-color($theme, $palette-name, default-contrast)\n  );\n  @include token-utils.values($tokens);\n}\n\n@mixin base($theme) {\n  $tokens: map.get(m2-toolbar.get-tokens($theme), base);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-toolbar.get-tokens($theme), base);\n  }\n\n  @include token-utils.values($tokens);\n}\n\n@mixin color($theme) {\n  $tokens: map.get(m2-toolbar.get-tokens($theme), color);\n  @if inspection.get-theme-version($theme) == 1 {\n    $tokens: map.get(m3-toolbar.get-tokens($theme), color);\n  }\n\n  @include token-utils.values($tokens);\n\n  @if inspection.get-theme-version($theme) != 1 {\n    .mat-toolbar {\n      &.mat-primary {\n        $tokens: m2-toolbar.private-get-color-palette-color-tokens(\n          $background-color: inspection.get-theme-color($theme, primary),\n          $text-color: inspection.get-theme-color($theme, primary, default-contrast)\n        );\n        @include token-utils.values($tokens);\n      }\n\n      &.mat-accent {\n        $tokens: m2-toolbar.private-get-color-palette-color-tokens(\n          $background-color: inspection.get-theme-color($theme, accent),\n          $text-color: inspection.get-theme-color($theme, accent, default-contrast)\n        );\n        @include token-utils.values($tokens);\n      }\n\n      &.mat-warn {\n        $tokens: m2-toolbar.private-get-color-palette-color-tokens(\n          $background-color: inspection.get-theme-color($theme, warn),\n          $text-color: inspection.get-theme-color($theme, warn, default-contrast)\n        );\n        @include token-utils.values($tokens);\n      }\n    }\n  }\n}\n\n  @mixin typography($theme) {\n    $tokens: map.get(m2-toolbar.get-tokens($theme), typography);\n    @if inspection.get-theme-version($theme) == 1 {\n      $tokens: map.get(m3-toolbar.get-tokens($theme), typography);\n    }\n\n    @include token-utils.values($tokens);\n  }\n\n  @mixin density($theme) {\n    $tokens: map.get(m2-toolbar.get-tokens($theme), density);\n    @if inspection.get-theme-version($theme) == 1 {\n      $tokens: map.get(m3-toolbar.get-tokens($theme), density);\n    }\n\n    @include token-utils.values($tokens);\n  }\n\n/// Defines the tokens that will be available in the `overrides` mixin and for docs extraction.\n@function _define-overrides() {\n  @return (\n    (\n      namespace: toolbar,\n      tokens: token-utils.get-overrides(m3-toolbar.get-tokens(), toolbar)\n    ),\n  );\n}\n\n/// Outputs the CSS variable values for the given tokens.\n/// @param {Map} $tokens The token values to emit.\n@mixin overrides($tokens: ()) {\n    @include token-utils.batch-create-token-values($tokens, _define-overrides());\n}\n\n@mixin theme($theme) {\n  @if inspection.get-theme-version($theme) == 1 {\n    @include base($theme);\n    @include color($theme);\n    @include density($theme);\n    @include typography($theme);\n  } @else {\n    @include base($theme);\n    @if inspection.theme-has($theme, color) {\n      @include color($theme);\n    }\n    @if inspection.theme-has($theme, density) {\n      @include density($theme);\n    }\n    @if inspection.theme-has($theme, typography) {\n      @include typography($theme);\n    }\n  }\n}\n","@import \"./layout.scss\";\n\n.custom-active-button {\n  @include button-theme-properties();\n  margin: 1em 0em;\n  padding: 0em 0em .3em;\n  border-radius: .2em;\n  width: 100%;\n  background-color: $admin-default !important;\n  color: $white !important;\n  --mat-button-text-label-text-color: #{$white};\n  --mat-button-outlined-label-text-color: #{$white};\n  --mat-button-filled-label-text-color: #{$white};\n  --mat-button-text-label-text-font: #{$bold};\n  --mat-button-outlined-label-text-font: #{$bold};\n  --mat-button-filled-label-text-font: #{$bold};\n}\n\n.custom-disabled-button {\n  @include button-theme-properties();\n  color: $white !important;\n  opacity: 0.6;\n}\n\n// Custom errors aligment\n.custom-error-aligment {\n  float: right;\n}\n\n@mixin drop-down {\n  padding-right: 1.5em;\n}","@import 'theme';\n\n// Utilities for the portal\n\n$left-gutter-responsive: 3%;\n$left-gutter-desktop: 8%;\n$right-gutter-responsive: 3%;\n$right-gutter-desktop: 8%;\n\n@mixin button-nofill {\n  color: $admin-default;\n  font-family: $bold;\n  background: none;\n  border: none;\n  font-size: 1em;\n  cursor: pointer;\n}\n\n@mixin button-fill {\n  color: $subscription-confirmation-button-yes;\n  background-color: $subscription-component-descriptor;\n  width: 100%;\n  margin-bottom: 1em;\n\n  @include desktop-screen() {\n    width: 27em;\n  }\n}\n\n@mixin button-theme-properties() {\n  font-family: $bold;\n  font-size: 1em;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
